/* Generated by Spago v1.0.4 */ (()=>{
    var mM = Object.create;
    var op = Object.defineProperty;
    var dM = Object.getOwnPropertyDescriptor;
    var _M = Object.getOwnPropertyNames;
    var vM = Object.getPrototypeOf, hM = Object.prototype.hasOwnProperty;
    var Jr = (n, r)=>()=>(r || n((r = {
                exports: {}
            }).exports, r), r.exports), Dl = (n, r)=>{
        for(var e in r)op(n, e, {
            get: r[e],
            enumerable: !0
        });
    }, DM = (n, r, e, t)=>{
        if (r && typeof r == "object" || typeof r == "function") for (let a of _M(r))!hM.call(n, a) && a !== e && op(n, a, {
            get: ()=>r[a],
            enumerable: !(t = dM(r, a)) || t.enumerable
        });
        return n;
    };
    var gM = (n, r, e)=>(e = n != null ? mM(vM(n)) : {}, DM(r || !n || !n.__esModule ? op(e, "default", {
            value: n,
            enumerable: !0
        }) : e, n));
    var ho = Jr((Byn, BE)=>{
        function yv(n, r, e) {
            var t = "KaTeX parse error: " + n;
            if (r !== void 0 && e !== void 0) {
                t += " at position " + e + ": ";
                var a = r._input;
                a = a.slice(0, e) + "\u0332" + a.slice(e);
                var o = Math.max(0, e - 15), u = e + 15;
                t += a.slice(o, u);
            }
            var i = new Error(t);
            return i.name = "ParseError", i.__proto__ = yv.prototype, i.position = e, i;
        }
        yv.prototype.__proto__ = Error.prototype;
        BE.exports = yv;
    });
    var Ev = Jr((zyn, zE)=>{
        function Cv(n, r) {
            return n === void 0 ? r : n;
        }
        function _S(n) {
            n = n || {}, this.displayMode = Cv(n.displayMode, !1), this.throwOnError = Cv(n.throwOnError, !0), this.errorColor = Cv(n.errorColor, "#cc0000");
        }
        zE.exports = _S;
    });
    var Gc = Jr((Vyn, JE)=>{
        function at(n, r, e, t) {
            this.id = n, this.size = r, this.cramped = t, this.sizeMultiplier = e;
        }
        at.prototype.sup = function() {
            return Do[DS[this.id]];
        };
        at.prototype.sub = function() {
            return Do[gS[this.id]];
        };
        at.prototype.fracNum = function() {
            return Do[bS[this.id]];
        };
        at.prototype.fracDen = function() {
            return Do[yS[this.id]];
        };
        at.prototype.cramp = function() {
            return Do[CS[this.id]];
        };
        at.prototype.cls = function() {
            return vS[this.size] + (this.cramped ? " cramped" : " uncramped");
        };
        at.prototype.reset = function() {
            return hS[this.size];
        };
        var VE = 0, Tv = 1, Mv = 2, Ki = 3, Jc = 4, Ut = 5, Yi = 6, ot = 7, vS = [
            "displaystyle textstyle",
            "textstyle",
            "scriptstyle",
            "scriptscriptstyle"
        ], hS = [
            "reset-textstyle",
            "reset-textstyle",
            "reset-scriptstyle",
            "reset-scriptscriptstyle"
        ], Do = [
            new at(VE, 0, 1, !1),
            new at(Tv, 0, 1, !0),
            new at(Mv, 1, 1, !1),
            new at(Ki, 1, 1, !0),
            new at(Jc, 2, .7, !1),
            new at(Ut, 2, .7, !0),
            new at(Yi, 3, .5, !1),
            new at(ot, 3, .5, !0)
        ], DS = [
            Jc,
            Ut,
            Jc,
            Ut,
            Yi,
            ot,
            Yi,
            ot
        ], gS = [
            Ut,
            Ut,
            Ut,
            Ut,
            ot,
            ot,
            ot,
            ot
        ], bS = [
            Mv,
            Ki,
            Jc,
            Ut,
            Yi,
            ot,
            Yi,
            ot
        ], yS = [
            Ki,
            Ki,
            Ut,
            Ut,
            ot,
            ot,
            ot,
            ot
        ], CS = [
            Tv,
            Tv,
            Ki,
            Ki,
            Ut,
            Ut,
            ot,
            ot
        ];
        JE.exports = {
            DISPLAY: Do[VE],
            TEXT: Do[Mv],
            SCRIPT: Do[Jc],
            SCRIPTSCRIPT: Do[Yi]
        };
    });
    var Na = Jr((Jyn, KE)=>{
        var GE = Array.prototype.indexOf, QE = function(n, r) {
            if (n == null) return -1;
            if (GE && n.indexOf === GE) return n.indexOf(r);
            for(var e = 0, t = n.length; e < t; e++)if (n[e] === r) return e;
            return -1;
        }, ES = function(n, r) {
            return QE(n, r) !== -1;
        }, TS = function(n, r) {
            return n === void 0 ? r : n;
        }, MS = /([A-Z])/g, FS = function(n) {
            return n.replace(MS, "-$1").toLowerCase();
        }, wS = {
            "&": "&amp;",
            ">": "&gt;",
            "<": "&lt;",
            '"': "&quot;",
            "'": "&#x27;"
        }, xS = /[&><"']/g;
        function AS(n) {
            return wS[n];
        }
        function IS(n) {
            return ("" + n).replace(xS, AS);
        }
        var k0;
        typeof document < "u" && (jE = document.createElement("span"), "textContent" in jE ? k0 = function(n, r) {
            n.textContent = r;
        } : k0 = function(n, r) {
            n.innerText = r;
        });
        var jE;
        function LS(n) {
            k0(n, "");
        }
        KE.exports = {
            contains: ES,
            deflt: TS,
            escape: IS,
            hyphenate: FS,
            indexOf: QE,
            setTextContent: k0,
            clearNode: LS
        };
    });
    var xv = Jr((Gyn, YE)=>{
        var Yo = Na(), O0 = function(n) {
            n = n.slice();
            for(var r = n.length - 1; r >= 0; r--)n[r] || n.splice(r, 1);
            return n.join(" ");
        };
        function q0(n, r, e, t, a, o) {
            this.classes = n || [], this.children = r || [], this.height = e || 0, this.depth = t || 0, this.maxFontSize = a || 0, this.style = o || {}, this.attributes = {};
        }
        q0.prototype.setAttribute = function(n, r) {
            this.attributes[n] = r;
        };
        q0.prototype.toNode = function() {
            var n = document.createElement("span");
            n.className = O0(this.classes);
            for(var r in this.style)Object.prototype.hasOwnProperty.call(this.style, r) && (n.style[r] = this.style[r]);
            for(var e in this.attributes)Object.prototype.hasOwnProperty.call(this.attributes, e) && n.setAttribute(e, this.attributes[e]);
            for(var t = 0; t < this.children.length; t++)n.appendChild(this.children[t].toNode());
            return n;
        };
        q0.prototype.toMarkup = function() {
            var n = "<span";
            this.classes.length && (n += ' class="', n += Yo.escape(O0(this.classes)), n += '"');
            var r = "";
            for(var e in this.style)this.style.hasOwnProperty(e) && (r += Yo.hyphenate(e) + ":" + this.style[e] + ";");
            r && (n += ' style="' + Yo.escape(r) + '"');
            for(var t in this.attributes)Object.prototype.hasOwnProperty.call(this.attributes, t) && (n += " " + t + '="', n += Yo.escape(this.attributes[t]), n += '"');
            n += ">";
            for(var a = 0; a < this.children.length; a++)n += this.children[a].toMarkup();
            return n += "</span>", n;
        };
        function Fv(n, r, e, t) {
            this.children = n || [], this.height = r || 0, this.depth = e || 0, this.maxFontSize = t || 0;
        }
        Fv.prototype.toNode = function() {
            for(var n = document.createDocumentFragment(), r = 0; r < this.children.length; r++)n.appendChild(this.children[r].toNode());
            return n;
        };
        Fv.prototype.toMarkup = function() {
            for(var n = "", r = 0; r < this.children.length; r++)n += this.children[r].toMarkup();
            return n;
        };
        function wv(n, r, e, t, a, o, u) {
            this.value = n || "", this.height = r || 0, this.depth = e || 0, this.italic = t || 0, this.skew = a || 0, this.classes = o || [], this.style = u || {}, this.maxFontSize = 0;
        }
        wv.prototype.toNode = function() {
            var n = document.createTextNode(this.value), r = null;
            this.italic > 0 && (r = document.createElement("span"), r.style.marginRight = this.italic + "em"), this.classes.length > 0 && (r = r || document.createElement("span"), r.className = O0(this.classes));
            for(var e in this.style)this.style.hasOwnProperty(e) && (r = r || document.createElement("span"), r.style[e] = this.style[e]);
            return r ? (r.appendChild(n), r) : n;
        };
        wv.prototype.toMarkup = function() {
            var n = !1, r = "<span";
            this.classes.length && (n = !0, r += ' class="', r += Yo.escape(O0(this.classes)), r += '"');
            var e = "";
            this.italic > 0 && (e += "margin-right:" + this.italic + "em;");
            for(var t in this.style)this.style.hasOwnProperty(t) && (e += Yo.hyphenate(t) + ":" + this.style[t] + ";");
            e && (n = !0, r += ' style="' + Yo.escape(e) + '"');
            var a = Yo.escape(this.value);
            return n ? (r += ">", r += a, r += "</span>", r) : a;
        };
        YE.exports = {
            span: q0,
            documentFragment: Fv,
            symbolNode: wv
        };
    });
    var ZE = Jr((jyn, XE)=>{
        XE.exports = {
            "AMS-Regular": {
                65: [
                    0,
                    .68889,
                    0,
                    0
                ],
                66: [
                    0,
                    .68889,
                    0,
                    0
                ],
                67: [
                    0,
                    .68889,
                    0,
                    0
                ],
                68: [
                    0,
                    .68889,
                    0,
                    0
                ],
                69: [
                    0,
                    .68889,
                    0,
                    0
                ],
                70: [
                    0,
                    .68889,
                    0,
                    0
                ],
                71: [
                    0,
                    .68889,
                    0,
                    0
                ],
                72: [
                    0,
                    .68889,
                    0,
                    0
                ],
                73: [
                    0,
                    .68889,
                    0,
                    0
                ],
                74: [
                    .16667,
                    .68889,
                    0,
                    0
                ],
                75: [
                    0,
                    .68889,
                    0,
                    0
                ],
                76: [
                    0,
                    .68889,
                    0,
                    0
                ],
                77: [
                    0,
                    .68889,
                    0,
                    0
                ],
                78: [
                    0,
                    .68889,
                    0,
                    0
                ],
                79: [
                    .16667,
                    .68889,
                    0,
                    0
                ],
                80: [
                    0,
                    .68889,
                    0,
                    0
                ],
                81: [
                    .16667,
                    .68889,
                    0,
                    0
                ],
                82: [
                    0,
                    .68889,
                    0,
                    0
                ],
                83: [
                    0,
                    .68889,
                    0,
                    0
                ],
                84: [
                    0,
                    .68889,
                    0,
                    0
                ],
                85: [
                    0,
                    .68889,
                    0,
                    0
                ],
                86: [
                    0,
                    .68889,
                    0,
                    0
                ],
                87: [
                    0,
                    .68889,
                    0,
                    0
                ],
                88: [
                    0,
                    .68889,
                    0,
                    0
                ],
                89: [
                    0,
                    .68889,
                    0,
                    0
                ],
                90: [
                    0,
                    .68889,
                    0,
                    0
                ],
                107: [
                    0,
                    .68889,
                    0,
                    0
                ],
                165: [
                    0,
                    .675,
                    .025,
                    0
                ],
                174: [
                    .15559,
                    .69224,
                    0,
                    0
                ],
                240: [
                    0,
                    .68889,
                    0,
                    0
                ],
                295: [
                    0,
                    .68889,
                    0,
                    0
                ],
                710: [
                    0,
                    .825,
                    0,
                    0
                ],
                732: [
                    0,
                    .9,
                    0,
                    0
                ],
                770: [
                    0,
                    .825,
                    0,
                    0
                ],
                771: [
                    0,
                    .9,
                    0,
                    0
                ],
                989: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                1008: [
                    0,
                    .43056,
                    .04028,
                    0
                ],
                8245: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8463: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8487: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8498: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8502: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8503: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8504: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8513: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8592: [
                    -0.03598,
                    .46402,
                    0,
                    0
                ],
                8594: [
                    -0.03598,
                    .46402,
                    0,
                    0
                ],
                8602: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8603: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8606: [
                    .01354,
                    .52239,
                    0,
                    0
                ],
                8608: [
                    .01354,
                    .52239,
                    0,
                    0
                ],
                8610: [
                    .01354,
                    .52239,
                    0,
                    0
                ],
                8611: [
                    .01354,
                    .52239,
                    0,
                    0
                ],
                8619: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8620: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8621: [
                    -0.13313,
                    .37788,
                    0,
                    0
                ],
                8622: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8624: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8625: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8630: [
                    0,
                    .43056,
                    0,
                    0
                ],
                8631: [
                    0,
                    .43056,
                    0,
                    0
                ],
                8634: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8635: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8638: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8639: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8642: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8643: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8644: [
                    .1808,
                    .675,
                    0,
                    0
                ],
                8646: [
                    .1808,
                    .675,
                    0,
                    0
                ],
                8647: [
                    .1808,
                    .675,
                    0,
                    0
                ],
                8648: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8649: [
                    .1808,
                    .675,
                    0,
                    0
                ],
                8650: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8651: [
                    .01354,
                    .52239,
                    0,
                    0
                ],
                8652: [
                    .01354,
                    .52239,
                    0,
                    0
                ],
                8653: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8654: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8655: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8666: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8667: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8669: [
                    -0.13313,
                    .37788,
                    0,
                    0
                ],
                8672: [
                    -0.064,
                    .437,
                    0,
                    0
                ],
                8674: [
                    -0.064,
                    .437,
                    0,
                    0
                ],
                8705: [
                    0,
                    .825,
                    0,
                    0
                ],
                8708: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8709: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8717: [
                    0,
                    .43056,
                    0,
                    0
                ],
                8722: [
                    -0.03598,
                    .46402,
                    0,
                    0
                ],
                8724: [
                    .08198,
                    .69224,
                    0,
                    0
                ],
                8726: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8733: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8736: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8737: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8738: [
                    .03517,
                    .52239,
                    0,
                    0
                ],
                8739: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8740: [
                    .25142,
                    .74111,
                    0,
                    0
                ],
                8741: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8742: [
                    .25142,
                    .74111,
                    0,
                    0
                ],
                8756: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8757: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8764: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8765: [
                    -0.13313,
                    .37788,
                    0,
                    0
                ],
                8769: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8770: [
                    -0.03625,
                    .46375,
                    0,
                    0
                ],
                8774: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8776: [
                    -0.01688,
                    .48312,
                    0,
                    0
                ],
                8778: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8782: [
                    .06062,
                    .54986,
                    0,
                    0
                ],
                8783: [
                    .06062,
                    .54986,
                    0,
                    0
                ],
                8785: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8786: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8787: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8790: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8791: [
                    .22958,
                    .72958,
                    0,
                    0
                ],
                8796: [
                    .08198,
                    .91667,
                    0,
                    0
                ],
                8806: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                8807: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                8808: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                8809: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                8812: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                8814: [
                    .20576,
                    .70576,
                    0,
                    0
                ],
                8815: [
                    .20576,
                    .70576,
                    0,
                    0
                ],
                8816: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8817: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8818: [
                    .22958,
                    .72958,
                    0,
                    0
                ],
                8819: [
                    .22958,
                    .72958,
                    0,
                    0
                ],
                8822: [
                    .1808,
                    .675,
                    0,
                    0
                ],
                8823: [
                    .1808,
                    .675,
                    0,
                    0
                ],
                8828: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8829: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8830: [
                    .22958,
                    .72958,
                    0,
                    0
                ],
                8831: [
                    .22958,
                    .72958,
                    0,
                    0
                ],
                8832: [
                    .20576,
                    .70576,
                    0,
                    0
                ],
                8833: [
                    .20576,
                    .70576,
                    0,
                    0
                ],
                8840: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8841: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8842: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8843: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8847: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8848: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8858: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8859: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8861: [
                    .08198,
                    .58198,
                    0,
                    0
                ],
                8862: [
                    0,
                    .675,
                    0,
                    0
                ],
                8863: [
                    0,
                    .675,
                    0,
                    0
                ],
                8864: [
                    0,
                    .675,
                    0,
                    0
                ],
                8865: [
                    0,
                    .675,
                    0,
                    0
                ],
                8872: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8873: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8874: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8876: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8877: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8878: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8879: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8882: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8883: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8884: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8885: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8888: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8890: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                8891: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8892: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8901: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8903: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8905: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8906: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                8907: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8908: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8909: [
                    -0.03598,
                    .46402,
                    0,
                    0
                ],
                8910: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8911: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8912: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8913: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8914: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8915: [
                    0,
                    .54986,
                    0,
                    0
                ],
                8916: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8918: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8919: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8920: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8921: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                8922: [
                    .38569,
                    .88569,
                    0,
                    0
                ],
                8923: [
                    .38569,
                    .88569,
                    0,
                    0
                ],
                8926: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8927: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                8928: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8929: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8934: [
                    .23222,
                    .74111,
                    0,
                    0
                ],
                8935: [
                    .23222,
                    .74111,
                    0,
                    0
                ],
                8936: [
                    .23222,
                    .74111,
                    0,
                    0
                ],
                8937: [
                    .23222,
                    .74111,
                    0,
                    0
                ],
                8938: [
                    .20576,
                    .70576,
                    0,
                    0
                ],
                8939: [
                    .20576,
                    .70576,
                    0,
                    0
                ],
                8940: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8941: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                8994: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                8995: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                9416: [
                    .15559,
                    .69224,
                    0,
                    0
                ],
                9484: [
                    0,
                    .69224,
                    0,
                    0
                ],
                9488: [
                    0,
                    .69224,
                    0,
                    0
                ],
                9492: [
                    0,
                    .37788,
                    0,
                    0
                ],
                9496: [
                    0,
                    .37788,
                    0,
                    0
                ],
                9585: [
                    .19444,
                    .68889,
                    0,
                    0
                ],
                9586: [
                    .19444,
                    .74111,
                    0,
                    0
                ],
                9632: [
                    0,
                    .675,
                    0,
                    0
                ],
                9633: [
                    0,
                    .675,
                    0,
                    0
                ],
                9650: [
                    0,
                    .54986,
                    0,
                    0
                ],
                9651: [
                    0,
                    .54986,
                    0,
                    0
                ],
                9654: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                9660: [
                    0,
                    .54986,
                    0,
                    0
                ],
                9661: [
                    0,
                    .54986,
                    0,
                    0
                ],
                9664: [
                    .03517,
                    .54986,
                    0,
                    0
                ],
                9674: [
                    .11111,
                    .69224,
                    0,
                    0
                ],
                9733: [
                    .19444,
                    .69224,
                    0,
                    0
                ],
                10003: [
                    0,
                    .69224,
                    0,
                    0
                ],
                10016: [
                    0,
                    .69224,
                    0,
                    0
                ],
                10731: [
                    .11111,
                    .69224,
                    0,
                    0
                ],
                10846: [
                    .19444,
                    .75583,
                    0,
                    0
                ],
                10877: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                10878: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                10885: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                10886: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                10887: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                10888: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                10889: [
                    .26167,
                    .75726,
                    0,
                    0
                ],
                10890: [
                    .26167,
                    .75726,
                    0,
                    0
                ],
                10891: [
                    .48256,
                    .98256,
                    0,
                    0
                ],
                10892: [
                    .48256,
                    .98256,
                    0,
                    0
                ],
                10901: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                10902: [
                    .13667,
                    .63667,
                    0,
                    0
                ],
                10933: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                10934: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                10935: [
                    .26167,
                    .75726,
                    0,
                    0
                ],
                10936: [
                    .26167,
                    .75726,
                    0,
                    0
                ],
                10937: [
                    .26167,
                    .75726,
                    0,
                    0
                ],
                10938: [
                    .26167,
                    .75726,
                    0,
                    0
                ],
                10949: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                10950: [
                    .25583,
                    .75583,
                    0,
                    0
                ],
                10955: [
                    .28481,
                    .79383,
                    0,
                    0
                ],
                10956: [
                    .28481,
                    .79383,
                    0,
                    0
                ],
                57350: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                57351: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                57352: [
                    .08167,
                    .58167,
                    0,
                    0
                ],
                57353: [
                    0,
                    .43056,
                    .04028,
                    0
                ],
                57356: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                57357: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                57358: [
                    .41951,
                    .91951,
                    0,
                    0
                ],
                57359: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                57360: [
                    .30274,
                    .79383,
                    0,
                    0
                ],
                57361: [
                    .41951,
                    .91951,
                    0,
                    0
                ],
                57366: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                57367: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                57368: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                57369: [
                    .25142,
                    .75726,
                    0,
                    0
                ],
                57370: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                57371: [
                    .13597,
                    .63597,
                    0,
                    0
                ]
            },
            "Caligraphic-Regular": {
                48: [
                    0,
                    .43056,
                    0,
                    0
                ],
                49: [
                    0,
                    .43056,
                    0,
                    0
                ],
                50: [
                    0,
                    .43056,
                    0,
                    0
                ],
                51: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                52: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                53: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                54: [
                    0,
                    .64444,
                    0,
                    0
                ],
                55: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                56: [
                    0,
                    .64444,
                    0,
                    0
                ],
                57: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                65: [
                    0,
                    .68333,
                    0,
                    .19445
                ],
                66: [
                    0,
                    .68333,
                    .03041,
                    .13889
                ],
                67: [
                    0,
                    .68333,
                    .05834,
                    .13889
                ],
                68: [
                    0,
                    .68333,
                    .02778,
                    .08334
                ],
                69: [
                    0,
                    .68333,
                    .08944,
                    .11111
                ],
                70: [
                    0,
                    .68333,
                    .09931,
                    .11111
                ],
                71: [
                    .09722,
                    .68333,
                    .0593,
                    .11111
                ],
                72: [
                    0,
                    .68333,
                    .00965,
                    .11111
                ],
                73: [
                    0,
                    .68333,
                    .07382,
                    0
                ],
                74: [
                    .09722,
                    .68333,
                    .18472,
                    .16667
                ],
                75: [
                    0,
                    .68333,
                    .01445,
                    .05556
                ],
                76: [
                    0,
                    .68333,
                    0,
                    .13889
                ],
                77: [
                    0,
                    .68333,
                    0,
                    .13889
                ],
                78: [
                    0,
                    .68333,
                    .14736,
                    .08334
                ],
                79: [
                    0,
                    .68333,
                    .02778,
                    .11111
                ],
                80: [
                    0,
                    .68333,
                    .08222,
                    .08334
                ],
                81: [
                    .09722,
                    .68333,
                    0,
                    .11111
                ],
                82: [
                    0,
                    .68333,
                    0,
                    .08334
                ],
                83: [
                    0,
                    .68333,
                    .075,
                    .13889
                ],
                84: [
                    0,
                    .68333,
                    .25417,
                    0
                ],
                85: [
                    0,
                    .68333,
                    .09931,
                    .08334
                ],
                86: [
                    0,
                    .68333,
                    .08222,
                    0
                ],
                87: [
                    0,
                    .68333,
                    .08222,
                    .08334
                ],
                88: [
                    0,
                    .68333,
                    .14643,
                    .13889
                ],
                89: [
                    .09722,
                    .68333,
                    .08222,
                    .08334
                ],
                90: [
                    0,
                    .68333,
                    .07944,
                    .13889
                ]
            },
            "Fraktur-Regular": {
                33: [
                    0,
                    .69141,
                    0,
                    0
                ],
                34: [
                    0,
                    .69141,
                    0,
                    0
                ],
                38: [
                    0,
                    .69141,
                    0,
                    0
                ],
                39: [
                    0,
                    .69141,
                    0,
                    0
                ],
                40: [
                    .24982,
                    .74947,
                    0,
                    0
                ],
                41: [
                    .24982,
                    .74947,
                    0,
                    0
                ],
                42: [
                    0,
                    .62119,
                    0,
                    0
                ],
                43: [
                    .08319,
                    .58283,
                    0,
                    0
                ],
                44: [
                    0,
                    .10803,
                    0,
                    0
                ],
                45: [
                    .08319,
                    .58283,
                    0,
                    0
                ],
                46: [
                    0,
                    .10803,
                    0,
                    0
                ],
                47: [
                    .24982,
                    .74947,
                    0,
                    0
                ],
                48: [
                    0,
                    .47534,
                    0,
                    0
                ],
                49: [
                    0,
                    .47534,
                    0,
                    0
                ],
                50: [
                    0,
                    .47534,
                    0,
                    0
                ],
                51: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                52: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                53: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                54: [
                    0,
                    .69141,
                    0,
                    0
                ],
                55: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                56: [
                    0,
                    .69141,
                    0,
                    0
                ],
                57: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                58: [
                    0,
                    .47534,
                    0,
                    0
                ],
                59: [
                    .12604,
                    .47534,
                    0,
                    0
                ],
                61: [
                    -0.13099,
                    .36866,
                    0,
                    0
                ],
                63: [
                    0,
                    .69141,
                    0,
                    0
                ],
                65: [
                    0,
                    .69141,
                    0,
                    0
                ],
                66: [
                    0,
                    .69141,
                    0,
                    0
                ],
                67: [
                    0,
                    .69141,
                    0,
                    0
                ],
                68: [
                    0,
                    .69141,
                    0,
                    0
                ],
                69: [
                    0,
                    .69141,
                    0,
                    0
                ],
                70: [
                    .12604,
                    .69141,
                    0,
                    0
                ],
                71: [
                    0,
                    .69141,
                    0,
                    0
                ],
                72: [
                    .06302,
                    .69141,
                    0,
                    0
                ],
                73: [
                    0,
                    .69141,
                    0,
                    0
                ],
                74: [
                    .12604,
                    .69141,
                    0,
                    0
                ],
                75: [
                    0,
                    .69141,
                    0,
                    0
                ],
                76: [
                    0,
                    .69141,
                    0,
                    0
                ],
                77: [
                    0,
                    .69141,
                    0,
                    0
                ],
                78: [
                    0,
                    .69141,
                    0,
                    0
                ],
                79: [
                    0,
                    .69141,
                    0,
                    0
                ],
                80: [
                    .18906,
                    .69141,
                    0,
                    0
                ],
                81: [
                    .03781,
                    .69141,
                    0,
                    0
                ],
                82: [
                    0,
                    .69141,
                    0,
                    0
                ],
                83: [
                    0,
                    .69141,
                    0,
                    0
                ],
                84: [
                    0,
                    .69141,
                    0,
                    0
                ],
                85: [
                    0,
                    .69141,
                    0,
                    0
                ],
                86: [
                    0,
                    .69141,
                    0,
                    0
                ],
                87: [
                    0,
                    .69141,
                    0,
                    0
                ],
                88: [
                    0,
                    .69141,
                    0,
                    0
                ],
                89: [
                    .18906,
                    .69141,
                    0,
                    0
                ],
                90: [
                    .12604,
                    .69141,
                    0,
                    0
                ],
                91: [
                    .24982,
                    .74947,
                    0,
                    0
                ],
                93: [
                    .24982,
                    .74947,
                    0,
                    0
                ],
                94: [
                    0,
                    .69141,
                    0,
                    0
                ],
                97: [
                    0,
                    .47534,
                    0,
                    0
                ],
                98: [
                    0,
                    .69141,
                    0,
                    0
                ],
                99: [
                    0,
                    .47534,
                    0,
                    0
                ],
                100: [
                    0,
                    .62119,
                    0,
                    0
                ],
                101: [
                    0,
                    .47534,
                    0,
                    0
                ],
                102: [
                    .18906,
                    .69141,
                    0,
                    0
                ],
                103: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                104: [
                    .18906,
                    .69141,
                    0,
                    0
                ],
                105: [
                    0,
                    .69141,
                    0,
                    0
                ],
                106: [
                    0,
                    .69141,
                    0,
                    0
                ],
                107: [
                    0,
                    .69141,
                    0,
                    0
                ],
                108: [
                    0,
                    .69141,
                    0,
                    0
                ],
                109: [
                    0,
                    .47534,
                    0,
                    0
                ],
                110: [
                    0,
                    .47534,
                    0,
                    0
                ],
                111: [
                    0,
                    .47534,
                    0,
                    0
                ],
                112: [
                    .18906,
                    .52396,
                    0,
                    0
                ],
                113: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                114: [
                    0,
                    .47534,
                    0,
                    0
                ],
                115: [
                    0,
                    .47534,
                    0,
                    0
                ],
                116: [
                    0,
                    .62119,
                    0,
                    0
                ],
                117: [
                    0,
                    .47534,
                    0,
                    0
                ],
                118: [
                    0,
                    .52396,
                    0,
                    0
                ],
                119: [
                    0,
                    .52396,
                    0,
                    0
                ],
                120: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                121: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                122: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                8216: [
                    0,
                    .69141,
                    0,
                    0
                ],
                8217: [
                    0,
                    .69141,
                    0,
                    0
                ],
                58112: [
                    0,
                    .62119,
                    0,
                    0
                ],
                58113: [
                    0,
                    .62119,
                    0,
                    0
                ],
                58114: [
                    .18906,
                    .69141,
                    0,
                    0
                ],
                58115: [
                    .18906,
                    .69141,
                    0,
                    0
                ],
                58116: [
                    .18906,
                    .47534,
                    0,
                    0
                ],
                58117: [
                    0,
                    .69141,
                    0,
                    0
                ],
                58118: [
                    0,
                    .62119,
                    0,
                    0
                ],
                58119: [
                    0,
                    .47534,
                    0,
                    0
                ]
            },
            "Main-Bold": {
                33: [
                    0,
                    .69444,
                    0,
                    0
                ],
                34: [
                    0,
                    .69444,
                    0,
                    0
                ],
                35: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                36: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                37: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                38: [
                    0,
                    .69444,
                    0,
                    0
                ],
                39: [
                    0,
                    .69444,
                    0,
                    0
                ],
                40: [
                    .25,
                    .75,
                    0,
                    0
                ],
                41: [
                    .25,
                    .75,
                    0,
                    0
                ],
                42: [
                    0,
                    .75,
                    0,
                    0
                ],
                43: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                44: [
                    .19444,
                    .15556,
                    0,
                    0
                ],
                45: [
                    0,
                    .44444,
                    0,
                    0
                ],
                46: [
                    0,
                    .15556,
                    0,
                    0
                ],
                47: [
                    .25,
                    .75,
                    0,
                    0
                ],
                48: [
                    0,
                    .64444,
                    0,
                    0
                ],
                49: [
                    0,
                    .64444,
                    0,
                    0
                ],
                50: [
                    0,
                    .64444,
                    0,
                    0
                ],
                51: [
                    0,
                    .64444,
                    0,
                    0
                ],
                52: [
                    0,
                    .64444,
                    0,
                    0
                ],
                53: [
                    0,
                    .64444,
                    0,
                    0
                ],
                54: [
                    0,
                    .64444,
                    0,
                    0
                ],
                55: [
                    0,
                    .64444,
                    0,
                    0
                ],
                56: [
                    0,
                    .64444,
                    0,
                    0
                ],
                57: [
                    0,
                    .64444,
                    0,
                    0
                ],
                58: [
                    0,
                    .44444,
                    0,
                    0
                ],
                59: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                60: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                61: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                62: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                63: [
                    0,
                    .69444,
                    0,
                    0
                ],
                64: [
                    0,
                    .69444,
                    0,
                    0
                ],
                65: [
                    0,
                    .68611,
                    0,
                    0
                ],
                66: [
                    0,
                    .68611,
                    0,
                    0
                ],
                67: [
                    0,
                    .68611,
                    0,
                    0
                ],
                68: [
                    0,
                    .68611,
                    0,
                    0
                ],
                69: [
                    0,
                    .68611,
                    0,
                    0
                ],
                70: [
                    0,
                    .68611,
                    0,
                    0
                ],
                71: [
                    0,
                    .68611,
                    0,
                    0
                ],
                72: [
                    0,
                    .68611,
                    0,
                    0
                ],
                73: [
                    0,
                    .68611,
                    0,
                    0
                ],
                74: [
                    0,
                    .68611,
                    0,
                    0
                ],
                75: [
                    0,
                    .68611,
                    0,
                    0
                ],
                76: [
                    0,
                    .68611,
                    0,
                    0
                ],
                77: [
                    0,
                    .68611,
                    0,
                    0
                ],
                78: [
                    0,
                    .68611,
                    0,
                    0
                ],
                79: [
                    0,
                    .68611,
                    0,
                    0
                ],
                80: [
                    0,
                    .68611,
                    0,
                    0
                ],
                81: [
                    .19444,
                    .68611,
                    0,
                    0
                ],
                82: [
                    0,
                    .68611,
                    0,
                    0
                ],
                83: [
                    0,
                    .68611,
                    0,
                    0
                ],
                84: [
                    0,
                    .68611,
                    0,
                    0
                ],
                85: [
                    0,
                    .68611,
                    0,
                    0
                ],
                86: [
                    0,
                    .68611,
                    .01597,
                    0
                ],
                87: [
                    0,
                    .68611,
                    .01597,
                    0
                ],
                88: [
                    0,
                    .68611,
                    0,
                    0
                ],
                89: [
                    0,
                    .68611,
                    .02875,
                    0
                ],
                90: [
                    0,
                    .68611,
                    0,
                    0
                ],
                91: [
                    .25,
                    .75,
                    0,
                    0
                ],
                92: [
                    .25,
                    .75,
                    0,
                    0
                ],
                93: [
                    .25,
                    .75,
                    0,
                    0
                ],
                94: [
                    0,
                    .69444,
                    0,
                    0
                ],
                95: [
                    .31,
                    .13444,
                    .03194,
                    0
                ],
                96: [
                    0,
                    .69444,
                    0,
                    0
                ],
                97: [
                    0,
                    .44444,
                    0,
                    0
                ],
                98: [
                    0,
                    .69444,
                    0,
                    0
                ],
                99: [
                    0,
                    .44444,
                    0,
                    0
                ],
                100: [
                    0,
                    .69444,
                    0,
                    0
                ],
                101: [
                    0,
                    .44444,
                    0,
                    0
                ],
                102: [
                    0,
                    .69444,
                    .10903,
                    0
                ],
                103: [
                    .19444,
                    .44444,
                    .01597,
                    0
                ],
                104: [
                    0,
                    .69444,
                    0,
                    0
                ],
                105: [
                    0,
                    .69444,
                    0,
                    0
                ],
                106: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                107: [
                    0,
                    .69444,
                    0,
                    0
                ],
                108: [
                    0,
                    .69444,
                    0,
                    0
                ],
                109: [
                    0,
                    .44444,
                    0,
                    0
                ],
                110: [
                    0,
                    .44444,
                    0,
                    0
                ],
                111: [
                    0,
                    .44444,
                    0,
                    0
                ],
                112: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                113: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                114: [
                    0,
                    .44444,
                    0,
                    0
                ],
                115: [
                    0,
                    .44444,
                    0,
                    0
                ],
                116: [
                    0,
                    .63492,
                    0,
                    0
                ],
                117: [
                    0,
                    .44444,
                    0,
                    0
                ],
                118: [
                    0,
                    .44444,
                    .01597,
                    0
                ],
                119: [
                    0,
                    .44444,
                    .01597,
                    0
                ],
                120: [
                    0,
                    .44444,
                    0,
                    0
                ],
                121: [
                    .19444,
                    .44444,
                    .01597,
                    0
                ],
                122: [
                    0,
                    .44444,
                    0,
                    0
                ],
                123: [
                    .25,
                    .75,
                    0,
                    0
                ],
                124: [
                    .25,
                    .75,
                    0,
                    0
                ],
                125: [
                    .25,
                    .75,
                    0,
                    0
                ],
                126: [
                    .35,
                    .34444,
                    0,
                    0
                ],
                168: [
                    0,
                    .69444,
                    0,
                    0
                ],
                172: [
                    0,
                    .44444,
                    0,
                    0
                ],
                175: [
                    0,
                    .59611,
                    0,
                    0
                ],
                176: [
                    0,
                    .69444,
                    0,
                    0
                ],
                177: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                180: [
                    0,
                    .69444,
                    0,
                    0
                ],
                215: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                247: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                305: [
                    0,
                    .44444,
                    0,
                    0
                ],
                567: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                710: [
                    0,
                    .69444,
                    0,
                    0
                ],
                711: [
                    0,
                    .63194,
                    0,
                    0
                ],
                713: [
                    0,
                    .59611,
                    0,
                    0
                ],
                714: [
                    0,
                    .69444,
                    0,
                    0
                ],
                715: [
                    0,
                    .69444,
                    0,
                    0
                ],
                728: [
                    0,
                    .69444,
                    0,
                    0
                ],
                729: [
                    0,
                    .69444,
                    0,
                    0
                ],
                730: [
                    0,
                    .69444,
                    0,
                    0
                ],
                732: [
                    0,
                    .69444,
                    0,
                    0
                ],
                768: [
                    0,
                    .69444,
                    0,
                    0
                ],
                769: [
                    0,
                    .69444,
                    0,
                    0
                ],
                770: [
                    0,
                    .69444,
                    0,
                    0
                ],
                771: [
                    0,
                    .69444,
                    0,
                    0
                ],
                772: [
                    0,
                    .59611,
                    0,
                    0
                ],
                774: [
                    0,
                    .69444,
                    0,
                    0
                ],
                775: [
                    0,
                    .69444,
                    0,
                    0
                ],
                776: [
                    0,
                    .69444,
                    0,
                    0
                ],
                778: [
                    0,
                    .69444,
                    0,
                    0
                ],
                779: [
                    0,
                    .69444,
                    0,
                    0
                ],
                780: [
                    0,
                    .63194,
                    0,
                    0
                ],
                824: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                915: [
                    0,
                    .68611,
                    0,
                    0
                ],
                916: [
                    0,
                    .68611,
                    0,
                    0
                ],
                920: [
                    0,
                    .68611,
                    0,
                    0
                ],
                923: [
                    0,
                    .68611,
                    0,
                    0
                ],
                926: [
                    0,
                    .68611,
                    0,
                    0
                ],
                928: [
                    0,
                    .68611,
                    0,
                    0
                ],
                931: [
                    0,
                    .68611,
                    0,
                    0
                ],
                933: [
                    0,
                    .68611,
                    0,
                    0
                ],
                934: [
                    0,
                    .68611,
                    0,
                    0
                ],
                936: [
                    0,
                    .68611,
                    0,
                    0
                ],
                937: [
                    0,
                    .68611,
                    0,
                    0
                ],
                8211: [
                    0,
                    .44444,
                    .03194,
                    0
                ],
                8212: [
                    0,
                    .44444,
                    .03194,
                    0
                ],
                8216: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8217: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8220: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8221: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8224: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8225: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8242: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8407: [
                    0,
                    .72444,
                    .15486,
                    0
                ],
                8463: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8465: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8467: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8472: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                8476: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8501: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8592: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8593: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8594: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8595: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8596: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8597: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8598: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8599: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8600: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8601: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8636: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8637: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8640: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8641: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8656: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8657: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8658: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8659: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8660: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8661: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8704: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8706: [
                    0,
                    .69444,
                    .06389,
                    0
                ],
                8707: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8709: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                8711: [
                    0,
                    .68611,
                    0,
                    0
                ],
                8712: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8715: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8722: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8723: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8725: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8726: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8727: [
                    -0.02778,
                    .47222,
                    0,
                    0
                ],
                8728: [
                    -0.02639,
                    .47361,
                    0,
                    0
                ],
                8729: [
                    -0.02639,
                    .47361,
                    0,
                    0
                ],
                8730: [
                    .18,
                    .82,
                    0,
                    0
                ],
                8733: [
                    0,
                    .44444,
                    0,
                    0
                ],
                8734: [
                    0,
                    .44444,
                    0,
                    0
                ],
                8736: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8739: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8741: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8743: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8744: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8745: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8746: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8747: [
                    .19444,
                    .69444,
                    .12778,
                    0
                ],
                8764: [
                    -0.10889,
                    .39111,
                    0,
                    0
                ],
                8768: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8771: [
                    .00222,
                    .50222,
                    0,
                    0
                ],
                8776: [
                    .02444,
                    .52444,
                    0,
                    0
                ],
                8781: [
                    .00222,
                    .50222,
                    0,
                    0
                ],
                8801: [
                    .00222,
                    .50222,
                    0,
                    0
                ],
                8804: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                8805: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                8810: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8811: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8826: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8827: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8834: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8835: [
                    .08556,
                    .58556,
                    0,
                    0
                ],
                8838: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                8839: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                8846: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8849: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                8850: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                8851: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8852: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8853: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8854: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8855: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8856: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8857: [
                    .13333,
                    .63333,
                    0,
                    0
                ],
                8866: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8867: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8868: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8869: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8900: [
                    -0.02639,
                    .47361,
                    0,
                    0
                ],
                8901: [
                    -0.02639,
                    .47361,
                    0,
                    0
                ],
                8902: [
                    -0.02778,
                    .47222,
                    0,
                    0
                ],
                8968: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8969: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8970: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8971: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8994: [
                    -0.13889,
                    .36111,
                    0,
                    0
                ],
                8995: [
                    -0.13889,
                    .36111,
                    0,
                    0
                ],
                9651: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9657: [
                    -0.02778,
                    .47222,
                    0,
                    0
                ],
                9661: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9667: [
                    -0.02778,
                    .47222,
                    0,
                    0
                ],
                9711: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9824: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9825: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9826: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9827: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9837: [
                    0,
                    .75,
                    0,
                    0
                ],
                9838: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9839: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                10216: [
                    .25,
                    .75,
                    0,
                    0
                ],
                10217: [
                    .25,
                    .75,
                    0,
                    0
                ],
                10815: [
                    0,
                    .68611,
                    0,
                    0
                ],
                10927: [
                    .19667,
                    .69667,
                    0,
                    0
                ],
                10928: [
                    .19667,
                    .69667,
                    0,
                    0
                ]
            },
            "Main-Italic": {
                33: [
                    0,
                    .69444,
                    .12417,
                    0
                ],
                34: [
                    0,
                    .69444,
                    .06961,
                    0
                ],
                35: [
                    .19444,
                    .69444,
                    .06616,
                    0
                ],
                37: [
                    .05556,
                    .75,
                    .13639,
                    0
                ],
                38: [
                    0,
                    .69444,
                    .09694,
                    0
                ],
                39: [
                    0,
                    .69444,
                    .12417,
                    0
                ],
                40: [
                    .25,
                    .75,
                    .16194,
                    0
                ],
                41: [
                    .25,
                    .75,
                    .03694,
                    0
                ],
                42: [
                    0,
                    .75,
                    .14917,
                    0
                ],
                43: [
                    .05667,
                    .56167,
                    .03694,
                    0
                ],
                44: [
                    .19444,
                    .10556,
                    0,
                    0
                ],
                45: [
                    0,
                    .43056,
                    .02826,
                    0
                ],
                46: [
                    0,
                    .10556,
                    0,
                    0
                ],
                47: [
                    .25,
                    .75,
                    .16194,
                    0
                ],
                48: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                49: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                50: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                51: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                52: [
                    .19444,
                    .64444,
                    .13556,
                    0
                ],
                53: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                54: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                55: [
                    .19444,
                    .64444,
                    .13556,
                    0
                ],
                56: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                57: [
                    0,
                    .64444,
                    .13556,
                    0
                ],
                58: [
                    0,
                    .43056,
                    .0582,
                    0
                ],
                59: [
                    .19444,
                    .43056,
                    .0582,
                    0
                ],
                61: [
                    -0.13313,
                    .36687,
                    .06616,
                    0
                ],
                63: [
                    0,
                    .69444,
                    .1225,
                    0
                ],
                64: [
                    0,
                    .69444,
                    .09597,
                    0
                ],
                65: [
                    0,
                    .68333,
                    0,
                    0
                ],
                66: [
                    0,
                    .68333,
                    .10257,
                    0
                ],
                67: [
                    0,
                    .68333,
                    .14528,
                    0
                ],
                68: [
                    0,
                    .68333,
                    .09403,
                    0
                ],
                69: [
                    0,
                    .68333,
                    .12028,
                    0
                ],
                70: [
                    0,
                    .68333,
                    .13305,
                    0
                ],
                71: [
                    0,
                    .68333,
                    .08722,
                    0
                ],
                72: [
                    0,
                    .68333,
                    .16389,
                    0
                ],
                73: [
                    0,
                    .68333,
                    .15806,
                    0
                ],
                74: [
                    0,
                    .68333,
                    .14028,
                    0
                ],
                75: [
                    0,
                    .68333,
                    .14528,
                    0
                ],
                76: [
                    0,
                    .68333,
                    0,
                    0
                ],
                77: [
                    0,
                    .68333,
                    .16389,
                    0
                ],
                78: [
                    0,
                    .68333,
                    .16389,
                    0
                ],
                79: [
                    0,
                    .68333,
                    .09403,
                    0
                ],
                80: [
                    0,
                    .68333,
                    .10257,
                    0
                ],
                81: [
                    .19444,
                    .68333,
                    .09403,
                    0
                ],
                82: [
                    0,
                    .68333,
                    .03868,
                    0
                ],
                83: [
                    0,
                    .68333,
                    .11972,
                    0
                ],
                84: [
                    0,
                    .68333,
                    .13305,
                    0
                ],
                85: [
                    0,
                    .68333,
                    .16389,
                    0
                ],
                86: [
                    0,
                    .68333,
                    .18361,
                    0
                ],
                87: [
                    0,
                    .68333,
                    .18361,
                    0
                ],
                88: [
                    0,
                    .68333,
                    .15806,
                    0
                ],
                89: [
                    0,
                    .68333,
                    .19383,
                    0
                ],
                90: [
                    0,
                    .68333,
                    .14528,
                    0
                ],
                91: [
                    .25,
                    .75,
                    .1875,
                    0
                ],
                93: [
                    .25,
                    .75,
                    .10528,
                    0
                ],
                94: [
                    0,
                    .69444,
                    .06646,
                    0
                ],
                95: [
                    .31,
                    .12056,
                    .09208,
                    0
                ],
                97: [
                    0,
                    .43056,
                    .07671,
                    0
                ],
                98: [
                    0,
                    .69444,
                    .06312,
                    0
                ],
                99: [
                    0,
                    .43056,
                    .05653,
                    0
                ],
                100: [
                    0,
                    .69444,
                    .10333,
                    0
                ],
                101: [
                    0,
                    .43056,
                    .07514,
                    0
                ],
                102: [
                    .19444,
                    .69444,
                    .21194,
                    0
                ],
                103: [
                    .19444,
                    .43056,
                    .08847,
                    0
                ],
                104: [
                    0,
                    .69444,
                    .07671,
                    0
                ],
                105: [
                    0,
                    .65536,
                    .1019,
                    0
                ],
                106: [
                    .19444,
                    .65536,
                    .14467,
                    0
                ],
                107: [
                    0,
                    .69444,
                    .10764,
                    0
                ],
                108: [
                    0,
                    .69444,
                    .10333,
                    0
                ],
                109: [
                    0,
                    .43056,
                    .07671,
                    0
                ],
                110: [
                    0,
                    .43056,
                    .07671,
                    0
                ],
                111: [
                    0,
                    .43056,
                    .06312,
                    0
                ],
                112: [
                    .19444,
                    .43056,
                    .06312,
                    0
                ],
                113: [
                    .19444,
                    .43056,
                    .08847,
                    0
                ],
                114: [
                    0,
                    .43056,
                    .10764,
                    0
                ],
                115: [
                    0,
                    .43056,
                    .08208,
                    0
                ],
                116: [
                    0,
                    .61508,
                    .09486,
                    0
                ],
                117: [
                    0,
                    .43056,
                    .07671,
                    0
                ],
                118: [
                    0,
                    .43056,
                    .10764,
                    0
                ],
                119: [
                    0,
                    .43056,
                    .10764,
                    0
                ],
                120: [
                    0,
                    .43056,
                    .12042,
                    0
                ],
                121: [
                    .19444,
                    .43056,
                    .08847,
                    0
                ],
                122: [
                    0,
                    .43056,
                    .12292,
                    0
                ],
                126: [
                    .35,
                    .31786,
                    .11585,
                    0
                ],
                163: [
                    0,
                    .69444,
                    0,
                    0
                ],
                305: [
                    0,
                    .43056,
                    0,
                    .02778
                ],
                567: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                768: [
                    0,
                    .69444,
                    0,
                    0
                ],
                769: [
                    0,
                    .69444,
                    .09694,
                    0
                ],
                770: [
                    0,
                    .69444,
                    .06646,
                    0
                ],
                771: [
                    0,
                    .66786,
                    .11585,
                    0
                ],
                772: [
                    0,
                    .56167,
                    .10333,
                    0
                ],
                774: [
                    0,
                    .69444,
                    .10806,
                    0
                ],
                775: [
                    0,
                    .66786,
                    .11752,
                    0
                ],
                776: [
                    0,
                    .66786,
                    .10474,
                    0
                ],
                778: [
                    0,
                    .69444,
                    0,
                    0
                ],
                779: [
                    0,
                    .69444,
                    .1225,
                    0
                ],
                780: [
                    0,
                    .62847,
                    .08295,
                    0
                ],
                915: [
                    0,
                    .68333,
                    .13305,
                    0
                ],
                916: [
                    0,
                    .68333,
                    0,
                    0
                ],
                920: [
                    0,
                    .68333,
                    .09403,
                    0
                ],
                923: [
                    0,
                    .68333,
                    0,
                    0
                ],
                926: [
                    0,
                    .68333,
                    .15294,
                    0
                ],
                928: [
                    0,
                    .68333,
                    .16389,
                    0
                ],
                931: [
                    0,
                    .68333,
                    .12028,
                    0
                ],
                933: [
                    0,
                    .68333,
                    .11111,
                    0
                ],
                934: [
                    0,
                    .68333,
                    .05986,
                    0
                ],
                936: [
                    0,
                    .68333,
                    .11111,
                    0
                ],
                937: [
                    0,
                    .68333,
                    .10257,
                    0
                ],
                8211: [
                    0,
                    .43056,
                    .09208,
                    0
                ],
                8212: [
                    0,
                    .43056,
                    .09208,
                    0
                ],
                8216: [
                    0,
                    .69444,
                    .12417,
                    0
                ],
                8217: [
                    0,
                    .69444,
                    .12417,
                    0
                ],
                8220: [
                    0,
                    .69444,
                    .1685,
                    0
                ],
                8221: [
                    0,
                    .69444,
                    .06961,
                    0
                ],
                8463: [
                    0,
                    .68889,
                    0,
                    0
                ]
            },
            "Main-Regular": {
                32: [
                    0,
                    0,
                    0,
                    0
                ],
                33: [
                    0,
                    .69444,
                    0,
                    0
                ],
                34: [
                    0,
                    .69444,
                    0,
                    0
                ],
                35: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                36: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                37: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                38: [
                    0,
                    .69444,
                    0,
                    0
                ],
                39: [
                    0,
                    .69444,
                    0,
                    0
                ],
                40: [
                    .25,
                    .75,
                    0,
                    0
                ],
                41: [
                    .25,
                    .75,
                    0,
                    0
                ],
                42: [
                    0,
                    .75,
                    0,
                    0
                ],
                43: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                44: [
                    .19444,
                    .10556,
                    0,
                    0
                ],
                45: [
                    0,
                    .43056,
                    0,
                    0
                ],
                46: [
                    0,
                    .10556,
                    0,
                    0
                ],
                47: [
                    .25,
                    .75,
                    0,
                    0
                ],
                48: [
                    0,
                    .64444,
                    0,
                    0
                ],
                49: [
                    0,
                    .64444,
                    0,
                    0
                ],
                50: [
                    0,
                    .64444,
                    0,
                    0
                ],
                51: [
                    0,
                    .64444,
                    0,
                    0
                ],
                52: [
                    0,
                    .64444,
                    0,
                    0
                ],
                53: [
                    0,
                    .64444,
                    0,
                    0
                ],
                54: [
                    0,
                    .64444,
                    0,
                    0
                ],
                55: [
                    0,
                    .64444,
                    0,
                    0
                ],
                56: [
                    0,
                    .64444,
                    0,
                    0
                ],
                57: [
                    0,
                    .64444,
                    0,
                    0
                ],
                58: [
                    0,
                    .43056,
                    0,
                    0
                ],
                59: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                60: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                61: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                62: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                63: [
                    0,
                    .69444,
                    0,
                    0
                ],
                64: [
                    0,
                    .69444,
                    0,
                    0
                ],
                65: [
                    0,
                    .68333,
                    0,
                    0
                ],
                66: [
                    0,
                    .68333,
                    0,
                    0
                ],
                67: [
                    0,
                    .68333,
                    0,
                    0
                ],
                68: [
                    0,
                    .68333,
                    0,
                    0
                ],
                69: [
                    0,
                    .68333,
                    0,
                    0
                ],
                70: [
                    0,
                    .68333,
                    0,
                    0
                ],
                71: [
                    0,
                    .68333,
                    0,
                    0
                ],
                72: [
                    0,
                    .68333,
                    0,
                    0
                ],
                73: [
                    0,
                    .68333,
                    0,
                    0
                ],
                74: [
                    0,
                    .68333,
                    0,
                    0
                ],
                75: [
                    0,
                    .68333,
                    0,
                    0
                ],
                76: [
                    0,
                    .68333,
                    0,
                    0
                ],
                77: [
                    0,
                    .68333,
                    0,
                    0
                ],
                78: [
                    0,
                    .68333,
                    0,
                    0
                ],
                79: [
                    0,
                    .68333,
                    0,
                    0
                ],
                80: [
                    0,
                    .68333,
                    0,
                    0
                ],
                81: [
                    .19444,
                    .68333,
                    0,
                    0
                ],
                82: [
                    0,
                    .68333,
                    0,
                    0
                ],
                83: [
                    0,
                    .68333,
                    0,
                    0
                ],
                84: [
                    0,
                    .68333,
                    0,
                    0
                ],
                85: [
                    0,
                    .68333,
                    0,
                    0
                ],
                86: [
                    0,
                    .68333,
                    .01389,
                    0
                ],
                87: [
                    0,
                    .68333,
                    .01389,
                    0
                ],
                88: [
                    0,
                    .68333,
                    0,
                    0
                ],
                89: [
                    0,
                    .68333,
                    .025,
                    0
                ],
                90: [
                    0,
                    .68333,
                    0,
                    0
                ],
                91: [
                    .25,
                    .75,
                    0,
                    0
                ],
                92: [
                    .25,
                    .75,
                    0,
                    0
                ],
                93: [
                    .25,
                    .75,
                    0,
                    0
                ],
                94: [
                    0,
                    .69444,
                    0,
                    0
                ],
                95: [
                    .31,
                    .12056,
                    .02778,
                    0
                ],
                96: [
                    0,
                    .69444,
                    0,
                    0
                ],
                97: [
                    0,
                    .43056,
                    0,
                    0
                ],
                98: [
                    0,
                    .69444,
                    0,
                    0
                ],
                99: [
                    0,
                    .43056,
                    0,
                    0
                ],
                100: [
                    0,
                    .69444,
                    0,
                    0
                ],
                101: [
                    0,
                    .43056,
                    0,
                    0
                ],
                102: [
                    0,
                    .69444,
                    .07778,
                    0
                ],
                103: [
                    .19444,
                    .43056,
                    .01389,
                    0
                ],
                104: [
                    0,
                    .69444,
                    0,
                    0
                ],
                105: [
                    0,
                    .66786,
                    0,
                    0
                ],
                106: [
                    .19444,
                    .66786,
                    0,
                    0
                ],
                107: [
                    0,
                    .69444,
                    0,
                    0
                ],
                108: [
                    0,
                    .69444,
                    0,
                    0
                ],
                109: [
                    0,
                    .43056,
                    0,
                    0
                ],
                110: [
                    0,
                    .43056,
                    0,
                    0
                ],
                111: [
                    0,
                    .43056,
                    0,
                    0
                ],
                112: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                113: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                114: [
                    0,
                    .43056,
                    0,
                    0
                ],
                115: [
                    0,
                    .43056,
                    0,
                    0
                ],
                116: [
                    0,
                    .61508,
                    0,
                    0
                ],
                117: [
                    0,
                    .43056,
                    0,
                    0
                ],
                118: [
                    0,
                    .43056,
                    .01389,
                    0
                ],
                119: [
                    0,
                    .43056,
                    .01389,
                    0
                ],
                120: [
                    0,
                    .43056,
                    0,
                    0
                ],
                121: [
                    .19444,
                    .43056,
                    .01389,
                    0
                ],
                122: [
                    0,
                    .43056,
                    0,
                    0
                ],
                123: [
                    .25,
                    .75,
                    0,
                    0
                ],
                124: [
                    .25,
                    .75,
                    0,
                    0
                ],
                125: [
                    .25,
                    .75,
                    0,
                    0
                ],
                126: [
                    .35,
                    .31786,
                    0,
                    0
                ],
                160: [
                    0,
                    0,
                    0,
                    0
                ],
                168: [
                    0,
                    .66786,
                    0,
                    0
                ],
                172: [
                    0,
                    .43056,
                    0,
                    0
                ],
                175: [
                    0,
                    .56778,
                    0,
                    0
                ],
                176: [
                    0,
                    .69444,
                    0,
                    0
                ],
                177: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                180: [
                    0,
                    .69444,
                    0,
                    0
                ],
                215: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                247: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                305: [
                    0,
                    .43056,
                    0,
                    0
                ],
                567: [
                    .19444,
                    .43056,
                    0,
                    0
                ],
                710: [
                    0,
                    .69444,
                    0,
                    0
                ],
                711: [
                    0,
                    .62847,
                    0,
                    0
                ],
                713: [
                    0,
                    .56778,
                    0,
                    0
                ],
                714: [
                    0,
                    .69444,
                    0,
                    0
                ],
                715: [
                    0,
                    .69444,
                    0,
                    0
                ],
                728: [
                    0,
                    .69444,
                    0,
                    0
                ],
                729: [
                    0,
                    .66786,
                    0,
                    0
                ],
                730: [
                    0,
                    .69444,
                    0,
                    0
                ],
                732: [
                    0,
                    .66786,
                    0,
                    0
                ],
                768: [
                    0,
                    .69444,
                    0,
                    0
                ],
                769: [
                    0,
                    .69444,
                    0,
                    0
                ],
                770: [
                    0,
                    .69444,
                    0,
                    0
                ],
                771: [
                    0,
                    .66786,
                    0,
                    0
                ],
                772: [
                    0,
                    .56778,
                    0,
                    0
                ],
                774: [
                    0,
                    .69444,
                    0,
                    0
                ],
                775: [
                    0,
                    .66786,
                    0,
                    0
                ],
                776: [
                    0,
                    .66786,
                    0,
                    0
                ],
                778: [
                    0,
                    .69444,
                    0,
                    0
                ],
                779: [
                    0,
                    .69444,
                    0,
                    0
                ],
                780: [
                    0,
                    .62847,
                    0,
                    0
                ],
                824: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                915: [
                    0,
                    .68333,
                    0,
                    0
                ],
                916: [
                    0,
                    .68333,
                    0,
                    0
                ],
                920: [
                    0,
                    .68333,
                    0,
                    0
                ],
                923: [
                    0,
                    .68333,
                    0,
                    0
                ],
                926: [
                    0,
                    .68333,
                    0,
                    0
                ],
                928: [
                    0,
                    .68333,
                    0,
                    0
                ],
                931: [
                    0,
                    .68333,
                    0,
                    0
                ],
                933: [
                    0,
                    .68333,
                    0,
                    0
                ],
                934: [
                    0,
                    .68333,
                    0,
                    0
                ],
                936: [
                    0,
                    .68333,
                    0,
                    0
                ],
                937: [
                    0,
                    .68333,
                    0,
                    0
                ],
                8211: [
                    0,
                    .43056,
                    .02778,
                    0
                ],
                8212: [
                    0,
                    .43056,
                    .02778,
                    0
                ],
                8216: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8217: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8220: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8221: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8224: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8225: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8230: [
                    0,
                    .12,
                    0,
                    0
                ],
                8242: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8407: [
                    0,
                    .71444,
                    .15382,
                    0
                ],
                8463: [
                    0,
                    .68889,
                    0,
                    0
                ],
                8465: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8467: [
                    0,
                    .69444,
                    0,
                    .11111
                ],
                8472: [
                    .19444,
                    .43056,
                    0,
                    .11111
                ],
                8476: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8501: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8592: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8593: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8594: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8595: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8596: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8597: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8598: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8599: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8600: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8601: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8614: [
                    .011,
                    .511,
                    0,
                    0
                ],
                8617: [
                    .011,
                    .511,
                    0,
                    0
                ],
                8618: [
                    .011,
                    .511,
                    0,
                    0
                ],
                8636: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8637: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8640: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8641: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8652: [
                    .011,
                    .671,
                    0,
                    0
                ],
                8656: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8657: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8658: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8659: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8660: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8661: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8704: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8706: [
                    0,
                    .69444,
                    .05556,
                    .08334
                ],
                8707: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8709: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                8711: [
                    0,
                    .68333,
                    0,
                    0
                ],
                8712: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8715: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8722: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8723: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8725: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8726: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8727: [
                    -0.03472,
                    .46528,
                    0,
                    0
                ],
                8728: [
                    -0.05555,
                    .44445,
                    0,
                    0
                ],
                8729: [
                    -0.05555,
                    .44445,
                    0,
                    0
                ],
                8730: [
                    .2,
                    .8,
                    0,
                    0
                ],
                8733: [
                    0,
                    .43056,
                    0,
                    0
                ],
                8734: [
                    0,
                    .43056,
                    0,
                    0
                ],
                8736: [
                    0,
                    .69224,
                    0,
                    0
                ],
                8739: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8741: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8743: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8744: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8745: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8746: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8747: [
                    .19444,
                    .69444,
                    .11111,
                    0
                ],
                8764: [
                    -0.13313,
                    .36687,
                    0,
                    0
                ],
                8768: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                8771: [
                    -0.03625,
                    .46375,
                    0,
                    0
                ],
                8773: [
                    -0.022,
                    .589,
                    0,
                    0
                ],
                8776: [
                    -0.01688,
                    .48312,
                    0,
                    0
                ],
                8781: [
                    -0.03625,
                    .46375,
                    0,
                    0
                ],
                8784: [
                    -0.133,
                    .67,
                    0,
                    0
                ],
                8800: [
                    .215,
                    .716,
                    0,
                    0
                ],
                8801: [
                    -0.03625,
                    .46375,
                    0,
                    0
                ],
                8804: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8805: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8810: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8811: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8826: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8827: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8834: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8835: [
                    .0391,
                    .5391,
                    0,
                    0
                ],
                8838: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8839: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8846: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8849: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8850: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                8851: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8852: [
                    0,
                    .55556,
                    0,
                    0
                ],
                8853: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8854: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8855: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8856: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8857: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                8866: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8867: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8868: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8869: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8872: [
                    .249,
                    .75,
                    0,
                    0
                ],
                8900: [
                    -0.05555,
                    .44445,
                    0,
                    0
                ],
                8901: [
                    -0.05555,
                    .44445,
                    0,
                    0
                ],
                8902: [
                    -0.03472,
                    .46528,
                    0,
                    0
                ],
                8904: [
                    .005,
                    .505,
                    0,
                    0
                ],
                8942: [
                    .03,
                    .9,
                    0,
                    0
                ],
                8943: [
                    -0.19,
                    .31,
                    0,
                    0
                ],
                8945: [
                    -0.1,
                    .82,
                    0,
                    0
                ],
                8968: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8969: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8970: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8971: [
                    .25,
                    .75,
                    0,
                    0
                ],
                8994: [
                    -0.14236,
                    .35764,
                    0,
                    0
                ],
                8995: [
                    -0.14236,
                    .35764,
                    0,
                    0
                ],
                9136: [
                    .244,
                    .744,
                    0,
                    0
                ],
                9137: [
                    .244,
                    .744,
                    0,
                    0
                ],
                9651: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9657: [
                    -0.03472,
                    .46528,
                    0,
                    0
                ],
                9661: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9667: [
                    -0.03472,
                    .46528,
                    0,
                    0
                ],
                9711: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9824: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9825: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9826: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9827: [
                    .12963,
                    .69444,
                    0,
                    0
                ],
                9837: [
                    0,
                    .75,
                    0,
                    0
                ],
                9838: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                9839: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                10216: [
                    .25,
                    .75,
                    0,
                    0
                ],
                10217: [
                    .25,
                    .75,
                    0,
                    0
                ],
                10222: [
                    .244,
                    .744,
                    0,
                    0
                ],
                10223: [
                    .244,
                    .744,
                    0,
                    0
                ],
                10229: [
                    .011,
                    .511,
                    0,
                    0
                ],
                10230: [
                    .011,
                    .511,
                    0,
                    0
                ],
                10231: [
                    .011,
                    .511,
                    0,
                    0
                ],
                10232: [
                    .024,
                    .525,
                    0,
                    0
                ],
                10233: [
                    .024,
                    .525,
                    0,
                    0
                ],
                10234: [
                    .024,
                    .525,
                    0,
                    0
                ],
                10236: [
                    .011,
                    .511,
                    0,
                    0
                ],
                10815: [
                    0,
                    .68333,
                    0,
                    0
                ],
                10927: [
                    .13597,
                    .63597,
                    0,
                    0
                ],
                10928: [
                    .13597,
                    .63597,
                    0,
                    0
                ]
            },
            "Math-BoldItalic": {
                47: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                65: [
                    0,
                    .68611,
                    0,
                    0
                ],
                66: [
                    0,
                    .68611,
                    .04835,
                    0
                ],
                67: [
                    0,
                    .68611,
                    .06979,
                    0
                ],
                68: [
                    0,
                    .68611,
                    .03194,
                    0
                ],
                69: [
                    0,
                    .68611,
                    .05451,
                    0
                ],
                70: [
                    0,
                    .68611,
                    .15972,
                    0
                ],
                71: [
                    0,
                    .68611,
                    0,
                    0
                ],
                72: [
                    0,
                    .68611,
                    .08229,
                    0
                ],
                73: [
                    0,
                    .68611,
                    .07778,
                    0
                ],
                74: [
                    0,
                    .68611,
                    .10069,
                    0
                ],
                75: [
                    0,
                    .68611,
                    .06979,
                    0
                ],
                76: [
                    0,
                    .68611,
                    0,
                    0
                ],
                77: [
                    0,
                    .68611,
                    .11424,
                    0
                ],
                78: [
                    0,
                    .68611,
                    .11424,
                    0
                ],
                79: [
                    0,
                    .68611,
                    .03194,
                    0
                ],
                80: [
                    0,
                    .68611,
                    .15972,
                    0
                ],
                81: [
                    .19444,
                    .68611,
                    0,
                    0
                ],
                82: [
                    0,
                    .68611,
                    .00421,
                    0
                ],
                83: [
                    0,
                    .68611,
                    .05382,
                    0
                ],
                84: [
                    0,
                    .68611,
                    .15972,
                    0
                ],
                85: [
                    0,
                    .68611,
                    .11424,
                    0
                ],
                86: [
                    0,
                    .68611,
                    .25555,
                    0
                ],
                87: [
                    0,
                    .68611,
                    .15972,
                    0
                ],
                88: [
                    0,
                    .68611,
                    .07778,
                    0
                ],
                89: [
                    0,
                    .68611,
                    .25555,
                    0
                ],
                90: [
                    0,
                    .68611,
                    .06979,
                    0
                ],
                97: [
                    0,
                    .44444,
                    0,
                    0
                ],
                98: [
                    0,
                    .69444,
                    0,
                    0
                ],
                99: [
                    0,
                    .44444,
                    0,
                    0
                ],
                100: [
                    0,
                    .69444,
                    0,
                    0
                ],
                101: [
                    0,
                    .44444,
                    0,
                    0
                ],
                102: [
                    .19444,
                    .69444,
                    .11042,
                    0
                ],
                103: [
                    .19444,
                    .44444,
                    .03704,
                    0
                ],
                104: [
                    0,
                    .69444,
                    0,
                    0
                ],
                105: [
                    0,
                    .69326,
                    0,
                    0
                ],
                106: [
                    .19444,
                    .69326,
                    .0622,
                    0
                ],
                107: [
                    0,
                    .69444,
                    .01852,
                    0
                ],
                108: [
                    0,
                    .69444,
                    .0088,
                    0
                ],
                109: [
                    0,
                    .44444,
                    0,
                    0
                ],
                110: [
                    0,
                    .44444,
                    0,
                    0
                ],
                111: [
                    0,
                    .44444,
                    0,
                    0
                ],
                112: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                113: [
                    .19444,
                    .44444,
                    .03704,
                    0
                ],
                114: [
                    0,
                    .44444,
                    .03194,
                    0
                ],
                115: [
                    0,
                    .44444,
                    0,
                    0
                ],
                116: [
                    0,
                    .63492,
                    0,
                    0
                ],
                117: [
                    0,
                    .44444,
                    0,
                    0
                ],
                118: [
                    0,
                    .44444,
                    .03704,
                    0
                ],
                119: [
                    0,
                    .44444,
                    .02778,
                    0
                ],
                120: [
                    0,
                    .44444,
                    0,
                    0
                ],
                121: [
                    .19444,
                    .44444,
                    .03704,
                    0
                ],
                122: [
                    0,
                    .44444,
                    .04213,
                    0
                ],
                915: [
                    0,
                    .68611,
                    .15972,
                    0
                ],
                916: [
                    0,
                    .68611,
                    0,
                    0
                ],
                920: [
                    0,
                    .68611,
                    .03194,
                    0
                ],
                923: [
                    0,
                    .68611,
                    0,
                    0
                ],
                926: [
                    0,
                    .68611,
                    .07458,
                    0
                ],
                928: [
                    0,
                    .68611,
                    .08229,
                    0
                ],
                931: [
                    0,
                    .68611,
                    .05451,
                    0
                ],
                933: [
                    0,
                    .68611,
                    .15972,
                    0
                ],
                934: [
                    0,
                    .68611,
                    0,
                    0
                ],
                936: [
                    0,
                    .68611,
                    .11653,
                    0
                ],
                937: [
                    0,
                    .68611,
                    .04835,
                    0
                ],
                945: [
                    0,
                    .44444,
                    0,
                    0
                ],
                946: [
                    .19444,
                    .69444,
                    .03403,
                    0
                ],
                947: [
                    .19444,
                    .44444,
                    .06389,
                    0
                ],
                948: [
                    0,
                    .69444,
                    .03819,
                    0
                ],
                949: [
                    0,
                    .44444,
                    0,
                    0
                ],
                950: [
                    .19444,
                    .69444,
                    .06215,
                    0
                ],
                951: [
                    .19444,
                    .44444,
                    .03704,
                    0
                ],
                952: [
                    0,
                    .69444,
                    .03194,
                    0
                ],
                953: [
                    0,
                    .44444,
                    0,
                    0
                ],
                954: [
                    0,
                    .44444,
                    0,
                    0
                ],
                955: [
                    0,
                    .69444,
                    0,
                    0
                ],
                956: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                957: [
                    0,
                    .44444,
                    .06898,
                    0
                ],
                958: [
                    .19444,
                    .69444,
                    .03021,
                    0
                ],
                959: [
                    0,
                    .44444,
                    0,
                    0
                ],
                960: [
                    0,
                    .44444,
                    .03704,
                    0
                ],
                961: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                962: [
                    .09722,
                    .44444,
                    .07917,
                    0
                ],
                963: [
                    0,
                    .44444,
                    .03704,
                    0
                ],
                964: [
                    0,
                    .44444,
                    .13472,
                    0
                ],
                965: [
                    0,
                    .44444,
                    .03704,
                    0
                ],
                966: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                967: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                968: [
                    .19444,
                    .69444,
                    .03704,
                    0
                ],
                969: [
                    0,
                    .44444,
                    .03704,
                    0
                ],
                977: [
                    0,
                    .69444,
                    0,
                    0
                ],
                981: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                982: [
                    0,
                    .44444,
                    .03194,
                    0
                ],
                1009: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                1013: [
                    0,
                    .44444,
                    0,
                    0
                ]
            },
            "Math-Italic": {
                47: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                65: [
                    0,
                    .68333,
                    0,
                    .13889
                ],
                66: [
                    0,
                    .68333,
                    .05017,
                    .08334
                ],
                67: [
                    0,
                    .68333,
                    .07153,
                    .08334
                ],
                68: [
                    0,
                    .68333,
                    .02778,
                    .05556
                ],
                69: [
                    0,
                    .68333,
                    .05764,
                    .08334
                ],
                70: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                71: [
                    0,
                    .68333,
                    0,
                    .08334
                ],
                72: [
                    0,
                    .68333,
                    .08125,
                    .05556
                ],
                73: [
                    0,
                    .68333,
                    .07847,
                    .11111
                ],
                74: [
                    0,
                    .68333,
                    .09618,
                    .16667
                ],
                75: [
                    0,
                    .68333,
                    .07153,
                    .05556
                ],
                76: [
                    0,
                    .68333,
                    0,
                    .02778
                ],
                77: [
                    0,
                    .68333,
                    .10903,
                    .08334
                ],
                78: [
                    0,
                    .68333,
                    .10903,
                    .08334
                ],
                79: [
                    0,
                    .68333,
                    .02778,
                    .08334
                ],
                80: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                81: [
                    .19444,
                    .68333,
                    0,
                    .08334
                ],
                82: [
                    0,
                    .68333,
                    .00773,
                    .08334
                ],
                83: [
                    0,
                    .68333,
                    .05764,
                    .08334
                ],
                84: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                85: [
                    0,
                    .68333,
                    .10903,
                    .02778
                ],
                86: [
                    0,
                    .68333,
                    .22222,
                    0
                ],
                87: [
                    0,
                    .68333,
                    .13889,
                    0
                ],
                88: [
                    0,
                    .68333,
                    .07847,
                    .08334
                ],
                89: [
                    0,
                    .68333,
                    .22222,
                    0
                ],
                90: [
                    0,
                    .68333,
                    .07153,
                    .08334
                ],
                97: [
                    0,
                    .43056,
                    0,
                    0
                ],
                98: [
                    0,
                    .69444,
                    0,
                    0
                ],
                99: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                100: [
                    0,
                    .69444,
                    0,
                    .16667
                ],
                101: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                102: [
                    .19444,
                    .69444,
                    .10764,
                    .16667
                ],
                103: [
                    .19444,
                    .43056,
                    .03588,
                    .02778
                ],
                104: [
                    0,
                    .69444,
                    0,
                    0
                ],
                105: [
                    0,
                    .65952,
                    0,
                    0
                ],
                106: [
                    .19444,
                    .65952,
                    .05724,
                    0
                ],
                107: [
                    0,
                    .69444,
                    .03148,
                    0
                ],
                108: [
                    0,
                    .69444,
                    .01968,
                    .08334
                ],
                109: [
                    0,
                    .43056,
                    0,
                    0
                ],
                110: [
                    0,
                    .43056,
                    0,
                    0
                ],
                111: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                112: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                113: [
                    .19444,
                    .43056,
                    .03588,
                    .08334
                ],
                114: [
                    0,
                    .43056,
                    .02778,
                    .05556
                ],
                115: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                116: [
                    0,
                    .61508,
                    0,
                    .08334
                ],
                117: [
                    0,
                    .43056,
                    0,
                    .02778
                ],
                118: [
                    0,
                    .43056,
                    .03588,
                    .02778
                ],
                119: [
                    0,
                    .43056,
                    .02691,
                    .08334
                ],
                120: [
                    0,
                    .43056,
                    0,
                    .02778
                ],
                121: [
                    .19444,
                    .43056,
                    .03588,
                    .05556
                ],
                122: [
                    0,
                    .43056,
                    .04398,
                    .05556
                ],
                915: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                916: [
                    0,
                    .68333,
                    0,
                    .16667
                ],
                920: [
                    0,
                    .68333,
                    .02778,
                    .08334
                ],
                923: [
                    0,
                    .68333,
                    0,
                    .16667
                ],
                926: [
                    0,
                    .68333,
                    .07569,
                    .08334
                ],
                928: [
                    0,
                    .68333,
                    .08125,
                    .05556
                ],
                931: [
                    0,
                    .68333,
                    .05764,
                    .08334
                ],
                933: [
                    0,
                    .68333,
                    .13889,
                    .05556
                ],
                934: [
                    0,
                    .68333,
                    0,
                    .08334
                ],
                936: [
                    0,
                    .68333,
                    .11,
                    .05556
                ],
                937: [
                    0,
                    .68333,
                    .05017,
                    .08334
                ],
                945: [
                    0,
                    .43056,
                    .0037,
                    .02778
                ],
                946: [
                    .19444,
                    .69444,
                    .05278,
                    .08334
                ],
                947: [
                    .19444,
                    .43056,
                    .05556,
                    0
                ],
                948: [
                    0,
                    .69444,
                    .03785,
                    .05556
                ],
                949: [
                    0,
                    .43056,
                    0,
                    .08334
                ],
                950: [
                    .19444,
                    .69444,
                    .07378,
                    .08334
                ],
                951: [
                    .19444,
                    .43056,
                    .03588,
                    .05556
                ],
                952: [
                    0,
                    .69444,
                    .02778,
                    .08334
                ],
                953: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                954: [
                    0,
                    .43056,
                    0,
                    0
                ],
                955: [
                    0,
                    .69444,
                    0,
                    0
                ],
                956: [
                    .19444,
                    .43056,
                    0,
                    .02778
                ],
                957: [
                    0,
                    .43056,
                    .06366,
                    .02778
                ],
                958: [
                    .19444,
                    .69444,
                    .04601,
                    .11111
                ],
                959: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                960: [
                    0,
                    .43056,
                    .03588,
                    0
                ],
                961: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                962: [
                    .09722,
                    .43056,
                    .07986,
                    .08334
                ],
                963: [
                    0,
                    .43056,
                    .03588,
                    0
                ],
                964: [
                    0,
                    .43056,
                    .1132,
                    .02778
                ],
                965: [
                    0,
                    .43056,
                    .03588,
                    .02778
                ],
                966: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                967: [
                    .19444,
                    .43056,
                    0,
                    .05556
                ],
                968: [
                    .19444,
                    .69444,
                    .03588,
                    .11111
                ],
                969: [
                    0,
                    .43056,
                    .03588,
                    0
                ],
                977: [
                    0,
                    .69444,
                    0,
                    .08334
                ],
                981: [
                    .19444,
                    .69444,
                    0,
                    .08334
                ],
                982: [
                    0,
                    .43056,
                    .02778,
                    0
                ],
                1009: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                1013: [
                    0,
                    .43056,
                    0,
                    .05556
                ]
            },
            "Math-Regular": {
                65: [
                    0,
                    .68333,
                    0,
                    .13889
                ],
                66: [
                    0,
                    .68333,
                    .05017,
                    .08334
                ],
                67: [
                    0,
                    .68333,
                    .07153,
                    .08334
                ],
                68: [
                    0,
                    .68333,
                    .02778,
                    .05556
                ],
                69: [
                    0,
                    .68333,
                    .05764,
                    .08334
                ],
                70: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                71: [
                    0,
                    .68333,
                    0,
                    .08334
                ],
                72: [
                    0,
                    .68333,
                    .08125,
                    .05556
                ],
                73: [
                    0,
                    .68333,
                    .07847,
                    .11111
                ],
                74: [
                    0,
                    .68333,
                    .09618,
                    .16667
                ],
                75: [
                    0,
                    .68333,
                    .07153,
                    .05556
                ],
                76: [
                    0,
                    .68333,
                    0,
                    .02778
                ],
                77: [
                    0,
                    .68333,
                    .10903,
                    .08334
                ],
                78: [
                    0,
                    .68333,
                    .10903,
                    .08334
                ],
                79: [
                    0,
                    .68333,
                    .02778,
                    .08334
                ],
                80: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                81: [
                    .19444,
                    .68333,
                    0,
                    .08334
                ],
                82: [
                    0,
                    .68333,
                    .00773,
                    .08334
                ],
                83: [
                    0,
                    .68333,
                    .05764,
                    .08334
                ],
                84: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                85: [
                    0,
                    .68333,
                    .10903,
                    .02778
                ],
                86: [
                    0,
                    .68333,
                    .22222,
                    0
                ],
                87: [
                    0,
                    .68333,
                    .13889,
                    0
                ],
                88: [
                    0,
                    .68333,
                    .07847,
                    .08334
                ],
                89: [
                    0,
                    .68333,
                    .22222,
                    0
                ],
                90: [
                    0,
                    .68333,
                    .07153,
                    .08334
                ],
                97: [
                    0,
                    .43056,
                    0,
                    0
                ],
                98: [
                    0,
                    .69444,
                    0,
                    0
                ],
                99: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                100: [
                    0,
                    .69444,
                    0,
                    .16667
                ],
                101: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                102: [
                    .19444,
                    .69444,
                    .10764,
                    .16667
                ],
                103: [
                    .19444,
                    .43056,
                    .03588,
                    .02778
                ],
                104: [
                    0,
                    .69444,
                    0,
                    0
                ],
                105: [
                    0,
                    .65952,
                    0,
                    0
                ],
                106: [
                    .19444,
                    .65952,
                    .05724,
                    0
                ],
                107: [
                    0,
                    .69444,
                    .03148,
                    0
                ],
                108: [
                    0,
                    .69444,
                    .01968,
                    .08334
                ],
                109: [
                    0,
                    .43056,
                    0,
                    0
                ],
                110: [
                    0,
                    .43056,
                    0,
                    0
                ],
                111: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                112: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                113: [
                    .19444,
                    .43056,
                    .03588,
                    .08334
                ],
                114: [
                    0,
                    .43056,
                    .02778,
                    .05556
                ],
                115: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                116: [
                    0,
                    .61508,
                    0,
                    .08334
                ],
                117: [
                    0,
                    .43056,
                    0,
                    .02778
                ],
                118: [
                    0,
                    .43056,
                    .03588,
                    .02778
                ],
                119: [
                    0,
                    .43056,
                    .02691,
                    .08334
                ],
                120: [
                    0,
                    .43056,
                    0,
                    .02778
                ],
                121: [
                    .19444,
                    .43056,
                    .03588,
                    .05556
                ],
                122: [
                    0,
                    .43056,
                    .04398,
                    .05556
                ],
                915: [
                    0,
                    .68333,
                    .13889,
                    .08334
                ],
                916: [
                    0,
                    .68333,
                    0,
                    .16667
                ],
                920: [
                    0,
                    .68333,
                    .02778,
                    .08334
                ],
                923: [
                    0,
                    .68333,
                    0,
                    .16667
                ],
                926: [
                    0,
                    .68333,
                    .07569,
                    .08334
                ],
                928: [
                    0,
                    .68333,
                    .08125,
                    .05556
                ],
                931: [
                    0,
                    .68333,
                    .05764,
                    .08334
                ],
                933: [
                    0,
                    .68333,
                    .13889,
                    .05556
                ],
                934: [
                    0,
                    .68333,
                    0,
                    .08334
                ],
                936: [
                    0,
                    .68333,
                    .11,
                    .05556
                ],
                937: [
                    0,
                    .68333,
                    .05017,
                    .08334
                ],
                945: [
                    0,
                    .43056,
                    .0037,
                    .02778
                ],
                946: [
                    .19444,
                    .69444,
                    .05278,
                    .08334
                ],
                947: [
                    .19444,
                    .43056,
                    .05556,
                    0
                ],
                948: [
                    0,
                    .69444,
                    .03785,
                    .05556
                ],
                949: [
                    0,
                    .43056,
                    0,
                    .08334
                ],
                950: [
                    .19444,
                    .69444,
                    .07378,
                    .08334
                ],
                951: [
                    .19444,
                    .43056,
                    .03588,
                    .05556
                ],
                952: [
                    0,
                    .69444,
                    .02778,
                    .08334
                ],
                953: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                954: [
                    0,
                    .43056,
                    0,
                    0
                ],
                955: [
                    0,
                    .69444,
                    0,
                    0
                ],
                956: [
                    .19444,
                    .43056,
                    0,
                    .02778
                ],
                957: [
                    0,
                    .43056,
                    .06366,
                    .02778
                ],
                958: [
                    .19444,
                    .69444,
                    .04601,
                    .11111
                ],
                959: [
                    0,
                    .43056,
                    0,
                    .05556
                ],
                960: [
                    0,
                    .43056,
                    .03588,
                    0
                ],
                961: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                962: [
                    .09722,
                    .43056,
                    .07986,
                    .08334
                ],
                963: [
                    0,
                    .43056,
                    .03588,
                    0
                ],
                964: [
                    0,
                    .43056,
                    .1132,
                    .02778
                ],
                965: [
                    0,
                    .43056,
                    .03588,
                    .02778
                ],
                966: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                967: [
                    .19444,
                    .43056,
                    0,
                    .05556
                ],
                968: [
                    .19444,
                    .69444,
                    .03588,
                    .11111
                ],
                969: [
                    0,
                    .43056,
                    .03588,
                    0
                ],
                977: [
                    0,
                    .69444,
                    0,
                    .08334
                ],
                981: [
                    .19444,
                    .69444,
                    0,
                    .08334
                ],
                982: [
                    0,
                    .43056,
                    .02778,
                    0
                ],
                1009: [
                    .19444,
                    .43056,
                    0,
                    .08334
                ],
                1013: [
                    0,
                    .43056,
                    0,
                    .05556
                ]
            },
            "SansSerif-Regular": {
                33: [
                    0,
                    .69444,
                    0,
                    0
                ],
                34: [
                    0,
                    .69444,
                    0,
                    0
                ],
                35: [
                    .19444,
                    .69444,
                    0,
                    0
                ],
                36: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                37: [
                    .05556,
                    .75,
                    0,
                    0
                ],
                38: [
                    0,
                    .69444,
                    0,
                    0
                ],
                39: [
                    0,
                    .69444,
                    0,
                    0
                ],
                40: [
                    .25,
                    .75,
                    0,
                    0
                ],
                41: [
                    .25,
                    .75,
                    0,
                    0
                ],
                42: [
                    0,
                    .75,
                    0,
                    0
                ],
                43: [
                    .08333,
                    .58333,
                    0,
                    0
                ],
                44: [
                    .125,
                    .08333,
                    0,
                    0
                ],
                45: [
                    0,
                    .44444,
                    0,
                    0
                ],
                46: [
                    0,
                    .08333,
                    0,
                    0
                ],
                47: [
                    .25,
                    .75,
                    0,
                    0
                ],
                48: [
                    0,
                    .65556,
                    0,
                    0
                ],
                49: [
                    0,
                    .65556,
                    0,
                    0
                ],
                50: [
                    0,
                    .65556,
                    0,
                    0
                ],
                51: [
                    0,
                    .65556,
                    0,
                    0
                ],
                52: [
                    0,
                    .65556,
                    0,
                    0
                ],
                53: [
                    0,
                    .65556,
                    0,
                    0
                ],
                54: [
                    0,
                    .65556,
                    0,
                    0
                ],
                55: [
                    0,
                    .65556,
                    0,
                    0
                ],
                56: [
                    0,
                    .65556,
                    0,
                    0
                ],
                57: [
                    0,
                    .65556,
                    0,
                    0
                ],
                58: [
                    0,
                    .44444,
                    0,
                    0
                ],
                59: [
                    .125,
                    .44444,
                    0,
                    0
                ],
                61: [
                    -0.13,
                    .37,
                    0,
                    0
                ],
                63: [
                    0,
                    .69444,
                    0,
                    0
                ],
                64: [
                    0,
                    .69444,
                    0,
                    0
                ],
                65: [
                    0,
                    .69444,
                    0,
                    0
                ],
                66: [
                    0,
                    .69444,
                    0,
                    0
                ],
                67: [
                    0,
                    .69444,
                    0,
                    0
                ],
                68: [
                    0,
                    .69444,
                    0,
                    0
                ],
                69: [
                    0,
                    .69444,
                    0,
                    0
                ],
                70: [
                    0,
                    .69444,
                    0,
                    0
                ],
                71: [
                    0,
                    .69444,
                    0,
                    0
                ],
                72: [
                    0,
                    .69444,
                    0,
                    0
                ],
                73: [
                    0,
                    .69444,
                    0,
                    0
                ],
                74: [
                    0,
                    .69444,
                    0,
                    0
                ],
                75: [
                    0,
                    .69444,
                    0,
                    0
                ],
                76: [
                    0,
                    .69444,
                    0,
                    0
                ],
                77: [
                    0,
                    .69444,
                    0,
                    0
                ],
                78: [
                    0,
                    .69444,
                    0,
                    0
                ],
                79: [
                    0,
                    .69444,
                    0,
                    0
                ],
                80: [
                    0,
                    .69444,
                    0,
                    0
                ],
                81: [
                    .125,
                    .69444,
                    0,
                    0
                ],
                82: [
                    0,
                    .69444,
                    0,
                    0
                ],
                83: [
                    0,
                    .69444,
                    0,
                    0
                ],
                84: [
                    0,
                    .69444,
                    0,
                    0
                ],
                85: [
                    0,
                    .69444,
                    0,
                    0
                ],
                86: [
                    0,
                    .69444,
                    .01389,
                    0
                ],
                87: [
                    0,
                    .69444,
                    .01389,
                    0
                ],
                88: [
                    0,
                    .69444,
                    0,
                    0
                ],
                89: [
                    0,
                    .69444,
                    .025,
                    0
                ],
                90: [
                    0,
                    .69444,
                    0,
                    0
                ],
                91: [
                    .25,
                    .75,
                    0,
                    0
                ],
                93: [
                    .25,
                    .75,
                    0,
                    0
                ],
                94: [
                    0,
                    .69444,
                    0,
                    0
                ],
                95: [
                    .35,
                    .09444,
                    .02778,
                    0
                ],
                97: [
                    0,
                    .44444,
                    0,
                    0
                ],
                98: [
                    0,
                    .69444,
                    0,
                    0
                ],
                99: [
                    0,
                    .44444,
                    0,
                    0
                ],
                100: [
                    0,
                    .69444,
                    0,
                    0
                ],
                101: [
                    0,
                    .44444,
                    0,
                    0
                ],
                102: [
                    0,
                    .69444,
                    .06944,
                    0
                ],
                103: [
                    .19444,
                    .44444,
                    .01389,
                    0
                ],
                104: [
                    0,
                    .69444,
                    0,
                    0
                ],
                105: [
                    0,
                    .67937,
                    0,
                    0
                ],
                106: [
                    .19444,
                    .67937,
                    0,
                    0
                ],
                107: [
                    0,
                    .69444,
                    0,
                    0
                ],
                108: [
                    0,
                    .69444,
                    0,
                    0
                ],
                109: [
                    0,
                    .44444,
                    0,
                    0
                ],
                110: [
                    0,
                    .44444,
                    0,
                    0
                ],
                111: [
                    0,
                    .44444,
                    0,
                    0
                ],
                112: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                113: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                114: [
                    0,
                    .44444,
                    .01389,
                    0
                ],
                115: [
                    0,
                    .44444,
                    0,
                    0
                ],
                116: [
                    0,
                    .57143,
                    0,
                    0
                ],
                117: [
                    0,
                    .44444,
                    0,
                    0
                ],
                118: [
                    0,
                    .44444,
                    .01389,
                    0
                ],
                119: [
                    0,
                    .44444,
                    .01389,
                    0
                ],
                120: [
                    0,
                    .44444,
                    0,
                    0
                ],
                121: [
                    .19444,
                    .44444,
                    .01389,
                    0
                ],
                122: [
                    0,
                    .44444,
                    0,
                    0
                ],
                126: [
                    .35,
                    .32659,
                    0,
                    0
                ],
                305: [
                    0,
                    .44444,
                    0,
                    0
                ],
                567: [
                    .19444,
                    .44444,
                    0,
                    0
                ],
                768: [
                    0,
                    .69444,
                    0,
                    0
                ],
                769: [
                    0,
                    .69444,
                    0,
                    0
                ],
                770: [
                    0,
                    .69444,
                    0,
                    0
                ],
                771: [
                    0,
                    .67659,
                    0,
                    0
                ],
                772: [
                    0,
                    .60889,
                    0,
                    0
                ],
                774: [
                    0,
                    .69444,
                    0,
                    0
                ],
                775: [
                    0,
                    .67937,
                    0,
                    0
                ],
                776: [
                    0,
                    .67937,
                    0,
                    0
                ],
                778: [
                    0,
                    .69444,
                    0,
                    0
                ],
                779: [
                    0,
                    .69444,
                    0,
                    0
                ],
                780: [
                    0,
                    .63194,
                    0,
                    0
                ],
                915: [
                    0,
                    .69444,
                    0,
                    0
                ],
                916: [
                    0,
                    .69444,
                    0,
                    0
                ],
                920: [
                    0,
                    .69444,
                    0,
                    0
                ],
                923: [
                    0,
                    .69444,
                    0,
                    0
                ],
                926: [
                    0,
                    .69444,
                    0,
                    0
                ],
                928: [
                    0,
                    .69444,
                    0,
                    0
                ],
                931: [
                    0,
                    .69444,
                    0,
                    0
                ],
                933: [
                    0,
                    .69444,
                    0,
                    0
                ],
                934: [
                    0,
                    .69444,
                    0,
                    0
                ],
                936: [
                    0,
                    .69444,
                    0,
                    0
                ],
                937: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8211: [
                    0,
                    .44444,
                    .02778,
                    0
                ],
                8212: [
                    0,
                    .44444,
                    .02778,
                    0
                ],
                8216: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8217: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8220: [
                    0,
                    .69444,
                    0,
                    0
                ],
                8221: [
                    0,
                    .69444,
                    0,
                    0
                ]
            },
            "Script-Regular": {
                65: [
                    0,
                    .7,
                    .22925,
                    0
                ],
                66: [
                    0,
                    .7,
                    .04087,
                    0
                ],
                67: [
                    0,
                    .7,
                    .1689,
                    0
                ],
                68: [
                    0,
                    .7,
                    .09371,
                    0
                ],
                69: [
                    0,
                    .7,
                    .18583,
                    0
                ],
                70: [
                    0,
                    .7,
                    .13634,
                    0
                ],
                71: [
                    0,
                    .7,
                    .17322,
                    0
                ],
                72: [
                    0,
                    .7,
                    .29694,
                    0
                ],
                73: [
                    0,
                    .7,
                    .19189,
                    0
                ],
                74: [
                    .27778,
                    .7,
                    .19189,
                    0
                ],
                75: [
                    0,
                    .7,
                    .31259,
                    0
                ],
                76: [
                    0,
                    .7,
                    .19189,
                    0
                ],
                77: [
                    0,
                    .7,
                    .15981,
                    0
                ],
                78: [
                    0,
                    .7,
                    .3525,
                    0
                ],
                79: [
                    0,
                    .7,
                    .08078,
                    0
                ],
                80: [
                    0,
                    .7,
                    .08078,
                    0
                ],
                81: [
                    0,
                    .7,
                    .03305,
                    0
                ],
                82: [
                    0,
                    .7,
                    .06259,
                    0
                ],
                83: [
                    0,
                    .7,
                    .19189,
                    0
                ],
                84: [
                    0,
                    .7,
                    .29087,
                    0
                ],
                85: [
                    0,
                    .7,
                    .25815,
                    0
                ],
                86: [
                    0,
                    .7,
                    .27523,
                    0
                ],
                87: [
                    0,
                    .7,
                    .27523,
                    0
                ],
                88: [
                    0,
                    .7,
                    .26006,
                    0
                ],
                89: [
                    0,
                    .7,
                    .2939,
                    0
                ],
                90: [
                    0,
                    .7,
                    .24037,
                    0
                ]
            },
            "Size1-Regular": {
                40: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                41: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                47: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                91: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                92: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                93: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                123: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                125: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                710: [
                    0,
                    .72222,
                    0,
                    0
                ],
                732: [
                    0,
                    .72222,
                    0,
                    0
                ],
                770: [
                    0,
                    .72222,
                    0,
                    0
                ],
                771: [
                    0,
                    .72222,
                    0,
                    0
                ],
                8214: [
                    -0.00099,
                    .601,
                    0,
                    0
                ],
                8593: [
                    1e-5,
                    .6,
                    0,
                    0
                ],
                8595: [
                    1e-5,
                    .6,
                    0,
                    0
                ],
                8657: [
                    1e-5,
                    .6,
                    0,
                    0
                ],
                8659: [
                    1e-5,
                    .6,
                    0,
                    0
                ],
                8719: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8720: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8721: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8730: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                8739: [
                    -0.00599,
                    .606,
                    0,
                    0
                ],
                8741: [
                    -0.00599,
                    .606,
                    0,
                    0
                ],
                8747: [
                    .30612,
                    .805,
                    .19445,
                    0
                ],
                8748: [
                    .306,
                    .805,
                    .19445,
                    0
                ],
                8749: [
                    .306,
                    .805,
                    .19445,
                    0
                ],
                8750: [
                    .30612,
                    .805,
                    .19445,
                    0
                ],
                8896: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8897: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8898: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8899: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                8968: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                8969: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                8970: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                8971: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                9168: [
                    -0.00099,
                    .601,
                    0,
                    0
                ],
                10216: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                10217: [
                    .35001,
                    .85,
                    0,
                    0
                ],
                10752: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                10753: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                10754: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                10756: [
                    .25001,
                    .75,
                    0,
                    0
                ],
                10758: [
                    .25001,
                    .75,
                    0,
                    0
                ]
            },
            "Size2-Regular": {
                40: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                41: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                47: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                91: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                92: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                93: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                123: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                125: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                710: [
                    0,
                    .75,
                    0,
                    0
                ],
                732: [
                    0,
                    .75,
                    0,
                    0
                ],
                770: [
                    0,
                    .75,
                    0,
                    0
                ],
                771: [
                    0,
                    .75,
                    0,
                    0
                ],
                8719: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8720: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8721: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8730: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                8747: [
                    .86225,
                    1.36,
                    .44445,
                    0
                ],
                8748: [
                    .862,
                    1.36,
                    .44445,
                    0
                ],
                8749: [
                    .862,
                    1.36,
                    .44445,
                    0
                ],
                8750: [
                    .86225,
                    1.36,
                    .44445,
                    0
                ],
                8896: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8897: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8898: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8899: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                8968: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                8969: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                8970: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                8971: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                10216: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                10217: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                10752: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                10753: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                10754: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                10756: [
                    .55001,
                    1.05,
                    0,
                    0
                ],
                10758: [
                    .55001,
                    1.05,
                    0,
                    0
                ]
            },
            "Size3-Regular": {
                40: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                41: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                47: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                91: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                92: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                93: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                123: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                125: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                710: [
                    0,
                    .75,
                    0,
                    0
                ],
                732: [
                    0,
                    .75,
                    0,
                    0
                ],
                770: [
                    0,
                    .75,
                    0,
                    0
                ],
                771: [
                    0,
                    .75,
                    0,
                    0
                ],
                8730: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                8968: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                8969: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                8970: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                8971: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                10216: [
                    .95003,
                    1.45,
                    0,
                    0
                ],
                10217: [
                    .95003,
                    1.45,
                    0,
                    0
                ]
            },
            "Size4-Regular": {
                40: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                41: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                47: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                91: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                92: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                93: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                123: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                125: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                710: [
                    0,
                    .825,
                    0,
                    0
                ],
                732: [
                    0,
                    .825,
                    0,
                    0
                ],
                770: [
                    0,
                    .825,
                    0,
                    0
                ],
                771: [
                    0,
                    .825,
                    0,
                    0
                ],
                8730: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                8968: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                8969: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                8970: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                8971: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                9115: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9116: [
                    1e-5,
                    .6,
                    0,
                    0
                ],
                9117: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9118: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9119: [
                    1e-5,
                    .6,
                    0,
                    0
                ],
                9120: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9121: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9122: [
                    -0.00099,
                    .601,
                    0,
                    0
                ],
                9123: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9124: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9125: [
                    -0.00099,
                    .601,
                    0,
                    0
                ],
                9126: [
                    .64502,
                    1.155,
                    0,
                    0
                ],
                9127: [
                    1e-5,
                    .9,
                    0,
                    0
                ],
                9128: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                9129: [
                    .90001,
                    0,
                    0,
                    0
                ],
                9130: [
                    0,
                    .3,
                    0,
                    0
                ],
                9131: [
                    1e-5,
                    .9,
                    0,
                    0
                ],
                9132: [
                    .65002,
                    1.15,
                    0,
                    0
                ],
                9133: [
                    .90001,
                    0,
                    0,
                    0
                ],
                9143: [
                    .88502,
                    .915,
                    0,
                    0
                ],
                10216: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                10217: [
                    1.25003,
                    1.75,
                    0,
                    0
                ],
                57344: [
                    -0.00499,
                    .605,
                    0,
                    0
                ],
                57345: [
                    -0.00499,
                    .605,
                    0,
                    0
                ],
                57680: [
                    0,
                    .12,
                    0,
                    0
                ],
                57681: [
                    0,
                    .12,
                    0,
                    0
                ],
                57682: [
                    0,
                    .12,
                    0,
                    0
                ],
                57683: [
                    0,
                    .12,
                    0,
                    0
                ]
            },
            "Typewriter-Regular": {
                33: [
                    0,
                    .61111,
                    0,
                    0
                ],
                34: [
                    0,
                    .61111,
                    0,
                    0
                ],
                35: [
                    0,
                    .61111,
                    0,
                    0
                ],
                36: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                37: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                38: [
                    0,
                    .61111,
                    0,
                    0
                ],
                39: [
                    0,
                    .61111,
                    0,
                    0
                ],
                40: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                41: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                42: [
                    0,
                    .52083,
                    0,
                    0
                ],
                43: [
                    -0.08056,
                    .53055,
                    0,
                    0
                ],
                44: [
                    .13889,
                    .125,
                    0,
                    0
                ],
                45: [
                    -0.08056,
                    .53055,
                    0,
                    0
                ],
                46: [
                    0,
                    .125,
                    0,
                    0
                ],
                47: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                48: [
                    0,
                    .61111,
                    0,
                    0
                ],
                49: [
                    0,
                    .61111,
                    0,
                    0
                ],
                50: [
                    0,
                    .61111,
                    0,
                    0
                ],
                51: [
                    0,
                    .61111,
                    0,
                    0
                ],
                52: [
                    0,
                    .61111,
                    0,
                    0
                ],
                53: [
                    0,
                    .61111,
                    0,
                    0
                ],
                54: [
                    0,
                    .61111,
                    0,
                    0
                ],
                55: [
                    0,
                    .61111,
                    0,
                    0
                ],
                56: [
                    0,
                    .61111,
                    0,
                    0
                ],
                57: [
                    0,
                    .61111,
                    0,
                    0
                ],
                58: [
                    0,
                    .43056,
                    0,
                    0
                ],
                59: [
                    .13889,
                    .43056,
                    0,
                    0
                ],
                60: [
                    -0.05556,
                    .55556,
                    0,
                    0
                ],
                61: [
                    -0.19549,
                    .41562,
                    0,
                    0
                ],
                62: [
                    -0.05556,
                    .55556,
                    0,
                    0
                ],
                63: [
                    0,
                    .61111,
                    0,
                    0
                ],
                64: [
                    0,
                    .61111,
                    0,
                    0
                ],
                65: [
                    0,
                    .61111,
                    0,
                    0
                ],
                66: [
                    0,
                    .61111,
                    0,
                    0
                ],
                67: [
                    0,
                    .61111,
                    0,
                    0
                ],
                68: [
                    0,
                    .61111,
                    0,
                    0
                ],
                69: [
                    0,
                    .61111,
                    0,
                    0
                ],
                70: [
                    0,
                    .61111,
                    0,
                    0
                ],
                71: [
                    0,
                    .61111,
                    0,
                    0
                ],
                72: [
                    0,
                    .61111,
                    0,
                    0
                ],
                73: [
                    0,
                    .61111,
                    0,
                    0
                ],
                74: [
                    0,
                    .61111,
                    0,
                    0
                ],
                75: [
                    0,
                    .61111,
                    0,
                    0
                ],
                76: [
                    0,
                    .61111,
                    0,
                    0
                ],
                77: [
                    0,
                    .61111,
                    0,
                    0
                ],
                78: [
                    0,
                    .61111,
                    0,
                    0
                ],
                79: [
                    0,
                    .61111,
                    0,
                    0
                ],
                80: [
                    0,
                    .61111,
                    0,
                    0
                ],
                81: [
                    .13889,
                    .61111,
                    0,
                    0
                ],
                82: [
                    0,
                    .61111,
                    0,
                    0
                ],
                83: [
                    0,
                    .61111,
                    0,
                    0
                ],
                84: [
                    0,
                    .61111,
                    0,
                    0
                ],
                85: [
                    0,
                    .61111,
                    0,
                    0
                ],
                86: [
                    0,
                    .61111,
                    0,
                    0
                ],
                87: [
                    0,
                    .61111,
                    0,
                    0
                ],
                88: [
                    0,
                    .61111,
                    0,
                    0
                ],
                89: [
                    0,
                    .61111,
                    0,
                    0
                ],
                90: [
                    0,
                    .61111,
                    0,
                    0
                ],
                91: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                92: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                93: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                94: [
                    0,
                    .61111,
                    0,
                    0
                ],
                95: [
                    .09514,
                    0,
                    0,
                    0
                ],
                96: [
                    0,
                    .61111,
                    0,
                    0
                ],
                97: [
                    0,
                    .43056,
                    0,
                    0
                ],
                98: [
                    0,
                    .61111,
                    0,
                    0
                ],
                99: [
                    0,
                    .43056,
                    0,
                    0
                ],
                100: [
                    0,
                    .61111,
                    0,
                    0
                ],
                101: [
                    0,
                    .43056,
                    0,
                    0
                ],
                102: [
                    0,
                    .61111,
                    0,
                    0
                ],
                103: [
                    .22222,
                    .43056,
                    0,
                    0
                ],
                104: [
                    0,
                    .61111,
                    0,
                    0
                ],
                105: [
                    0,
                    .61111,
                    0,
                    0
                ],
                106: [
                    .22222,
                    .61111,
                    0,
                    0
                ],
                107: [
                    0,
                    .61111,
                    0,
                    0
                ],
                108: [
                    0,
                    .61111,
                    0,
                    0
                ],
                109: [
                    0,
                    .43056,
                    0,
                    0
                ],
                110: [
                    0,
                    .43056,
                    0,
                    0
                ],
                111: [
                    0,
                    .43056,
                    0,
                    0
                ],
                112: [
                    .22222,
                    .43056,
                    0,
                    0
                ],
                113: [
                    .22222,
                    .43056,
                    0,
                    0
                ],
                114: [
                    0,
                    .43056,
                    0,
                    0
                ],
                115: [
                    0,
                    .43056,
                    0,
                    0
                ],
                116: [
                    0,
                    .55358,
                    0,
                    0
                ],
                117: [
                    0,
                    .43056,
                    0,
                    0
                ],
                118: [
                    0,
                    .43056,
                    0,
                    0
                ],
                119: [
                    0,
                    .43056,
                    0,
                    0
                ],
                120: [
                    0,
                    .43056,
                    0,
                    0
                ],
                121: [
                    .22222,
                    .43056,
                    0,
                    0
                ],
                122: [
                    0,
                    .43056,
                    0,
                    0
                ],
                123: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                124: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                125: [
                    .08333,
                    .69444,
                    0,
                    0
                ],
                126: [
                    0,
                    .61111,
                    0,
                    0
                ],
                127: [
                    0,
                    .61111,
                    0,
                    0
                ],
                305: [
                    0,
                    .43056,
                    0,
                    0
                ],
                567: [
                    .22222,
                    .43056,
                    0,
                    0
                ],
                768: [
                    0,
                    .61111,
                    0,
                    0
                ],
                769: [
                    0,
                    .61111,
                    0,
                    0
                ],
                770: [
                    0,
                    .61111,
                    0,
                    0
                ],
                771: [
                    0,
                    .61111,
                    0,
                    0
                ],
                772: [
                    0,
                    .56555,
                    0,
                    0
                ],
                774: [
                    0,
                    .61111,
                    0,
                    0
                ],
                776: [
                    0,
                    .61111,
                    0,
                    0
                ],
                778: [
                    0,
                    .61111,
                    0,
                    0
                ],
                780: [
                    0,
                    .56597,
                    0,
                    0
                ],
                915: [
                    0,
                    .61111,
                    0,
                    0
                ],
                916: [
                    0,
                    .61111,
                    0,
                    0
                ],
                920: [
                    0,
                    .61111,
                    0,
                    0
                ],
                923: [
                    0,
                    .61111,
                    0,
                    0
                ],
                926: [
                    0,
                    .61111,
                    0,
                    0
                ],
                928: [
                    0,
                    .61111,
                    0,
                    0
                ],
                931: [
                    0,
                    .61111,
                    0,
                    0
                ],
                933: [
                    0,
                    .61111,
                    0,
                    0
                ],
                934: [
                    0,
                    .61111,
                    0,
                    0
                ],
                936: [
                    0,
                    .61111,
                    0,
                    0
                ],
                937: [
                    0,
                    .61111,
                    0,
                    0
                ],
                2018: [
                    0,
                    .61111,
                    0,
                    0
                ],
                2019: [
                    0,
                    .61111,
                    0,
                    0
                ],
                8242: [
                    0,
                    .61111,
                    0,
                    0
                ]
            }
        };
    });
    var Xi = Jr((Qyn, tT)=>{
        var Av = Gc(), nT = .431, rT = 1, SS = .677, RS = .394, NS = .444, HS = .686, PS = .345, kS = .413, OS = .363, qS = .289, WS = .15, $S = .247, US = .386, BS = .05, zS = 2.39, VS = 1.01, JS = .81, GS = .71, jS = .25, QS = .04, KS = .111, YS = .166, XS = .2, ZS = .6, n7 = .1, eT = 10, r7 = 2 / eT, e7 = {
            xHeight: nT,
            quad: rT,
            num1: SS,
            num2: RS,
            num3: NS,
            denom1: HS,
            denom2: PS,
            sup1: kS,
            sup2: OS,
            sup3: qS,
            sub1: WS,
            sub2: $S,
            supDrop: US,
            subDrop: BS,
            axisHeight: jS,
            defaultRuleThickness: QS,
            bigOpSpacing1: KS,
            bigOpSpacing2: YS,
            bigOpSpacing3: XS,
            bigOpSpacing4: ZS,
            bigOpSpacing5: n7,
            ptPerEm: eT,
            emPerEx: nT / rT,
            doubleRuleSep: r7,
            delim1: zS,
            getDelim2: function(n) {
                if (n.size === Av.TEXT.size) return VS;
                if (n.size === Av.SCRIPT.size) return JS;
                if (n.size === Av.SCRIPTSCRIPT.size) return GS;
                throw new Error("Unexpected style size: " + n.size);
            }
        }, t7 = ZE(), a7 = function(n, r) {
            var e = t7[r][n.charCodeAt(0)];
            if (e) return {
                depth: e[0],
                height: e[1],
                italic: e[2],
                skew: e[3],
                width: e[4]
            };
        };
        tT.exports = {
            metrics: e7,
            getCharacterMetrics: a7
        };
    });
    var Kc = Jr((Kyn, Lv)=>{
        Lv.exports = {
            math: {},
            text: {}
        };
        function p(n, r, e, t, a) {
            Lv.exports[n][a] = {
                font: r,
                group: e,
                replace: t
            };
        }
        var s = "math", jc = "text", g = "main", y = "ams", Ha = "accent", cn = "bin", je = "close", Iv = "inner", gr = "mathord", Re = "op", vt = "open", Qc = "punct", b = "rel", At = "spacing", K = "textord";
        p(s, g, b, "\u2261", "\\equiv");
        p(s, g, b, "\u227A", "\\prec");
        p(s, g, b, "\u227B", "\\succ");
        p(s, g, b, "\u223C", "\\sim");
        p(s, g, b, "\u22A5", "\\perp");
        p(s, g, b, "\u2AAF", "\\preceq");
        p(s, g, b, "\u2AB0", "\\succeq");
        p(s, g, b, "\u2243", "\\simeq");
        p(s, g, b, "\u2223", "\\mid");
        p(s, g, b, "\u226A", "\\ll");
        p(s, g, b, "\u226B", "\\gg");
        p(s, g, b, "\u224D", "\\asymp");
        p(s, g, b, "\u2225", "\\parallel");
        p(s, g, b, "\u22C8", "\\bowtie");
        p(s, g, b, "\u2323", "\\smile");
        p(s, g, b, "\u2291", "\\sqsubseteq");
        p(s, g, b, "\u2292", "\\sqsupseteq");
        p(s, g, b, "\u2250", "\\doteq");
        p(s, g, b, "\u2322", "\\frown");
        p(s, g, b, "\u220B", "\\ni");
        p(s, g, b, "\u221D", "\\propto");
        p(s, g, b, "\u22A2", "\\vdash");
        p(s, g, b, "\u22A3", "\\dashv");
        p(s, g, b, "\u220B", "\\owns");
        p(s, g, Qc, ".", "\\ldotp");
        p(s, g, Qc, "\u22C5", "\\cdotp");
        p(s, g, K, "#", "\\#");
        p(s, g, K, "&", "\\&");
        p(s, g, K, "\u2135", "\\aleph");
        p(s, g, K, "\u2200", "\\forall");
        p(s, g, K, "\u210F", "\\hbar");
        p(s, g, K, "\u2203", "\\exists");
        p(s, g, K, "\u2207", "\\nabla");
        p(s, g, K, "\u266D", "\\flat");
        p(s, g, K, "\u2113", "\\ell");
        p(s, g, K, "\u266E", "\\natural");
        p(s, g, K, "\u2663", "\\clubsuit");
        p(s, g, K, "\u2118", "\\wp");
        p(s, g, K, "\u266F", "\\sharp");
        p(s, g, K, "\u2662", "\\diamondsuit");
        p(s, g, K, "\u211C", "\\Re");
        p(s, g, K, "\u2661", "\\heartsuit");
        p(s, g, K, "\u2111", "\\Im");
        p(s, g, K, "\u2660", "\\spadesuit");
        p(s, g, K, "\u2020", "\\dag");
        p(s, g, K, "\u2021", "\\ddag");
        p(s, g, je, "\u23B1", "\\rmoustache");
        p(s, g, vt, "\u23B0", "\\lmoustache");
        p(s, g, je, "\u27EF", "\\rgroup");
        p(s, g, vt, "\u27EE", "\\lgroup");
        p(s, g, cn, "\u2213", "\\mp");
        p(s, g, cn, "\u2296", "\\ominus");
        p(s, g, cn, "\u228E", "\\uplus");
        p(s, g, cn, "\u2293", "\\sqcap");
        p(s, g, cn, "\u2217", "\\ast");
        p(s, g, cn, "\u2294", "\\sqcup");
        p(s, g, cn, "\u25EF", "\\bigcirc");
        p(s, g, cn, "\u2219", "\\bullet");
        p(s, g, cn, "\u2021", "\\ddagger");
        p(s, g, cn, "\u2240", "\\wr");
        p(s, g, cn, "\u2A3F", "\\amalg");
        p(s, g, b, "\u27F5", "\\longleftarrow");
        p(s, g, b, "\u21D0", "\\Leftarrow");
        p(s, g, b, "\u27F8", "\\Longleftarrow");
        p(s, g, b, "\u27F6", "\\longrightarrow");
        p(s, g, b, "\u21D2", "\\Rightarrow");
        p(s, g, b, "\u27F9", "\\Longrightarrow");
        p(s, g, b, "\u2194", "\\leftrightarrow");
        p(s, g, b, "\u27F7", "\\longleftrightarrow");
        p(s, g, b, "\u21D4", "\\Leftrightarrow");
        p(s, g, b, "\u27FA", "\\Longleftrightarrow");
        p(s, g, b, "\u21A6", "\\mapsto");
        p(s, g, b, "\u27FC", "\\longmapsto");
        p(s, g, b, "\u2197", "\\nearrow");
        p(s, g, b, "\u21A9", "\\hookleftarrow");
        p(s, g, b, "\u21AA", "\\hookrightarrow");
        p(s, g, b, "\u2198", "\\searrow");
        p(s, g, b, "\u21BC", "\\leftharpoonup");
        p(s, g, b, "\u21C0", "\\rightharpoonup");
        p(s, g, b, "\u2199", "\\swarrow");
        p(s, g, b, "\u21BD", "\\leftharpoondown");
        p(s, g, b, "\u21C1", "\\rightharpoondown");
        p(s, g, b, "\u2196", "\\nwarrow");
        p(s, g, b, "\u21CC", "\\rightleftharpoons");
        p(s, y, b, "\u226E", "\\nless");
        p(s, y, b, "\uE010", "\\nleqslant");
        p(s, y, b, "\uE011", "\\nleqq");
        p(s, y, b, "\u2A87", "\\lneq");
        p(s, y, b, "\u2268", "\\lneqq");
        p(s, y, b, "\uE00C", "\\lvertneqq");
        p(s, y, b, "\u22E6", "\\lnsim");
        p(s, y, b, "\u2A89", "\\lnapprox");
        p(s, y, b, "\u2280", "\\nprec");
        p(s, y, b, "\u22E0", "\\npreceq");
        p(s, y, b, "\u22E8", "\\precnsim");
        p(s, y, b, "\u2AB9", "\\precnapprox");
        p(s, y, b, "\u2241", "\\nsim");
        p(s, y, b, "\uE006", "\\nshortmid");
        p(s, y, b, "\u2224", "\\nmid");
        p(s, y, b, "\u22AC", "\\nvdash");
        p(s, y, b, "\u22AD", "\\nvDash");
        p(s, y, b, "\u22EA", "\\ntriangleleft");
        p(s, y, b, "\u22EC", "\\ntrianglelefteq");
        p(s, y, b, "\u228A", "\\subsetneq");
        p(s, y, b, "\uE01A", "\\varsubsetneq");
        p(s, y, b, "\u2ACB", "\\subsetneqq");
        p(s, y, b, "\uE017", "\\varsubsetneqq");
        p(s, y, b, "\u226F", "\\ngtr");
        p(s, y, b, "\uE00F", "\\ngeqslant");
        p(s, y, b, "\uE00E", "\\ngeqq");
        p(s, y, b, "\u2A88", "\\gneq");
        p(s, y, b, "\u2269", "\\gneqq");
        p(s, y, b, "\uE00D", "\\gvertneqq");
        p(s, y, b, "\u22E7", "\\gnsim");
        p(s, y, b, "\u2A8A", "\\gnapprox");
        p(s, y, b, "\u2281", "\\nsucc");
        p(s, y, b, "\u22E1", "\\nsucceq");
        p(s, y, b, "\u22E9", "\\succnsim");
        p(s, y, b, "\u2ABA", "\\succnapprox");
        p(s, y, b, "\u2246", "\\ncong");
        p(s, y, b, "\uE007", "\\nshortparallel");
        p(s, y, b, "\u2226", "\\nparallel");
        p(s, y, b, "\u22AF", "\\nVDash");
        p(s, y, b, "\u22EB", "\\ntriangleright");
        p(s, y, b, "\u22ED", "\\ntrianglerighteq");
        p(s, y, b, "\uE018", "\\nsupseteqq");
        p(s, y, b, "\u228B", "\\supsetneq");
        p(s, y, b, "\uE01B", "\\varsupsetneq");
        p(s, y, b, "\u2ACC", "\\supsetneqq");
        p(s, y, b, "\uE019", "\\varsupsetneqq");
        p(s, y, b, "\u22AE", "\\nVdash");
        p(s, y, b, "\u2AB5", "\\precneqq");
        p(s, y, b, "\u2AB6", "\\succneqq");
        p(s, y, b, "\uE016", "\\nsubseteqq");
        p(s, y, cn, "\u22B4", "\\unlhd");
        p(s, y, cn, "\u22B5", "\\unrhd");
        p(s, y, b, "\u219A", "\\nleftarrow");
        p(s, y, b, "\u219B", "\\nrightarrow");
        p(s, y, b, "\u21CD", "\\nLeftarrow");
        p(s, y, b, "\u21CF", "\\nRightarrow");
        p(s, y, b, "\u21AE", "\\nleftrightarrow");
        p(s, y, b, "\u21CE", "\\nLeftrightarrow");
        p(s, y, b, "\u25B3", "\\vartriangle");
        p(s, y, K, "\u210F", "\\hslash");
        p(s, y, K, "\u25BD", "\\triangledown");
        p(s, y, K, "\u25CA", "\\lozenge");
        p(s, y, K, "\u24C8", "\\circledS");
        p(s, y, K, "\xAE", "\\circledR");
        p(s, y, K, "\u2221", "\\measuredangle");
        p(s, y, K, "\u2204", "\\nexists");
        p(s, y, K, "\u2127", "\\mho");
        p(s, y, K, "\u2132", "\\Finv");
        p(s, y, K, "\u2141", "\\Game");
        p(s, y, K, "k", "\\Bbbk");
        p(s, y, K, "\u2035", "\\backprime");
        p(s, y, K, "\u25B2", "\\blacktriangle");
        p(s, y, K, "\u25BC", "\\blacktriangledown");
        p(s, y, K, "\u25A0", "\\blacksquare");
        p(s, y, K, "\u29EB", "\\blacklozenge");
        p(s, y, K, "\u2605", "\\bigstar");
        p(s, y, K, "\u2222", "\\sphericalangle");
        p(s, y, K, "\u2201", "\\complement");
        p(s, y, K, "\xF0", "\\eth");
        p(s, y, K, "\u2571", "\\diagup");
        p(s, y, K, "\u2572", "\\diagdown");
        p(s, y, K, "\u25A1", "\\square");
        p(s, y, K, "\u25A1", "\\Box");
        p(s, y, K, "\u25CA", "\\Diamond");
        p(s, y, K, "\xA5", "\\yen");
        p(s, y, K, "\u2713", "\\checkmark");
        p(s, y, K, "\u2136", "\\beth");
        p(s, y, K, "\u2138", "\\daleth");
        p(s, y, K, "\u2137", "\\gimel");
        p(s, y, K, "\u03DD", "\\digamma");
        p(s, y, K, "\u03F0", "\\varkappa");
        p(s, y, vt, "\u250C", "\\ulcorner");
        p(s, y, je, "\u2510", "\\urcorner");
        p(s, y, vt, "\u2514", "\\llcorner");
        p(s, y, je, "\u2518", "\\lrcorner");
        p(s, y, b, "\u2266", "\\leqq");
        p(s, y, b, "\u2A7D", "\\leqslant");
        p(s, y, b, "\u2A95", "\\eqslantless");
        p(s, y, b, "\u2272", "\\lesssim");
        p(s, y, b, "\u2A85", "\\lessapprox");
        p(s, y, b, "\u224A", "\\approxeq");
        p(s, y, cn, "\u22D6", "\\lessdot");
        p(s, y, b, "\u22D8", "\\lll");
        p(s, y, b, "\u2276", "\\lessgtr");
        p(s, y, b, "\u22DA", "\\lesseqgtr");
        p(s, y, b, "\u2A8B", "\\lesseqqgtr");
        p(s, y, b, "\u2251", "\\doteqdot");
        p(s, y, b, "\u2253", "\\risingdotseq");
        p(s, y, b, "\u2252", "\\fallingdotseq");
        p(s, y, b, "\u223D", "\\backsim");
        p(s, y, b, "\u22CD", "\\backsimeq");
        p(s, y, b, "\u2AC5", "\\subseteqq");
        p(s, y, b, "\u22D0", "\\Subset");
        p(s, y, b, "\u228F", "\\sqsubset");
        p(s, y, b, "\u227C", "\\preccurlyeq");
        p(s, y, b, "\u22DE", "\\curlyeqprec");
        p(s, y, b, "\u227E", "\\precsim");
        p(s, y, b, "\u2AB7", "\\precapprox");
        p(s, y, b, "\u22B2", "\\vartriangleleft");
        p(s, y, b, "\u22B4", "\\trianglelefteq");
        p(s, y, b, "\u22A8", "\\vDash");
        p(s, y, b, "\u22AA", "\\Vvdash");
        p(s, y, b, "\u2323", "\\smallsmile");
        p(s, y, b, "\u2322", "\\smallfrown");
        p(s, y, b, "\u224F", "\\bumpeq");
        p(s, y, b, "\u224E", "\\Bumpeq");
        p(s, y, b, "\u2267", "\\geqq");
        p(s, y, b, "\u2A7E", "\\geqslant");
        p(s, y, b, "\u2A96", "\\eqslantgtr");
        p(s, y, b, "\u2273", "\\gtrsim");
        p(s, y, b, "\u2A86", "\\gtrapprox");
        p(s, y, cn, "\u22D7", "\\gtrdot");
        p(s, y, b, "\u22D9", "\\ggg");
        p(s, y, b, "\u2277", "\\gtrless");
        p(s, y, b, "\u22DB", "\\gtreqless");
        p(s, y, b, "\u2A8C", "\\gtreqqless");
        p(s, y, b, "\u2256", "\\eqcirc");
        p(s, y, b, "\u2257", "\\circeq");
        p(s, y, b, "\u225C", "\\triangleq");
        p(s, y, b, "\u223C", "\\thicksim");
        p(s, y, b, "\u2248", "\\thickapprox");
        p(s, y, b, "\u2AC6", "\\supseteqq");
        p(s, y, b, "\u22D1", "\\Supset");
        p(s, y, b, "\u2290", "\\sqsupset");
        p(s, y, b, "\u227D", "\\succcurlyeq");
        p(s, y, b, "\u22DF", "\\curlyeqsucc");
        p(s, y, b, "\u227F", "\\succsim");
        p(s, y, b, "\u2AB8", "\\succapprox");
        p(s, y, b, "\u22B3", "\\vartriangleright");
        p(s, y, b, "\u22B5", "\\trianglerighteq");
        p(s, y, b, "\u22A9", "\\Vdash");
        p(s, y, b, "\u2223", "\\shortmid");
        p(s, y, b, "\u2225", "\\shortparallel");
        p(s, y, b, "\u226C", "\\between");
        p(s, y, b, "\u22D4", "\\pitchfork");
        p(s, y, b, "\u221D", "\\varpropto");
        p(s, y, b, "\u25C0", "\\blacktriangleleft");
        p(s, y, b, "\u2234", "\\therefore");
        p(s, y, b, "\u220D", "\\backepsilon");
        p(s, y, b, "\u25B6", "\\blacktriangleright");
        p(s, y, b, "\u2235", "\\because");
        p(s, y, b, "\u22D8", "\\llless");
        p(s, y, b, "\u22D9", "\\gggtr");
        p(s, y, cn, "\u22B2", "\\lhd");
        p(s, y, cn, "\u22B3", "\\rhd");
        p(s, y, b, "\u2242", "\\eqsim");
        p(s, g, b, "\u22C8", "\\Join");
        p(s, y, b, "\u2251", "\\Doteq");
        p(s, y, cn, "\u2214", "\\dotplus");
        p(s, y, cn, "\u2216", "\\smallsetminus");
        p(s, y, cn, "\u22D2", "\\Cap");
        p(s, y, cn, "\u22D3", "\\Cup");
        p(s, y, cn, "\u2A5E", "\\doublebarwedge");
        p(s, y, cn, "\u229F", "\\boxminus");
        p(s, y, cn, "\u229E", "\\boxplus");
        p(s, y, cn, "\u22C7", "\\divideontimes");
        p(s, y, cn, "\u22C9", "\\ltimes");
        p(s, y, cn, "\u22CA", "\\rtimes");
        p(s, y, cn, "\u22CB", "\\leftthreetimes");
        p(s, y, cn, "\u22CC", "\\rightthreetimes");
        p(s, y, cn, "\u22CF", "\\curlywedge");
        p(s, y, cn, "\u22CE", "\\curlyvee");
        p(s, y, cn, "\u229D", "\\circleddash");
        p(s, y, cn, "\u229B", "\\circledast");
        p(s, y, cn, "\u22C5", "\\centerdot");
        p(s, y, cn, "\u22BA", "\\intercal");
        p(s, y, cn, "\u22D2", "\\doublecap");
        p(s, y, cn, "\u22D3", "\\doublecup");
        p(s, y, cn, "\u22A0", "\\boxtimes");
        p(s, y, b, "\u21E2", "\\dashrightarrow");
        p(s, y, b, "\u21E0", "\\dashleftarrow");
        p(s, y, b, "\u21C7", "\\leftleftarrows");
        p(s, y, b, "\u21C6", "\\leftrightarrows");
        p(s, y, b, "\u21DA", "\\Lleftarrow");
        p(s, y, b, "\u219E", "\\twoheadleftarrow");
        p(s, y, b, "\u21A2", "\\leftarrowtail");
        p(s, y, b, "\u21AB", "\\looparrowleft");
        p(s, y, b, "\u21CB", "\\leftrightharpoons");
        p(s, y, b, "\u21B6", "\\curvearrowleft");
        p(s, y, b, "\u21BA", "\\circlearrowleft");
        p(s, y, b, "\u21B0", "\\Lsh");
        p(s, y, b, "\u21C8", "\\upuparrows");
        p(s, y, b, "\u21BF", "\\upharpoonleft");
        p(s, y, b, "\u21C3", "\\downharpoonleft");
        p(s, y, b, "\u22B8", "\\multimap");
        p(s, y, b, "\u21AD", "\\leftrightsquigarrow");
        p(s, y, b, "\u21C9", "\\rightrightarrows");
        p(s, y, b, "\u21C4", "\\rightleftarrows");
        p(s, y, b, "\u21A0", "\\twoheadrightarrow");
        p(s, y, b, "\u21A3", "\\rightarrowtail");
        p(s, y, b, "\u21AC", "\\looparrowright");
        p(s, y, b, "\u21B7", "\\curvearrowright");
        p(s, y, b, "\u21BB", "\\circlearrowright");
        p(s, y, b, "\u21B1", "\\Rsh");
        p(s, y, b, "\u21CA", "\\downdownarrows");
        p(s, y, b, "\u21BE", "\\upharpoonright");
        p(s, y, b, "\u21C2", "\\downharpoonright");
        p(s, y, b, "\u21DD", "\\rightsquigarrow");
        p(s, y, b, "\u21DD", "\\leadsto");
        p(s, y, b, "\u21DB", "\\Rrightarrow");
        p(s, y, b, "\u21BE", "\\restriction");
        p(s, g, K, "\u2018", "`");
        p(s, g, K, "$", "\\$");
        p(s, g, K, "%", "\\%");
        p(s, g, K, "_", "\\_");
        p(s, g, K, "\u2220", "\\angle");
        p(s, g, K, "\u221E", "\\infty");
        p(s, g, K, "\u2032", "\\prime");
        p(s, g, K, "\u25B3", "\\triangle");
        p(s, g, K, "\u0393", "\\Gamma");
        p(s, g, K, "\u0394", "\\Delta");
        p(s, g, K, "\u0398", "\\Theta");
        p(s, g, K, "\u039B", "\\Lambda");
        p(s, g, K, "\u039E", "\\Xi");
        p(s, g, K, "\u03A0", "\\Pi");
        p(s, g, K, "\u03A3", "\\Sigma");
        p(s, g, K, "\u03A5", "\\Upsilon");
        p(s, g, K, "\u03A6", "\\Phi");
        p(s, g, K, "\u03A8", "\\Psi");
        p(s, g, K, "\u03A9", "\\Omega");
        p(s, g, K, "\xAC", "\\neg");
        p(s, g, K, "\xAC", "\\lnot");
        p(s, g, K, "\u22A4", "\\top");
        p(s, g, K, "\u22A5", "\\bot");
        p(s, g, K, "\u2205", "\\emptyset");
        p(s, y, K, "\u2205", "\\varnothing");
        p(s, g, gr, "\u03B1", "\\alpha");
        p(s, g, gr, "\u03B2", "\\beta");
        p(s, g, gr, "\u03B3", "\\gamma");
        p(s, g, gr, "\u03B4", "\\delta");
        p(s, g, gr, "\u03F5", "\\epsilon");
        p(s, g, gr, "\u03B6", "\\zeta");
        p(s, g, gr, "\u03B7", "\\eta");
        p(s, g, gr, "\u03B8", "\\theta");
        p(s, g, gr, "\u03B9", "\\iota");
        p(s, g, gr, "\u03BA", "\\kappa");
        p(s, g, gr, "\u03BB", "\\lambda");
        p(s, g, gr, "\u03BC", "\\mu");
        p(s, g, gr, "\u03BD", "\\nu");
        p(s, g, gr, "\u03BE", "\\xi");
        p(s, g, gr, "o", "\\omicron");
        p(s, g, gr, "\u03C0", "\\pi");
        p(s, g, gr, "\u03C1", "\\rho");
        p(s, g, gr, "\u03C3", "\\sigma");
        p(s, g, gr, "\u03C4", "\\tau");
        p(s, g, gr, "\u03C5", "\\upsilon");
        p(s, g, gr, "\u03D5", "\\phi");
        p(s, g, gr, "\u03C7", "\\chi");
        p(s, g, gr, "\u03C8", "\\psi");
        p(s, g, gr, "\u03C9", "\\omega");
        p(s, g, gr, "\u03B5", "\\varepsilon");
        p(s, g, gr, "\u03D1", "\\vartheta");
        p(s, g, gr, "\u03D6", "\\varpi");
        p(s, g, gr, "\u03F1", "\\varrho");
        p(s, g, gr, "\u03C2", "\\varsigma");
        p(s, g, gr, "\u03C6", "\\varphi");
        p(s, g, cn, "\u2217", "*");
        p(s, g, cn, "+", "+");
        p(s, g, cn, "\u2212", "-");
        p(s, g, cn, "\u22C5", "\\cdot");
        p(s, g, cn, "\u2218", "\\circ");
        p(s, g, cn, "\xF7", "\\div");
        p(s, g, cn, "\xB1", "\\pm");
        p(s, g, cn, "\xD7", "\\times");
        p(s, g, cn, "\u2229", "\\cap");
        p(s, g, cn, "\u222A", "\\cup");
        p(s, g, cn, "\u2216", "\\setminus");
        p(s, g, cn, "\u2227", "\\land");
        p(s, g, cn, "\u2228", "\\lor");
        p(s, g, cn, "\u2227", "\\wedge");
        p(s, g, cn, "\u2228", "\\vee");
        p(s, g, K, "\u221A", "\\surd");
        p(s, g, vt, "(", "(");
        p(s, g, vt, "[", "[");
        p(s, g, vt, "\u27E8", "\\langle");
        p(s, g, vt, "\u2223", "\\lvert");
        p(s, g, vt, "\u2225", "\\lVert");
        p(s, g, je, ")", ")");
        p(s, g, je, "]", "]");
        p(s, g, je, "?", "?");
        p(s, g, je, "!", "!");
        p(s, g, je, "\u27E9", "\\rangle");
        p(s, g, je, "\u2223", "\\rvert");
        p(s, g, je, "\u2225", "\\rVert");
        p(s, g, b, "=", "=");
        p(s, g, b, "<", "<");
        p(s, g, b, ">", ">");
        p(s, g, b, ":", ":");
        p(s, g, b, "\u2248", "\\approx");
        p(s, g, b, "\u2245", "\\cong");
        p(s, g, b, "\u2265", "\\ge");
        p(s, g, b, "\u2265", "\\geq");
        p(s, g, b, "\u2190", "\\gets");
        p(s, g, b, ">", "\\gt");
        p(s, g, b, "\u2208", "\\in");
        p(s, g, b, "\u2209", "\\notin");
        p(s, g, b, "\u2282", "\\subset");
        p(s, g, b, "\u2283", "\\supset");
        p(s, g, b, "\u2286", "\\subseteq");
        p(s, g, b, "\u2287", "\\supseteq");
        p(s, y, b, "\u2288", "\\nsubseteq");
        p(s, y, b, "\u2289", "\\nsupseteq");
        p(s, g, b, "\u22A8", "\\models");
        p(s, g, b, "\u2190", "\\leftarrow");
        p(s, g, b, "\u2264", "\\le");
        p(s, g, b, "\u2264", "\\leq");
        p(s, g, b, "<", "\\lt");
        p(s, g, b, "\u2260", "\\ne");
        p(s, g, b, "\u2260", "\\neq");
        p(s, g, b, "\u2192", "\\rightarrow");
        p(s, g, b, "\u2192", "\\to");
        p(s, y, b, "\u2271", "\\ngeq");
        p(s, y, b, "\u2270", "\\nleq");
        p(s, g, At, null, "\\!");
        p(s, g, At, "\xA0", "\\ ");
        p(s, g, At, "\xA0", "~");
        p(s, g, At, null, "\\,");
        p(s, g, At, null, "\\:");
        p(s, g, At, null, "\\;");
        p(s, g, At, null, "\\enspace");
        p(s, g, At, null, "\\qquad");
        p(s, g, At, null, "\\quad");
        p(s, g, At, "\xA0", "\\space");
        p(s, g, Qc, ",", ",");
        p(s, g, Qc, ";", ";");
        p(s, g, Qc, ":", "\\colon");
        p(s, y, cn, "\u22BC", "\\barwedge");
        p(s, y, cn, "\u22BB", "\\veebar");
        p(s, g, cn, "\u2299", "\\odot");
        p(s, g, cn, "\u2295", "\\oplus");
        p(s, g, cn, "\u2297", "\\otimes");
        p(s, g, K, "\u2202", "\\partial");
        p(s, g, cn, "\u2298", "\\oslash");
        p(s, y, cn, "\u229A", "\\circledcirc");
        p(s, y, cn, "\u22A1", "\\boxdot");
        p(s, g, cn, "\u25B3", "\\bigtriangleup");
        p(s, g, cn, "\u25BD", "\\bigtriangledown");
        p(s, g, cn, "\u2020", "\\dagger");
        p(s, g, cn, "\u22C4", "\\diamond");
        p(s, g, cn, "\u22C6", "\\star");
        p(s, g, cn, "\u25C3", "\\triangleleft");
        p(s, g, cn, "\u25B9", "\\triangleright");
        p(s, g, vt, "{", "\\{");
        p(s, g, je, "}", "\\}");
        p(s, g, vt, "{", "\\lbrace");
        p(s, g, je, "}", "\\rbrace");
        p(s, g, vt, "[", "\\lbrack");
        p(s, g, je, "]", "\\rbrack");
        p(s, g, vt, "\u230A", "\\lfloor");
        p(s, g, je, "\u230B", "\\rfloor");
        p(s, g, vt, "\u2308", "\\lceil");
        p(s, g, je, "\u2309", "\\rceil");
        p(s, g, K, "\\", "\\backslash");
        p(s, g, K, "\u2223", "|");
        p(s, g, K, "\u2223", "\\vert");
        p(s, g, K, "\u2225", "\\|");
        p(s, g, K, "\u2225", "\\Vert");
        p(s, g, b, "\u2191", "\\uparrow");
        p(s, g, b, "\u21D1", "\\Uparrow");
        p(s, g, b, "\u2193", "\\downarrow");
        p(s, g, b, "\u21D3", "\\Downarrow");
        p(s, g, b, "\u2195", "\\updownarrow");
        p(s, g, b, "\u21D5", "\\Updownarrow");
        p(s, s, Re, "\u2210", "\\coprod");
        p(s, s, Re, "\u22C1", "\\bigvee");
        p(s, s, Re, "\u22C0", "\\bigwedge");
        p(s, s, Re, "\u2A04", "\\biguplus");
        p(s, s, Re, "\u22C2", "\\bigcap");
        p(s, s, Re, "\u22C3", "\\bigcup");
        p(s, s, Re, "\u222B", "\\int");
        p(s, s, Re, "\u222B", "\\intop");
        p(s, s, Re, "\u222C", "\\iint");
        p(s, s, Re, "\u222D", "\\iiint");
        p(s, s, Re, "\u220F", "\\prod");
        p(s, s, Re, "\u2211", "\\sum");
        p(s, s, Re, "\u2A02", "\\bigotimes");
        p(s, s, Re, "\u2A01", "\\bigoplus");
        p(s, s, Re, "\u2A00", "\\bigodot");
        p(s, s, Re, "\u222E", "\\oint");
        p(s, s, Re, "\u2A06", "\\bigsqcup");
        p(s, s, Re, "\u222B", "\\smallint");
        p(s, g, Iv, "\u2026", "\\ldots");
        p(s, g, Iv, "\u22EF", "\\cdots");
        p(s, g, Iv, "\u22F1", "\\ddots");
        p(s, g, K, "\u22EE", "\\vdots");
        p(s, g, Ha, "\xB4", "\\acute");
        p(s, g, Ha, "`", "\\grave");
        p(s, g, Ha, "\xA8", "\\ddot");
        p(s, g, Ha, "~", "\\tilde");
        p(s, g, Ha, "\xAF", "\\bar");
        p(s, g, Ha, "\u02D8", "\\breve");
        p(s, g, Ha, "\u02C7", "\\check");
        p(s, g, Ha, "^", "\\hat");
        p(s, g, Ha, "\u20D7", "\\vec");
        p(s, g, Ha, "\u02D9", "\\dot");
        p(s, g, gr, "\u0131", "\\imath");
        p(s, g, gr, "\u0237", "\\jmath");
        p(jc, g, At, "\xA0", "\\ ");
        p(jc, g, At, "\xA0", " ");
        p(jc, g, At, "\xA0", "~");
        var Bt, aa, aT = '0123456789/@."';
        for(Bt = 0; Bt < aT.length; Bt++)aa = aT.charAt(Bt), p(s, g, K, aa, aa);
        var oT = "0123456789`!@*()-=+[]'\";:?/.,";
        for(Bt = 0; Bt < oT.length; Bt++)aa = oT.charAt(Bt), p(jc, g, K, aa, aa);
        var uT = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(Bt = 0; Bt < uT.length; Bt++)aa = uT.charAt(Bt), p(s, g, gr, aa, aa), p(jc, g, K, aa, aa);
    });
    var Yc = Jr((Yyn, mT)=>{
        var nf = xv(), fT = Xi(), Vu = Kc(), Sv = Na(), o7 = [
            "\\Gamma",
            "\\Delta",
            "\\Theta",
            "\\Lambda",
            "\\Xi",
            "\\Pi",
            "\\Sigma",
            "\\Upsilon",
            "\\Phi",
            "\\Psi",
            "\\Omega"
        ], cT = [
            "\u0131",
            "\u0237"
        ], Ju = function(n, r, e, t, a) {
            Vu[e][n] && Vu[e][n].replace && (n = Vu[e][n].replace);
            var o = fT.getCharacterMetrics(n, r), u;
            return o ? u = new nf.symbolNode(n, o.height, o.depth, o.italic, o.skew, a) : (typeof console < "u" && console.warn("No character metrics for '" + n + "' in style '" + r + "'"), u = new nf.symbolNode(n, 0, 0, 0, 0, a)), t && (u.style.color = t), u;
        }, u7 = function(n, r, e, t) {
            return n === "\\" || Vu[r][n].font === "main" ? Ju(n, "Main-Regular", r, e, t) : Ju(n, "AMS-Regular", r, e, t.concat([
                "amsrm"
            ]));
        }, iT = function(n, r, e, t, a) {
            if (a === "mathord") return lT(n, r, e, t);
            if (a === "textord") return Ju(n, "Main-Regular", r, e, t.concat([
                "mathrm"
            ]));
            throw new Error("unexpected type: " + a + " in mathDefault");
        }, lT = function(n, r, e, t) {
            return /[0-9]/.test(n.charAt(0)) || Sv.contains(cT, n) || Sv.contains(o7, n) ? Ju(n, "Main-Italic", r, e, t.concat([
                "mainit"
            ])) : Ju(n, "Math-Italic", r, e, t.concat([
                "mathit"
            ]));
        }, i7 = function(n, r, e) {
            var t = n.mode, a = n.value;
            Vu[t][a] && Vu[t][a].replace && (a = Vu[t][a].replace);
            var o = [
                "mord"
            ], u = r.getColor(), i = r.font;
            if (i) {
                if (i === "mathit" || Sv.contains(cT, a)) return lT(a, t, u, o);
                var c = pT[i].fontName;
                return fT.getCharacterMetrics(a, c) ? Ju(a, c, t, u, o.concat([
                    i
                ])) : iT(a, t, u, o, e);
            } else return iT(a, t, u, o, e);
        }, sT = function(n) {
            var r = 0, e = 0, t = 0;
            if (n.children) for(var a = 0; a < n.children.length; a++)n.children[a].height > r && (r = n.children[a].height), n.children[a].depth > e && (e = n.children[a].depth), n.children[a].maxFontSize > t && (t = n.children[a].maxFontSize);
            n.height = r, n.depth = e, n.maxFontSize = t;
        }, Zi = function(n, r, e) {
            var t = new nf.span(n, r);
            return sT(t), e && (t.style.color = e), t;
        }, f7 = function(n) {
            var r = new nf.documentFragment(n);
            return sT(r), r;
        }, c7 = function(n, r) {
            var e = Zi([], [
                new nf.symbolNode("\u200B")
            ]);
            e.style.fontSize = r / n.style.sizeMultiplier + "em";
            var t = Zi([
                "fontsize-ensurer",
                "reset-" + n.size,
                "size5"
            ], [
                e
            ]);
            return t;
        }, l7 = function(n, r, e, t) {
            var a, o, u;
            if (r === "individualShift") {
                var i = n;
                for(n = [
                    i[0]
                ], a = -i[0].shift - i[0].elem.depth, o = a, u = 1; u < i.length; u++){
                    var c = -i[u].shift - o - i[u].elem.depth, l = c - (i[u - 1].elem.height + i[u - 1].elem.depth);
                    o = o + c, n.push({
                        type: "kern",
                        size: l
                    }), n.push(i[u]);
                }
            } else if (r === "top") {
                var d = e;
                for(u = 0; u < n.length; u++)n[u].type === "kern" ? d -= n[u].size : d -= n[u].elem.height + n[u].elem.depth;
                a = d;
            } else r === "bottom" ? a = -e : r === "shift" ? a = -n[0].elem.depth - e : r === "firstBaseline" ? a = -n[0].elem.depth : a = 0;
            var m = 0;
            for(u = 0; u < n.length; u++)n[u].type === "elem" && (m = Math.max(m, n[u].elem.maxFontSize));
            var v = c7(t, m), _ = [];
            for(o = a, u = 0; u < n.length; u++)if (n[u].type === "kern") o += n[u].size;
            else {
                var D = n[u].elem, T = -D.depth - o;
                o += D.height + D.depth;
                var I = Zi([], [
                    v,
                    D
                ]);
                I.height -= T, I.depth += T, I.style.top = T + "em", _.push(I);
            }
            var $ = Zi([
                "baseline-fix"
            ], [
                v,
                new nf.symbolNode("\u200B")
            ]);
            _.push($);
            var q = Zi([
                "vlist"
            ], _);
            return q.height = Math.max(o, q.height), q.depth = Math.max(-a, q.depth), q;
        }, s7 = {
            size1: .5,
            size2: .7,
            size3: .8,
            size4: .9,
            size5: 1,
            size6: 1.2,
            size7: 1.44,
            size8: 1.73,
            size9: 2.07,
            size10: 2.49
        }, p7 = {
            "\\qquad": {
                size: "2em",
                className: "qquad"
            },
            "\\quad": {
                size: "1em",
                className: "quad"
            },
            "\\enspace": {
                size: "0.5em",
                className: "enspace"
            },
            "\\;": {
                size: "0.277778em",
                className: "thickspace"
            },
            "\\:": {
                size: "0.22222em",
                className: "mediumspace"
            },
            "\\,": {
                size: "0.16667em",
                className: "thinspace"
            },
            "\\!": {
                size: "-0.16667em",
                className: "negativethinspace"
            }
        }, pT = {
            mathbf: {
                variant: "bold",
                fontName: "Main-Bold"
            },
            mathrm: {
                variant: "normal",
                fontName: "Main-Regular"
            },
            mathbb: {
                variant: "double-struck",
                fontName: "AMS-Regular"
            },
            mathcal: {
                variant: "script",
                fontName: "Caligraphic-Regular"
            },
            mathfrak: {
                variant: "fraktur",
                fontName: "Fraktur-Regular"
            },
            mathscr: {
                variant: "script",
                fontName: "Script-Regular"
            },
            mathsf: {
                variant: "sans-serif",
                fontName: "SansSerif-Regular"
            },
            mathtt: {
                variant: "monospace",
                fontName: "Typewriter-Regular"
            }
        };
        mT.exports = {
            fontMap: pT,
            makeSymbol: Ju,
            mathsym: u7,
            makeSpan: Zi,
            makeFragment: f7,
            makeVList: l7,
            makeOrd: i7,
            sizingMultiplier: s7,
            spacingFunctions: p7
        };
    });
    var bT = Jr((Xyn, gT)=>{
        var m7 = ho(), oa = Gc(), rl = Yc(), Gu = Xi(), Rv = Kc(), Zc = Na(), nl = rl.makeSpan, Xc = function(n, r) {
            return Rv.math[n] && Rv.math[n].replace ? Gu.getCharacterMetrics(Rv.math[n].replace, r) : Gu.getCharacterMetrics(n, r);
        }, d7 = function(n, r, e) {
            return rl.makeSymbol(n, "Size" + r + "-Regular", e);
        }, Nv = function(n, r, e) {
            var t = nl([
                "style-wrap",
                e.style.reset(),
                r.cls()
            ], [
                n
            ]), a = r.sizeMultiplier / e.style.sizeMultiplier;
            return t.height *= a, t.depth *= a, t.maxFontSize = r.sizeMultiplier, t;
        }, _7 = function(n, r, e, t, a) {
            var o = rl.makeSymbol(n, "Main-Regular", a), u = Nv(o, r, t);
            if (e) {
                var i = (1 - t.style.sizeMultiplier / r.sizeMultiplier) * Gu.metrics.axisHeight;
                u.style.top = i + "em", u.height -= i, u.depth += i;
            }
            return u;
        }, dT = function(n, r, e, t, a) {
            var o = d7(n, r, a), u = Nv(nl([
                "delimsizing",
                "size" + r
            ], [
                o
            ], t.getColor()), oa.TEXT, t);
            if (e) {
                var i = (1 - t.style.sizeMultiplier) * Gu.metrics.axisHeight;
                u.style.top = i + "em", u.height -= i, u.depth += i;
            }
            return u;
        }, rf = function(n, r, e) {
            var t;
            r === "Size1-Regular" ? t = "delim-size1" : r === "Size4-Regular" && (t = "delim-size4");
            var a = nl([
                "delimsizinginner",
                t
            ], [
                nl([], [
                    rl.makeSymbol(n, r, e)
                ])
            ]);
            return {
                type: "elem",
                elem: a
            };
        }, _T = function(n, r, e, t, a) {
            var o, u, i, c;
            o = i = c = n, u = null;
            var l = "Size1-Regular";
            n === "\\uparrow" ? i = c = "\u23D0" : n === "\\Uparrow" ? i = c = "\u2016" : n === "\\downarrow" ? o = i = "\u23D0" : n === "\\Downarrow" ? o = i = "\u2016" : n === "\\updownarrow" ? (o = "\\uparrow", i = "\u23D0", c = "\\downarrow") : n === "\\Updownarrow" ? (o = "\\Uparrow", i = "\u2016", c = "\\Downarrow") : n === "[" || n === "\\lbrack" ? (o = "\u23A1", i = "\u23A2", c = "\u23A3", l = "Size4-Regular") : n === "]" || n === "\\rbrack" ? (o = "\u23A4", i = "\u23A5", c = "\u23A6", l = "Size4-Regular") : n === "\\lfloor" ? (i = o = "\u23A2", c = "\u23A3", l = "Size4-Regular") : n === "\\lceil" ? (o = "\u23A1", i = c = "\u23A2", l = "Size4-Regular") : n === "\\rfloor" ? (i = o = "\u23A5", c = "\u23A6", l = "Size4-Regular") : n === "\\rceil" ? (o = "\u23A4", i = c = "\u23A5", l = "Size4-Regular") : n === "(" ? (o = "\u239B", i = "\u239C", c = "\u239D", l = "Size4-Regular") : n === ")" ? (o = "\u239E", i = "\u239F", c = "\u23A0", l = "Size4-Regular") : n === "\\{" || n === "\\lbrace" ? (o = "\u23A7", u = "\u23A8", c = "\u23A9", i = "\u23AA", l = "Size4-Regular") : n === "\\}" || n === "\\rbrace" ? (o = "\u23AB", u = "\u23AC", c = "\u23AD", i = "\u23AA", l = "Size4-Regular") : n === "\\lgroup" ? (o = "\u23A7", c = "\u23A9", i = "\u23AA", l = "Size4-Regular") : n === "\\rgroup" ? (o = "\u23AB", c = "\u23AD", i = "\u23AA", l = "Size4-Regular") : n === "\\lmoustache" ? (o = "\u23A7", c = "\u23AD", i = "\u23AA", l = "Size4-Regular") : n === "\\rmoustache" ? (o = "\u23AB", c = "\u23A9", i = "\u23AA", l = "Size4-Regular") : n === "\\surd" && (o = "\uE001", c = "\u23B7", i = "\uE000", l = "Size4-Regular");
            var d = Xc(o, l), m = d.height + d.depth, v = Xc(i, l), _ = v.height + v.depth, D = Xc(c, l), T = D.height + D.depth, I = 0, $ = 1;
            if (u !== null) {
                var q = Xc(u, l);
                I = q.height + q.depth, $ = 2;
            }
            var z = m + T + I, S = Math.ceil((r - z) / ($ * _)), x = z + S * $ * _, Y = Gu.metrics.axisHeight;
            e && (Y *= t.style.sizeMultiplier);
            var Yn = x / 2 - Y, dr = [];
            dr.push(rf(c, l, a));
            var cr;
            if (u === null) for(cr = 0; cr < S; cr++)dr.push(rf(i, l, a));
            else {
                for(cr = 0; cr < S; cr++)dr.push(rf(i, l, a));
                for(dr.push(rf(u, l, a)), cr = 0; cr < S; cr++)dr.push(rf(i, l, a));
            }
            dr.push(rf(o, l, a));
            var Xr = rl.makeVList(dr, "bottom", Yn, t);
            return Nv(nl([
                "delimsizing",
                "mult"
            ], [
                Xr
            ], t.getColor()), oa.TEXT, t);
        }, vT = [
            "(",
            ")",
            "[",
            "\\lbrack",
            "]",
            "\\rbrack",
            "\\{",
            "\\lbrace",
            "\\}",
            "\\rbrace",
            "\\lfloor",
            "\\rfloor",
            "\\lceil",
            "\\rceil",
            "\\surd"
        ], v7 = [
            "\\uparrow",
            "\\downarrow",
            "\\updownarrow",
            "\\Uparrow",
            "\\Downarrow",
            "\\Updownarrow",
            "|",
            "\\|",
            "\\vert",
            "\\Vert",
            "\\lvert",
            "\\rvert",
            "\\lVert",
            "\\rVert",
            "\\lgroup",
            "\\rgroup",
            "\\lmoustache",
            "\\rmoustache"
        ], hT = [
            "<",
            ">",
            "\\langle",
            "\\rangle",
            "/",
            "\\backslash",
            "\\lt",
            "\\gt"
        ], h7 = [
            0,
            1.2,
            1.8,
            2.4,
            3
        ], D7 = function(n, r, e, t) {
            if (n === "<" || n === "\\lt" ? n = "\\langle" : (n === ">" || n === "\\gt") && (n = "\\rangle"), Zc.contains(vT, n) || Zc.contains(hT, n)) return dT(n, r, !1, e, t);
            if (Zc.contains(v7, n)) return _T(n, h7[r], !1, e, t);
            throw new m7("Illegal delimiter: '" + n + "'");
        }, g7 = [
            {
                type: "small",
                style: oa.SCRIPTSCRIPT
            },
            {
                type: "small",
                style: oa.SCRIPT
            },
            {
                type: "small",
                style: oa.TEXT
            },
            {
                type: "large",
                size: 1
            },
            {
                type: "large",
                size: 2
            },
            {
                type: "large",
                size: 3
            },
            {
                type: "large",
                size: 4
            }
        ], b7 = [
            {
                type: "small",
                style: oa.SCRIPTSCRIPT
            },
            {
                type: "small",
                style: oa.SCRIPT
            },
            {
                type: "small",
                style: oa.TEXT
            },
            {
                type: "stack"
            }
        ], y7 = [
            {
                type: "small",
                style: oa.SCRIPTSCRIPT
            },
            {
                type: "small",
                style: oa.SCRIPT
            },
            {
                type: "small",
                style: oa.TEXT
            },
            {
                type: "large",
                size: 1
            },
            {
                type: "large",
                size: 2
            },
            {
                type: "large",
                size: 3
            },
            {
                type: "large",
                size: 4
            },
            {
                type: "stack"
            }
        ], C7 = function(n) {
            if (n.type === "small") return "Main-Regular";
            if (n.type === "large") return "Size" + n.size + "-Regular";
            if (n.type === "stack") return "Size4-Regular";
        }, E7 = function(n, r, e, t) {
            for(var a = Math.min(2, 3 - t.style.size), o = a; o < e.length && e[o].type !== "stack"; o++){
                var u = Xc(n, C7(e[o])), i = u.height + u.depth;
                if (e[o].type === "small" && (i *= e[o].style.sizeMultiplier), i > r) return e[o];
            }
            return e[e.length - 1];
        }, DT = function(n, r, e, t, a) {
            n === "<" || n === "\\lt" ? n = "\\langle" : (n === ">" || n === "\\gt") && (n = "\\rangle");
            var o;
            Zc.contains(hT, n) ? o = g7 : Zc.contains(vT, n) ? o = y7 : o = b7;
            var u = E7(n, r, o, t);
            if (u.type === "small") return _7(n, u.style, e, t, a);
            if (u.type === "large") return dT(n, u.size, e, t, a);
            if (u.type === "stack") return _T(n, r, e, t, a);
        }, T7 = function(n, r, e, t, a) {
            var o = Gu.metrics.axisHeight * t.style.sizeMultiplier, u = 901, i = 5 / Gu.metrics.ptPerEm, c = Math.max(r - o, e + o), l = Math.max(c / 500 * u, 2 * c - i);
            return DT(n, l, !0, t, a);
        };
        gT.exports = {
            sizedDelim: D7,
            customSizedDelim: DT,
            leftRightDelim: T7
        };
    });
    var TT = Jr((Zyn, ET)=>{
        var CT = ho(), de = Gc(), ur = Yc(), ef = bT(), yT = xv(), jn = Xi(), el = Na(), _n = ur.makeSpan, Xo = function(n, r, e) {
            for(var t = [], a = 0; a < n.length; a++){
                var o = n[a];
                t.push(Ce(o, r, e)), e = o;
            }
            return t;
        }, tl = {
            mathord: "mord",
            textord: "mord",
            bin: "mbin",
            rel: "mrel",
            text: "mord",
            open: "mopen",
            close: "mclose",
            inner: "minner",
            genfrac: "mord",
            array: "mord",
            spacing: "mord",
            punct: "mpunct",
            ordgroup: "mord",
            op: "mop",
            katex: "mord",
            overline: "mord",
            underline: "mord",
            rule: "mord",
            leftright: "minner",
            sqrt: "mord",
            accent: "mord"
        }, ju = function(n) {
            return n == null ? tl.mathord : n.type === "supsub" ? ju(n.value.base) : n.type === "llap" || n.type === "rlap" ? ju(n.value) : n.type === "color" || n.type === "sizing" || n.type === "styling" ? ju(n.value.value) : n.type === "delimsizing" ? tl[n.value.delimType] : tl[n.type];
        }, M7 = function(n, r) {
            return n ? n.type === "op" ? n.value.limits && (r.style.size === de.DISPLAY.size || n.value.alwaysHandleSupSub) : n.type === "accent" ? Hv(n.value.base) : null : !1;
        }, W0 = function(n) {
            return n ? n.type === "ordgroup" ? n.value.length === 1 ? W0(n.value[0]) : n : n.type === "color" && n.value.value.length === 1 ? W0(n.value.value[0]) : n : !1;
        }, Hv = function(n) {
            var r = W0(n);
            return r.type === "mathord" || r.type === "textord" || r.type === "bin" || r.type === "rel" || r.type === "inner" || r.type === "open" || r.type === "close" || r.type === "punct";
        }, $0 = function(n) {
            return _n([
                "sizing",
                "reset-" + n.size,
                "size5",
                n.style.reset(),
                de.TEXT.cls(),
                "nulldelimiter"
            ]);
        }, br = {};
        br.mathord = function(n, r, e) {
            return ur.makeOrd(n, r, "mathord");
        };
        br.textord = function(n, r, e) {
            return ur.makeOrd(n, r, "textord");
        };
        br.bin = function(n, r, e) {
            for(var t = "mbin", a = e; a && a.type === "color";){
                var o = a.value.value;
                a = o[o.length - 1];
            }
            return (!e || el.contains([
                "mbin",
                "mopen",
                "mrel",
                "mop",
                "mpunct"
            ], ju(a))) && (n.type = "textord", t = "mord"), ur.mathsym(n.value, n.mode, r.getColor(), [
                t
            ]);
        };
        br.rel = function(n, r, e) {
            return ur.mathsym(n.value, n.mode, r.getColor(), [
                "mrel"
            ]);
        };
        br.open = function(n, r, e) {
            return ur.mathsym(n.value, n.mode, r.getColor(), [
                "mopen"
            ]);
        };
        br.close = function(n, r, e) {
            return ur.mathsym(n.value, n.mode, r.getColor(), [
                "mclose"
            ]);
        };
        br.inner = function(n, r, e) {
            return ur.mathsym(n.value, n.mode, r.getColor(), [
                "minner"
            ]);
        };
        br.punct = function(n, r, e) {
            return ur.mathsym(n.value, n.mode, r.getColor(), [
                "mpunct"
            ]);
        };
        br.ordgroup = function(n, r, e) {
            return _n([
                "mord",
                r.style.cls()
            ], Xo(n.value, r.reset()));
        };
        br.text = function(n, r, e) {
            return _n([
                "text",
                "mord",
                r.style.cls()
            ], Xo(n.value.body, r.reset()));
        };
        br.color = function(n, r, e) {
            var t = Xo(n.value.value, r.withColor(n.value.color), e);
            return new ur.makeFragment(t);
        };
        br.supsub = function(n, r, e) {
            if (M7(n.value.base, r)) return br[n.value.base.type](n, r, e);
            var t = Ce(n.value.base, r.reset()), a, o, u, i;
            n.value.sup && (u = Ce(n.value.sup, r.withStyle(r.style.sup())), a = _n([
                r.style.reset(),
                r.style.sup().cls()
            ], [
                u
            ])), n.value.sub && (i = Ce(n.value.sub, r.withStyle(r.style.sub())), o = _n([
                r.style.reset(),
                r.style.sub().cls()
            ], [
                i
            ]));
            var c, l;
            Hv(n.value.base) ? (c = 0, l = 0) : (c = t.height - jn.metrics.supDrop, l = t.depth + jn.metrics.subDrop);
            var d;
            r.style === de.DISPLAY ? d = jn.metrics.sup1 : r.style.cramped ? d = jn.metrics.sup3 : d = jn.metrics.sup2;
            var m = de.TEXT.sizeMultiplier * r.style.sizeMultiplier, v = .5 / jn.metrics.ptPerEm / m + "em", _;
            if (!n.value.sup) l = Math.max(l, jn.metrics.sub1, i.height - .8 * jn.metrics.xHeight), _ = ur.makeVList([
                {
                    type: "elem",
                    elem: o
                }
            ], "shift", l, r), _.children[0].style.marginRight = v, t instanceof yT.symbolNode && (_.children[0].style.marginLeft = -t.italic + "em");
            else if (!n.value.sub) c = Math.max(c, d, u.depth + .25 * jn.metrics.xHeight), _ = ur.makeVList([
                {
                    type: "elem",
                    elem: a
                }
            ], "shift", -c, r), _.children[0].style.marginRight = v;
            else {
                c = Math.max(c, d, u.depth + .25 * jn.metrics.xHeight), l = Math.max(l, jn.metrics.sub2);
                var D = jn.metrics.defaultRuleThickness;
                if (c - u.depth - (i.height - l) < 4 * D) {
                    l = 4 * D - (c - u.depth) + i.height;
                    var T = .8 * jn.metrics.xHeight - (c - u.depth);
                    T > 0 && (c += T, l -= T);
                }
                _ = ur.makeVList([
                    {
                        type: "elem",
                        elem: o,
                        shift: l
                    },
                    {
                        type: "elem",
                        elem: a,
                        shift: -c
                    }
                ], "individualShift", null, r), t instanceof yT.symbolNode && (_.children[0].style.marginLeft = -t.italic + "em"), _.children[0].style.marginRight = v, _.children[1].style.marginRight = v;
            }
            return _n([
                ju(n.value.base)
            ], [
                t,
                _
            ]);
        };
        br.genfrac = function(n, r, e) {
            var t = r.style;
            n.value.size === "display" ? t = de.DISPLAY : n.value.size === "text" && (t = de.TEXT);
            var a = t.fracNum(), o = t.fracDen(), u = Ce(n.value.numer, r.withStyle(a)), i = _n([
                t.reset(),
                a.cls()
            ], [
                u
            ]), c = Ce(n.value.denom, r.withStyle(o)), l = _n([
                t.reset(),
                o.cls()
            ], [
                c
            ]), d;
            n.value.hasBarLine ? d = jn.metrics.defaultRuleThickness / r.style.sizeMultiplier : d = 0;
            var m, v, _;
            t.size === de.DISPLAY.size ? (m = jn.metrics.num1, d > 0 ? v = 3 * d : v = 7 * jn.metrics.defaultRuleThickness, _ = jn.metrics.denom1) : (d > 0 ? (m = jn.metrics.num2, v = d) : (m = jn.metrics.num3, v = 3 * jn.metrics.defaultRuleThickness), _ = jn.metrics.denom2);
            var D;
            if (d === 0) {
                var T = m - u.depth - (c.height - _);
                T < v && (m += .5 * (v - T), _ += .5 * (v - T)), D = ur.makeVList([
                    {
                        type: "elem",
                        elem: l,
                        shift: _
                    },
                    {
                        type: "elem",
                        elem: i,
                        shift: -m
                    }
                ], "individualShift", null, r);
            } else {
                var I = jn.metrics.axisHeight;
                m - u.depth - (I + .5 * d) < v && (m += v - (m - u.depth - (I + .5 * d))), I - .5 * d - (c.height - _) < v && (_ += v - (I - .5 * d - (c.height - _)));
                var $ = _n([
                    r.style.reset(),
                    de.TEXT.cls(),
                    "frac-line"
                ]);
                $.height = d;
                var q = -(I - .5 * d);
                D = ur.makeVList([
                    {
                        type: "elem",
                        elem: l,
                        shift: _
                    },
                    {
                        type: "elem",
                        elem: $,
                        shift: q
                    },
                    {
                        type: "elem",
                        elem: i,
                        shift: -m
                    }
                ], "individualShift", null, r);
            }
            D.height *= t.sizeMultiplier / r.style.sizeMultiplier, D.depth *= t.sizeMultiplier / r.style.sizeMultiplier;
            var z;
            t.size === de.DISPLAY.size ? z = jn.metrics.delim1 : z = jn.metrics.getDelim2(t);
            var S, x;
            return n.value.leftDelim == null ? S = $0(r) : S = ef.customSizedDelim(n.value.leftDelim, z, !0, r.withStyle(t), n.mode), n.value.rightDelim == null ? x = $0(r) : x = ef.customSizedDelim(n.value.rightDelim, z, !0, r.withStyle(t), n.mode), _n([
                "mord",
                r.style.reset(),
                t.cls()
            ], [
                S,
                _n([
                    "mfrac"
                ], [
                    D
                ]),
                x
            ], r.getColor());
        };
        br.array = function(n, r, e) {
            var t, a, o = n.value.body.length, u = 0, i = new Array(o), c = 1 / jn.metrics.ptPerEm, l = 5 * c, d = 12 * c, m = el.deflt(n.value.arraystretch, 1), v = m * d, _ = .7 * v, D = .3 * v, T = 0;
            for(t = 0; t < n.value.body.length; ++t){
                var I = n.value.body[t], $ = _, q = D;
                u < I.length && (u = I.length);
                var z = new Array(I.length);
                for(a = 0; a < I.length; ++a){
                    var S = Ce(I[a], r);
                    q < S.depth && (q = S.depth), $ < S.height && ($ = S.height), z[a] = S;
                }
                var x = 0;
                if (n.value.rowGaps[t]) {
                    switch(x = n.value.rowGaps[t].value, x.unit){
                        case "em":
                            x = x.number;
                            break;
                        case "ex":
                            x = x.number * jn.metrics.emPerEx;
                            break;
                        default:
                            console.error("Can't handle unit " + x.unit), x = 0;
                    }
                    x > 0 && (x += D, q < x && (q = x), x = 0);
                }
                z.height = $, z.depth = q, T += $, z.pos = T, T += q + x, i[t] = z;
            }
            var Y = T / 2 + jn.metrics.axisHeight, Yn = n.value.cols || [], dr = [], cr, Xr;
            for(a = 0, Xr = 0; a < u || Xr < Yn.length; ++a, ++Xr){
                for(var te = Yn[Xr] || {}, fa = !0; te.type === "separator";){
                    if (fa || (cr = _n([
                        "arraycolsep"
                    ], []), cr.style.width = jn.metrics.doubleRuleSep + "em", dr.push(cr)), te.separator === "|") {
                        var Te = _n([
                            "vertical-separator"
                        ], []);
                        Te.style.height = T + "em", Te.style.verticalAlign = -(T - Y) + "em", dr.push(Te);
                    } else throw new CT("Invalid separator type: " + te.separator);
                    Xr++, te = Yn[Xr] || {}, fa = !1;
                }
                if (!(a >= u)) {
                    var Fr;
                    (a > 0 || n.value.hskipBeforeAndAfter) && (Fr = el.deflt(te.pregap, l), Fr !== 0 && (cr = _n([
                        "arraycolsep"
                    ], []), cr.style.width = Fr + "em", dr.push(cr)));
                    var Vr = [];
                    for(t = 0; t < o; ++t){
                        var Er = i[t], it = Er[a];
                        if (it) {
                            var en = Er.pos - Y;
                            it.depth = Er.depth, it.height = Er.height, Vr.push({
                                type: "elem",
                                elem: it,
                                shift: en
                            });
                        }
                    }
                    Vr = ur.makeVList(Vr, "individualShift", null, r), Vr = _n([
                        "col-align-" + (te.align || "c")
                    ], [
                        Vr
                    ]), dr.push(Vr), (a < u - 1 || n.value.hskipBeforeAndAfter) && (Fr = el.deflt(te.postgap, l), Fr !== 0 && (cr = _n([
                        "arraycolsep"
                    ], []), cr.style.width = Fr + "em", dr.push(cr)));
                }
            }
            return i = _n([
                "mtable"
            ], dr), _n([
                "mord"
            ], [
                i
            ], r.getColor());
        };
        br.spacing = function(n, r, e) {
            return n.value === "\\ " || n.value === "\\space" || n.value === " " || n.value === "~" ? _n([
                "mord",
                "mspace"
            ], [
                ur.mathsym(n.value, n.mode)
            ]) : _n([
                "mord",
                "mspace",
                ur.spacingFunctions[n.value].className
            ]);
        };
        br.llap = function(n, r, e) {
            var t = _n([
                "inner"
            ], [
                Ce(n.value.body, r.reset())
            ]), a = _n([
                "fix"
            ], []);
            return _n([
                "llap",
                r.style.cls()
            ], [
                t,
                a
            ]);
        };
        br.rlap = function(n, r, e) {
            var t = _n([
                "inner"
            ], [
                Ce(n.value.body, r.reset())
            ]), a = _n([
                "fix"
            ], []);
            return _n([
                "rlap",
                r.style.cls()
            ], [
                t,
                a
            ]);
        };
        br.op = function(n, r, e) {
            var t, a, o = !1;
            n.type === "supsub" && (t = n.value.sup, a = n.value.sub, n = n.value.base, o = !0);
            var u = [
                "\\smallint"
            ], i = !1;
            r.style.size === de.DISPLAY.size && n.value.symbol && !el.contains(u, n.value.body) && (i = !0);
            var c, l = 0, d = 0;
            if (n.value.symbol) {
                var m = i ? "Size2-Regular" : "Size1-Regular";
                c = ur.makeSymbol(n.value.body, m, "math", r.getColor(), [
                    "op-symbol",
                    i ? "large-op" : "small-op",
                    "mop"
                ]), l = (c.height - c.depth) / 2 - jn.metrics.axisHeight * r.style.sizeMultiplier, d = c.italic;
            } else {
                for(var v = [], _ = 1; _ < n.value.body.length; _++)v.push(ur.mathsym(n.value.body[_], n.mode));
                c = _n([
                    "mop"
                ], v, r.getColor());
            }
            if (o) {
                c = _n([], [
                    c
                ]);
                var D, T, I, $;
                if (t) {
                    var q = Ce(t, r.withStyle(r.style.sup()));
                    D = _n([
                        r.style.reset(),
                        r.style.sup().cls()
                    ], [
                        q
                    ]), T = Math.max(jn.metrics.bigOpSpacing1, jn.metrics.bigOpSpacing3 - q.depth);
                }
                if (a) {
                    var z = Ce(a, r.withStyle(r.style.sub()));
                    I = _n([
                        r.style.reset(),
                        r.style.sub().cls()
                    ], [
                        z
                    ]), $ = Math.max(jn.metrics.bigOpSpacing2, jn.metrics.bigOpSpacing4 - z.height);
                }
                var S, x, Y;
                if (!t) x = c.height - l, S = ur.makeVList([
                    {
                        type: "kern",
                        size: jn.metrics.bigOpSpacing5
                    },
                    {
                        type: "elem",
                        elem: I
                    },
                    {
                        type: "kern",
                        size: $
                    },
                    {
                        type: "elem",
                        elem: c
                    }
                ], "top", x, r), S.children[0].style.marginLeft = -d + "em";
                else if (!a) Y = c.depth + l, S = ur.makeVList([
                    {
                        type: "elem",
                        elem: c
                    },
                    {
                        type: "kern",
                        size: T
                    },
                    {
                        type: "elem",
                        elem: D
                    },
                    {
                        type: "kern",
                        size: jn.metrics.bigOpSpacing5
                    }
                ], "bottom", Y, r), S.children[1].style.marginLeft = d + "em";
                else {
                    if (!t && !a) return c;
                    Y = jn.metrics.bigOpSpacing5 + I.height + I.depth + $ + c.depth + l, S = ur.makeVList([
                        {
                            type: "kern",
                            size: jn.metrics.bigOpSpacing5
                        },
                        {
                            type: "elem",
                            elem: I
                        },
                        {
                            type: "kern",
                            size: $
                        },
                        {
                            type: "elem",
                            elem: c
                        },
                        {
                            type: "kern",
                            size: T
                        },
                        {
                            type: "elem",
                            elem: D
                        },
                        {
                            type: "kern",
                            size: jn.metrics.bigOpSpacing5
                        }
                    ], "bottom", Y, r), S.children[0].style.marginLeft = -d + "em", S.children[2].style.marginLeft = d + "em";
                }
                return _n([
                    "mop",
                    "op-limits"
                ], [
                    S
                ]);
            } else return n.value.symbol && (c.style.top = l + "em"), c;
        };
        br.katex = function(n, r, e) {
            var t = _n([
                "k"
            ], [
                ur.mathsym("K", n.mode)
            ]), a = _n([
                "a"
            ], [
                ur.mathsym("A", n.mode)
            ]);
            a.height = (a.height + .2) * .75, a.depth = (a.height - .2) * .75;
            var o = _n([
                "t"
            ], [
                ur.mathsym("T", n.mode)
            ]), u = _n([
                "e"
            ], [
                ur.mathsym("E", n.mode)
            ]);
            u.height = u.height - .2155, u.depth = u.depth + .2155;
            var i = _n([
                "x"
            ], [
                ur.mathsym("X", n.mode)
            ]);
            return _n([
                "katex-logo",
                "mord"
            ], [
                t,
                a,
                o,
                u,
                i
            ], r.getColor());
        };
        br.overline = function(n, r, e) {
            var t = Ce(n.value.body, r.withStyle(r.style.cramp())), a = jn.metrics.defaultRuleThickness / r.style.sizeMultiplier, o = _n([
                r.style.reset(),
                de.TEXT.cls(),
                "overline-line"
            ]);
            o.height = a, o.maxFontSize = 1;
            var u = ur.makeVList([
                {
                    type: "elem",
                    elem: t
                },
                {
                    type: "kern",
                    size: 3 * a
                },
                {
                    type: "elem",
                    elem: o
                },
                {
                    type: "kern",
                    size: a
                }
            ], "firstBaseline", null, r);
            return _n([
                "overline",
                "mord"
            ], [
                u
            ], r.getColor());
        };
        br.underline = function(n, r, e) {
            var t = Ce(n.value.body, r), a = jn.metrics.defaultRuleThickness / r.style.sizeMultiplier, o = _n([
                r.style.reset(),
                de.TEXT.cls(),
                "underline-line"
            ]);
            o.height = a, o.maxFontSize = 1;
            var u = ur.makeVList([
                {
                    type: "kern",
                    size: a
                },
                {
                    type: "elem",
                    elem: o
                },
                {
                    type: "kern",
                    size: 3 * a
                },
                {
                    type: "elem",
                    elem: t
                }
            ], "top", t.height, r);
            return _n([
                "underline",
                "mord"
            ], [
                u
            ], r.getColor());
        };
        br.sqrt = function(n, r, e) {
            var t = Ce(n.value.body, r.withStyle(r.style.cramp())), a = jn.metrics.defaultRuleThickness / r.style.sizeMultiplier, o = _n([
                r.style.reset(),
                de.TEXT.cls(),
                "sqrt-line"
            ], [], r.getColor());
            o.height = a, o.maxFontSize = 1;
            var u = a;
            r.style.id < de.TEXT.id && (u = jn.metrics.xHeight);
            var i = a + u / 4, c = (t.height + t.depth) * r.style.sizeMultiplier, l = c + i + a, d = _n([
                "sqrt-sign"
            ], [
                ef.customSizedDelim("\\surd", l, !1, r, n.mode)
            ], r.getColor()), m = d.height + d.depth - a;
            m > t.height + t.depth + i && (i = (i + m - t.height - t.depth) / 2);
            var v = -(t.height + i + a) + d.height;
            d.style.top = v + "em", d.height -= v, d.depth += v;
            var _;
            if (t.height === 0 && t.depth === 0 ? _ = _n() : _ = ur.makeVList([
                {
                    type: "elem",
                    elem: t
                },
                {
                    type: "kern",
                    size: i
                },
                {
                    type: "elem",
                    elem: o
                },
                {
                    type: "kern",
                    size: a
                }
            ], "firstBaseline", null, r), n.value.index) {
                var D = Ce(n.value.index, r.withStyle(de.SCRIPTSCRIPT)), T = _n([
                    r.style.reset(),
                    de.SCRIPTSCRIPT.cls()
                ], [
                    D
                ]), I = Math.max(d.height, _.height), $ = Math.max(d.depth, _.depth), q = .6 * (I - $), z = ur.makeVList([
                    {
                        type: "elem",
                        elem: T
                    }
                ], "shift", -q, r), S = _n([
                    "root"
                ], [
                    z
                ]);
                return _n([
                    "sqrt",
                    "mord"
                ], [
                    S,
                    d,
                    _
                ]);
            } else return _n([
                "sqrt",
                "mord"
            ], [
                d,
                _
            ]);
        };
        br.sizing = function(n, r, e) {
            var t = Xo(n.value.value, r.withSize(n.value.size), e), a = _n([
                "mord"
            ], [
                _n([
                    "sizing",
                    "reset-" + r.size,
                    n.value.size,
                    r.style.cls()
                ], t)
            ]), o = ur.sizingMultiplier[n.value.size];
            return a.maxFontSize = o * r.style.sizeMultiplier, a;
        };
        br.styling = function(n, r, e) {
            var t = {
                display: de.DISPLAY,
                text: de.TEXT,
                script: de.SCRIPT,
                scriptscript: de.SCRIPTSCRIPT
            }, a = t[n.value.style], o = Xo(n.value.value, r.withStyle(a), e);
            return _n([
                r.style.reset(),
                a.cls()
            ], o);
        };
        br.font = function(n, r, e) {
            var t = n.value.font;
            return Ce(n.value.body, r.withFont(t), e);
        };
        br.delimsizing = function(n, r, e) {
            var t = n.value.value;
            return t === "." ? _n([
                tl[n.value.delimType]
            ]) : _n([
                tl[n.value.delimType]
            ], [
                ef.sizedDelim(t, n.value.size, r, n.mode)
            ]);
        };
        br.leftright = function(n, r, e) {
            for(var t = Xo(n.value.body, r.reset()), a = 0, o = 0, u = 0; u < t.length; u++)a = Math.max(t[u].height, a), o = Math.max(t[u].depth, o);
            a *= r.style.sizeMultiplier, o *= r.style.sizeMultiplier;
            var i;
            n.value.left === "." ? i = $0(r) : i = ef.leftRightDelim(n.value.left, a, o, r, n.mode), t.unshift(i);
            var c;
            return n.value.right === "." ? c = $0(r) : c = ef.leftRightDelim(n.value.right, a, o, r, n.mode), t.push(c), _n([
                "minner",
                r.style.cls()
            ], t, r.getColor());
        };
        br.rule = function(n, r, e) {
            var t = _n([
                "mord",
                "rule"
            ], [], r.getColor()), a = 0;
            n.value.shift && (a = n.value.shift.number, n.value.shift.unit === "ex" && (a *= jn.metrics.xHeight));
            var o = n.value.width.number;
            n.value.width.unit === "ex" && (o *= jn.metrics.xHeight);
            var u = n.value.height.number;
            return n.value.height.unit === "ex" && (u *= jn.metrics.xHeight), a /= r.style.sizeMultiplier, o /= r.style.sizeMultiplier, u /= r.style.sizeMultiplier, t.style.borderRightWidth = o + "em", t.style.borderTopWidth = u + "em", t.style.bottom = a + "em", t.width = o, t.height = u + a, t.depth = -a, t;
        };
        br.accent = function(n, r, e) {
            var t = n.value.base, a;
            if (n.type === "supsub") {
                var o = n;
                n = o.value.base, t = n.value.base, o.value.base = t, a = Ce(o, r.reset(), e);
            }
            var u = Ce(t, r.withStyle(r.style.cramp())), i;
            if (Hv(t)) {
                var c = W0(t), l = Ce(c, r.withStyle(r.style.cramp()));
                i = l.skew;
            } else i = 0;
            var d = Math.min(u.height, jn.metrics.xHeight), m = ur.makeSymbol(n.value.accent, "Main-Regular", "math", r.getColor());
            m.italic = 0;
            var v = n.value.accent === "\\vec" ? "accent-vec" : null, _ = _n([
                "accent-body",
                v
            ], [
                _n([], [
                    m
                ])
            ]);
            _ = ur.makeVList([
                {
                    type: "elem",
                    elem: u
                },
                {
                    type: "kern",
                    size: -d
                },
                {
                    type: "elem",
                    elem: _
                }
            ], "firstBaseline", null, r), _.children[1].style.marginLeft = 2 * i + "em";
            var D = _n([
                "mord",
                "accent"
            ], [
                _
            ]);
            return a ? (a.children[0] = D, a.height = Math.max(D.height, a.height), a.classes[0] = "mord", a) : D;
        };
        br.phantom = function(n, r, e) {
            var t = Xo(n.value.value, r.withPhantom(), e);
            return new ur.makeFragment(t);
        };
        var Ce = function(n, r, e) {
            if (!n) return _n();
            if (br[n.type]) {
                var t = br[n.type](n, r, e), a;
                return r.style !== r.parentStyle && (a = r.style.sizeMultiplier / r.parentStyle.sizeMultiplier, t.height *= a, t.depth *= a), r.size !== r.parentSize && (a = ur.sizingMultiplier[r.size] / ur.sizingMultiplier[r.parentSize], t.height *= a, t.depth *= a), t;
            } else throw new CT("Got group of unknown type: '" + n.type + "'");
        }, F7 = function(n, r) {
            n = JSON.parse(JSON.stringify(n));
            var e = Xo(n, r), t = _n([
                "base",
                r.style.cls()
            ], e), a = _n([
                "strut"
            ]), o = _n([
                "strut",
                "bottom"
            ]);
            a.style.height = t.height + "em", o.style.height = t.height + t.depth + "em", o.style.verticalAlign = -t.depth + "em";
            var u = _n([
                "katex-html"
            ], [
                a,
                o,
                t
            ]);
            return u.setAttribute("aria-hidden", "true"), u;
        };
        ET.exports = F7;
    });
    var wT = Jr((n2n, FT)=>{
        var MT = Na();
        function U0(n, r) {
            this.type = n, this.attributes = {}, this.children = r || [];
        }
        U0.prototype.setAttribute = function(n, r) {
            this.attributes[n] = r;
        };
        U0.prototype.toNode = function() {
            var n = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
            for(var r in this.attributes)Object.prototype.hasOwnProperty.call(this.attributes, r) && n.setAttribute(r, this.attributes[r]);
            for(var e = 0; e < this.children.length; e++)n.appendChild(this.children[e].toNode());
            return n;
        };
        U0.prototype.toMarkup = function() {
            var n = "<" + this.type;
            for(var r in this.attributes)Object.prototype.hasOwnProperty.call(this.attributes, r) && (n += " " + r + '="', n += MT.escape(this.attributes[r]), n += '"');
            n += ">";
            for(var e = 0; e < this.children.length; e++)n += this.children[e].toMarkup();
            return n += "</" + this.type + ">", n;
        };
        function Pv(n) {
            this.text = n;
        }
        Pv.prototype.toNode = function() {
            return document.createTextNode(this.text);
        };
        Pv.prototype.toMarkup = function() {
            return MT.escape(this.text);
        };
        FT.exports = {
            MathNode: U0,
            TextNode: Pv
        };
    });
    var LT = Jr((r2n, IT)=>{
        var B0 = Yc(), w7 = Xi(), Fn = wT(), x7 = ho(), tf = Kc(), A7 = Na(), I7 = B0.makeSpan, xT = B0.fontMap, It = function(n, r) {
            return tf[r][n] && tf[r][n].replace && (n = tf[r][n].replace), new Fn.TextNode(n);
        }, AT = function(n, r) {
            var e = r.font;
            if (!e) return null;
            var t = n.mode;
            if (e === "mathit") return "italic";
            var a = n.value;
            if (A7.contains([
                "\\imath",
                "\\jmath"
            ], a)) return null;
            tf[t][a] && tf[t][a].replace && (a = tf[t][a].replace);
            var o = xT[e].fontName;
            return w7.getCharacterMetrics(a, o) ? xT[r.font].variant : null;
        }, yr = {};
        yr.mathord = function(n, r) {
            var e = new Fn.MathNode("mi", [
                It(n.value, n.mode)
            ]), t = AT(n, r);
            return t && e.setAttribute("mathvariant", t), e;
        };
        yr.textord = function(n, r) {
            var e = It(n.value, n.mode), t = AT(n, r) || "normal", a;
            return /[0-9]/.test(n.value) ? (a = new Fn.MathNode("mn", [
                e
            ]), r.font && a.setAttribute("mathvariant", t)) : (a = new Fn.MathNode("mi", [
                e
            ]), a.setAttribute("mathvariant", t)), a;
        };
        yr.bin = function(n) {
            var r = new Fn.MathNode("mo", [
                It(n.value, n.mode)
            ]);
            return r;
        };
        yr.rel = function(n) {
            var r = new Fn.MathNode("mo", [
                It(n.value, n.mode)
            ]);
            return r;
        };
        yr.open = function(n) {
            var r = new Fn.MathNode("mo", [
                It(n.value, n.mode)
            ]);
            return r;
        };
        yr.close = function(n) {
            var r = new Fn.MathNode("mo", [
                It(n.value, n.mode)
            ]);
            return r;
        };
        yr.inner = function(n) {
            var r = new Fn.MathNode("mo", [
                It(n.value, n.mode)
            ]);
            return r;
        };
        yr.punct = function(n) {
            var r = new Fn.MathNode("mo", [
                It(n.value, n.mode)
            ]);
            return r.setAttribute("separator", "true"), r;
        };
        yr.ordgroup = function(n, r) {
            var e = Zo(n.value, r), t = new Fn.MathNode("mrow", e);
            return t;
        };
        yr.text = function(n, r) {
            var e = Zo(n.value.body, r), t = new Fn.MathNode("mtext", e);
            return t;
        };
        yr.color = function(n, r) {
            var e = Zo(n.value.value, r), t = new Fn.MathNode("mstyle", e);
            return t.setAttribute("mathcolor", n.value.color), t;
        };
        yr.supsub = function(n, r) {
            var e = [
                Qe(n.value.base, r)
            ];
            n.value.sub && e.push(Qe(n.value.sub, r)), n.value.sup && e.push(Qe(n.value.sup, r));
            var t;
            n.value.sub ? n.value.sup ? t = "msubsup" : t = "msub" : t = "msup";
            var a = new Fn.MathNode(t, e);
            return a;
        };
        yr.genfrac = function(n, r) {
            var e = new Fn.MathNode("mfrac", [
                Qe(n.value.numer, r),
                Qe(n.value.denom, r)
            ]);
            if (n.value.hasBarLine || e.setAttribute("linethickness", "0px"), n.value.leftDelim != null || n.value.rightDelim != null) {
                var t = [];
                if (n.value.leftDelim != null) {
                    var a = new Fn.MathNode("mo", [
                        new Fn.TextNode(n.value.leftDelim)
                    ]);
                    a.setAttribute("fence", "true"), t.push(a);
                }
                if (t.push(e), n.value.rightDelim != null) {
                    var o = new Fn.MathNode("mo", [
                        new Fn.TextNode(n.value.rightDelim)
                    ]);
                    o.setAttribute("fence", "true"), t.push(o);
                }
                var u = new Fn.MathNode("mrow", t);
                return u;
            }
            return e;
        };
        yr.array = function(n, r) {
            return new Fn.MathNode("mtable", n.value.body.map(function(e) {
                return new Fn.MathNode("mtr", e.map(function(t) {
                    return new Fn.MathNode("mtd", [
                        Qe(t, r)
                    ]);
                }));
            }));
        };
        yr.sqrt = function(n, r) {
            var e;
            return n.value.index ? e = new Fn.MathNode("mroot", [
                Qe(n.value.body, r),
                Qe(n.value.index, r)
            ]) : e = new Fn.MathNode("msqrt", [
                Qe(n.value.body, r)
            ]), e;
        };
        yr.leftright = function(n, r) {
            var e = Zo(n.value.body, r);
            if (n.value.left !== ".") {
                var t = new Fn.MathNode("mo", [
                    It(n.value.left, n.mode)
                ]);
                t.setAttribute("fence", "true"), e.unshift(t);
            }
            if (n.value.right !== ".") {
                var a = new Fn.MathNode("mo", [
                    It(n.value.right, n.mode)
                ]);
                a.setAttribute("fence", "true"), e.push(a);
            }
            var o = new Fn.MathNode("mrow", e);
            return o;
        };
        yr.accent = function(n, r) {
            var e = new Fn.MathNode("mo", [
                It(n.value.accent, n.mode)
            ]), t = new Fn.MathNode("mover", [
                Qe(n.value.base, r),
                e
            ]);
            return t.setAttribute("accent", "true"), t;
        };
        yr.spacing = function(n) {
            var r;
            return n.value === "\\ " || n.value === "\\space" || n.value === " " || n.value === "~" ? r = new Fn.MathNode("mtext", [
                new Fn.TextNode("\xA0")
            ]) : (r = new Fn.MathNode("mspace"), r.setAttribute("width", B0.spacingFunctions[n.value].size)), r;
        };
        yr.op = function(n) {
            var r;
            return n.value.symbol ? r = new Fn.MathNode("mo", [
                It(n.value.body, n.mode)
            ]) : r = new Fn.MathNode("mi", [
                new Fn.TextNode(n.value.body.slice(1))
            ]), r;
        };
        yr.katex = function(n) {
            var r = new Fn.MathNode("mtext", [
                new Fn.TextNode("KaTeX")
            ]);
            return r;
        };
        yr.font = function(n, r) {
            var e = n.value.font;
            return Qe(n.value.body, r.withFont(e));
        };
        yr.delimsizing = function(n) {
            var r = [];
            n.value.value !== "." && r.push(It(n.value.value, n.mode));
            var e = new Fn.MathNode("mo", r);
            return n.value.delimType === "open" || n.value.delimType === "close" ? e.setAttribute("fence", "true") : e.setAttribute("fence", "false"), e;
        };
        yr.styling = function(n, r) {
            var e = Zo(n.value.value, r), t = new Fn.MathNode("mstyle", e), a = {
                display: [
                    "0",
                    "true"
                ],
                text: [
                    "0",
                    "false"
                ],
                script: [
                    "1",
                    "false"
                ],
                scriptscript: [
                    "2",
                    "false"
                ]
            }, o = a[n.value.style];
            return t.setAttribute("scriptlevel", o[0]), t.setAttribute("displaystyle", o[1]), t;
        };
        yr.sizing = function(n, r) {
            var e = Zo(n.value.value, r), t = new Fn.MathNode("mstyle", e);
            return t.setAttribute("mathsize", B0.sizingMultiplier[n.value.size] + "em"), t;
        };
        yr.overline = function(n, r) {
            var e = new Fn.MathNode("mo", [
                new Fn.TextNode("\u203E")
            ]);
            e.setAttribute("stretchy", "true");
            var t = new Fn.MathNode("mover", [
                Qe(n.value.body, r),
                e
            ]);
            return t.setAttribute("accent", "true"), t;
        };
        yr.underline = function(n, r) {
            var e = new Fn.MathNode("mo", [
                new Fn.TextNode("\u203E")
            ]);
            e.setAttribute("stretchy", "true");
            var t = new Fn.MathNode("munder", [
                Qe(n.value.body, r),
                e
            ]);
            return t.setAttribute("accentunder", "true"), t;
        };
        yr.rule = function(n) {
            var r = new Fn.MathNode("mrow");
            return r;
        };
        yr.llap = function(n, r) {
            var e = new Fn.MathNode("mpadded", [
                Qe(n.value.body, r)
            ]);
            return e.setAttribute("lspace", "-1width"), e.setAttribute("width", "0px"), e;
        };
        yr.rlap = function(n, r) {
            var e = new Fn.MathNode("mpadded", [
                Qe(n.value.body, r)
            ]);
            return e.setAttribute("width", "0px"), e;
        };
        yr.phantom = function(n, r, e) {
            var t = Zo(n.value.value, r);
            return new Fn.MathNode("mphantom", t);
        };
        var Zo = function(n, r) {
            for(var e = [], t = 0; t < n.length; t++){
                var a = n[t];
                e.push(Qe(a, r));
            }
            return e;
        }, Qe = function(n, r) {
            if (!n) return new Fn.MathNode("mrow");
            if (yr[n.type]) return yr[n.type](n, r);
            throw new x7("Got group of unknown type: '" + n.type + "'");
        }, L7 = function(n, r, e) {
            var t = Zo(n, e), a = new Fn.MathNode("mrow", t), o = new Fn.MathNode("annotation", [
                new Fn.TextNode(r)
            ]);
            o.setAttribute("encoding", "application/x-tex");
            var u = new Fn.MathNode("semantics", [
                a,
                o
            ]), i = new Fn.MathNode("math", [
                u
            ]);
            return I7([
                "katex-mathml"
            ], [
                i
            ]);
        };
        IT.exports = L7;
    });
    var RT = Jr((e2n, ST)=>{
        function Pa(n) {
            this.style = n.style, this.color = n.color, this.size = n.size, this.phantom = n.phantom, this.font = n.font, n.parentStyle === void 0 ? this.parentStyle = n.style : this.parentStyle = n.parentStyle, n.parentSize === void 0 ? this.parentSize = n.size : this.parentSize = n.parentSize;
        }
        Pa.prototype.extend = function(n) {
            var r = {
                style: this.style,
                size: this.size,
                color: this.color,
                parentStyle: this.style,
                parentSize: this.size,
                phantom: this.phantom,
                font: this.font
            };
            for(var e in n)n.hasOwnProperty(e) && (r[e] = n[e]);
            return new Pa(r);
        };
        Pa.prototype.withStyle = function(n) {
            return this.extend({
                style: n
            });
        };
        Pa.prototype.withSize = function(n) {
            return this.extend({
                size: n
            });
        };
        Pa.prototype.withColor = function(n) {
            return this.extend({
                color: n
            });
        };
        Pa.prototype.withPhantom = function() {
            return this.extend({
                phantom: !0
            });
        };
        Pa.prototype.withFont = function(n) {
            return this.extend({
                font: n
            });
        };
        Pa.prototype.reset = function() {
            return this.extend({});
        };
        var S7 = {
            "katex-blue": "#6495ed",
            "katex-orange": "#ffa500",
            "katex-pink": "#ff00af",
            "katex-red": "#df0030",
            "katex-green": "#28ae7b",
            "katex-gray": "gray",
            "katex-purple": "#9d38bd",
            "katex-blueA": "#c7e9f1",
            "katex-blueB": "#9cdceb",
            "katex-blueC": "#58c4dd",
            "katex-blueD": "#29abca",
            "katex-blueE": "#1c758a",
            "katex-tealA": "#acead7",
            "katex-tealB": "#76ddc0",
            "katex-tealC": "#5cd0b3",
            "katex-tealD": "#55c1a7",
            "katex-tealE": "#49a88f",
            "katex-greenA": "#c9e2ae",
            "katex-greenB": "#a6cf8c",
            "katex-greenC": "#83c167",
            "katex-greenD": "#77b05d",
            "katex-greenE": "#699c52",
            "katex-goldA": "#f7c797",
            "katex-goldB": "#f9b775",
            "katex-goldC": "#f0ac5f",
            "katex-goldD": "#e1a158",
            "katex-goldE": "#c78d46",
            "katex-redA": "#f7a1a3",
            "katex-redB": "#ff8080",
            "katex-redC": "#fc6255",
            "katex-redD": "#e65a4c",
            "katex-redE": "#cf5044",
            "katex-maroonA": "#ecabc1",
            "katex-maroonB": "#ec92ab",
            "katex-maroonC": "#c55f73",
            "katex-maroonD": "#a24d61",
            "katex-maroonE": "#94424f",
            "katex-purpleA": "#caa3e8",
            "katex-purpleB": "#b189c6",
            "katex-purpleC": "#9a72ac",
            "katex-purpleD": "#715582",
            "katex-purpleE": "#644172",
            "katex-mintA": "#f5f9e8",
            "katex-mintB": "#edf2df",
            "katex-mintC": "#e0e5cc",
            "katex-grayA": "#fdfdfd",
            "katex-grayB": "#f7f7f7",
            "katex-grayC": "#eeeeee",
            "katex-grayD": "#dddddd",
            "katex-grayE": "#cccccc",
            "katex-grayF": "#aaaaaa",
            "katex-grayG": "#999999",
            "katex-grayH": "#555555",
            "katex-grayI": "#333333",
            "katex-kaBlue": "#314453",
            "katex-kaGreen": "#639b24"
        };
        Pa.prototype.getColor = function() {
            return this.phantom ? "transparent" : S7[this.color] || this.color;
        };
        ST.exports = Pa;
    });
    var kT = Jr((t2n, PT)=>{
        var R7 = TT(), N7 = LT(), H7 = Yc(), P7 = RT(), k7 = Ev(), NT = Gc(), HT = H7.makeSpan, O7 = function(n, r, e) {
            e = e || new k7({});
            var t = NT.TEXT;
            e.displayMode && (t = NT.DISPLAY);
            var a = new P7({
                style: t,
                size: "size5"
            }), o = N7(n, r, a), u = R7(n, a), i = HT([
                "katex"
            ], [
                o,
                u
            ]);
            return e.displayMode ? HT([
                "katex-display"
            ], [
                i
            ]) : i;
        };
        PT.exports = O7;
    });
    var UT = Jr((a2n, $T)=>{
        var q7 = Na(), WT = ho();
        function ee(n, r, e) {
            typeof n == "string" && (n = [
                n
            ]), typeof r == "number" && (r = {
                numArgs: r
            });
            for(var t = {
                numArgs: r.numArgs,
                argTypes: r.argTypes,
                greediness: r.greediness === void 0 ? 1 : r.greediness,
                allowedInText: !!r.allowedInText,
                numOptionalArgs: r.numOptionalArgs || 0,
                handler: e
            }, a = 0; a < n.length; ++a)$T.exports[n[a]] = t;
        }
        ee("\\sqrt", {
            numArgs: 1,
            numOptionalArgs: 1
        }, function(n, r) {
            var e = r[0], t = r[1];
            return {
                type: "sqrt",
                body: t,
                index: e
            };
        });
        ee("\\text", {
            numArgs: 1,
            argTypes: [
                "text"
            ],
            greediness: 2
        }, function(n, r) {
            var e = r[0], t;
            return e.type === "ordgroup" ? t = e.value : t = [
                e
            ], {
                type: "text",
                body: t
            };
        });
        ee("\\color", {
            numArgs: 2,
            allowedInText: !0,
            greediness: 3,
            argTypes: [
                "color",
                "original"
            ]
        }, function(n, r) {
            var e = r[0], t = r[1], a;
            return t.type === "ordgroup" ? a = t.value : a = [
                t
            ], {
                type: "color",
                color: e.value,
                value: a
            };
        });
        ee("\\overline", {
            numArgs: 1
        }, function(n, r) {
            var e = r[0];
            return {
                type: "overline",
                body: e
            };
        });
        ee("\\underline", {
            numArgs: 1
        }, function(n, r) {
            var e = r[0];
            return {
                type: "underline",
                body: e
            };
        });
        ee("\\rule", {
            numArgs: 2,
            numOptionalArgs: 1,
            argTypes: [
                "size",
                "size",
                "size"
            ]
        }, function(n, r) {
            var e = r[0], t = r[1], a = r[2];
            return {
                type: "rule",
                shift: e && e.value,
                width: t.value,
                height: a.value
            };
        });
        ee("\\KaTeX", {
            numArgs: 0
        }, function(n) {
            return {
                type: "katex"
            };
        });
        ee("\\phantom", {
            numArgs: 1
        }, function(n, r) {
            var e = r[0], t;
            return e.type === "ordgroup" ? t = e.value : t = [
                e
            ], {
                type: "phantom",
                value: t
            };
        });
        var OT = {
            "\\bigl": {
                type: "open",
                size: 1
            },
            "\\Bigl": {
                type: "open",
                size: 2
            },
            "\\biggl": {
                type: "open",
                size: 3
            },
            "\\Biggl": {
                type: "open",
                size: 4
            },
            "\\bigr": {
                type: "close",
                size: 1
            },
            "\\Bigr": {
                type: "close",
                size: 2
            },
            "\\biggr": {
                type: "close",
                size: 3
            },
            "\\Biggr": {
                type: "close",
                size: 4
            },
            "\\bigm": {
                type: "rel",
                size: 1
            },
            "\\Bigm": {
                type: "rel",
                size: 2
            },
            "\\biggm": {
                type: "rel",
                size: 3
            },
            "\\Biggm": {
                type: "rel",
                size: 4
            },
            "\\big": {
                type: "textord",
                size: 1
            },
            "\\Big": {
                type: "textord",
                size: 2
            },
            "\\bigg": {
                type: "textord",
                size: 3
            },
            "\\Bigg": {
                type: "textord",
                size: 4
            }
        }, W7 = [
            "(",
            ")",
            "[",
            "\\lbrack",
            "]",
            "\\rbrack",
            "\\{",
            "\\lbrace",
            "\\}",
            "\\rbrace",
            "\\lfloor",
            "\\rfloor",
            "\\lceil",
            "\\rceil",
            "<",
            ">",
            "\\langle",
            "\\rangle",
            "\\lt",
            "\\gt",
            "\\lvert",
            "\\rvert",
            "\\lVert",
            "\\rVert",
            "\\lgroup",
            "\\rgroup",
            "\\lmoustache",
            "\\rmoustache",
            "/",
            "\\backslash",
            "|",
            "\\vert",
            "\\|",
            "\\Vert",
            "\\uparrow",
            "\\Uparrow",
            "\\downarrow",
            "\\Downarrow",
            "\\updownarrow",
            "\\Updownarrow",
            "."
        ], qT = {
            "\\Bbb": "\\mathbb",
            "\\bold": "\\mathbf",
            "\\frak": "\\mathfrak"
        };
        ee([
            "\\blue",
            "\\orange",
            "\\pink",
            "\\red",
            "\\green",
            "\\gray",
            "\\purple",
            "\\blueA",
            "\\blueB",
            "\\blueC",
            "\\blueD",
            "\\blueE",
            "\\tealA",
            "\\tealB",
            "\\tealC",
            "\\tealD",
            "\\tealE",
            "\\greenA",
            "\\greenB",
            "\\greenC",
            "\\greenD",
            "\\greenE",
            "\\goldA",
            "\\goldB",
            "\\goldC",
            "\\goldD",
            "\\goldE",
            "\\redA",
            "\\redB",
            "\\redC",
            "\\redD",
            "\\redE",
            "\\maroonA",
            "\\maroonB",
            "\\maroonC",
            "\\maroonD",
            "\\maroonE",
            "\\purpleA",
            "\\purpleB",
            "\\purpleC",
            "\\purpleD",
            "\\purpleE",
            "\\mintA",
            "\\mintB",
            "\\mintC",
            "\\grayA",
            "\\grayB",
            "\\grayC",
            "\\grayD",
            "\\grayE",
            "\\grayF",
            "\\grayG",
            "\\grayH",
            "\\grayI",
            "\\kaBlue",
            "\\kaGreen"
        ], {
            numArgs: 1,
            allowedInText: !0,
            greediness: 3
        }, function(n, r) {
            var e = r[0], t;
            return e.type === "ordgroup" ? t = e.value : t = [
                e
            ], {
                type: "color",
                color: "katex-" + n.funcName.slice(1),
                value: t
            };
        });
        ee([
            "\\arcsin",
            "\\arccos",
            "\\arctan",
            "\\arg",
            "\\cos",
            "\\cosh",
            "\\cot",
            "\\coth",
            "\\csc",
            "\\deg",
            "\\dim",
            "\\exp",
            "\\hom",
            "\\ker",
            "\\lg",
            "\\ln",
            "\\log",
            "\\sec",
            "\\sin",
            "\\sinh",
            "\\tan",
            "\\tanh"
        ], {
            numArgs: 0
        }, function(n) {
            return {
                type: "op",
                limits: !1,
                symbol: !1,
                body: n.funcName
            };
        });
        ee([
            "\\det",
            "\\gcd",
            "\\inf",
            "\\lim",
            "\\liminf",
            "\\limsup",
            "\\max",
            "\\min",
            "\\Pr",
            "\\sup"
        ], {
            numArgs: 0
        }, function(n) {
            return {
                type: "op",
                limits: !0,
                symbol: !1,
                body: n.funcName
            };
        });
        ee([
            "\\int",
            "\\iint",
            "\\iiint",
            "\\oint"
        ], {
            numArgs: 0
        }, function(n) {
            return {
                type: "op",
                limits: !1,
                symbol: !0,
                body: n.funcName
            };
        });
        ee([
            "\\coprod",
            "\\bigvee",
            "\\bigwedge",
            "\\biguplus",
            "\\bigcap",
            "\\bigcup",
            "\\intop",
            "\\prod",
            "\\sum",
            "\\bigotimes",
            "\\bigoplus",
            "\\bigodot",
            "\\bigsqcup",
            "\\smallint"
        ], {
            numArgs: 0
        }, function(n) {
            return {
                type: "op",
                limits: !0,
                symbol: !0,
                body: n.funcName
            };
        });
        ee([
            "\\dfrac",
            "\\frac",
            "\\tfrac",
            "\\dbinom",
            "\\binom",
            "\\tbinom"
        ], {
            numArgs: 2,
            greediness: 2
        }, function(n, r) {
            var e = r[0], t = r[1], a, o = null, u = null, i = "auto";
            switch(n.funcName){
                case "\\dfrac":
                case "\\frac":
                case "\\tfrac":
                    a = !0;
                    break;
                case "\\dbinom":
                case "\\binom":
                case "\\tbinom":
                    a = !1, o = "(", u = ")";
                    break;
                default:
                    throw new Error("Unrecognized genfrac command");
            }
            switch(n.funcName){
                case "\\dfrac":
                case "\\dbinom":
                    i = "display";
                    break;
                case "\\tfrac":
                case "\\tbinom":
                    i = "text";
                    break;
            }
            return {
                type: "genfrac",
                numer: e,
                denom: t,
                hasBarLine: a,
                leftDelim: o,
                rightDelim: u,
                size: i
            };
        });
        ee([
            "\\llap",
            "\\rlap"
        ], {
            numArgs: 1,
            allowedInText: !0
        }, function(n, r) {
            var e = r[0];
            return {
                type: n.funcName.slice(1),
                body: e
            };
        });
        ee([
            "\\bigl",
            "\\Bigl",
            "\\biggl",
            "\\Biggl",
            "\\bigr",
            "\\Bigr",
            "\\biggr",
            "\\Biggr",
            "\\bigm",
            "\\Bigm",
            "\\biggm",
            "\\Biggm",
            "\\big",
            "\\Big",
            "\\bigg",
            "\\Bigg",
            "\\left",
            "\\right"
        ], {
            numArgs: 1
        }, function(n, r) {
            var e = r[0];
            if (!q7.contains(W7, e.value)) throw new WT("Invalid delimiter: '" + e.value + "' after '" + n.funcName + "'", n.lexer, n.positions[1]);
            return n.funcName === "\\left" || n.funcName === "\\right" ? {
                type: "leftright",
                value: e.value
            } : {
                type: "delimsizing",
                size: OT[n.funcName].size,
                delimType: OT[n.funcName].type,
                value: e.value
            };
        });
        ee([
            "\\tiny",
            "\\scriptsize",
            "\\footnotesize",
            "\\small",
            "\\normalsize",
            "\\large",
            "\\Large",
            "\\LARGE",
            "\\huge",
            "\\Huge"
        ], 0, null);
        ee([
            "\\displaystyle",
            "\\textstyle",
            "\\scriptstyle",
            "\\scriptscriptstyle"
        ], 0, null);
        ee([
            "\\mathrm",
            "\\mathit",
            "\\mathbf",
            "\\mathbb",
            "\\mathcal",
            "\\mathfrak",
            "\\mathscr",
            "\\mathsf",
            "\\mathtt",
            "\\Bbb",
            "\\bold",
            "\\frak"
        ], {
            numArgs: 1,
            greediness: 2
        }, function(n, r) {
            var e = r[0], t = n.funcName;
            return t in qT && (t = qT[t]), {
                type: "font",
                font: t.slice(1),
                body: e
            };
        });
        ee([
            "\\acute",
            "\\grave",
            "\\ddot",
            "\\tilde",
            "\\bar",
            "\\breve",
            "\\check",
            "\\hat",
            "\\vec",
            "\\dot"
        ], {
            numArgs: 1
        }, function(n, r) {
            var e = r[0];
            return {
                type: "accent",
                accent: n.funcName,
                base: e
            };
        });
        ee([
            "\\over",
            "\\choose"
        ], {
            numArgs: 0
        }, function(n) {
            var r;
            switch(n.funcName){
                case "\\over":
                    r = "\\frac";
                    break;
                case "\\choose":
                    r = "\\binom";
                    break;
                default:
                    throw new Error("Unrecognized infix genfrac command");
            }
            return {
                type: "infix",
                replaceWith: r
            };
        });
        ee([
            "\\\\",
            "\\cr"
        ], {
            numArgs: 0,
            numOptionalArgs: 1,
            argTypes: [
                "size"
            ]
        }, function(n, r) {
            var e = r[0];
            return {
                type: "cr",
                size: e
            };
        });
        ee([
            "\\begin",
            "\\end"
        ], {
            numArgs: 1,
            argTypes: [
                "text"
            ]
        }, function(n, r) {
            var e = r[0];
            if (e.type !== "ordgroup") throw new WT("Invalid environment name", n.lexer, n.positions[1]);
            for(var t = "", a = 0; a < e.value.length; ++a)t += e.value[a].value;
            return {
                type: "environment",
                name: t,
                namepos: n.positions[1]
            };
        });
    });
    var kv = Jr((o2n, BT)=>{
        function $7(n, r, e) {
            this.type = n, this.value = r, this.mode = e;
        }
        BT.exports = {
            ParseNode: $7
        };
    });
    var JT = Jr((u2n, VT)=>{
        var U7 = Xi(), B7 = kv(), zT = ho(), al = B7.ParseNode;
        function z0(n, r) {
            for(var e = [], t = [
                e
            ], a = [];;){
                var o = n.parseExpression(!1, null);
                e.push(new al("ordgroup", o, n.mode));
                var u = n.nextToken.text;
                if (u === "&") n.consume();
                else {
                    if (u === "\\end") break;
                    if (u === "\\\\" || u === "\\cr") {
                        var i = n.parseFunction();
                        a.push(i.value.size), e = [], t.push(e);
                    } else {
                        var c = Math.min(n.pos + 1, n.lexer._input.length);
                        throw new zT("Expected & or \\\\ or \\end", n.lexer, c);
                    }
                }
            }
            return r.body = t, r.rowGaps = a, new al(r.type, r, n.mode);
        }
        function V0(n, r, e) {
            typeof n == "string" && (n = [
                n
            ]), typeof r == "number" && (r = {
                numArgs: r
            });
            for(var t = {
                numArgs: r.numArgs || 0,
                argTypes: r.argTypes,
                greediness: 1,
                allowedInText: !!r.allowedInText,
                numOptionalArgs: r.numOptionalArgs || 0,
                handler: e
            }, a = 0; a < n.length; ++a)VT.exports[n[a]] = t;
        }
        V0("array", {
            numArgs: 1
        }, function(n, r) {
            var e = r[0];
            e = e.value.map ? e.value : [
                e
            ];
            var t = e.map(function(o) {
                var u = o.value;
                if ("lcr".indexOf(u) !== -1) return {
                    type: "align",
                    align: u
                };
                if (u === "|") return {
                    type: "separator",
                    separator: "|"
                };
                throw new zT("Unknown column alignment: " + o.value, n.lexer, n.positions[1]);
            }), a = {
                type: "array",
                cols: t,
                hskipBeforeAndAfter: !0
            };
            return a = z0(n.parser, a), a;
        });
        V0([
            "matrix",
            "pmatrix",
            "bmatrix",
            "Bmatrix",
            "vmatrix",
            "Vmatrix"
        ], {}, function(n) {
            var r = {
                matrix: null,
                pmatrix: [
                    "(",
                    ")"
                ],
                bmatrix: [
                    "[",
                    "]"
                ],
                Bmatrix: [
                    "\\{",
                    "\\}"
                ],
                vmatrix: [
                    "|",
                    "|"
                ],
                Vmatrix: [
                    "\\Vert",
                    "\\Vert"
                ]
            }[n.envName], e = {
                type: "array",
                hskipBeforeAndAfter: !1
            };
            return e = z0(n.parser, e), r && (e = new al("leftright", {
                body: [
                    e
                ],
                left: r[0],
                right: r[1]
            }, n.mode)), e;
        });
        V0("cases", {}, function(n) {
            var r = {
                type: "array",
                arraystretch: 1.2,
                cols: [
                    {
                        type: "align",
                        align: "l",
                        pregap: 0,
                        postgap: U7.metrics.quad
                    },
                    {
                        type: "align",
                        align: "l",
                        pregap: 0,
                        postgap: 0
                    }
                ]
            };
            return r = z0(n.parser, r), r = new al("leftright", {
                body: [
                    r
                ],
                left: "\\{",
                right: "."
            }, n.mode), r;
        });
        V0("aligned", {}, function(n) {
            var r = {
                type: "array",
                cols: []
            };
            r = z0(n.parser, r);
            var e = new al("ordgroup", [], n.mode), t = 0;
            r.value.body.forEach(function(i) {
                var c;
                for(c = 1; c < i.length; c += 2)i[c].value.unshift(e);
                t < i.length && (t = i.length);
            });
            for(var a = 0; a < t; ++a){
                var o = "r", u = 0;
                a % 2 === 1 ? o = "l" : a > 0 && (u = 2), r.value.cols[a] = {
                    type: "align",
                    align: o,
                    pregap: u,
                    postgap: 0
                };
            }
            return r;
        });
    });
    var jT = Jr((i2n, GT)=>{
        function z7(n) {
            if (!n.__matchAtRelocatable) {
                var r = n.source + "|()", e = "g" + (n.ignoreCase ? "i" : "") + (n.multiline ? "m" : "") + (n.unicode ? "u" : "");
                n.__matchAtRelocatable = new RegExp(r, e);
            }
            return n.__matchAtRelocatable;
        }
        function V7(n, r, e) {
            if (n.global || n.sticky) throw new Error("matchAt(...): Only non-global regexes are supported");
            var t = z7(n);
            t.lastIndex = e;
            var a = t.exec(r);
            return a[a.length - 1] == null ? (a.length = a.length - 1, a) : null;
        }
        GT.exports = V7;
    });
    var KT = Jr((f2n, QT)=>{
        var of = jT(), J0 = ho();
        function uf(n) {
            this._input = n;
        }
        function af(n, r, e) {
            this.text = n, this.data = r, this.position = e;
        }
        var J7 = new RegExp(`([ \r
	]+)|(---?|[!-\\[\\]-\u2027\u202A-\uD7FF\uF900-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|\\\\(?:[a-zA-Z]+|[^\uD800-\uDFFF]))`), Ov = /\s*/;
        uf.prototype._innerLex = function(n, r) {
            var e = this._input;
            if (n === e.length) return new af("EOF", null, n);
            var t = of(J7, e, n);
            if (t === null) throw new J0("Unexpected character: '" + e[n] + "'", this, n);
            return t[2] ? new af(t[2], null, n + t[2].length) : r ? this._innerLex(n + t[1].length, !0) : new af(" ", null, n + t[1].length);
        };
        var G7 = /#[a-z0-9]+|[a-z]+/i;
        uf.prototype._innerLexColor = function(n) {
            var r = this._input, e = of(Ov, r, n)[0];
            n += e.length;
            var t;
            if (t = of(G7, r, n)) return new af(t[0], null, n + t[0].length);
            throw new J0("Invalid color", this, n);
        };
        var j7 = /(-?)\s*(\d+(?:\.\d*)?|\.\d+)\s*([a-z]{2})/;
        uf.prototype._innerLexSize = function(n) {
            var r = this._input, e = of(Ov, r, n)[0];
            n += e.length;
            var t;
            if (t = of(j7, r, n)) {
                var a = t[3];
                if (a !== "em" && a !== "ex") throw new J0("Invalid unit: '" + a + "'", this, n);
                return new af(t[0], {
                    number: +(t[1] + t[2]),
                    unit: a
                }, n + t[0].length);
            }
            throw new J0("Invalid size", this, n);
        };
        uf.prototype._innerLexWhitespace = function(n) {
            var r = this._input, e = of(Ov, r, n)[0];
            return n += e.length, new af(e[0], null, n);
        };
        uf.prototype.lex = function(n, r) {
            if (r === "math") return this._innerLex(n, !0);
            if (r === "text") return this._innerLex(n, !1);
            if (r === "color") return this._innerLexColor(n);
            if (r === "size") return this._innerLexSize(n);
            if (r === "whitespace") return this._innerLexWhitespace(n);
        };
        QT.exports = uf;
    });
    var r3 = Jr((c2n, n3)=>{
        var ol = UT(), YT = JT(), Q7 = KT(), XT = Kc(), qv = Na(), K7 = kv(), zt = ho();
        function Ee(n, r) {
            this.lexer = new Q7(n), this.settings = r;
        }
        var Ne = K7.ParseNode;
        function ff(n, r) {
            this.result = n, this.isFunction = r;
        }
        Ee.prototype.expect = function(n, r) {
            if (this.nextToken.text !== n) throw new zt("Expected '" + n + "', got '" + this.nextToken.text + "'", this.lexer, this.nextToken.position);
            r !== !1 && this.consume();
        };
        Ee.prototype.consume = function() {
            this.pos = this.nextToken.position, this.nextToken = this.lexer.lex(this.pos, this.mode);
        };
        Ee.prototype.parse = function() {
            this.mode = "math", this.pos = 0, this.nextToken = this.lexer.lex(this.pos, this.mode);
            var n = this.parseInput();
            return n;
        };
        Ee.prototype.parseInput = function() {
            var n = this.parseExpression(!1);
            return this.expect("EOF", !1), n;
        };
        var Y7 = [
            "}",
            "\\end",
            "\\right",
            "&",
            "\\\\",
            "\\cr"
        ];
        Ee.prototype.parseExpression = function(n, r) {
            for(var e = [];;){
                var t = this.nextToken, a = this.pos;
                if (Y7.indexOf(t.text) !== -1 || r && t.text === r) break;
                var o = this.parseAtom();
                if (!o) {
                    if (!this.settings.throwOnError && t.text[0] === "\\") {
                        var u = this.handleUnsupportedCmd();
                        e.push(u), a = t.position;
                        continue;
                    }
                    break;
                }
                if (n && o.type === "infix") {
                    this.pos = a, this.nextToken = t;
                    break;
                }
                e.push(o);
            }
            return this.handleInfixNodes(e);
        };
        Ee.prototype.handleInfixNodes = function(n) {
            for(var r = -1, e, t = 0; t < n.length; t++){
                var a = n[t];
                if (a.type === "infix") {
                    if (r !== -1) throw new zt("only one infix operator per group", this.lexer, -1);
                    r = t, e = a.value.replaceWith;
                }
            }
            if (r !== -1) {
                var o, u, i = n.slice(0, r), c = n.slice(r + 1);
                i.length === 1 && i[0].type === "ordgroup" ? o = i[0] : o = new Ne("ordgroup", i, this.mode), c.length === 1 && c[0].type === "ordgroup" ? u = c[0] : u = new Ne("ordgroup", c, this.mode);
                var l = this.callFunction(e, [
                    o,
                    u
                ], null);
                return [
                    new Ne(l.type, l, this.mode)
                ];
            } else return n;
        };
        var X7 = 1;
        Ee.prototype.handleSupSubscript = function(n) {
            var r = this.nextToken.text, e = this.pos;
            this.consume();
            var t = this.parseGroup();
            if (t) {
                if (t.isFunction) {
                    var a = ol[t.result].greediness;
                    if (a > X7) return this.parseFunction(t);
                    throw new zt("Got function '" + t.result + "' with no arguments as " + n, this.lexer, e + 1);
                } else return t.result;
            } else {
                if (!this.settings.throwOnError && this.nextToken.text[0] === "\\") return this.handleUnsupportedCmd();
                throw new zt("Expected group after '" + r + "'", this.lexer, e + 1);
            }
        };
        Ee.prototype.handleUnsupportedCmd = function() {
            for(var n = this.nextToken.text, r = [], e = 0; e < n.length; e++)r.push(new Ne("textord", n[e], "text"));
            var t = new Ne("text", {
                body: r,
                type: "text"
            }, this.mode), a = new Ne("color", {
                color: this.settings.errorColor,
                value: [
                    t
                ],
                type: "color"
            }, this.mode);
            return this.consume(), a;
        };
        Ee.prototype.parseAtom = function() {
            var n = this.parseImplicitGroup();
            if (this.mode === "text") return n;
            for(var r, e;;){
                var t = this.nextToken;
                if (t.text === "\\limits" || t.text === "\\nolimits") {
                    if (!n || n.type !== "op") throw new zt("Limit controls must follow a math operator", this.lexer, this.pos);
                    var a = t.text === "\\limits";
                    n.value.limits = a, n.value.alwaysHandleSupSub = !0, this.consume();
                } else if (t.text === "^") {
                    if (r) throw new zt("Double superscript", this.lexer, this.pos);
                    r = this.handleSupSubscript("superscript");
                } else if (t.text === "_") {
                    if (e) throw new zt("Double subscript", this.lexer, this.pos);
                    e = this.handleSupSubscript("subscript");
                } else if (t.text === "'") {
                    var o = new Ne("textord", "\\prime", this.mode), u = [
                        o
                    ];
                    for(this.consume(); this.nextToken.text === "'";)u.push(o), this.consume();
                    r = new Ne("ordgroup", u, this.mode);
                } else break;
            }
            return r || e ? new Ne("supsub", {
                base: n,
                sup: r,
                sub: e
            }, this.mode) : n;
        };
        var ZT = [
            "\\tiny",
            "\\scriptsize",
            "\\footnotesize",
            "\\small",
            "\\normalsize",
            "\\large",
            "\\Large",
            "\\LARGE",
            "\\huge",
            "\\Huge"
        ], Z7 = [
            "\\displaystyle",
            "\\textstyle",
            "\\scriptstyle",
            "\\scriptscriptstyle"
        ];
        Ee.prototype.parseImplicitGroup = function() {
            var n = this.parseSymbol();
            if (n == null) return this.parseFunction();
            var r = n.result, e;
            if (r === "\\left") {
                var t = this.parseFunction(n);
                e = this.parseExpression(!1), this.expect("\\right", !1);
                var a = this.parseFunction();
                return new Ne("leftright", {
                    body: e,
                    left: t.value.value,
                    right: a.value.value
                }, this.mode);
            } else if (r === "\\begin") {
                var o = this.parseFunction(n), u = o.value.name;
                if (!YT.hasOwnProperty(u)) throw new zt("No such environment: " + u, this.lexer, o.value.namepos);
                var i = YT[u], c = this.parseArguments("\\begin{" + u + "}", i), l = {
                    mode: this.mode,
                    envName: u,
                    parser: this,
                    lexer: this.lexer,
                    positions: c.pop()
                }, d = i.handler(l, c);
                this.expect("\\end", !1);
                var m = this.parseFunction();
                if (m.value.name !== u) throw new zt("Mismatch: \\begin{" + u + "} matched by \\end{" + m.value.name + "}", this.lexer);
                return d.position = m.position, d;
            } else return qv.contains(ZT, r) ? (e = this.parseExpression(!1), new Ne("sizing", {
                size: "size" + (qv.indexOf(ZT, r) + 1),
                value: e
            }, this.mode)) : qv.contains(Z7, r) ? (e = this.parseExpression(!0), new Ne("styling", {
                style: r.slice(1, r.length - 5),
                value: e
            }, this.mode)) : this.parseFunction(n);
        };
        Ee.prototype.parseFunction = function(n) {
            if (n || (n = this.parseGroup()), n) {
                if (n.isFunction) {
                    var r = n.result, e = ol[r];
                    if (this.mode === "text" && !e.allowedInText) throw new zt("Can't use function '" + r + "' in text mode", this.lexer, n.position);
                    var t = this.parseArguments(r, e), a = this.callFunction(r, t, t.pop());
                    return new Ne(a.type, a, this.mode);
                } else return n.result;
            } else return null;
        };
        Ee.prototype.callFunction = function(n, r, e) {
            var t = {
                funcName: n,
                parser: this,
                lexer: this.lexer,
                positions: e
            };
            return ol[n].handler(t, r);
        };
        Ee.prototype.parseArguments = function(n, r) {
            var e = r.numArgs + r.numOptionalArgs;
            if (e === 0) return [
                [
                    this.pos
                ]
            ];
            for(var t = r.greediness, a = [
                this.pos
            ], o = [], u = 0; u < e; u++){
                var i = r.argTypes && r.argTypes[u], c;
                if (u < r.numOptionalArgs) {
                    if (i ? c = this.parseSpecialGroup(i, !0) : c = this.parseOptionalGroup(), !c) {
                        o.push(null), a.push(this.pos);
                        continue;
                    }
                } else if (i ? c = this.parseSpecialGroup(i) : c = this.parseGroup(), !c) {
                    if (!this.settings.throwOnError && this.nextToken.text[0] === "\\") c = new ff(this.handleUnsupportedCmd(this.nextToken.text), !1);
                    else throw new zt("Expected group after '" + n + "'", this.lexer, this.pos);
                }
                var l;
                if (c.isFunction) {
                    var d = ol[c.result].greediness;
                    if (d > t) l = this.parseFunction(c);
                    else throw new zt("Got function '" + c.result + "' as argument to '" + n + "'", this.lexer, this.pos - 1);
                } else l = c.result;
                o.push(l), a.push(this.pos);
            }
            return o.push(a), o;
        };
        Ee.prototype.parseSpecialGroup = function(n, r) {
            var e = this.mode;
            if (n === "original" && (n = e), n === "color" || n === "size") {
                var t = this.nextToken;
                if (r && t.text !== "[") return null;
                this.mode = n, this.expect(r ? "[" : "{");
                var a = this.nextToken;
                this.mode = e;
                var o;
                return n === "color" ? o = a.text : o = a.data, this.consume(), this.expect(r ? "]" : "}"), new ff(new Ne(n, o, e), !1);
            } else if (n === "text") {
                var u = this.lexer.lex(this.pos, "whitespace");
                this.pos = u.position;
            }
            this.mode = n, this.nextToken = this.lexer.lex(this.pos, n);
            var i;
            return r ? i = this.parseOptionalGroup() : i = this.parseGroup(), this.mode = e, this.nextToken = this.lexer.lex(this.pos, e), i;
        };
        Ee.prototype.parseGroup = function() {
            if (this.nextToken.text === "{") {
                this.consume();
                var n = this.parseExpression(!1);
                return this.expect("}"), new ff(new Ne("ordgroup", n, this.mode), !1);
            } else return this.parseSymbol();
        };
        Ee.prototype.parseOptionalGroup = function() {
            if (this.nextToken.text === "[") {
                this.consume();
                var n = this.parseExpression(!1, "]");
                return this.expect("]"), new ff(new Ne("ordgroup", n, this.mode), !1);
            } else return null;
        };
        Ee.prototype.parseSymbol = function() {
            var n = this.nextToken;
            return ol[n.text] ? (this.consume(), new ff(n.text, !0)) : XT[this.mode][n.text] ? (this.consume(), new ff(new Ne(XT[this.mode][n.text].group, n.text, this.mode), !1)) : null;
        };
        Ee.prototype.ParseNode = Ne;
        n3.exports = Ee;
    });
    var t3 = Jr((l2n, e3)=>{
        var nR = r3(), rR = function(n, r) {
            var e = new nR(n, r);
            return e.parse();
        };
        e3.exports = rR;
    });
    var f3 = Jr((s2n, i3)=>{
        var a3 = ho(), Wv = Ev(), o3 = kT(), $v = t3(), eR = Na(), u3 = function(n, r, e) {
            eR.clearNode(r);
            var t = new Wv(e), a = $v(n, t), o = o3(a, n, t).toNode();
            r.appendChild(o);
        };
        typeof document < "u" && document.compatMode !== "CSS1Compat" && (typeof console < "u" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), u3 = function() {
            throw new a3("KaTeX doesn't work in quirks mode.");
        });
        var tR = function(n, r) {
            var e = new Wv(r), t = $v(n, e);
            return o3(t, n, e).toMarkup();
        }, aR = function(n, r) {
            var e = new Wv(r);
            return $v(n, e);
        };
        i3.exports = {
            render: u3,
            renderToString: tR,
            __parse: aR,
            ParseError: a3
        };
    });
    var p3 = Jr((p2n, s3)=>{
        "use strict";
        var c3 = f3();
        function l3(n, r) {
            var e, t, a = n.posMax, o = !0, u = !0;
            return e = r > 0 ? n.src.charCodeAt(r - 1) : -1, t = r + 1 <= a ? n.src.charCodeAt(r + 1) : -1, (e === 32 || e === 9 || t >= 48 && t <= 57) && (u = !1), (t === 32 || t === 9) && (o = !1), {
                can_open: o,
                can_close: u
            };
        }
        function oR(n, r) {
            var e, t, a, o, u, i;
            if (n.src[n.pos] !== "$") return !1;
            if (o = l3(n, n.pos), !o.can_open) return r || (n.pending += "$"), n.pos += 1, !0;
            for(e = n.pos + 1, t = e; (t = n.src.indexOf("$", t)) !== -1;){
                for(u = t - 1; n.src[u] === "\\";)u -= 1;
                if ((t - u) % 2 == 1) break;
                t += 1;
            }
            return t === -1 ? (r || (n.pending += "$"), n.pos = e, !0) : t - e === 0 ? (r || (n.pending += "$$"), n.pos = e + 1, !0) : (o = l3(n, t), o.can_close ? (r || (a = n.push("math_inline", "math", 0), a.markup = "$", a.content = n.src.slice(e, t)), n.pos = t + 1, !0) : (r || (n.pending += "$"), n.pos = e, !0));
        }
        function uR(n, r, e, t) {
            var a, o, u, i, c = !1, l, d = n.bMarks[r] + n.tShift[r], m = n.eMarks[r];
            if (d + 2 > m || n.src.slice(d, d + 2) !== "$$") return !1;
            if (d += 2, a = n.src.slice(d, m), t) return !0;
            for(a.trim().slice(-2) === "$$" && (a = a.trim().slice(0, -2), c = !0), u = r; !c && (u++, !(u >= e || (d = n.bMarks[u] + n.tShift[u], m = n.eMarks[u], d < m && n.tShift[u] < n.blkIndent)));)n.src.slice(d, m).trim().slice(-2) === "$$" && (i = n.src.slice(0, m).lastIndexOf("$$"), o = n.src.slice(d, i), c = !0);
            return n.line = u + 1, l = n.push("math_block", "math", 0), l.block = !0, l.content = (a && a.trim() ? a + `
` : "") + n.getLines(r + 1, u, n.tShift[r], !0) + (o && o.trim() ? o : ""), l.map = [
                r,
                n.line
            ], l.markup = "$$", !0;
        }
        s3.exports = function(r, e) {
            e = e || {};
            var t = function(i) {
                e.displayMode = !1;
                try {
                    return c3.renderToString(i, e);
                } catch (c) {
                    return e.throwOnError && console.log(c), i;
                }
            }, a = function(i, c) {
                return t(i[c].content);
            }, o = function(i) {
                e.displayMode = !0;
                try {
                    return "<p>" + c3.renderToString(i, e) + "</p>";
                } catch (c) {
                    return e.throwOnError && console.log(c), i;
                }
            }, u = function(i, c) {
                return o(i[c].content) + `
`;
            };
            r.inline.ruler.after("escape", "math_inline", oR), r.block.ruler.after("blockquote", "math_block", uR, {
                alt: [
                    "paragraph",
                    "reference",
                    "blockquote",
                    "list"
                ]
            }), r.renderer.rules.math_inline = a, r.renderer.rules.math_block = u;
        };
    });
    var A1 = function(n) {
        return function(r) {
            for(var e = n.length, t = r.length, a = new Array(e * t), o = 0, u = 0; u < e; u++)for(var i = n[u], c = 0; c < t; c++)a[o++] = i(r[c]);
            return a;
        };
    };
    var vf = {
        compose: function(n) {
            return function(r) {
                return function(e) {
                    return n(r(e));
                };
            };
        }
    }, ri = function(n) {
        return n.compose;
    };
    var vn = function(n) {
        return n.identity;
    }, Dn = {
        identity: function(n) {
            return n;
        },
        Semigroupoid0: function() {
            return vf;
        }
    };
    var Wr = !0;
    var On = function(n) {
        return function(r) {
            return function(e) {
                return n(e)(r);
            };
        };
    }, Q = function(n) {
        return function(r) {
            return n;
        };
    };
    var up = function(n) {
        return function(r) {
            return r(n);
        };
    };
    var I1 = function(n) {
        return function(r) {
            for(var e = r.length, t = new Array(e), a = 0; a < e; a++)t[a] = n(r[a]);
            return t;
        };
    };
    var $r = function() {
        function n() {}
        return n.value = new n, n;
    }();
    var C = function(n) {
        return n.map;
    }, ei = function(n) {
        var r = C(n);
        return function(e) {
            return function(t) {
                return r(t)(e);
            };
        };
    }, Hr = function(n) {
        return C(n)(Q(void 0));
    }, eu = function(n) {
        var r = C(n);
        return function(e) {
            return function(t) {
                return r(Q(t))(e);
            };
        };
    }, tu = function(n) {
        var r = C(n);
        return function(e) {
            return r(Q(e));
        };
    };
    var _e = {
        map: ri(vf)
    }, Ur = {
        map: I1
    };
    var CM = vn(Dn);
    var Df = {
        apply: function(n) {
            return function(r) {
                return function(e) {
                    return n(e)(r(e));
                };
            };
        },
        Functor0: function() {
            return _e;
        }
    }, gl = {
        apply: A1,
        Functor0: function() {
            return Ur;
        }
    }, Gn = function(n) {
        return n.apply;
    }, L1 = function(n) {
        var r = Gn(n), e = C(n.Functor0());
        return function(t) {
            return function(a) {
                return r(e(Q)(t))(a);
            };
        };
    }, ti = function(n) {
        var r = Gn(n), e = C(n.Functor0());
        return function(t) {
            return function(a) {
                return r(e(Q(CM))(t))(a);
            };
        };
    };
    var k = function(n) {
        return n.pure;
    }, gf = function(n) {
        var r = k(n);
        return function(e) {
            return function(t) {
                if (!e) return t;
                if (e) return r(void 0);
                throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                    e.constructor.name,
                    t.constructor.name
                ]);
            };
        };
    }, bt = function(n) {
        var r = k(n);
        return function(e) {
            return function(t) {
                if (e) return t;
                if (!e) return r(void 0);
                throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                    e.constructor.name,
                    t.constructor.name
                ]);
            };
        };
    }, bf = function(n) {
        var r = Gn(n.Apply0()), e = k(n);
        return function(t) {
            return function(a) {
                return r(e(t))(a);
            };
        };
    };
    var S1 = typeof Array.prototype.flatMap == "function" ? function(n) {
        return function(r) {
            return n.flatMap(r);
        };
    } : function(n) {
        return function(r) {
            for(var e = [], t = n.length, a = 0; a < t; a++)for(var o = r(n[a]), u = o.length, i = 0; i < u; i++)e.push(o[i]);
            return e;
        };
    };
    var MM = vn(Dn), yt = function(n) {
        return n.discard;
    };
    var bl = {
        bind: S1,
        Apply0: function() {
            return gl;
        }
    }, Z = function(n) {
        return n.bind;
    }, Pr = function(n) {
        return On(Z(n));
    }, au = function(n) {
        var r = Pr(n);
        return function(e) {
            return function(t) {
                return function(a) {
                    return r(e)(t(a));
                };
            };
        };
    }, ip = function(n) {
        var r = Z(n);
        return function(e) {
            return function(t) {
                return function(a) {
                    return r(e(a))(t);
                };
            };
        };
    };
    var Ct = {
        discard: function(n) {
            return Z(n);
        }
    };
    var yf = function(n) {
        var r = Z(n);
        return function(e) {
            return r(e)(MM);
        };
    };
    var N1 = function(n) {
        var r = Z(n.Bind1()), e = gf(n.Applicative0());
        return function(t) {
            return function(a) {
                return r(t)(function(o) {
                    return e(o)(a);
                });
            };
        };
    };
    var ft = function(n) {
        var r = Z(n.Bind1()), e = k(n.Applicative0());
        return function(t) {
            return function(a) {
                return r(t)(function(o) {
                    return r(a)(function(u) {
                        return e(o(u));
                    });
                });
            };
        };
    };
    var Wa = function(n) {
        return n.ask;
    }, Cf = function(n) {
        var r = C(n.Monad0().Bind1().Apply0().Functor0()), e = Wa(n);
        return function(t) {
            return r(t)(e);
        };
    };
    var H1 = function(n) {
        return function(r) {
            return n + r;
        };
    }, P1 = function(n) {
        return function(r) {
            return n.length === 0 ? r : r.length === 0 ? n : n.concat(r);
        };
    };
    var ve = function(n) {
        return n.reflectSymbol;
    };
    var la = function(n) {
        return function(r) {
            return r[n];
        };
    }, $a = function(n) {
        return function(r) {
            return function(e) {
                var t = {};
                for(var a in e)({}).hasOwnProperty.call(e, a) && (t[a] = e[a]);
                return t[n] = r, t;
            };
        };
    };
    var Eo = {
        append: H1
    };
    var lt = {
        append: P1
    };
    var tn = function(n) {
        return n.append;
    };
    var Rr = function(n) {
        return n.alt;
    };
    var IM = Number.POSITIVE_INFINITY, LM = Number.NEGATIVE_INFINITY;
    var O1 = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return t < a ? n : t === a ? r : e;
                    };
                };
            };
        };
    };
    var q1 = O1;
    var W1 = O1;
    var cp = function(n) {
        return function(r) {
            return n === r;
        };
    }, $1 = cp, U1 = cp;
    var B1 = cp;
    var Gt = {
        eq: B1
    };
    var yl = {
        eq: U1
    };
    var lp = {
        eq: $1
    };
    var Bn = function(n) {
        return n.eq;
    }, HM = Bn(lp);
    var uu = function(n) {
        var r = Bn(n);
        return function(e) {
            return function(t) {
                return HM(r(e)(t))(!1);
            };
        };
    };
    var En = function() {
        function n() {}
        return n.value = new n, n;
    }(), yn = function() {
        function n() {}
        return n.value = new n, n;
    }(), $n = function() {
        function n() {}
        return n.value = new n, n;
    }();
    var z1 = function(n) {
        return function(r) {
            return n + r | 0;
        };
    }, V1 = function(n) {
        return function(r) {
            return n * r | 0;
        };
    };
    var Tf = {
        add: z1,
        zero: 0,
        mul: V1,
        one: 1
    };
    var Et = function(n) {
        return n.add;
    };
    var oe = function() {
        return {
            compare: W1(En.value)($n.value)(yn.value),
            Eq0: function() {
                return Gt;
            }
        };
    }();
    var He = function() {
        return {
            compare: q1(En.value)($n.value)(yn.value),
            Eq0: function() {
                return yl;
            }
        };
    }();
    var Hn = function(n) {
        return n.compare;
    };
    var G1 = function(n) {
        return n.toString();
    };
    var j1 = function(n) {
        var r = n.length;
        return '"' + n.replace(/[\0-\x1F\x7F"\\]/g, function(e, t) {
            switch(e){
                case '"':
                case "\\":
                    return "\\" + e;
                case "\x07":
                    return "\\a";
                case "\b":
                    return "\\b";
                case "\f":
                    return "\\f";
                case `
`:
                    return "\\n";
                case "\r":
                    return "\\r";
                case "	":
                    return "\\t";
                case "\v":
                    return "\\v";
            }
            var a = t + 1, o = a < r && n[a] >= "0" && n[a] <= "9" ? "\\&" : "";
            return "\\" + e.charCodeAt(0).toString(10) + o;
        }) + '"';
    };
    var jt = {
        show: j1
    };
    var Va = {
        show: G1
    };
    var Tn = function(n) {
        return n.show;
    };
    var Xe = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), ce = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }();
    var Ja = function() {
        function n() {}
        return n.value = new n, n;
    }(), Q1 = function(n) {
        return n;
    }, K1 = function(n) {
        return n;
    }, Y1 = function(n) {
        return n.to;
    };
    var sp = function(n) {
        return n.from;
    };
    var KM = vn(Dn), F = function() {
        function n() {}
        return n.value = new n, n;
    }(), E = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }();
    var X1 = function(n) {
        var r = tn(n);
        return {
            append: function(e) {
                return function(t) {
                    if (e instanceof F) return t;
                    if (t instanceof F) return e;
                    if (e instanceof E && t instanceof E) return new E(r(e.value0)(t.value0));
                    throw new Error("Failed pattern match at Data.Maybe (line 182, column 1 - line 185, column 43): " + [
                        e.constructor.name,
                        t.constructor.name
                    ]);
                };
            }
        };
    };
    var _r = function(n) {
        return function(r) {
            return function(e) {
                if (e instanceof F) return n;
                if (e instanceof E) return r(e.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                    n.constructor.name,
                    r.constructor.name,
                    e.constructor.name
                ]);
            };
        };
    }, Mo = _r(!0)(Q(!1)), El = _r(!1)(Q(!0));
    var wr = {
        map: function(n) {
            return function(r) {
                return r instanceof E ? new E(n(r.value0)) : F.value;
            };
        }
    }, YM = C(wr);
    var Ir = function(n) {
        return _r(n)(KM);
    }, Tt = function() {
        return function(n) {
            if (n instanceof E) return n.value0;
            throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
                n.constructor.name
            ]);
        };
    };
    var Fo = function(n) {
        var r = Bn(n);
        return {
            eq: function(e) {
                return function(t) {
                    return e instanceof F && t instanceof F ? !0 : e instanceof E && t instanceof E ? r(e.value0)(t.value0) : !1;
                };
            }
        };
    };
    var cu = {
        apply: function(n) {
            return function(r) {
                if (n instanceof E) return YM(n.value0)(r);
                if (n instanceof F) return F.value;
                throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                    n.constructor.name,
                    r.constructor.name
                ]);
            };
        },
        Functor0: function() {
            return wr;
        }
    };
    var Pe = {
        bind: function(n) {
            return function(r) {
                if (n instanceof E) return r(n.value0);
                if (n instanceof F) return F.value;
                throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                    n.constructor.name,
                    r.constructor.name
                ]);
            };
        },
        Apply0: function() {
            return cu;
        }
    };
    var Ga = function() {
        return {
            pure: E.create,
            Apply0: function() {
                return cu;
            }
        };
    }();
    var rn = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), nn = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }();
    var Z1 = function(n) {
        return _r(new rn(n))(nn.create);
    };
    var st = {
        map: function(n) {
            return function(r) {
                if (r instanceof rn) return new rn(r.value0);
                if (r instanceof nn) return new nn(n(r.value0));
                throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                    r.constructor.name
                ]);
            };
        }
    }, XM = C(st);
    var nh = function(n) {
        return function(r) {
            return r instanceof rn ? r.value0 : n;
        };
    };
    var ke = function(n) {
        return function(r) {
            return function(e) {
                if (e instanceof rn) return n(e.value0);
                if (e instanceof nn) return r(e.value0);
                throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                    n.constructor.name,
                    r.constructor.name,
                    e.constructor.name
                ]);
            };
        };
    }, ja = function() {
        return ke(Q(F.value))(E.create);
    }(), rh = ke(Q(!0))(Q(!1));
    var Tl = {
        apply: function(n) {
            return function(r) {
                if (n instanceof rn) return new rn(n.value0);
                if (n instanceof nn) return XM(n.value0)(r);
                throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                    n.constructor.name,
                    r.constructor.name
                ]);
            };
        },
        Functor0: function() {
            return st;
        }
    };
    var wo = {
        bind: ke(function(n) {
            return function(r) {
                return new rn(n);
            };
        })(function(n) {
            return function(r) {
                return r(n);
            };
        }),
        Apply0: function() {
            return Tl;
        }
    };
    var Qa = function() {
        return {
            pure: nn.create,
            Apply0: function() {
                return Tl;
            }
        };
    }();
    var eh = function(n) {
        return function() {
            return n;
        };
    }, th = function(n) {
        return function(r) {
            return function() {
                return r(n())();
            };
        };
    };
    var Ml = {
        mempty: "",
        Semigroup0: function() {
            return Eo;
        }
    };
    var tr = function(n) {
        return n.mempty;
    };
    var ih = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, Ka = {
        Applicative0: function() {
            return xr;
        },
        Bind1: function() {
            return he;
        }
    }, he = {
        bind: th,
        Apply0: function() {
            return ch(0);
        }
    }, xr = {
        pure: eh,
        Apply0: function() {
            return ch(0);
        }
    }, fh = ih("functorEffect", "Effect", function() {
        return {
            map: bf(xr)
        };
    }), ch = ih("applyEffect", "Effect", function() {
        return {
            apply: ft(Ka),
            Functor0: function() {
                return fh(0);
            }
        };
    }), Pn = fh(20);
    function lh(n) {
        return n.stack || n.toString();
    }
    function pt(n) {
        return new Error(n);
    }
    function xo(n) {
        return function() {
            throw n;
        };
    }
    var ph = function(n) {
        return xo(pt(n));
    };
    var mh = {
        show: lh
    };
    var Ze = function(n) {
        return n.throwError;
    };
    var da = function(n) {
        return n.catchError;
    };
    var dp = function(n) {
        var r = da(n), e = n.MonadThrow0().Monad0(), t = C(e.Bind1().Apply0().Functor0()), a = k(e.Applicative0());
        return function(o) {
            return r(t(nn.create)(o))(function(u) {
                return a(rn.create(u));
            });
        };
    };
    var Ao = function(n) {
        return n;
    };
    var Ya = {
        map: function(n) {
            return function(r) {
                return n(r);
            };
        }
    };
    var dh = {
        apply: function(n) {
            return function(r) {
                return n(r);
            };
        },
        Functor0: function() {
            return Ya;
        }
    }, cF = {
        bind: function(n) {
            return function(r) {
                return r(n);
            };
        },
        Apply0: function() {
            return dh;
        }
    }, _p = {
        pure: Ao,
        Apply0: function() {
            return dh;
        }
    }, Nt = {
        Applicative0: function() {
            return _p;
        },
        Bind1: function() {
            return cF;
        }
    };
    var _h = function(n) {
        return function() {
            return {
                value: n
            };
        };
    };
    var hn = function(n) {
        return function() {
            return n.value;
        };
    }, vh = function(n) {
        return function(r) {
            return function() {
                var e = n(r.value);
                return r.value = e.state, e.value;
            };
        };
    }, mr = function(n) {
        return function(r) {
            return function() {
                r.value = n;
            };
        };
    };
    var sF = Hr(Pn), Cr = _h, vp = vh, hh = function(n) {
        return vp(function(r) {
            var e = n(r);
            return {
                state: e,
                value: e
            };
        });
    }, qe = function(n) {
        return function(r) {
            return sF(hh(n)(r));
        };
    };
    var pF = Pr(he), mF = C(Pn), We = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), we = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Pt = function(n) {
        return n.tailRecM;
    };
    var Dh = {
        tailRecM: function(n) {
            return function(r) {
                var e = function(t) {
                    if (t instanceof we) return t.value0;
                    throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                        t.constructor.name
                    ]);
                };
                return function() {
                    var a = pF(Cr)(n(r))();
                    return function() {
                        for(; !function() {
                            var u = hn(a)();
                            if (u instanceof We) {
                                var i = n(u.value0)();
                                return mr(i)(a)(), !1;
                            }
                            if (u instanceof we) return !0;
                            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                                u.constructor.name
                            ]);
                        }(););
                        return {};
                    }(), mF(e)(hn(a))();
                };
            };
        },
        Monad0: function() {
            return Ka;
        }
    };
    var R = function(n) {
        return n;
    };
    var Eh = function(n) {
        return function(r) {
            return n && r;
        };
    }, Th = function(n) {
        return function(r) {
            return n || r;
        };
    }, Mh = function(n) {
        return !n;
    };
    var wf = function(n) {
        return n.tt;
    };
    var Lo = function(n) {
        return n.not;
    };
    var Dp = function(n) {
        return n.implies;
    };
    var xf = function(n) {
        return n.ff;
    };
    var ui = function(n) {
        return n.disj;
    }, Io = {
        ff: !1,
        tt: !0,
        implies: function(n) {
            return function(r) {
                return ui(Io)(Lo(Io)(n))(r);
            };
        },
        conj: Eh,
        disj: Th,
        not: Mh
    };
    var Af = function(n) {
        return n.conj;
    }, gp = function(n) {
        var r = xf(n), e = wf(n), t = Dp(n), a = Af(n), o = ui(n), u = Lo(n);
        return {
            ff: function(i) {
                return r;
            },
            tt: function(i) {
                return e;
            },
            implies: function(i) {
                return function(c) {
                    return function(l) {
                        return t(i(l))(c(l));
                    };
                };
            },
            conj: function(i) {
                return function(c) {
                    return function(l) {
                        return a(i(l))(c(l));
                    };
                };
            },
            disj: function(i) {
                return function(c) {
                    return function(l) {
                        return o(i(l))(c(l));
                    };
                };
            },
            not: function(i) {
                return function(c) {
                    return u(i(c));
                };
            }
        };
    };
    var dn = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), If = function(n) {
        return function(r) {
            return n(r.value0)(r.value1);
        };
    };
    var De = function(n) {
        return n.value1;
    };
    var So = {
        map: function(n) {
            return function(r) {
                return new dn(r.value0, n(r.value1));
            };
        }
    };
    var xe = function(n) {
        return n.value0;
    };
    var Ro = function(n) {
        return n.state;
    };
    var Lf = function(n) {
        var r = Ro(n);
        return function(e) {
            return r(function(t) {
                return new dn(void 0, e(t));
            });
        };
    };
    var Sf = function(n) {
        return Ro(n)(function(r) {
            return new dn(r, r);
        });
    };
    var Br = function(n) {
        return n.lift;
    };
    var nt = function(n) {
        return n.empty;
    };
    var Nf = function() {
        return R;
    };
    var wh = Nf();
    var $e = function() {
        return wh;
    };
    var yp = function() {
        return function() {
            return function(n) {
                return wh;
            };
        };
    };
    var xh = {
        proof: function(n) {
            return n;
        },
        Coercible0: function() {}
    }, yF = function(n) {
        return n.proof;
    };
    var Cp = function(n) {
        var r = yF(n)(function(e) {
            return e;
        });
        return r;
    };
    var Ih = {
        liftEffect: vn(Dn),
        Monad0: function() {
            return Ka;
        }
    }, ir = function(n) {
        return n.liftEffect;
    };
    var Rh = function(n) {
        return n;
    };
    var Ep = function(n) {
        return n;
    };
    var Il = {
        lift: function(n) {
            return function(r) {
                return Rh(Q(r));
            };
        }
    }, CF = Br(Il), Nh = function(n) {
        return function(r) {
            return function(e) {
                return n(r(e));
            };
        };
    }, Hh = function(n) {
        return {
            map: function() {
                var r = C(n);
                return function(e) {
                    return Nh(r(e));
                };
            }()
        };
    };
    var Ll = function(n) {
        var r = Gn(n), e = Hh(n.Functor0());
        return {
            apply: function(t) {
                return function(a) {
                    return function(o) {
                        return r(t(o))(a(o));
                    };
                };
            },
            Functor0: function() {
                return e;
            }
        };
    }, Tp = function(n) {
        var r = Z(n), e = Ll(n.Apply0());
        return {
            bind: function(t) {
                return function(a) {
                    return function(o) {
                        return r(t(o))(function(u) {
                            var i = a(u);
                            return i(o);
                        });
                    };
                };
            },
            Apply0: function() {
                return e;
            }
        };
    };
    var Ph = function(n) {
        var r = Ll(n.Apply0());
        return {
            pure: function() {
                var e = k(n);
                return function(t) {
                    return Rh(Q(e(t)));
                };
            }(),
            Apply0: function() {
                return r;
            }
        };
    }, Of = function(n) {
        var r = Ph(n.Applicative0()), e = Tp(n.Bind1());
        return {
            Applicative0: function() {
                return r;
            },
            Bind1: function() {
                return e;
            }
        };
    }, kh = function(n) {
        var r = Of(n);
        return {
            ask: k(n.Applicative0()),
            Monad0: function() {
                return r;
            }
        };
    };
    var Sl = function(n) {
        var r = n.Monad0(), e = Of(r);
        return {
            liftEffect: function() {
                var t = CF(r), a = ir(n);
                return function(o) {
                    return t(a(o));
                };
            }(),
            Monad0: function() {
                return e;
            }
        };
    };
    var EF = C(st);
    var Nl = function(n) {
        return n;
    }, Hl = function(n) {
        var r = C(n);
        return function(e) {
            return function(t) {
                var a = function(o) {
                    return function(u) {
                        if (u instanceof nn) return new nn(u.value0);
                        if (u instanceof rn) return new rn(o(u.value0));
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 43, column 3 - line 43, column 32): " + [
                            o.constructor.name,
                            u.constructor.name
                        ]);
                    };
                };
                return r(a(e))(t);
            };
        };
    }, Mp = function(n) {
        return n;
    };
    var Pl = function(n) {
        return function(r) {
            return n(r);
        };
    }, kl = function(n) {
        var r = C(n);
        return {
            map: function(e) {
                return Pl(r(EF(e)));
            }
        };
    }, Fp = function(n) {
        var r = k(n);
        return function(e) {
            return Nl(r(e));
        };
    }, qh = function(n) {
        return {
            Applicative0: function() {
                return fi(n);
            },
            Bind1: function() {
                return su(n);
            }
        };
    }, su = function(n) {
        var r = Z(n.Bind1()), e = k(n.Applicative0());
        return {
            bind: function(t) {
                return function(a) {
                    return r(t)(ke(function(o) {
                        return e(rn.create(o));
                    })(function(o) {
                        var u = a(o);
                        return u;
                    }));
                };
            },
            Apply0: function() {
                return wp(n);
            }
        };
    }, wp = function(n) {
        var r = kl(n.Bind1().Apply0().Functor0());
        return {
            apply: ft(qh(n)),
            Functor0: function() {
                return r;
            }
        };
    }, fi = function(n) {
        return {
            pure: function() {
                var r = k(n.Applicative0());
                return function(e) {
                    return Nl(r(nn.create(e)));
                };
            }(),
            Apply0: function() {
                return wp(n);
            }
        };
    };
    var Wh = function(n) {
        var r = qh(n);
        return {
            throwError: function() {
                var e = k(n.Applicative0());
                return function(t) {
                    return Nl(e(rn.create(t)));
                };
            }(),
            Monad0: function() {
                return r;
            }
        };
    };
    var $h = function(n) {
        var r = tn(n);
        return function(e) {
            var t = e.Bind1(), a = Z(t), o = k(e.Applicative0()), u = kl(t.Apply0().Functor0());
            return {
                alt: function(i) {
                    return function(c) {
                        return a(i)(function(l) {
                            if (l instanceof nn) return o(new nn(l.value0));
                            if (l instanceof rn) return a(c)(function(d) {
                                if (d instanceof nn) return o(new nn(d.value0));
                                if (d instanceof rn) return o(new rn(r(l.value0)(d.value0)));
                                throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 87, column 9 - line 89, column 49): " + [
                                    d.constructor.name
                                ]);
                            });
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 83, column 5 - line 89, column 49): " + [
                                l.constructor.name
                            ]);
                        });
                    };
                },
                Functor0: function() {
                    return u;
                }
            };
        };
    };
    var Ip = function(n) {
        return n.dimap;
    };
    var du = function(n) {
        return n.sequential;
    }, ro = function(n) {
        return n.parallel;
    };
    var Gh = function(n) {
        return function(r) {
            return function(e) {
                for(var t = r, a = e.length, o = a - 1; o >= 0; o--)t = n(e[o])(t);
                return t;
            };
        };
    }, jh = function(n) {
        return function(r) {
            return function(e) {
                for(var t = r, a = e.length, o = 0; o < a; o++)t = n(t)(e[o]);
                return t;
            };
        };
    };
    var IF = vn(Dn), Ue = function(n) {
        return n.bimap;
    };
    var Ho = function(n) {
        var r = Ue(n);
        return function(e) {
            return r(e)(IF);
        };
    };
    var _u = {
        bimap: function(n) {
            return function(r) {
                return function(e) {
                    return new dn(n(e.value0), r(e.value1));
                };
            };
        }
    }, ha = {
        bimap: function(n) {
            return function(r) {
                return function(e) {
                    if (e instanceof rn) return new rn(n(e.value0));
                    if (e instanceof nn) return new nn(r(e.value0));
                    throw new Error("Failed pattern match at Data.Bifunctor (line 38, column 1 - line 40, column 36): " + [
                        n.constructor.name,
                        r.constructor.name,
                        e.constructor.name
                    ]);
                };
            };
        }
    };
    var Gr = function(n) {
        return n.foldr;
    };
    var ne = function(n) {
        var r = ti(n.Apply0()), e = k(n);
        return function(t) {
            var a = Gr(t);
            return function(o) {
                return a(function(u) {
                    return r(o(u));
                })(e(void 0));
            };
        };
    }, $l = function(n) {
        var r = ne(n);
        return function(e) {
            return On(r(e));
        };
    };
    var kr = function(n) {
        return n.foldl;
    }, Op = function(n) {
        var r = kr(n);
        return function(e) {
            var t = function(o) {
                return function(u) {
                    if (o.elem instanceof E) return o;
                    var i = o.pos === e;
                    return i ? {
                        elem: new E(u),
                        pos: o.pos
                    } : {
                        pos: o.pos + 1 | 0,
                        elem: o.elem
                    };
                };
            }, a = r(t)({
                elem: F.value,
                pos: 0
            });
            return function(o) {
                return function(u) {
                    return u.elem;
                }(a(o));
            };
        };
    };
    var me = {
        foldr: function(n) {
            return function(r) {
                return function(e) {
                    if (e instanceof F) return r;
                    if (e instanceof E) return n(e.value0)(r);
                    throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                        n.constructor.name,
                        r.constructor.name,
                        e.constructor.name
                    ]);
                };
            };
        },
        foldl: function(n) {
            return function(r) {
                return function(e) {
                    if (e instanceof F) return r;
                    if (e instanceof E) return n(r)(e.value0);
                    throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                        n.constructor.name,
                        r.constructor.name,
                        e.constructor.name
                    ]);
                };
            };
        },
        foldMap: function(n) {
            var r = tr(n);
            return function(e) {
                return function(t) {
                    if (t instanceof F) return r;
                    if (t instanceof E) return e(t.value0);
                    throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                        e.constructor.name,
                        t.constructor.name
                    ]);
                };
            };
        }
    };
    var Po = {
        foldr: function(n) {
            return function(r) {
                return function(e) {
                    if (e instanceof rn) return r;
                    if (e instanceof nn) return n(e.value0)(r);
                    throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                        n.constructor.name,
                        r.constructor.name,
                        e.constructor.name
                    ]);
                };
            };
        },
        foldl: function(n) {
            return function(r) {
                return function(e) {
                    if (e instanceof rn) return r;
                    if (e instanceof nn) return n(r)(e.value0);
                    throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                        n.constructor.name,
                        r.constructor.name,
                        e.constructor.name
                    ]);
                };
            };
        },
        foldMap: function(n) {
            var r = tr(n);
            return function(e) {
                return function(t) {
                    if (t instanceof rn) return r;
                    if (t instanceof nn) return e(t.value0);
                    throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                        e.constructor.name,
                        t.constructor.name
                    ]);
                };
            };
        }
    };
    var nD = function(n) {
        var r = Gr(n);
        return function(e) {
            var t = tn(e.Semigroup0()), a = tr(e);
            return function(o) {
                return r(function(u) {
                    return function(i) {
                        return t(o(u))(i);
                    };
                })(a);
            };
        };
    }, ue = {
        foldr: Gh,
        foldl: jh,
        foldMap: function(n) {
            return nD(ue)(n);
        }
    };
    var ge = function(n) {
        return n.foldMap;
    };
    var rD = function() {
        function n(a) {
            return [
                a
            ];
        }
        function r(a) {
            return function(o) {
                return [
                    a,
                    o
                ];
            };
        }
        function e(a) {
            return function(o) {
                return function(u) {
                    return [
                        a,
                        o,
                        u
                    ];
                };
            };
        }
        function t(a) {
            return function(o) {
                return a.concat(o);
            };
        }
        return function(a) {
            return function(o) {
                return function(u) {
                    return function(i) {
                        return function(c) {
                            function l(d, m) {
                                switch(m - d){
                                    case 0:
                                        return u([]);
                                    case 1:
                                        return o(n)(i(c[d]));
                                    case 2:
                                        return a(o(r)(i(c[d])))(i(c[d + 1]));
                                    case 3:
                                        return a(a(o(e)(i(c[d])))(i(c[d + 1])))(i(c[d + 2]));
                                    default:
                                        var v = d + Math.floor((m - d) / 4) * 2;
                                        return a(o(t)(l(d, v)))(l(v, m));
                                }
                            }
                            return l(0, c.length);
                        };
                    };
                };
            };
        };
    }();
    var hw = vn(Dn), be = function(n) {
        return n.traverse;
    };
    var Up = {
        traverse: function(n) {
            var r = k(n), e = C(n.Apply0().Functor0());
            return function(t) {
                return function(a) {
                    if (a instanceof rn) return r(new rn(a.value0));
                    if (a instanceof nn) return e(nn.create)(t(a.value0));
                    throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                        t.constructor.name,
                        a.constructor.name
                    ]);
                };
            };
        },
        sequence: function(n) {
            var r = k(n), e = C(n.Apply0().Functor0());
            return function(t) {
                if (t instanceof rn) return r(new rn(t.value0));
                if (t instanceof nn) return e(nn.create)(t.value0);
                throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                    t.constructor.name
                ]);
            };
        },
        Functor0: function() {
            return st;
        },
        Foldable1: function() {
            return Po;
        }
    };
    var _D = function(n) {
        var r = be(n);
        return function(e) {
            return r(e)(hw);
        };
    }, kt = {
        traverse: function(n) {
            var r = n.Apply0();
            return rD(Gn(r))(C(r.Functor0()))(k(n));
        },
        sequence: function(n) {
            return _D(kt)(n);
        },
        Functor0: function() {
            return Ur;
        },
        Foldable1: function() {
            return ue;
        }
    }, Kt = function(n) {
        return n.sequence;
    };
    var vD = vn(Dn), Dw = function(n) {
        var r = du(n), e = ro(n);
        return function(t) {
            var a = ne(t);
            return function(o) {
                var u = a(o);
                return function(i) {
                    var c = u(function(l) {
                        return e(i(l));
                    });
                    return function(l) {
                        return r(c(l));
                    };
                };
            };
        };
    }, gw = function(n) {
        var r = du(n), e = ro(n);
        return function(t) {
            return function(a) {
                var o = be(a)(t);
                return function(u) {
                    var i = o(function(c) {
                        return e(u(c));
                    });
                    return function(c) {
                        return r(i(c));
                    };
                };
            };
        };
    }, ci = function(n) {
        var r = Dw(n);
        return function(e) {
            var t = r(e);
            return function(a) {
                return t(a)(vD);
            };
        };
    }, Bp = function(n) {
        var r = gw(n);
        return function(e) {
            var t = r(e);
            return function(a) {
                return t(a)(vD);
            };
        };
    };
    var bw = "MCV1";
    function Jl(n) {
        return document.getElementById(n);
    }
    function Vl(n, r) {
        let e = Jl("cv-status");
        e && (e.textContent = n, e.className = r === "error" ? "text-sm mt-3 text-red-700" : "text-sm mt-3 text-gray-500");
    }
    async function yw(n, r) {
        let e = new Uint8Array(n), t = new DataView(e.buffer, e.byteOffset, 36);
        if (String.fromCharCode(...e.slice(0, 4)) !== bw) throw new Error("not a CV blob");
        let o = t.getUint32(4, !1), u = e.slice(8, 24), i = e.slice(24, 36), c = e.slice(36), l = await crypto.subtle.importKey("raw", new TextEncoder().encode(r), "PBKDF2", !1, [
            "deriveKey"
        ]), d = await crypto.subtle.deriveKey({
            name: "PBKDF2",
            salt: u,
            iterations: o,
            hash: "SHA-256"
        }, l, {
            name: "AES-GCM",
            length: 256
        }, !1, [
            "decrypt"
        ]);
        return crypto.subtle.decrypt({
            name: "AES-GCM",
            iv: i
        }, d, c);
    }
    function zp() {
        let n = Jl("cv-password");
        if (!n) return;
        let r = n.value;
        if (!r) {
            Vl("Enter the passphrase.", "error");
            return;
        }
        Vl("Decrypting\u2026 (deriving the key takes a moment)"), fetch("/cv.enc").then(function(e) {
            if (!e.ok) throw new Error("could not fetch the encrypted CV");
            return e.arrayBuffer();
        }).then(function(e) {
            return yw(e, r);
        }).then(function(e) {
            let t = URL.createObjectURL(new Blob([
                e
            ], {
                type: "application/pdf"
            })), a = Jl("cv-result");
            a && (a.innerHTML = '<iframe src="' + t + '" class="w-full h-[80vh] border border-gray-200"></iframe><p class="mt-3 text-sm"><a href="' + t + '" download="matthias-meschede-cv.pdf" class="text-gray-600 underline">Download the PDF</a></p>');
            let o = Jl("cv-gate");
            o && o.classList.add("hidden"), Vl("");
        }).catch(function(e) {
            Vl("That passphrase did not work.", "error"), console && console.debug && console.debug(e);
        });
    }
    function Vp(n) {
        return JSON.stringify(n);
    }
    function zf(n, r, e, t, a, o, u) {
        return u == null ? n() : typeof u == "boolean" ? r(u) : typeof u == "number" ? e(u) : typeof u == "string" ? t(u) : Object.prototype.toString.call(u) === "[object Array]" ? a(u) : o(u);
    }
    function hD(n, r, e, t) {
        return e in t ? r(t[e]) : n;
    }
    function Jp(n) {
        return function(r) {
            var e = [];
            for(var t in r)hasOwnProperty.call(r, t) && e.push(n(t)(r[t]));
            return e;
        };
    }
    var Tw = Object.keys || Jp(function(n) {
        return function() {
            return n;
        };
    });
    var Fw = function(n, r) {
        if (n < 1) return [];
        var e = new Array(n);
        return e.fill(r);
    }, ww = function(n, r) {
        for(var e = [], t = 0, a = 0; a < n; a++)e[t++] = r;
        return e;
    }, xw = typeof Array.prototype.fill == "function" ? Fw : ww;
    var rt = function(n) {
        return n.length;
    }, Gp = function(n, r, e) {
        return e.length === 0 ? n({}) : r(e[0])(e.slice(1));
    }, DD = function(n, r, e, t) {
        return t < 0 || t >= e.length ? r : n(e[t]);
    };
    var gD = function(n, r, e, t) {
        for(var a = 0, o = t.length; a < o; a++)if (e(t[a])) return n(a);
        return r;
    };
    var bD = function(n, r, e, t) {
        if (e < 0 || e >= t.length) return r;
        var a = t.slice();
        return a.splice(e, 1), n(a);
    };
    var Gl = function(n) {
        return n.slice().reverse();
    };
    var yD = function(n, r) {
        return r.filter(n);
    };
    var CD = function(n, r, e) {
        return e.slice(n, r);
    }, ED = function(n, r, e) {
        for(var t = r.length < e.length ? r.length : e.length, a = new Array(t), o = 0; o < t; o++)a[o] = n(r[o])(e[o]);
        return a;
    };
    function Iw(n) {
        return n;
    }
    var TD = Iw;
    function Lw(n) {
        return n.slice();
    }
    var MD = Lw;
    var FD = function(n, r) {
        return r.push(n);
    };
    var jl = function(r) {
        return function(e) {
            return function() {
                return r(e);
            };
        };
    }, jp = function(r) {
        return function(e) {
            return function(t) {
                return function() {
                    return r(e, t);
                };
            };
        };
    };
    var wD = jl(TD);
    var qw = jl(MD), xD = function(n) {
        return function(r) {
            return function() {
                var t = qw(r)();
                return n(t)(), wD(t)();
            };
        };
    };
    var Qp = jp(FD);
    var Vf = function(n) {
        return function(r) {
            return function(e) {
                return n(r, e);
            };
        };
    }, eo = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        };
    }, hu = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return n(r, e, t, a);
                    };
                };
            };
        };
    };
    var LD = function(n) {
        return function(r) {
            for(var e = r.length, t = Array(e), a = 0; a < e; a++)t[a] = n(a)(r[a]);
            return t;
        };
    };
    var Du = function(n) {
        return n.mapWithIndex;
    };
    var si = {
        mapWithIndex: LD,
        Functor0: function() {
            return Ur;
        }
    };
    var RD = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(o) {
                            for(var u = [], i = o;;){
                                var c = a(i);
                                if (n(c)) return u;
                                var l = r(c);
                                u.push(e(l)), i = t(l);
                            }
                        };
                    };
                };
            };
        };
    };
    var ND = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(o) {
                            for(var u = [], i = o;;){
                                var c = a(i);
                                u.push(e(c));
                                var l = t(c);
                                if (n(l)) return u;
                                i = r(l);
                            }
                        };
                    };
                };
            };
        };
    };
    var Zw = Tt();
    var Yp = {
        unfoldr1: ND(Mo)(Zw)(xe)(De)
    };
    var r6 = Tt(), to = function(n) {
        return n.unfoldr;
    };
    var mi = {
        unfoldr: RD(Mo)(r6)(xe)(De),
        Unfoldable10: function() {
            return Yp;
        }
    };
    var a6 = Tt();
    var o6 = tn(lt);
    var kD = eo(ED);
    var Xp = function() {
        return kD(dn.create);
    }();
    var Kl = function() {
        return eo(Gp)(Q(F.value))(function(n) {
            return function(r) {
                return new E({
                    head: n,
                    tail: r
                });
            };
        });
    }();
    var OD = function() {
        return eo(Gp)(Q(F.value))(function(n) {
            return function(r) {
                return new E(r);
            };
        });
    }();
    var jf = function(n) {
        return function(r) {
            return xD(Qp(r))(n)();
        };
    }, Zp = eo(CD);
    var nm = function(n) {
        return [
            n
        ];
    };
    var u6 = function(n) {
        return rt(n) === 0;
    };
    var qD = function(n) {
        if (u6(n)) return F.value;
        if (Wr) return new E(Zp(0)(rt(n) - 1 | 0)(n));
        throw new Error("Failed pattern match at Data.Array (line 351, column 1 - line 351, column 45): " + [
            n.constructor.name
        ]);
    }, Qf = function() {
        return hu(DD)(E.create)(F.value);
    }(), WD = function(n) {
        return Qf(n)(rt(n) - 1 | 0);
    };
    var di = function(n) {
        return Qf(n)(0);
    };
    var $D = function() {
        return hu(gD)(E.create)(F.value);
    }();
    var rm = Vf(yD);
    var em = function(n) {
        return function(r) {
            var e = n < 1;
            return e ? r : Zp(n)(rt(r))(r);
        };
    };
    var UD = function() {
        return hu(bD)(E.create)(F.value);
    }(), tm = function(n) {
        return function(r) {
            return function(e) {
                return e.length === 0 ? [] : _r(e)(function(t) {
                    return a6(UD(t)(e));
                })($D(n(r))(e));
            };
        };
    };
    var Yl = function(n) {
        return function(r) {
            return o6([
                n
            ])(r);
        };
    };
    var i6 = On(Z(bl)), Kf = function(n) {
        return i6(function() {
            var r = _r([])(nm);
            return function(e) {
                return r(n(e));
            };
        }());
    };
    var am = Kf(vn(Dn));
    var f6 = Gr(ue), BD = Du(si), c6 = kr(ue);
    var Yf = function(n) {
        return n.foldrWithIndex;
    };
    var l6 = function(n) {
        var r = Yf(n);
        return function(e) {
            var t = tn(e.Semigroup0()), a = tr(e);
            return function(o) {
                return r(function(u) {
                    return function(i) {
                        return function(c) {
                            return t(o(u)(i))(c);
                        };
                    };
                })(a);
            };
        };
    }, Xl = {
        foldrWithIndex: function(n) {
            return function(r) {
                var e = f6(function(a) {
                    return function(o) {
                        return n(a.value0)(a.value1)(o);
                    };
                })(r), t = BD(dn.create);
                return function(a) {
                    return e(t(a));
                };
            };
        },
        foldlWithIndex: function(n) {
            return function(r) {
                var e = c6(function(a) {
                    return function(o) {
                        return n(o.value0)(a)(o.value1);
                    };
                })(r), t = BD(dn.create);
                return function(a) {
                    return e(t(a));
                };
            };
        },
        foldMapWithIndex: function(n) {
            return l6(Xl)(n);
        },
        Foldable0: function() {
            return ue;
        }
    };
    var s6 = function(n) {
        var r = Kt(n.Traversable2()), e = Du(n.FunctorWithIndex0());
        return function(t) {
            var a = r(t);
            return function(o) {
                var u = e(o);
                return function(i) {
                    return a(u(i));
                };
            };
        };
    }, Xf = function(n) {
        return n.traverseWithIndex;
    };
    var Zl = {
        traverseWithIndex: function(n) {
            return s6(Zl)(n);
        },
        FunctorWithIndex0: function() {
            return si;
        },
        FoldableWithIndex1: function() {
            return Xl;
        },
        Traversable2: function() {
            return kt;
        }
    };
    var ns = function() {
        return {};
    };
    var nc = function() {
        return hu(hD)(F.value)(E.create);
    }();
    var QD = function(n) {
        return function(r) {
            return function(e) {
                return e(n)(r);
            };
        };
    }, KD = function() {
        return QD(F.value)(E.create);
    }();
    var b6 = QD(!1)(Q(!0));
    var YD = function(n) {
        return function(r) {
            return function(e) {
                return zf(Q(n), Q(n), Q(n), r, Q(n), Q(n), e);
            };
        };
    };
    var y6 = function(n) {
        return function(r) {
            return function(e) {
                return zf(Q(n), Q(n), Q(n), Q(n), Q(n), r, e);
            };
        };
    };
    var om = KD(y6);
    var XD = function(n) {
        return function(r) {
            return function(e) {
                return zf(r, Q(n), Q(n), Q(n), Q(n), Q(n), e);
            };
        };
    }, ZD = b6(XD);
    var C6 = function(n) {
        return function(r) {
            return function(e) {
                return zf(Q(n), Q(n), Q(n), Q(n), r, Q(n), e);
            };
        };
    };
    var ng = KD(C6);
    var E6 = Tn(Va);
    var _i = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), rg = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), im = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), rc = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), fm = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), ts = function() {
        function n() {}
        return n.value = new n, n;
    }();
    var eg = function(n) {
        var r = function(e) {
            if (e instanceof _i) return "  Expected value of type '" + (e.value0 + "'.");
            if (e instanceof rg) return "  Unexpected value " + (Vp(e.value0) + ".");
            if (e instanceof im) return "  At array index " + (E6(e.value0) + (`:
` + r(e.value1)));
            if (e instanceof rc) return "  At object key '" + (e.value0 + (`':
` + r(e.value1)));
            if (e instanceof fm) return "  Under '" + (e.value0 + (`':
` + r(e.value1)));
            if (e instanceof ts) return "  No value was found.";
            throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 37, column 8 - line 43, column 44): " + [
                e.constructor.name
            ]);
        };
        return `An error occurred while decoding a JSON value:
` + r(n);
    };
    var tg = function(n) {
        return n;
    };
    var ag = lt;
    var lm = Ur;
    var og = ue;
    var Xt = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }();
    var pm = function(n) {
        var r = nt(n);
        return function(e) {
            return new Xt(e, r);
        };
    };
    var ig = function(n) {
        var r = ge(n), e = kr(n), t = Gr(n);
        return {
            foldMap: function(a) {
                var o = tn(a.Semigroup0()), u = r(a);
                return function(i) {
                    return function(c) {
                        return o(i(c.value0))(u(i)(c.value1));
                    };
                };
            },
            foldl: function(a) {
                return function(o) {
                    return function(u) {
                        return e(a)(a(o)(u.value0))(u.value1);
                    };
                };
            },
            foldr: function(a) {
                return function(o) {
                    return function(u) {
                        return a(u.value0)(t(a)(o)(u.value1));
                    };
                };
            }
        };
    };
    var x6 = Tt();
    var hi = tg;
    var mm = function(n) {
        return n;
    };
    var cg = function(n) {
        return function(r) {
            return hi(jf(n)(r));
        };
    }, lg = function(n) {
        return function(r) {
            return hi(jf(mm(n))(r));
        };
    }, sg = function(n) {
        return hi(nm(n));
    };
    var pg = function(n) {
        if (rt(n) > 0) return new E(hi(n));
        if (Wr) return F.value;
        throw new Error("Failed pattern match at Data.Array.NonEmpty (line 161, column 1 - line 161, column 58): " + [
            n.constructor.name
        ]);
    };
    var as = function(n) {
        return function(r) {
            return hi(Yl(n)(r));
        };
    };
    var os = function(n) {
        return function(r) {
            return x6(n(mm(r)));
        };
    }, dm = os(di), _m = os(qD), vm = os(WD), hm = os(OD);
    var mg = function(n) {
        return function(r) {
            return n(mm(r));
        };
    };
    var ec = mg(Qf);
    var A6 = function(n) {
        var r = mg(n);
        return function(e) {
            return hi(r(e));
        };
    }, Dm = function(n) {
        return A6(Yl(n));
    };
    var kn = function() {
        function n() {}
        return n.value = new n, n;
    }(), Wn = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), bm = function(n) {
        return n;
    }, $6 = function(n) {
        return new Wn(n.value0, n.value1);
    };
    var U6 = function(n) {
        var r = function(e) {
            return function(t) {
                var a = e, o = !1, u;
                function i(c, l) {
                    if (l instanceof Wn && l.value1 instanceof Wn && l.value1.value1 instanceof Wn) {
                        a = new Wn(l, c), t = l.value1.value1.value1;
                        return;
                    }
                    var d = function(v) {
                        return v instanceof Wn && v.value1 instanceof Wn && v.value1.value1 instanceof kn ? new Wn(n(v.value0), new Wn(n(v.value1.value0), kn.value)) : v instanceof Wn && v.value1 instanceof kn ? new Wn(n(v.value0), kn.value) : kn.value;
                    }, m = function(v) {
                        return function(_) {
                            var D = v, T = !1, I;
                            function $(q, z) {
                                if (q instanceof Wn && q.value0 instanceof Wn && q.value0.value1 instanceof Wn && q.value0.value1.value1 instanceof Wn) {
                                    D = q.value1, _ = new Wn(n(q.value0.value0), new Wn(n(q.value0.value1.value0), new Wn(n(q.value0.value1.value1.value0), z)));
                                    return;
                                }
                                return T = !0, z;
                            }
                            for(; !T;)I = $(D, _);
                            return I;
                        };
                    };
                    return o = !0, m(c)(d(l));
                }
                for(; !o;)u = i(a, t);
                return u;
            };
        };
        return r(kn.value);
    }, ac = {
        map: U6
    };
    var et = {
        foldr: function(n) {
            return function(r) {
                var e = function() {
                    var a = function(o) {
                        return function(u) {
                            var i = o, c = !1, l;
                            function d(m, v) {
                                if (v instanceof kn) return c = !0, m;
                                if (v instanceof Wn) {
                                    i = new Wn(v.value0, m), u = v.value1;
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                    m.constructor.name,
                                    v.constructor.name
                                ]);
                            }
                            for(; !c;)l = d(i, u);
                            return l;
                        };
                    };
                    return a(kn.value);
                }(), t = kr(et)(On(n))(r);
                return function(a) {
                    return t(e(a));
                };
            };
        },
        foldl: function(n) {
            var r = function(e) {
                return function(t) {
                    var a = e, o = !1, u;
                    function i(c, l) {
                        if (l instanceof kn) return o = !0, c;
                        if (l instanceof Wn) {
                            a = n(c)(l.value0), t = l.value1;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                            l.constructor.name
                        ]);
                    }
                    for(; !o;)u = i(a, t);
                    return u;
                };
            };
            return r;
        },
        foldMap: function(n) {
            var r = tn(n.Semigroup0()), e = tr(n);
            return function(t) {
                return kr(et)(function(a) {
                    var o = r(a);
                    return function(u) {
                        return o(t(u));
                    };
                })(e);
            };
        }
    };
    var B6 = Gr(et);
    var hg = ig(et);
    var oc = {
        append: function(n) {
            return function(r) {
                return B6(Wn.create)(r)(n);
            };
        }
    }, Dg = tn(oc);
    var gg = {
        append: function(n) {
            return function(r) {
                return new Xt(n.value0, Dg(n.value1)($6(r)));
            };
        }
    };
    var z6 = {
        alt: Dg,
        Functor0: function() {
            return ac;
        }
    }, bg = function() {
        return {
            empty: kn.value,
            Alt0: function() {
                return z6;
            }
        };
    }();
    var K6 = C(wr);
    var ym = function(n) {
        if (n instanceof kn) return F.value;
        if (n instanceof Wn) return new E({
            head: n.value0,
            tail: n.value1
        });
        throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
            n.constructor.name
        ]);
    }, Cm = function(n) {
        return to(n)(function(r) {
            return K6(function(e) {
                return new dn(e.head, e.tail);
            })(ym(r));
        });
    };
    var ko = function() {
        var n = function(r) {
            return function(e) {
                var t = r, a = !1, o;
                function u(i, c) {
                    if (c instanceof kn) return a = !0, i;
                    if (c instanceof Wn) {
                        t = new Wn(c.value0, i), e = c.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                        i.constructor.name,
                        c.constructor.name
                    ]);
                }
                for(; !a;)o = u(t, e);
                return o;
            };
        };
        return n(kn.value);
    }();
    var Mg = function(n) {
        return n instanceof kn;
    };
    var Fg = function(n) {
        return n();
    };
    var wg = function(n) {
        throw new Error(n);
    };
    var xg = function() {
        return wg;
    };
    var nx = xg(), rx = Fg, us = function(n) {
        return rx(function() {
            return nx(n);
        });
    };
    var is = function() {
        var n = pm(bg);
        return function(r) {
            return bm(n(r));
        };
    }();
    var Lg = function(n) {
        return function(r) {
            return new Xt(n, new Wn(r.value0, r.value1));
        };
    };
    var cs = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    };
    var ie = function() {
        function n() {}
        return n.value = new n, n;
    }(), Qr = function() {
        function n(r, e, t, a, o, u) {
            this.value0 = r, this.value1 = e, this.value2 = t, this.value3 = a, this.value4 = o, this.value5 = u;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(o) {
                            return function(u) {
                                return new n(r, e, t, a, o, u);
                            };
                        };
                    };
                };
            };
        }, n;
    }();
    var fs = function() {
        function n(r, e, t) {
            this.value0 = r, this.value1 = e, this.value2 = t;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return new n(r, e, t);
                };
            };
        }, n;
    }(), Sg = function() {
        function n(r, e, t) {
            this.value0 = r, this.value1 = e, this.value2 = t;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return new n(r, e, t);
                };
            };
        }, n;
    }(), qt = function(n, r, e, t) {
        if (e instanceof ie) {
            if (t instanceof ie) return new Qr(1, 1, n, r, e, t);
            if (t instanceof Qr) return new Qr(1 + t.value0 | 0, 1 + t.value1 | 0, n, r, e, t);
            throw new Error("Failed pattern match at Data.Map.Internal (line 702, column 5 - line 706, column 39): " + [
                t.constructor.name
            ]);
        }
        if (e instanceof Qr) {
            if (t instanceof ie) return new Qr(1 + e.value0 | 0, 1 + e.value1 | 0, n, r, e, t);
            if (t instanceof Qr) return new Qr(1 + function() {
                var a = e.value0 > t.value0;
                return a ? e.value0 : t.value0;
            }() | 0, (1 + e.value1 | 0) + t.value1 | 0, n, r, e, t);
            throw new Error("Failed pattern match at Data.Map.Internal (line 708, column 5 - line 712, column 68): " + [
                t.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 700, column 32 - line 712, column 68): " + [
            e.constructor.name
        ]);
    };
    var ls = function(n) {
        return function(r) {
            return new Qr(1, 1, n, r, ie.value, ie.value);
        };
    }, oo = function() {
        var n = function(t) {
            if (t instanceof ie) return 0;
            if (t instanceof Qr) return t.value0;
            throw new Error("Failed pattern match at Data.Map.Internal (line 757, column 12 - line 759, column 26): " + [
                t.constructor.name
            ]);
        }, r = function(t, a, o, u, i, c, l) {
            return c instanceof Qr && c.value0 > n(l) ? qt(c.value2, c.value3, qt(t, a, o, c.value4), qt(u, i, c.value5, l)) : qt(u, i, qt(t, a, o, c), l);
        }, e = function(t, a, o, u, i, c, l) {
            return c instanceof Qr && n(i) <= c.value0 ? qt(c.value2, c.value3, qt(o, u, i, c.value4), qt(t, a, c.value5, l)) : qt(o, u, i, qt(t, a, c, l));
        };
        return function(t, a, o, u) {
            if (o instanceof ie) return u instanceof ie ? ls(t)(a) : u instanceof Qr && u.value0 > 1 ? r(t, a, o, u.value2, u.value3, u.value4, u.value5) : qt(t, a, o, u);
            if (o instanceof Qr) {
                if (u instanceof Qr) {
                    if (u.value0 > (o.value0 + 1 | 0)) return r(t, a, o, u.value2, u.value3, u.value4, u.value5);
                    if (o.value0 > (u.value0 + 1 | 0)) return e(t, a, o.value2, o.value3, o.value4, o.value5, u);
                }
                return u instanceof ie && o.value0 > 1 ? e(t, a, o.value2, o.value3, o.value4, o.value5, u) : qt(t, a, o, u);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 717, column 40 - line 738, column 34): " + [
                o.constructor.name
            ]);
        };
    }(), Tm = cs("unsafeSplit", "Data.Map.Internal", function() {
        return function(n, r, e) {
            if (e instanceof ie) return new fs(F.value, ie.value, ie.value);
            if (e instanceof Qr) {
                var t = n(r)(e.value2);
                if (t instanceof En) {
                    var a = Tm(793)(n, r, e.value4);
                    return new fs(a.value0, a.value1, oo(e.value2, e.value3, a.value2, e.value5));
                }
                if (t instanceof yn) {
                    var a = Tm(796)(n, r, e.value5);
                    return new fs(a.value0, oo(e.value2, e.value3, e.value4, a.value1), a.value2);
                }
                if (t instanceof $n) return new fs(new E(e.value3), e.value4, e.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 791, column 5 - line 799, column 30): " + [
                    t.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 787, column 34 - line 799, column 30): " + [
                e.constructor.name
            ]);
        };
    }), ux = Tm(786), Rg = cs("unsafeSplitLast", "Data.Map.Internal", function() {
        return function(n, r, e, t) {
            if (t instanceof ie) return new Sg(n, r, e);
            if (t instanceof Qr) {
                var a = Rg(779)(t.value2, t.value3, t.value4, t.value5);
                return new Sg(a.value0, a.value1, oo(n, r, e, a.value2));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 776, column 37 - line 780, column 57): " + [
                t.constructor.name
            ]);
        };
    }), ix = Rg(775), Ng = function(n, r) {
        if (n instanceof ie) return r;
        if (n instanceof Qr) {
            var e = ix(n.value2, n.value3, n.value4, n.value5);
            return oo(e.value0, e.value1, e.value2, r);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 764, column 25 - line 768, column 38): " + [
            n.constructor.name,
            r.constructor.name
        ]);
    };
    var Oo = function(n) {
        var r = Hn(n);
        return function(e) {
            var t = function(a) {
                var o = !1, u;
                function i(c) {
                    if (c instanceof ie) return o = !0, F.value;
                    if (c instanceof Qr) {
                        var l = r(e)(c.value2);
                        if (l instanceof En) {
                            a = c.value4;
                            return;
                        }
                        if (l instanceof yn) {
                            a = c.value5;
                            return;
                        }
                        if (l instanceof $n) return o = !0, new E(c.value3);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 7 - line 286, column 22): " + [
                            l.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 280, column 8 - line 286, column 22): " + [
                        c.constructor.name
                    ]);
                }
                for(; !o;)u = i(a);
                return u;
            };
            return t;
        };
    };
    var uo = function(n) {
        var r = Hn(n);
        return function(e) {
            return function(t) {
                var a = function(o) {
                    if (o instanceof ie) return ls(e)(t);
                    if (o instanceof Qr) {
                        var u = r(e)(o.value2);
                        if (u instanceof En) return oo(o.value2, o.value3, a(o.value4), o.value5);
                        if (u instanceof yn) return oo(o.value2, o.value3, o.value4, a(o.value5));
                        if (u instanceof $n) return new Qr(o.value0, o.value1, e, t, o.value4, o.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 471, column 7 - line 474, column 35): " + [
                            u.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 8 - line 474, column 35): " + [
                        o.constructor.name
                    ]);
                };
                return a;
            };
        };
    };
    var bu = {
        foldr: function(n) {
            return function(r) {
                var e = cs("go", "Data.Map.Internal", function() {
                    return function(a, o) {
                        if (a instanceof ie) return o;
                        if (a instanceof Qr) return e(172)(a.value4, n(a.value3)(e(172)(a.value5, o)));
                        throw new Error("Failed pattern match at Data.Map.Internal (line 169, column 26 - line 172, column 43): " + [
                            a.constructor.name
                        ]);
                    };
                }), t = e(169);
                return function(a) {
                    return t(a, r);
                };
            };
        },
        foldl: function(n) {
            return function(r) {
                var e = cs("go", "Data.Map.Internal", function() {
                    return function(a, o) {
                        if (o instanceof ie) return a;
                        if (o instanceof Qr) return e(178)(n(e(178)(a, o.value4))(o.value3), o.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 175, column 26 - line 178, column 43): " + [
                            o.constructor.name
                        ]);
                    };
                }), t = e(175);
                return function(a) {
                    return t(r, a);
                };
            };
        },
        foldMap: function(n) {
            var r = tr(n), e = tn(n.Semigroup0());
            return function(t) {
                var a = function(o) {
                    if (o instanceof ie) return r;
                    if (o instanceof Qr) return e(a(o.value4))(e(t(o.value3))(a(o.value5)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 181, column 10 - line 184, column 28): " + [
                        o.constructor.name
                    ]);
                };
                return a;
            };
        }
    };
    var Hg = function() {
        return Gr(bu)(Wn.create)(kn.value);
    }();
    var Ft = function() {
        return ie.value;
    }(), ss = function(n) {
        var r = uo(n);
        return function(e) {
            return kr(e)(function(t) {
                return function(a) {
                    return r(a.value0)(a.value1)(t);
                };
            })(Ft);
        };
    };
    var Di = function(n) {
        var r = Hn(n);
        return function(e) {
            var t = function(a) {
                if (a instanceof ie) return ie.value;
                if (a instanceof Qr) {
                    var o = r(e)(a.value2);
                    if (o instanceof En) return oo(a.value2, a.value3, t(a.value4), a.value5);
                    if (o instanceof yn) return oo(a.value2, a.value3, a.value4, t(a.value5));
                    if (o instanceof $n) return Ng(a.value4, a.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 7 - line 501, column 43): " + [
                        o.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 8 - line 501, column 43): " + [
                    a.constructor.name
                ]);
            };
            return t;
        };
    };
    var Mm = function(n) {
        var r = Hn(n);
        return function(e) {
            return function(t) {
                return function(a) {
                    var o = ux(r, t, a), u = e(o.value0);
                    if (u instanceof F) return Ng(o.value1, o.value2);
                    if (u instanceof E) return oo(t, u.value0, o.value1, o.value2);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 514, column 3 - line 518, column 41): " + [
                        u.constructor.name
                    ]);
                };
            };
        };
    };
    var jV = typeof Symbol < "u" && Symbol != null && typeof Symbol.iterator < "u" && typeof String.prototype[Symbol.iterator] == "function", QV = typeof String.prototype.fromCodePoint == "function", KV = typeof String.prototype.codePointAt == "function";
    var yu = function(n) {
        return n.length;
    };
    var kg = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    var a = t.indexOf(e);
                    return a === -1 ? r : n(a);
                };
            };
        };
    };
    var uc = function(n) {
        return function(r) {
            return r.substr(0, n);
        };
    }, ic = function(n) {
        return function(r) {
            return r.substring(n);
        };
    };
    var wm = function(n) {
        return function(r) {
            return {
                before: r.substring(0, n),
                after: r.substring(n)
            };
        };
    };
    var ps = function(n) {
        return function(r) {
            var e = wm(yu(r) - yu(n) | 0)(r), t = e.after === n;
            return t ? new E(e.before) : F.value;
        };
    };
    var xm = function() {
        return kg(E.create)(F.value);
    }();
    var qo = function(n) {
        return function(r) {
            return r.split(n);
        };
    };
    var Eu = function(n) {
        return function(r) {
            return r.join(n);
        };
    };
    var Fx = k(Qa), wx = C(st), zg = Ho(ha);
    var xx = au(wo);
    var Ax = Xf(Zl)(Qa);
    var Vg = function() {
        return YD(new rn(new _i("String")))(nn.create);
    }();
    var Jg = function(n) {
        return function(r) {
            if (ZD(r)) return Fx(F.value);
            if (Wr) return wx(E.create)(n(r));
            throw new Error("Failed pattern match at Data.Argonaut.Decode.Decoders (line 37, column 1 - line 41, column 38): " + [
                n.constructor.name,
                r.constructor.name
            ]);
        };
    };
    var Ix = function() {
        var n = Z1(new _i("Array"));
        return function(r) {
            return n(ng(r));
        };
    }();
    var Gg = function(n) {
        return xx(function() {
            var r = zg(fm.create("Array")), e = Ax(function(t) {
                var a = zg(im.create(t));
                return function(o) {
                    return a(n(o));
                };
            });
            return function(t) {
                return r(e(t));
            };
        }())(Ix);
    };
    var Im = function(n) {
        var r = ve(n);
        return function() {
            return function() {
                return function(e) {
                    return function(t) {
                        return function(a) {
                            return $a(r(e))(t)(a);
                        };
                    };
                };
            };
        };
    }, Lm = function(n) {
        var r = ve(n);
        return function() {
            return function(e) {
                return function(t) {
                    return la(r(e))(t);
                };
            };
        };
    };
    var Qg = Z(wo), Nx = Ho(ha), Hx = C(wr), ds = {
        gDecodeJson: function(n) {
            return function(r) {
                return new nn({});
            };
        }
    }, Kg = function(n) {
        return n.gDecodeJson;
    };
    var Tu = function(n) {
        var r = Kg(n);
        return function() {
            return {
                decodeJson: function(e) {
                    var t = om(e);
                    if (t instanceof E) return r(t.value0)($r.value);
                    if (t instanceof F) return new rn(new _i("Object"));
                    throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 103, column 5 - line 105, column 46): " + [
                        t.constructor.name
                    ]);
                }
            };
        };
    }, _s = {
        decodeJson: Vg
    };
    var Px = function(n) {
        return n.decodeJsonField;
    }, Mu = function(n) {
        var r = Px(n);
        return function(e) {
            var t = Kg(e);
            return function(a) {
                var o = ve(a), u = Im(a)()();
                return function() {
                    return function() {
                        return {
                            gDecodeJson: function(i) {
                                return function(c) {
                                    var l = o($r.value), d = nc(l)(i), m = r(d);
                                    if (m instanceof E) return Qg(Nx(rc.create(l))(m.value0))(function(v) {
                                        return Qg(t(i)($r.value))(function(_) {
                                            return new nn(u($r.value)(v)(_));
                                        });
                                    });
                                    if (m instanceof F) return new rn(new rc(l, ts.value));
                                    throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 127, column 5 - line 134, column 44): " + [
                                        m.constructor.name
                                    ]);
                                };
                            }
                        };
                    };
                };
            };
        };
    };
    var gi = function(n) {
        return n.decodeJson;
    };
    var kx = function(n) {
        return {
            decodeJson: Jg(gi(n))
        };
    };
    var Yg = function(n) {
        var r = gi(kx(n));
        return {
            decodeJsonField: function(e) {
                if (e instanceof F) return new E(new nn(F.value));
                if (e instanceof E) return new E(r(e.value0));
                throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 139, column 1 - line 143, column 49): " + [
                    e.constructor.name
                ]);
            }
        };
    }, lc = function(n) {
        var r = gi(n);
        return {
            decodeJsonField: function(e) {
                return Hx(r)(e);
            }
        };
    }, vs = function(n) {
        return {
            decodeJson: Gg(gi(n))
        };
    };
    var Ie = function() {
        var n = {}, r = "Pure", e = "Throw", t = "Catch", a = "Sync", o = "Async", u = "Bind", i = "Bracket", c = "Fork", l = "Sequential", d = "Map", m = "Apply", v = "Alt", _ = "Cons", D = "Resume", T = "Release", I = "Finalizer", $ = "Finalized", q = "Forked", z = "Fiber", S = "Thunk";
        function x(pn, er, Tr, lr) {
            this.tag = pn, this._1 = er, this._2 = Tr, this._3 = lr;
        }
        function Y(pn) {
            var er = function(Tr, lr, on) {
                return new x(pn, Tr, lr, on);
            };
            return er.tag = pn, er;
        }
        function Yn(pn) {
            return new x(r, void 0);
        }
        function dr(pn) {
            try {
                pn();
            } catch (er) {
                setTimeout(function() {
                    throw er;
                }, 0);
            }
        }
        function cr(pn, er, Tr) {
            try {
                return er(Tr());
            } catch (lr) {
                return pn(lr);
            }
        }
        function Xr(pn, er, Tr) {
            try {
                return er(Tr)();
            } catch (lr) {
                return Tr(pn(lr))(), Yn;
            }
        }
        var te = function() {
            var pn = 1024, er = 0, Tr = 0, lr = new Array(pn), on = !1;
            function X() {
                var Zn;
                for(on = !0; er !== 0;)er--, Zn = lr[Tr], lr[Tr] = void 0, Tr = (Tr + 1) % pn, Zn();
                on = !1;
            }
            return {
                isDraining: function() {
                    return on;
                },
                enqueue: function(Zn) {
                    var Un, Vn;
                    er === pn && (Vn = on, X(), on = Vn), lr[(Tr + er) % pn] = Zn, er++, on || X();
                }
            };
        }();
        function fa(pn) {
            var er = {}, Tr = 0, lr = 0;
            return {
                register: function(on) {
                    var X = Tr++;
                    on.onComplete({
                        rethrow: !0,
                        handler: function(Zn) {
                            return function() {
                                lr--, delete er[X];
                            };
                        }
                    })(), er[X] = on, lr++;
                },
                isEmpty: function() {
                    return lr === 0;
                },
                killAll: function(on, X) {
                    return function() {
                        if (lr === 0) return X();
                        var Zn = 0, Un = {};
                        function Vn(ar) {
                            Un[ar] = er[ar].kill(on, function(Lr) {
                                return function() {
                                    delete Un[ar], Zn--, pn.isLeft(Lr) && pn.fromLeft(Lr) && setTimeout(function() {
                                        throw pn.fromLeft(Lr);
                                    }, 0), Zn === 0 && X();
                                };
                            })();
                        }
                        for(var qr in er)er.hasOwnProperty(qr) && (Zn++, Vn(qr));
                        return er = {}, Tr = 0, lr = 0, function(ar) {
                            return new x(a, function() {
                                for(var Lr in Un)Un.hasOwnProperty(Lr) && Un[Lr]();
                            });
                        };
                    };
                }
            };
        }
        var Te = 0, Fr = 1, Vr = 2, Er = 3, it = 4, en = 5, St = 6;
        function ht(pn, er, Tr) {
            var lr = 0, on = Te, X = Tr, Zn = null, Un = null, Vn = null, qr = null, ar = null, Lr = 0, Rt = 0, Me = null, Dt = !0;
            function gt(gn) {
                for(var Cn, nr, Qn;;)switch(Cn = null, nr = null, Qn = null, on){
                    case Vr:
                        on = Fr;
                        try {
                            X = Vn(X), qr === null ? Vn = null : (Vn = qr._1, qr = qr._2);
                        } catch (ae) {
                            on = en, Zn = pn.left(ae), X = null;
                        }
                        break;
                    case Er:
                        pn.isLeft(X) ? (on = en, Zn = X, X = null) : Vn === null ? on = en : (on = Vr, X = pn.fromRight(X));
                        break;
                    case Fr:
                        switch(X.tag){
                            case u:
                                Vn && (qr = new x(_, Vn, qr)), Vn = X._2, on = Fr, X = X._1;
                                break;
                            case r:
                                Vn === null ? (on = en, X = pn.right(X._1)) : (on = Vr, X = X._1);
                                break;
                            case a:
                                on = Er, X = cr(pn.left, pn.right, X._1);
                                break;
                            case o:
                                on = it, X = Xr(pn.left, X._1, function(ae) {
                                    return function() {
                                        lr === gn && (lr++, te.enqueue(function() {
                                            lr === gn + 1 && (on = Er, X = ae, gt(lr));
                                        }));
                                    };
                                });
                                return;
                            case e:
                                on = en, Zn = pn.left(X._1), X = null;
                                break;
                            case t:
                                Vn === null ? ar = new x(_, X, ar, Un) : ar = new x(_, X, new x(_, new x(D, Vn, qr), ar, Un), Un), Vn = null, qr = null, on = Fr, X = X._1;
                                break;
                            case i:
                                Lr++, Vn === null ? ar = new x(_, X, ar, Un) : ar = new x(_, X, new x(_, new x(D, Vn, qr), ar, Un), Un), Vn = null, qr = null, on = Fr, X = X._1;
                                break;
                            case c:
                                on = Er, Cn = ht(pn, er, X._2), er && er.register(Cn), X._1 && Cn.run(), X = pn.right(Cn);
                                break;
                            case l:
                                on = Fr, X = qa(pn, er, X._1);
                                break;
                        }
                        break;
                    case en:
                        if (Vn = null, qr = null, ar === null) on = St, X = Un || Zn || X;
                        else switch(Cn = ar._3, Qn = ar._1, ar = ar._2, Qn.tag){
                            case t:
                                Un && Un !== Cn && Lr === 0 ? on = en : Zn && (on = Fr, X = Qn._2(pn.fromLeft(Zn)), Zn = null);
                                break;
                            case D:
                                Un && Un !== Cn && Lr === 0 || Zn ? on = en : (Vn = Qn._1, qr = Qn._2, on = Vr, X = pn.fromRight(X));
                                break;
                            case i:
                                Lr--, Zn === null && (nr = pn.fromRight(X), ar = new x(_, new x(T, Qn._2, nr), ar, Cn), (Un === Cn || Lr > 0) && (on = Fr, X = Qn._3(nr)));
                                break;
                            case T:
                                ar = new x(_, new x($, X, Zn), ar, Un), on = Fr, Un && Un !== Cn && Lr === 0 ? X = Qn._1.killed(pn.fromLeft(Un))(Qn._2) : Zn ? X = Qn._1.failed(pn.fromLeft(Zn))(Qn._2) : X = Qn._1.completed(pn.fromRight(X))(Qn._2), Zn = null, Lr++;
                                break;
                            case I:
                                Lr++, ar = new x(_, new x($, X, Zn), ar, Un), on = Fr, X = Qn._1;
                                break;
                            case $:
                                Lr--, on = en, X = Qn._1, Zn = Qn._2;
                                break;
                        }
                        break;
                    case St:
                        for(var Sr in Me)Me.hasOwnProperty(Sr) && (Dt = Dt && Me[Sr].rethrow, dr(Me[Sr].handler(X)));
                        Me = null, Un && Zn ? setTimeout(function() {
                            throw pn.fromLeft(Zn);
                        }, 0) : pn.isLeft(X) && Dt && setTimeout(function() {
                            if (Dt) throw pn.fromLeft(X);
                        }, 0);
                        return;
                    case Te:
                        on = Fr;
                        break;
                    case it:
                        return;
                }
            }
            function Dr(gn) {
                return function() {
                    if (on === St) return Dt = Dt && gn.rethrow, gn.handler(X)(), function() {};
                    var Cn = Rt++;
                    return Me = Me || {}, Me[Cn] = gn, function() {
                        Me !== null && delete Me[Cn];
                    };
                };
            }
            function wn(gn, Cn) {
                return function() {
                    if (on === St) return Cn(pn.right(void 0))(), function() {};
                    var nr = Dr({
                        rethrow: !1,
                        handler: function() {
                            return Cn(pn.right(void 0));
                        }
                    })();
                    switch(on){
                        case Te:
                            Un = pn.left(gn), on = St, X = Un, gt(lr);
                            break;
                        case it:
                            Un === null && (Un = pn.left(gn)), Lr === 0 && (on === it && (ar = new x(_, new x(I, X(gn)), ar, Un)), on = en, X = null, Zn = null, gt(++lr));
                            break;
                        default:
                            Un === null && (Un = pn.left(gn)), Lr === 0 && (on = en, X = null, Zn = null);
                    }
                    return nr;
                };
            }
            function Xn(gn) {
                return function() {
                    var Cn = Dr({
                        rethrow: !1,
                        handler: gn
                    })();
                    return on === Te && gt(lr), Cn;
                };
            }
            return {
                kill: wn,
                join: Xn,
                onComplete: Dr,
                isSuspended: function() {
                    return on === Te;
                },
                run: function() {
                    on === Te && (te.isDraining() ? gt(lr) : te.enqueue(function() {
                        gt(lr);
                    }));
                }
            };
        }
        function pf(pn, er, Tr, lr) {
            var on = 0, X = {}, Zn = 0, Un = {}, Vn = new Error("[ParAff] Early exit"), qr = null, ar = n;
            function Lr(Dr, wn, Xn) {
                var gn = wn, Cn = null, nr = null, Qn = 0, Sr = {}, ae, ca;
                n: for(;;)switch(ae = null, gn.tag){
                    case q:
                        if (gn._3 === n && (ae = X[gn._1], Sr[Qn++] = ae.kill(Dr, function(mf) {
                            return function() {
                                Qn--, Qn === 0 && Xn(mf)();
                            };
                        })), Cn === null) break n;
                        gn = Cn._2, nr === null ? Cn = null : (Cn = nr._1, nr = nr._2);
                        break;
                    case d:
                        gn = gn._2;
                        break;
                    case m:
                    case v:
                        Cn && (nr = new x(_, Cn, nr)), Cn = gn, gn = gn._1;
                        break;
                }
                if (Qn === 0) Xn(pn.right(void 0))();
                else for(ca = 0, ae = Qn; ca < ae; ca++)Sr[ca] = Sr[ca]();
                return Sr;
            }
            function Rt(Dr, wn, Xn) {
                var gn, Cn, nr, Qn, Sr, ae;
                for(pn.isLeft(Dr) ? (gn = Dr, Cn = null) : (Cn = Dr, gn = null);;){
                    if (nr = null, Qn = null, Sr = null, ae = null, qr !== null) return;
                    if (wn === null) {
                        lr(gn || Cn)();
                        return;
                    }
                    if (wn._3 !== n) return;
                    switch(wn.tag){
                        case d:
                            gn === null ? (wn._3 = pn.right(wn._1(pn.fromRight(Cn))), Cn = wn._3) : wn._3 = gn;
                            break;
                        case m:
                            if (nr = wn._1._3, Qn = wn._2._3, gn) {
                                if (wn._3 = gn, Sr = !0, ae = Zn++, Un[ae] = Lr(Vn, gn === nr ? wn._2 : wn._1, function() {
                                    return function() {
                                        delete Un[ae], Sr ? Sr = !1 : Xn === null ? Rt(gn, null, null) : Rt(gn, Xn._1, Xn._2);
                                    };
                                }), Sr) {
                                    Sr = !1;
                                    return;
                                }
                            } else {
                                if (nr === n || Qn === n) return;
                                Cn = pn.right(pn.fromRight(nr)(pn.fromRight(Qn))), wn._3 = Cn;
                            }
                            break;
                        case v:
                            if (nr = wn._1._3, Qn = wn._2._3, nr === n && pn.isLeft(Qn) || Qn === n && pn.isLeft(nr)) return;
                            if (nr !== n && pn.isLeft(nr) && Qn !== n && pn.isLeft(Qn)) gn = Cn === nr ? Qn : nr, Cn = null, wn._3 = gn;
                            else if (wn._3 = Cn, Sr = !0, ae = Zn++, Un[ae] = Lr(Vn, Cn === nr ? wn._2 : wn._1, function() {
                                return function() {
                                    delete Un[ae], Sr ? Sr = !1 : Xn === null ? Rt(Cn, null, null) : Rt(Cn, Xn._1, Xn._2);
                                };
                            }), Sr) {
                                Sr = !1;
                                return;
                            }
                            break;
                    }
                    Xn === null ? wn = null : (wn = Xn._1, Xn = Xn._2);
                }
            }
            function Me(Dr) {
                return function(wn) {
                    return function() {
                        delete X[Dr._1], Dr._3 = wn, Rt(wn, Dr._2._1, Dr._2._2);
                    };
                };
            }
            function Dt() {
                var Dr = Fr, wn = Tr, Xn = null, gn = null, Cn, nr;
                n: for(;;)switch(Cn = null, nr = null, Dr){
                    case Fr:
                        switch(wn.tag){
                            case d:
                                Xn && (gn = new x(_, Xn, gn)), Xn = new x(d, wn._1, n, n), wn = wn._2;
                                break;
                            case m:
                                Xn && (gn = new x(_, Xn, gn)), Xn = new x(m, n, wn._2, n), wn = wn._1;
                                break;
                            case v:
                                Xn && (gn = new x(_, Xn, gn)), Xn = new x(v, n, wn._2, n), wn = wn._1;
                                break;
                            default:
                                nr = on++, Dr = en, Cn = wn, wn = new x(q, nr, new x(_, Xn, gn), n), Cn = ht(pn, er, Cn), Cn.onComplete({
                                    rethrow: !1,
                                    handler: Me(wn)
                                })(), X[nr] = Cn, er && er.register(Cn);
                        }
                        break;
                    case en:
                        if (Xn === null) break n;
                        Xn._1 === n ? (Xn._1 = wn, Dr = Fr, wn = Xn._2, Xn._2 = n) : (Xn._2 = wn, wn = Xn, gn === null ? Xn = null : (Xn = gn._1, gn = gn._2));
                }
                for(ar = wn, nr = 0; nr < on; nr++)X[nr].run();
            }
            function gt(Dr, wn) {
                qr = pn.left(Dr);
                var Xn;
                for(var gn in Un)if (Un.hasOwnProperty(gn)) {
                    Xn = Un[gn];
                    for(gn in Xn)Xn.hasOwnProperty(gn) && Xn[gn]();
                }
                Un = null;
                var Cn = Lr(Dr, ar, wn);
                return function(nr) {
                    return new x(o, function(Qn) {
                        return function() {
                            for(var Sr in Cn)Cn.hasOwnProperty(Sr) && Cn[Sr]();
                            return Yn;
                        };
                    });
                };
            }
            return Dt(), function(Dr) {
                return new x(o, function(wn) {
                    return function() {
                        return gt(Dr, wn);
                    };
                });
            };
        }
        function qa(pn, er, Tr) {
            return new x(o, function(lr) {
                return function() {
                    return pf(pn, er, Tr, lr);
                };
            });
        }
        return x.EMPTY = n, x.Pure = Y(r), x.Throw = Y(e), x.Catch = Y(t), x.Sync = Y(a), x.Async = Y(o), x.Bind = Y(u), x.Bracket = Y(i), x.Fork = Y(c), x.Seq = Y(l), x.ParMap = Y(d), x.ParApply = Y(m), x.ParAlt = Y(v), x.Fiber = ht, x.Supervisor = fa, x.Scheduler = te, x.nonCanceler = Yn, x;
    }(), Zg = Ie.Pure, nb = Ie.Throw;
    function rb(n) {
        return function(r) {
            return Ie.Catch(n, r);
        };
    }
    function eb(n) {
        return function(r) {
            return r.tag === Ie.Pure.tag ? Ie.Pure(n(r._1)) : Ie.Bind(r, function(e) {
                return Ie.Pure(n(e));
            });
        };
    }
    function tb(n) {
        return function(r) {
            return Ie.Bind(n, r);
        };
    }
    function Rm(n) {
        return function(r) {
            return Ie.Fork(n, r);
        };
    }
    var ab = Ie.Sync;
    function ob(n) {
        return function(r) {
            return Ie.ParMap(n, r);
        };
    }
    function ub(n) {
        return function(r) {
            return Ie.ParApply(n, r);
        };
    }
    var Wo = Ie.Async;
    function hs(n) {
        return function(r) {
            return function(e) {
                return Ie.Bracket(n, r, e);
            };
        };
    }
    function ib(n, r) {
        return function() {
            return Ie.Fiber(n, null, r);
        };
    }
    var fb = function() {
        function n(e, t) {
            return e === 0 && typeof setImmediate < "u" ? setImmediate(t) : setTimeout(t, e);
        }
        function r(e, t) {
            return e === 0 && typeof clearImmediate < "u" ? clearImmediate(t) : clearTimeout(t);
        }
        return function(e, t) {
            return Ie.Async(function(a) {
                return function() {
                    var o = n(t, a(e()));
                    return function() {
                        return Ie.Sync(function() {
                            return e(r(t, o));
                        });
                    };
                };
            });
        };
    }(), cb = Ie.Seq;
    var sc = function(n) {
        return n();
    };
    var Wx = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, $x = k(xr), Hm = Hr(Pn), lb = C(Pn);
    var Ux = function(n) {
        return n;
    }, sb = Rm(!1);
    var Bx = {
        map: ob
    }, ya = {
        map: eb
    }, zx = C(ya), pb = Rm(!0), Vx = function() {
        var n = function(t) {
            if (t instanceof nn) return t.value0;
            if (t instanceof rn) return us("unsafeFromRight: Left");
            throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
                t.constructor.name
            ]);
        }, r = function(t) {
            if (t instanceof rn) return t.value0;
            if (t instanceof nn) return us("unsafeFromLeft: Right");
            throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
                t.constructor.name
            ]);
        }, e = function(t) {
            if (t instanceof rn) return !0;
            if (t instanceof nn) return !1;
            throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
                t.constructor.name
            ]);
        };
        return {
            isLeft: e,
            fromLeft: r,
            fromRight: n,
            left: rn.create,
            right: nn.create
        };
    }(), mb = function(n) {
        return ib(Vx, n);
    }, db = function(n) {
        return function() {
            var e = mb(n)();
            return e.run(), e;
        };
    }, _b = function(n) {
        return Hm(db(n));
    };
    var vb = function(n) {
        return fb(nn.create, n);
    }, Jx = function(n) {
        return function(r) {
            return hs(n)({
                killed: Q(r),
                failed: Q(r),
                completed: Q(r)
            });
        };
    }, hb = {
        apply: ub,
        Functor0: function() {
            return Bx;
        }
    };
    var io = {
        Applicative0: function() {
            return tt;
        },
        Bind1: function() {
            return fe;
        }
    }, fe = {
        bind: tb,
        Apply0: function() {
            return Pm(0);
        }
    }, tt = {
        pure: Zg,
        Apply0: function() {
            return Pm(0);
        }
    }, Pm = Wx("applyAff", "Effect.Aff", function() {
        return {
            apply: ft(io),
            Functor0: function() {
                return ya;
            }
        };
    }), Db = Pm(73), gs = k(tt), gb = Z(fe);
    var Gx = Pr(fe);
    var bb = function(n) {
        return function(r) {
            return Jx(gs(void 0))(Q(n))(Q(r));
        };
    };
    var Ca = {
        parallel: R,
        sequential: cb,
        Apply0: function() {
            return Db;
        },
        Apply1: function() {
            return hb;
        }
    }, jx = ro(Ca), fo = {
        pure: function(n) {
            return jx(gs(n));
        },
        Apply0: function() {
            return hb;
        }
    };
    var Qx = ci(Ca)(fo)(ue);
    var Kx = {
        append: function(n) {
            return function(r) {
                return function(e) {
                    return Qx([
                        n(e),
                        r(e)
                    ]);
                };
            };
        }
    };
    var ye = {
        liftEffect: ab,
        Monad0: function() {
            return io;
        }
    }, Ds = ir(ye), bs = function(n) {
        return Ux(Q(Ds(n)));
    }, pc = function(n) {
        return Wo(function(r) {
            return lb(bs)(n.join(r));
        });
    }, yb = {
        map: function(n) {
            return function(r) {
                return sc(mb(zx(n)(pc(r))));
            };
        }
    };
    var mc = function(n) {
        return function(r) {
            return gb(Ds(r.isSuspended))(function(e) {
                return e ? Ds(Hm(r.kill(n, Q($x(void 0))))) : Wo(function(t) {
                    return lb(bs)(r.kill(n, t));
                });
            });
        };
    };
    var ys = {
        throwError: nb,
        Monad0: function() {
            return io;
        }
    }, Cb = {
        catchError: rb,
        MonadThrow0: function() {
            return ys;
        }
    }, Eb = dp(Cb);
    var Tb = Eb, Yx = function(n) {
        return function(r) {
            return db(Gx(function(e) {
                return Ds(n(e));
            })(Eb(r)));
        };
    }, dc = function(n) {
        return function(r) {
            return Hm(Yx(n)(r));
        };
    };
    var Mb = {
        tailRecM: function(n) {
            var r = function(e) {
                return gb(n(e))(function(t) {
                    if (t instanceof we) return gs(t.value0);
                    if (t instanceof We) return r(t.value0);
                    throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                        t.constructor.name
                    ]);
                });
            };
            return r;
        },
        Monad0: function() {
            return io;
        }
    };
    var km = Q(gs(void 0)), Fb = {
        mempty: km,
        Semigroup0: function() {
            return Kx;
        }
    };
    var e8 = Br(Il);
    var Lb = {
        liftAff: vn(Dn),
        MonadEffect0: function() {
            return ye;
        }
    }, Fu = function(n) {
        return n.liftAff;
    };
    var Sb = function(n) {
        var r = n.MonadEffect0(), e = Sl(r);
        return {
            liftAff: function() {
                var t = e8(r.Monad0()), a = Fu(n);
                return function(o) {
                    return t(a(o));
                };
            }(),
            MonadEffect0: function() {
                return e;
            }
        };
    };
    var Es = function(n) {
        return function() {
            console.log(n);
        };
    }, _c = function(n) {
        return function() {
            console.warn(n);
        };
    };
    var qm = function(n) {
        var r = ir(n);
        return function(e) {
            return r(Es(e));
        };
    };
    var Ts = function(n) {
        return function(r) {
            return function() {
                return r[n];
            };
        };
    }, l8 = Ts("children"), s8 = Ts("firstElementChild"), p8 = Ts("lastElementChild"), m8 = Ts("childElementCount");
    function Wb(n) {
        return function(r) {
            return function() {
                return r.querySelector(n);
            };
        };
    }
    function $b(n, r, e) {
        return n == null ? r : e(n);
    }
    function Wm(n) {
        return n;
    }
    var Ta = _r(null)(Wm), Nr = function(n) {
        return $b(n, F.value, E.create);
    };
    var v8 = C(Pn);
    var Ub = function(n) {
        var r = v8(Nr), e = Wb(n);
        return function(t) {
            return r(e(t));
        };
    };
    function $o(n) {
        return function() {
            return function(r) {
                return n(r)();
            };
        };
    }
    function bi(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function() {
                        return t.addEventListener(n, r, e);
                    };
                };
            };
        };
    }
    function Ms(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function() {
                        return t.removeEventListener(n, r, e);
                    };
                };
            };
        };
    }
    var Ve = function() {
        return window;
    };
    var hc = function(n) {
        return n;
    };
    function Bb(n) {
        return n.readyState;
    }
    function zb(n, r) {
        r.title = n;
    }
    var Dc = function() {
        function n() {}
        return n.value = new n, n;
    }(), E8 = function() {
        function n() {}
        return n.value = new n, n;
    }(), T8 = function() {
        function n() {}
        return n.value = new n, n;
    }();
    var Vb = function(n) {
        return n === "loading" ? new E(Dc.value) : n === "interactive" ? new E(E8.value) : n === "complete" ? new E(T8.value) : F.value;
    };
    var F8 = C(Pn);
    var Gb = R;
    var ws = R;
    var jb = function(n) {
        return function(r) {
            return function() {
                return zb(n, r);
            };
        };
    };
    var Qb = function(n) {
        return F8(function() {
            var r = Ir(Dc.value);
            return function(e) {
                return r(Vb(e));
            };
        }())(function() {
            return Bb(n);
        });
    };
    function Kb(n, r, e) {
        var t = Object.prototype.toString.call(e);
        return t.indexOf("[object HTML") === 0 && t.indexOf("Element]") === t.length - 8 ? r(e) : n;
    }
    var Yb = R;
    var $m = function(n) {
        return Kb(F.value, E.create, n);
    };
    function Bm(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function() {
                        return t.pushState(n, r, e);
                    };
                };
            };
        };
    }
    function zm(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function() {
                        return t.replaceState(n, r, e);
                    };
                };
            };
        };
    }
    function Vm(n) {
        return function() {
            return n.state;
        };
    }
    function As(n) {
        return function() {
            return n.hash;
        };
    }
    function Jm(n) {
        return function() {
            return n.pathname;
        };
    }
    function Gm(n) {
        return function() {
            return n.search;
        };
    }
    function Ma(n) {
        return function() {
            return n.document;
        };
    }
    function Is(n) {
        return function() {
            return n.location;
        };
    }
    function Ls(n) {
        return function() {
            return n.history;
        };
    }
    function jm(n) {
        return function(r) {
            return function(e) {
                return function() {
                    e.scroll(n, r);
                };
            };
        };
    }
    var gc = R;
    var Qm = "DOMContentLoaded";
    var ty = Z(fe), M5 = ir(ye), Km = Pr(he), F5 = au(he), ay = k(tt), w5 = Pr(Pe), x5 = k(xr), A5 = C(Pn), I5 = yt(Ct), L5 = Ze(ys), S5 = function(n) {
        return ty(M5(Km(F5(function() {
            var r = Ub(n);
            return function(e) {
                return r(Gb(e));
            };
        }())(Ma))(Ve)))(function(r) {
            return ay(w5($m)(r));
        });
    }, oy = dc(ke(xo)(Q(x5(void 0)))), Ym = Wo(function(n) {
        return function() {
            var e = Km(Qb)(Km(Ma)(Ve))();
            if (e instanceof Dc) {
                var t = A5(gc)(Ve)(), a = $o(function(o) {
                    return n(new nn(void 0));
                })();
                return bi(Qm)(a)(!1)(t)(), bs(Ms(Qm)(a)(!1)(t));
            }
            return n(new nn(void 0))(), km;
        };
    }), uy = I5(fe)(Ym)(function() {
        return ty(S5("body"))(function(n) {
            return _r(L5(pt("Could not find body")))(ay)(n);
        });
    });
    var Xm = R, iy = R;
    var H5 = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }();
    var fy = function(n) {
        return function(r) {
            return Xm(function(e) {
                return n(e.value0)(e.value1);
            })(r);
        };
    };
    var cy = function(n) {
        return function(r) {
            return iy(new H5(n, r));
        };
    }, Zm = {
        map: function(n) {
            return function(r) {
                return Xm(function(e) {
                    return cy(function(t) {
                        return n(e.value0(t));
                    })(e.value1);
                })(r);
            };
        }
    };
    var ly = cy(vn(Dn));
    var py = function(n) {
        var r = ne(n)(bu);
        return function(e) {
            return function(t) {
                return r(function(a) {
                    return t(a);
                })(e);
            };
        };
    }, yi = Ft;
    var my = function() {
        function n() {}
        return n.value = new n, n;
    }(), dy = function() {
        function n() {}
        return n.value = new n, n;
    }(), _y = function() {
        function n() {}
        return n.value = new n, n;
    }(), vy = function() {
        function n() {}
        return n.value = new n, n;
    }(), hy = function() {
        function n() {}
        return n.value = new n, n;
    }(), Dy = function() {
        function n() {}
        return n.value = new n, n;
    }(), gy = function() {
        function n() {}
        return n.value = new n, n;
    }(), by = function() {
        function n() {}
        return n.value = new n, n;
    }(), yy = function() {
        function n() {}
        return n.value = new n, n;
    }(), Cy = function() {
        function n() {}
        return n.value = new n, n;
    }(), Ey = function() {
        function n() {}
        return n.value = new n, n;
    }(), Rs = function() {
        function n() {}
        return n.value = new n, n;
    }(), Ty = function() {
        function n() {}
        return n.value = new n, n;
    }(), My = function() {
        function n() {}
        return n.value = new n, n;
    }(), Fy = function() {
        function n() {}
        return n.value = new n, n;
    }(), wy = function() {
        function n() {}
        return n.value = new n, n;
    }(), xy = function() {
        function n() {}
        return n.value = new n, n;
    }(), Ay = function() {
        function n() {}
        return n.value = new n, n;
    }(), Iy = function() {
        function n() {}
        return n.value = new n, n;
    }(), Ly = function() {
        function n() {}
        return n.value = new n, n;
    }(), Sy = function() {
        function n() {}
        return n.value = new n, n;
    }(), Ry = function() {
        function n() {}
        return n.value = new n, n;
    }(), Ny = function(n) {
        if (n instanceof my) return "button";
        if (n instanceof dy) return "checkbox";
        if (n instanceof _y) return "color";
        if (n instanceof vy) return "date";
        if (n instanceof hy) return "datetime-local";
        if (n instanceof Dy) return "email";
        if (n instanceof gy) return "file";
        if (n instanceof by) return "hidden";
        if (n instanceof yy) return "image";
        if (n instanceof Cy) return "month";
        if (n instanceof Ey) return "number";
        if (n instanceof Rs) return "password";
        if (n instanceof Ty) return "radio";
        if (n instanceof My) return "range";
        if (n instanceof Fy) return "reset";
        if (n instanceof wy) return "search";
        if (n instanceof xy) return "submit";
        if (n instanceof Ay) return "tel";
        if (n instanceof Iy) return "text";
        if (n instanceof Ly) return "time";
        if (n instanceof Sy) return "url";
        if (n instanceof Ry) return "week";
        throw new Error("Failed pattern match at DOM.HTML.Indexed.InputType (line 33, column 19 - line 55, column 22): " + [
            n.constructor.name
        ]);
    };
    var Cc = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), co = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }();
    var rd = {
        map: function(n) {
            return function(r) {
                if (r instanceof Cc) return new Cc(r.value0, r.value1);
                if (r instanceof co) return new co(n(r.value0));
                throw new Error("Failed pattern match at Halogen.Query.Input (line 0, column 0 - line 0, column 0): " + [
                    r.constructor.name
                ]);
            };
        }
    };
    var Kr = function() {
        function n(r, e, t, a) {
            this.value0 = r, this.value1 = e, this.value2 = t, this.value3 = a;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return new n(r, e, t, a);
                    };
                };
            };
        }, n;
    }(), Tc = R, dt = function(n, r) {
        return n.value2(n.value1, r);
    }, Yr = R, _t = function(n) {
        return n.value3(n.value1);
    }, Je = Tc(function(n) {
        return n.value0;
    });
    var Py = C(Ur), Z5 = C(So);
    var Fa = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), lo = function() {
        function n(r, e, t, a) {
            this.value0 = r, this.value1 = e, this.value2 = t, this.value3 = a;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return new n(r, e, t, a);
                    };
                };
            };
        }, n;
    }(), Uo = function() {
        function n(r, e, t, a) {
            this.value0 = r, this.value1 = e, this.value2 = t, this.value3 = a;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return new n(r, e, t, a);
                    };
                };
            };
        }, n;
    }(), wu = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Wt = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), ky = function() {
        function n(r, e, t) {
            this.value0 = r, this.value1 = e, this.value2 = t;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return new n(r, e, t);
                };
            };
        }, n;
    }(), Oy = function(n) {
        return function(r) {
            return n(r);
        };
    };
    var qy = R;
    var nA = {
        bimap: function(n) {
            return function(r) {
                return Oy(function(e) {
                    return qy(new ky(function(t) {
                        return n(e.value0(t));
                    }, function(t) {
                        return r(e.value1(t));
                    }, e.value2));
                });
            };
        }
    }, Wy = Ue(nA), $y = {
        bimap: function(n) {
            return function(r) {
                return function(e) {
                    return e instanceof Fa ? new Fa(e.value0) : e instanceof Wt ? new Wt(Wy(n)(r)(e.value0)) : new Wt(qy(new ky(n, r, e)));
                };
            };
        }
    }, xu = Oy(function(n) {
        var r = function(e) {
            if (e instanceof Fa) return new Fa(e.value0);
            if (e instanceof lo) return new lo(e.value0, e.value1, n.value0(e.value2), Py(r)(e.value3));
            if (e instanceof Uo) return new Uo(e.value0, e.value1, n.value0(e.value2), Py(Z5(r))(e.value3));
            if (e instanceof wu) return new wu(n.value1(e.value0));
            if (e instanceof Wt) return new Wt(Wy(n.value0)(n.value1)(e.value0));
            throw new Error("Failed pattern match at Halogen.VDom.Types (line 86, column 7 - line 86, column 27): " + [
                e.constructor.name
            ]);
        };
        return r(n.value2);
    });
    function Au(n, r) {
        return r[n];
    }
    function td(n, r) {
        return r.hasOwnProperty(n);
    }
    function so(n, r, e) {
        e[n] = r;
    }
    function ad(n, r) {
        for(var e = [], t = 0; t < n.length; t++)e.push(r(t, n[t]));
        return e;
    }
    function od(n, r) {
        for(var e = 0; e < n.length; e++)r(n[e]);
    }
    function ud(n, r) {
        for(var e = Object.keys(n), t = 0; t < e.length; t++){
            var a = e[t];
            r(a, n[a]);
        }
    }
    function id(n, r, e, t, a) {
        for(var o = [], u = n.length, i = r.length, c = 0;;){
            if (c < u) c < i ? o.push(e(c, n[c], r[c])) : t(c, n[c]);
            else if (c < i) o.push(a(c, r[c]));
            else break;
            c++;
        }
        return o;
    }
    function Mc(n, r, e) {
        for(var t = {}, a = 0; a < n.length; a++){
            var o = n[a], u = r(o);
            t[u] = e(u, a, o);
        }
        return t;
    }
    function Fc(n, r, e, t, a, o) {
        for(var u = {}, i = 0; i < r.length; i++){
            var c = r[i], l = e(c);
            n.hasOwnProperty(l) ? u[l] = t(l, i, n[l], c) : u[l] = o(l, i, c);
        }
        for(var l in n)l in u || a(l, n[l]);
        return u;
    }
    function Iu(n, r) {
        return n === r;
    }
    function fd(n, r) {
        return r.createTextNode(n);
    }
    function cd(n, r) {
        r.textContent = n;
    }
    function Hs(n, r, e) {
        return n != null ? e.createElementNS(n, r) : e.createElement(r);
    }
    function Bo(n, r, e) {
        var t = e.childNodes.item(n) || null;
        t !== r && e.insertBefore(r, t);
    }
    function wc(n, r) {
        r && n.parentNode === r && r.removeChild(n);
    }
    function xc(n) {
        return n.parentNode;
    }
    function Ps(n, r, e, t) {
        n != null ? t.setAttributeNS(n, r, e) : t.setAttribute(r, e);
    }
    function ks(n, r, e) {
        n != null ? e.removeAttributeNS(n, r) : e.removeAttribute(r);
    }
    function ld(n, r, e) {
        return n != null ? e.hasAttributeNS(n, r) : e.hasAttribute(r);
    }
    function sd(n, r, e) {
        e.addEventListener(n, r, !1);
    }
    function pd(n, r, e) {
        e.removeEventListener(n, r, !1);
    }
    var md = void 0;
    var dd = Au, _d = R, vd = so, hd = ns;
    var Os = function(n) {
        return function(r) {
            return r[n];
        };
    }, tA = Os("namespaceURI"), aA = Os("prefix"), oA = Os("localName"), uA = Os("tagName");
    var gd = R;
    var Ac = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    };
    var bd = function(n) {
        return _t(n.widget);
    }, yd = Ac("patchWidget", "Halogen.VDom.DOM", function() {
        return function(n, r) {
            if (r instanceof Wt) return yd(291)(n, xu(r.value0));
            if (r instanceof wu) {
                var e = dt(n.widget, r.value0), t = Tc(function(a) {
                    return Yr(new Kr(a.value0, {
                        build: n.build,
                        widget: e
                    }, yd(296), bd));
                })(e);
                return t;
            }
            return bd(n), n.build(r);
        };
    }), sA = yd(286), qs = function(n) {
        var r = xc(n.node);
        return wc(n.node, r);
    }, Ws = Ac("patchText", "Halogen.VDom.DOM", function() {
        return function(n, r) {
            if (r instanceof Wt) return Ws(82)(n, xu(r.value0));
            if (r instanceof Fa) {
                if (n.value === r.value0) return Yr(new Kr(n.node, n, Ws(85), qs));
                if (Wr) {
                    var e = {
                        build: n.build,
                        node: n.node,
                        value: r.value0
                    };
                    return cd(r.value0, n.node), Yr(new Kr(n.node, e, Ws(89), qs));
                }
            }
            return qs(n), n.build(r);
        };
    }), pA = Ws(77), $s = function(n) {
        var r = xc(n.node);
        return wc(n.node, r), ud(n.children, function(e, t) {
            return _t(t);
        }), _t(n.attrs);
    }, Us = function(n) {
        var r = xc(n.node);
        return wc(n.node, r), od(n.children, _t), _t(n.attrs);
    }, Uy = function(n, r, e, t) {
        var a = r === t;
        return a ? n instanceof E && e instanceof E && n.value0 === e.value0 || n instanceof F && e instanceof F : !1;
    }, Bs = Ac("patchElem", "Halogen.VDom.DOM", function() {
        return function(n, r) {
            if (r instanceof Wt) return Bs(135)(n, xu(r.value0));
            if (r instanceof lo && Uy(n.ns, n.name, r.value0, r.value1)) {
                var e = rt(r.value3), t = rt(n.children);
                if (t === 0 && e === 0) {
                    var c = dt(n.attrs, r.value2), l = {
                        build: n.build,
                        node: n.node,
                        attrs: c,
                        ns: r.value0,
                        name: r.value1,
                        children: n.children
                    };
                    return Yr(new Kr(n.node, l, Bs(149), Us));
                }
                var a = function(d, m) {
                    return _t(m);
                }, o = function(d, m, v) {
                    var _ = dt(m, v);
                    return Bo(d, Je(_), n.node), _;
                }, u = function(d, m) {
                    var v = n.build(m);
                    return Bo(d, Je(v), n.node), v;
                }, i = id(n.children, r.value3, o, a, u), c = dt(n.attrs, r.value2), l = {
                    build: n.build,
                    node: n.node,
                    attrs: c,
                    ns: r.value0,
                    name: r.value1,
                    children: i
                };
                return Yr(new Kr(n.node, l, Bs(172), Us));
            }
            return Us(n), n.build(r);
        };
    }), mA = Bs(130), zs = Ac("patchKeyed", "Halogen.VDom.DOM", function() {
        return function(n, r) {
            if (r instanceof Wt) return zs(222)(n, xu(r.value0));
            if (r instanceof Uo && Uy(n.ns, n.name, r.value0, r.value1)) {
                var e = rt(r.value3);
                if (n.length === 0 && e === 0) {
                    var i = dt(n.attrs, r.value2), c = {
                        build: n.build,
                        node: n.node,
                        attrs: i,
                        ns: r.value0,
                        name: r.value1,
                        children: n.children,
                        length: 0
                    };
                    return Yr(new Kr(n.node, c, zs(237), $s));
                }
                var t = function(l, d) {
                    return _t(d);
                }, a = function(l, d, m, v) {
                    var _ = dt(m, v.value1);
                    return Bo(d, Je(_), n.node), _;
                }, o = function(l, d, m) {
                    var v = n.build(m.value1);
                    return Bo(d, Je(v), n.node), v;
                }, u = Fc(n.children, r.value3, xe, a, t, o), i = dt(n.attrs, r.value2), c = {
                    build: n.build,
                    node: n.node,
                    attrs: i,
                    ns: r.value0,
                    name: r.value1,
                    children: u,
                    length: e
                };
                return Yr(new Kr(n.node, c, zs(261), $s));
            }
            return $s(n), n.build(r);
        };
    }), dA = zs(217), _A = function(n, r, e) {
        var t = n.buildWidget(n)(e), a = Tc(function(o) {
            return Yr(new Kr(o.value0, {
                build: r,
                widget: t
            }, sA, bd));
        })(t);
        return a;
    }, vA = function(n, r, e) {
        var t = fd(e, n.document), a = {
            build: r,
            node: t,
            value: e
        };
        return Yr(new Kr(t, a, pA, qs));
    }, hA = function(n, r, e, t, a, o) {
        var u = Hs(Ta(e), t, n.document), i = gd(u), c = function(v, _, D) {
            var T = r(D.value1);
            return Bo(_, Je(T), i), T;
        }, l = Mc(o, xe, c), d = n.buildAttributes(u)(a), m = {
            build: r,
            node: i,
            attrs: d,
            ns: e,
            name: t,
            children: l,
            length: rt(o)
        };
        return Yr(new Kr(i, m, dA, $s));
    }, DA = function(n, r, e, t, a, o) {
        var u = Hs(Ta(e), t, n.document), i = gd(u), c = function(v, _) {
            var D = r(_);
            return Bo(v, Je(D), i), D;
        }, l = ad(o, c), d = n.buildAttributes(u)(a), m = {
            build: r,
            node: i,
            attrs: d,
            ns: e,
            name: t,
            children: l
        };
        return Yr(new Kr(i, m, mA, Us));
    }, Ic = function(n) {
        var r = Ac("build", "Halogen.VDom.DOM", function() {
            return function(t) {
                if (t instanceof Fa) return vA(n, r(59), t.value0);
                if (t instanceof lo) return DA(n, r(60), t.value0, t.value1, t.value2, t.value3);
                if (t instanceof Uo) return hA(n, r(61), t.value0, t.value1, t.value2, t.value3);
                if (t instanceof wu) return _A(n, r(62), t.value0);
                if (t instanceof Wt) return r(63)(xu(t.value0));
                throw new Error("Failed pattern match at Halogen.VDom.DOM (line 58, column 27 - line 63, column 52): " + [
                    t.constructor.name
                ]);
            };
        }), e = r(58);
        return e;
    };
    function Vs(n) {
        return typeof n;
    }
    function Js(n) {
        return Object.prototype.toString.call(n).slice(8, -1);
    }
    var yA = Tn(jt), CA = Tn(Va);
    var Td = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Md = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Jy = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Gy = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Fd = R, EA = R;
    var Gs = function(n) {
        if (n instanceof Td) return n.value0;
        if (n instanceof Jy) return "Error at array index " + (CA(n.value0) + (": " + Gs(n.value1)));
        if (n instanceof Gy) return "Error at property " + (yA(n.value0) + (": " + Gs(n.value1)));
        if (n instanceof Md) return "Type mismatch: expected " + (n.value0 + (", found " + n.value1));
        throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
            n.constructor.name
        ]);
    };
    var js = function(n) {
        var r = Ze(Wh(n));
        return function(e) {
            return r(is(e));
        };
    };
    var wd = function(n) {
        var r = k(fi(n)), e = js(n);
        return function(t) {
            return function(a) {
                if (Js(a) === t) return r(EA(a));
                if (Wr) return e(new Md(t, Js(a)));
                throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                    t.constructor.name,
                    a.constructor.name
                ]);
            };
        };
    };
    var xd = function(n) {
        return wd(n)("String");
    };
    var TA = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, jy = C(_e), Qy = C(wr), Yy = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Xy = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), po = function() {
        function n(r, e, t) {
            this.value0 = r, this.value1 = e, this.value2 = t;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return new n(r, e, t);
                };
            };
        }, n;
    }(), zo = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), wa = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Vo = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), MA = Au, Ad = so, FA = function(n, r) {
        var e = ld(null, n, r);
        if (e) return ks(null, n, r);
        var t = Vs(Au(n, r));
        return t === "string" ? so(n, "", r) : n === "rowSpan" ? so(n, 1, r) : n === "colSpan" ? so(n, 1, r) : so(n, md, r);
    }, Ky = function(n) {
        if (n instanceof po && n.value0 instanceof E) return "attr/" + (n.value0.value0 + (":" + n.value1));
        if (n instanceof po) return "attr/:" + n.value1;
        if (n instanceof zo) return "prop/" + n.value0;
        if (n instanceof wa) return "handler/" + n.value0;
        if (n instanceof Vo) return "ref";
        throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 182, column 16 - line 187, column 16): " + [
            n.constructor.name
        ]);
    }, Id = R;
    var Ld = {
        map: function(n) {
            return function(r) {
                return r instanceof wa ? new wa(r.value0, jy(Qy(n))(r.value1)) : r instanceof Vo ? new Vo(jy(Qy(n))(r.value0)) : r;
            };
        }
    };
    var Zy = function(n) {
        return function(r) {
            var e = function(d) {
                return function(m, v) {
                    if (v instanceof po) return ks(Ta(v.value0), v.value1, r);
                    if (v instanceof zo) return FA(v.value0, r);
                    if (v instanceof wa) {
                        var _ = dd(v.value0, d);
                        return pd(v.value0, xe(_), r);
                    }
                    if (v instanceof Vo) return void 0;
                    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 169, column 5 - line 179, column 18): " + [
                        v.constructor.name
                    ]);
                };
            }, t = function(d) {
                return d instanceof E ? n(d.value0)() : void 0;
            }, a = function(d) {
                var m = nc("ref")(d.props);
                return m instanceof E && m.value0 instanceof Vo ? t(m.value0.value0(new Xy(r))) : void 0;
            }, o = function(d, m) {
                return function(v, _, D, T) {
                    if (D instanceof po && T instanceof po) {
                        var I = D.value2 === T.value2;
                        return I || Ps(Ta(T.value0), T.value1, T.value2, r), T;
                    }
                    if (D instanceof zo && T instanceof zo) {
                        var $ = Iu(D.value1, T.value1);
                        if ($) return T;
                        if (T.value0 === "value") {
                            var q = MA("value", r), z = Iu(q, T.value1);
                            return z || Ad(T.value0, T.value1, r), T;
                        }
                        return Ad(T.value0, T.value1, r), T;
                    }
                    if (D instanceof wa && T instanceof wa) {
                        var S = dd(T.value0, d);
                        return mr(T.value1)(De(S))(), vd(T.value0, S, m), T;
                    }
                    return T;
                };
            }, u = function(d) {
                return function(m, v, _) {
                    if (_ instanceof po) return Ps(Ta(_.value0), _.value1, _.value2, r), _;
                    if (_ instanceof zo) return Ad(_.value0, _.value1, r), _;
                    if (_ instanceof wa) {
                        var D = Au(_.value0, d);
                        if (td(_.value0, d)) return mr(_.value1)(De(D))(), _;
                        var T = Cr(_.value1)(), I = $o(function($) {
                            return function() {
                                var z = hn(T)();
                                return t(z($));
                            };
                        })();
                        return vd(_.value0, new dn(I, T), d), sd(_.value0, I, r), _;
                    }
                    if (_ instanceof Vo) return t(_.value0(new Yy(r))), _;
                    throw new Error("Failed pattern match at Halogen.VDom.DOM.Prop (line 113, column 5 - line 135, column 15): " + [
                        _.constructor.name
                    ]);
                };
            }, i = TA("patchProp", "Halogen.VDom.DOM.Prop", function() {
                return function(d, m) {
                    var v = hd(), _ = e(d.events), D = o(d.events, v), T = u(v), I = Fc(d.props, m, Ky, D, _, T), $ = {
                        events: _d(v),
                        props: I
                    };
                    return Yr(new Kr(void 0, $, i(100), a));
                };
            }), c = i(87), l = function(d) {
                var m = hd(), v = Mc(d, Ky, u(m)), _ = {
                    events: _d(m),
                    props: v
                };
                return Yr(new Kr(void 0, _, c, a));
            };
            return l;
        };
    };
    var wA = C(Ur), xA = C(Ld), AA = C(rd);
    var IA = Ue($y), e2 = function(n) {
        return n;
    };
    var LA = function(n) {
        return n.toPropValue;
    }, Mr = function(n) {
        return e2(Fa.create(n));
    };
    var t2 = function(n) {
        var r = LA(n);
        return function(e) {
            var t = zo.create(e);
            return function(a) {
                return t(r(a));
            };
        };
    };
    var a2 = {
        toPropValue: Id
    };
    var o2 = {
        toPropValue: function(n) {
            return Id(Ny(n));
        }
    };
    var Rd = function() {
        return wa.create;
    }(), u2 = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return new lo(n, r, e, t);
                };
            };
        };
    }, i2 = {
        bimap: function(n) {
            return function(r) {
                return function(e) {
                    return IA(wA(xA(AA(r))))(n)(e);
                };
            };
        }
    };
    var f2 = function(n) {
        return function(r) {
            return po.create(n)(r);
        };
    };
    var RA = vn(Dn);
    var Qs = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Nd = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Hd = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), c2 = function(n) {
        return function(r) {
            return new Hd(n, r);
        };
    }, Pd = function() {
        return Nd.create;
    }(), l2 = function(n) {
        var r = k(n);
        return function(e) {
            return function(t) {
                return function(a) {
                    return function(o) {
                        return function(u) {
                            if (o instanceof Qs) return new dn(new Wn({
                                func: r(o.value0),
                                count: u
                            }, e), t);
                            if (o instanceof Nd) return new dn(new Wn({
                                func: a(o.value0),
                                count: u
                            }, e), t);
                            if (o instanceof Hd) return l2(n)(e)(Lg(o.value1)(t))(a)(o.value0)(u + 1 | 0);
                            throw new Error("Failed pattern match at Control.Applicative.Free (line 102, column 41 - line 105, column 81): " + [
                                o.constructor.name
                            ]);
                        };
                    };
                };
            };
        };
    }, s2 = function(n) {
        var r = Gn(n.Apply0());
        return function(e) {
            return function(t) {
                return function(a) {
                    if (e instanceof kn) return new rn(a);
                    if (e instanceof Wn) {
                        var o = r(e.value0.func)(a), u = e.value0.count === 1;
                        if (u) return e.value1 instanceof kn ? new rn(o) : s2(n)(e.value1)(t)(o);
                        if (t instanceof kn) return new rn(o);
                        if (t instanceof Wn) return new nn(new dn(new Wn({
                            func: o,
                            count: e.value0.count - 1 | 0
                        }, e.value1), new Xt(t.value0, t.value1)));
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 83, column 11 - line 88, column 50): " + [
                            t.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Control.Applicative.Free (line 72, column 3 - line 88, column 50): " + [
                        e.constructor.name
                    ]);
                };
            };
        };
    }, p2 = {
        map: function(n) {
            return function(r) {
                return c2(new Qs(n))(r);
            };
        }
    }, m2 = function(n) {
        var r = s2(n), e = k(n), t = l2(n);
        return function(a) {
            return function(o) {
                var u = function(i) {
                    var c = !1, l;
                    function d(m) {
                        if (m.value1.value0 instanceof Qs) {
                            var v = r(m.value0)(m.value1.value1)(e(m.value1.value0.value0));
                            if (v instanceof rn) return c = !0, v.value0;
                            if (v instanceof nn) {
                                i = v.value0;
                                return;
                            }
                            throw new Error("Failed pattern match at Control.Applicative.Free (line 54, column 17 - line 56, column 24): " + [
                                v.constructor.name
                            ]);
                        }
                        if (m.value1.value0 instanceof Nd) {
                            var v = r(m.value0)(m.value1.value1)(a(m.value1.value0.value0));
                            if (v instanceof rn) return c = !0, v.value0;
                            if (v instanceof nn) {
                                i = v.value0;
                                return;
                            }
                            throw new Error("Failed pattern match at Control.Applicative.Free (line 57, column 17 - line 59, column 24): " + [
                                v.constructor.name
                            ]);
                        }
                        if (m.value1.value0 instanceof Hd) {
                            var _ = new Xt(m.value1.value0.value1, m.value1.value1);
                            i = t(m.value0)(_)(a)(m.value1.value0.value0)(1);
                            return;
                        }
                        throw new Error("Failed pattern match at Control.Applicative.Free (line 53, column 5 - line 62, column 47): " + [
                            m.value1.value0.constructor.name
                        ]);
                    }
                    for(; !c;)l = d(i);
                    return l;
                };
                return u(new dn(kn.value, is(o)));
            };
        };
    }, d2 = function(n) {
        return m2(n)(RA);
    }, kd = {
        apply: function(n) {
            return function(r) {
                return c2(n)(r);
            };
        },
        Functor0: function() {
            return p2;
        }
    }, Od = function() {
        return {
            pure: Qs.create,
            Apply0: function() {
                return kd;
            }
        };
    }(), NA = m2(Od), Ks = function(n) {
        return NA(function(r) {
            return Pd(n(r));
        });
    };
    var Ys = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }();
    var v2 = function(n) {
        var r = !1, e;
        function t(a) {
            if (a.value0 instanceof kn && a.value1 instanceof kn) return r = !0, F.value;
            if (a.value0 instanceof kn) {
                n = new Ys(ko(a.value1), kn.value);
                return;
            }
            if (a.value0 instanceof Wn) return r = !0, new E(new dn(a.value0.value0, new Ys(a.value0.value1, a.value1)));
            throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
                a.constructor.name
            ]);
        }
        for(; !r;)e = t(n);
        return e;
    }, h2 = function(n) {
        return function(r) {
            return new Ys(n.value0, new Wn(r, n.value1));
        };
    };
    var D2 = function(n) {
        return n.value0 instanceof kn && n.value1 instanceof kn;
    };
    var g2 = function() {
        return new Ys(kn.value, kn.value);
    }();
    var Ei = function() {
        function n() {}
        return n.value = new n, n;
    }(), Xs = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }();
    var b2 = function(n) {
        return function(r) {
            if (n instanceof Ei) return r;
            if (r instanceof Ei) return n;
            if (n instanceof Xs) return new Xs(n.value0, h2(n.value1)(r));
            throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
                n.constructor.name,
                r.constructor.name
            ]);
        };
    }, PA = function(n) {
        return function(r) {
            return function(e) {
                var t = function(o) {
                    return function(u) {
                        return function(i) {
                            var c = o, l = u, d = !1, m;
                            function v(_, D, T) {
                                if (T instanceof kn) return d = !0, D;
                                if (T instanceof Wn) {
                                    c = _, l = _(D)(T.value0), i = T.value1;
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                    _.constructor.name,
                                    D.constructor.name,
                                    T.constructor.name
                                ]);
                            }
                            for(; !d;)m = v(c, l, i);
                            return m;
                        };
                    };
                }, a = function(o) {
                    return function(u) {
                        var i = o, c = !1, l;
                        function d(m, v) {
                            var _ = v2(m);
                            if (_ instanceof F) return c = !0, t(function(D) {
                                return function(T) {
                                    return T(D);
                                };
                            })(r)(v);
                            if (_ instanceof E) {
                                i = _.value0.value1, u = new Wn(n(_.value0.value0), v);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                                _.constructor.name
                            ]);
                        }
                        for(; !c;)l = d(i, u);
                        return l;
                    };
                };
                return a(e)(kn.value);
            };
        };
    }, y2 = function(n) {
        if (n instanceof Ei) return F.value;
        if (n instanceof Xs) return new E(new dn(n.value0, function() {
            var r = D2(n.value1);
            return r ? Ei.value : PA(b2)(Ei.value)(n.value1);
        }()));
        throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
            n.constructor.name
        ]);
    };
    var C2 = function() {
        return Ei.value;
    }(), E2 = b2;
    var T2 = {
        append: E2
    };
    var M2 = function(n) {
        return function(r) {
            return E2(n)(new Xs(r, g2));
        };
    };
    var OA = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, qA = tn(T2), WA = C(_e);
    var qd = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Lc = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Sc = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), F2 = function(n) {
        var r = !1, e;
        function t(a) {
            var o = function(c) {
                return c;
            }, u = function(c) {
                return function(l) {
                    return new qd(c.value0, qA(c.value1)(l));
                };
            };
            if (a.value0 instanceof Lc) {
                var i = y2(a.value1);
                if (i instanceof F) return r = !0, new Lc(a.value0.value0);
                if (i instanceof E) {
                    n = u(o(i.value0.value0)(a.value0.value0))(i.value0.value1);
                    return;
                }
                throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                    i.constructor.name
                ]);
            }
            if (a.value0 instanceof Sc) return r = !0, new Sc(a.value0.value0, function(c) {
                return u(a.value0.value1(c))(a.value1);
            });
            throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
                a.value0.constructor.name
            ]);
        }
        for(; !r;)e = t(n);
        return e;
    };
    var w2 = function(n) {
        return new qd(n, C2);
    };
    var Wd = {
        Applicative0: function() {
            return Nc;
        },
        Bind1: function() {
            return Rc;
        }
    }, $d = {
        map: function(n) {
            return function(r) {
                return Pr(Rc)(function() {
                    var e = k(Nc);
                    return function(t) {
                        return e(n(t));
                    };
                }())(r);
            };
        }
    }, Rc = {
        bind: function(n) {
            return function(r) {
                return new qd(n.value0, M2(n.value1)(r));
            };
        },
        Apply0: function() {
            return Ud(0);
        }
    }, Nc = {
        pure: function(n) {
            return w2(Lc.create(n));
        },
        Apply0: function() {
            return Ud(0);
        }
    }, Ud = OA("freeApply", "Control.Monad.Free", function() {
        return {
            apply: ft(Wd),
            Functor0: function() {
                return $d;
            }
        };
    }), x2 = Ud(77);
    var $A = Z(Rc), A2 = k(Nc);
    var Jo = function(n) {
        return w2(new Sc(n, function(r) {
            return A2(r);
        }));
    };
    var UA = function(n) {
        var r = function(e) {
            var t = F2(e);
            if (t instanceof Lc) return A2(t.value0);
            if (t instanceof Sc) return $A(n(t.value0))(WA(r)(t.value1));
            throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [
                t.constructor.name
            ]);
        };
        return r;
    }, I2 = function(n) {
        return UA(function(r) {
            return Jo(n(r));
        });
    };
    var L2 = function(n) {
        var r = n.Monad0(), e = C(r.Bind1().Apply0().Functor0()), t = k(r.Applicative0()), a = Pt(n);
        return function(o) {
            var u = function(i) {
                var c = F2(i);
                if (c instanceof Lc) return e(we.create)(t(c.value0));
                if (c instanceof Sc) return e(function(l) {
                    return We.create(c.value1(l));
                })(o(c.value0));
                throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                    c.constructor.name
                ]);
            };
            return a(u);
        };
    };
    var R2 = R;
    function Bd(n) {
        return function(r) {
            return n === r;
        };
    }
    var Ti = Bd;
    var JA = Hr(Pn);
    var GA = Z(he);
    var jA = tn(lt), QA = ne(xr), KA = QA(ue);
    var Zs = function(n) {
        return n;
    }, H2 = function(n) {
        return function(r) {
            return n(function(e) {
                return JA(r(e));
            });
        };
    };
    var P2 = function(n) {
        return function(r) {
            return n(r);
        };
    };
    var k2 = function() {
        var r = Cr([])();
        return {
            emitter: function(e) {
                return function() {
                    return qe(function(a) {
                        return jA(a)([
                            e
                        ]);
                    })(r)(), qe(tm(Ti)(e))(r);
                };
            },
            listener: function(e) {
                return GA(hn(r))(KA(function(t) {
                    return t(e);
                }));
            }
        };
    };
    var XA = yp()();
    var O2 = function(n) {
        return n;
    }, q2 = function(n) {
        return n;
    }, Su = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Mi = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Fi = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), xa = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), wi = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), xi = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Ru = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Ai = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Ii = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Li = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Si = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), W2 = function(n) {
        return n;
    }, Nu = function(n) {
        return n;
    };
    var Jd = He, r0 = He;
    var $2 = {
        lift: function(n) {
            return function(r) {
                return Nu(Jo(xa.create(r)));
            };
        }
    }, Hc = Wd, Gd = {
        state: function(n) {
            return Nu(Jo(Su.create(n)));
        },
        Monad0: function() {
            return Hc;
        }
    };
    var jd = function(n) {
        return {
            liftEffect: function() {
                var r = ir(n);
                return function(e) {
                    return Nu(Jo(xa.create(r(e))));
                };
            }(),
            Monad0: function() {
                return Hc;
            }
        };
    }, U2 = function(n) {
        return {
            ask: Jo(new xa(Wa(n))),
            Monad0: function() {
                return Hc;
            }
        };
    }, B2 = function(n) {
        var r = jd(n.MonadEffect0());
        return {
            liftAff: function() {
                var e = Fu(n);
                return function(t) {
                    return Nu(Jo(xa.create(e(t))));
                };
            }(),
            MonadEffect0: function() {
                return r;
            }
        };
    };
    var n0 = function(n) {
        return function(r) {
            return function(e) {
                var t = function(a) {
                    if (a instanceof Su) return new Su(a.value0);
                    if (a instanceof Mi) return new Mi(a.value0, a.value1);
                    if (a instanceof Fi) return new Fi(a.value0, a.value1);
                    if (a instanceof xa) return new xa(r(a.value0));
                    if (a instanceof wi) return new wi(a.value0);
                    if (a instanceof xi) return new xi(a.value0, a.value1);
                    if (a instanceof Ru) return new Ru(XA(W2)(Ks(n0(n)(r)))(a.value0));
                    if (a instanceof Ai) return new Ai(n0(n)(r)(a.value0), a.value1);
                    if (a instanceof Ii) return new Ii(a.value0, a.value1);
                    if (a instanceof Li) return new Li(a.value0, a.value1);
                    if (a instanceof Si) return new Si(a.value0, a.value1);
                    throw new Error("Failed pattern match at Halogen.Query.HalogenM (line 312, column 8 - line 323, column 29): " + [
                        a.constructor.name
                    ]);
                };
                return I2(t)(e);
            };
        };
    };
    var e0 = $d;
    var Qd = Rc;
    var ZA = x2, n9 = kd, z2 = {
        parallel: function(n) {
            return W2(Pd(n));
        },
        sequential: function(n) {
            return Nu(Jo(Ru.create(n)));
        },
        Apply0: function() {
            return ZA;
        },
        Apply1: function() {
            return n9;
        }
    }, Ri = Nc;
    var V2 = Od;
    var Ni = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Hi = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Pi = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), ki = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Oi = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }();
    var r9 = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, e9 = function() {
        function n(r, e, t, a) {
            this.value0 = r, this.value1 = e, this.value2 = t, this.value3 = a;
        }
        return n.create = function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return new n(r, e, t, a);
                    };
                };
            };
        }, n;
    }();
    var t9 = function(n, r) {
        return Iu(n.value0, r.value0) && Iu(n.value1, r.value1) && n.value1(n.value3, r.value3);
    };
    var J2 = function(n) {
        return n.value2(n.value3);
    }, G2 = function(n) {
        return function(r) {
            return new e9(r.value0, r.value1, function(e) {
                return n(r.value2(e));
            }, r.value3);
        };
    }, j2 = G2;
    var Q2 = function(n) {
        var r = function(o) {
            return _t(o.vdom);
        }, e = r9("patchThunk", "Halogen.VDom.Thunk", function() {
            return function(o, u) {
                var i = t9(o.thunk, u);
                if (i) return Yr(new Kr(Je(o.vdom), o, e(112), r));
                var c = dt(o.vdom, n(J2(u)));
                return Yr(new Kr(Je(c), {
                    vdom: c,
                    thunk: u
                }, e(115), r));
            };
        }), t = e(108), a = function(o) {
            return function(u) {
                var i = Ic(o)(n(J2(u)));
                return Yr(new Kr(Je(i), {
                    thunk: u,
                    vdom: i
                }, t, r));
            };
        };
        return a;
    };
    var a0 = eu(e0), Xd = ne(Ri)(me), a9 = C(e0), Y2 = Ho(i2);
    var K2 = k(Ri);
    var qi = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Wi = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), o0 = R, u0 = R, Zd = function(n) {
        return function(r) {
            if (r instanceof Ni) return a0(Xd(n.handleAction)(n.initialize))(r.value0);
            if (r instanceof Hi) return a0(Xd(n.handleAction)(n.finalize))(r.value0);
            if (r instanceof Pi) return a0(Xd(n.handleAction)(n.receive(r.value0)))(r.value1);
            if (r instanceof ki) return a0(n.handleAction(r.value0))(r.value1);
            if (r instanceof Oi) return fy(function(e) {
                var t = a9(_r(r.value1(void 0))(e));
                return function(a) {
                    return t(n.handleQuery(a));
                };
            })(r.value0);
            throw new Error("Failed pattern match at Halogen.Component (line 182, column 15 - line 192, column 71): " + [
                r.constructor.name
            ]);
        };
    }, o9 = R, i0 = R, X2 = function(n) {
        return function(r) {
            return function(e) {
                if (e instanceof qi) return o0(function(t) {
                    return new qi(o9({
                        get: t.get,
                        pop: t.pop,
                        set: t.set,
                        input: t.input,
                        output: t.output,
                        component: f0(n)(r)(t.component)
                    }));
                })(e.value0);
                if (e instanceof Wi) return new Wi(j2(Y2(X2(n)(r)))(e.value0));
                throw new Error("Failed pattern match at Halogen.Component (line 279, column 17 - line 284, column 53): " + [
                    e.constructor.name
                ]);
            };
        };
    }, f0 = function(n) {
        var r = n0(n);
        return function(e) {
            return u0(function(t) {
                return i0({
                    initialState: t.initialState,
                    render: function() {
                        var a = Y2(X2(n)(e));
                        return function(o) {
                            return a(t.render(o));
                        };
                    }(),
                    eval: function() {
                        var a = r(e);
                        return function(o) {
                            return a(t.eval(o));
                        };
                    }()
                });
            });
        };
    };
    var c0 = function() {
        return {
            handleAction: Q(K2(void 0)),
            handleQuery: Q(K2(F.value)),
            receive: Q(F.value),
            initialize: F.value,
            finalize: F.value
        };
    }();
    var s0 = {
        suspend: sb,
        fork: pb,
        join: pc,
        Monad0: function() {
            return io;
        },
        Functor1: function() {
            return yb;
        }
    };
    var p0 = function(n) {
        return n.fork;
    };
    var Aa = function() {
        return u2(F.value);
    }();
    var $i = Aa("h1");
    var n_ = Aa("h2");
    var r_ = function(n) {
        return Aa("hr")(n)([]);
    };
    var e_ = function(n) {
        return Aa("input")(n)([]);
    };
    var m0 = Aa("p"), Pc = m0([]);
    var d0 = Aa("span");
    var hr = Aa("div"), Hu = hr([]);
    var t_ = Aa("button");
    var Go = Aa("a");
    var i9 = $e();
    var a_ = function(n) {
        return t2(n);
    };
    var kc = a_(a2);
    var Oc = kc("target");
    var nC = function(n) {
        return a_(n)("type");
    };
    var rC = kc("placeholder");
    var Ui = kc("id"), Pu = kc("href");
    var eC = function() {
        var n = kc("className");
        return function(r) {
            return n(i9(r));
        };
    }();
    var tC = function() {
        return f2(F.value);
    }();
    var aC = tC("style");
    var o_ = function(n) {
        return n(void 0);
    };
    var fC = R, Zt = R, cC = function(n) {
        var r = ne(n)(me);
        return function(e) {
            return Zt(function(t) {
                return r(e)(t.rendering);
            });
        };
    }, g9 = R, lC = function(n) {
        return function(r) {
            return Zt(function(e) {
                return g9(r(e.rendering));
            });
        };
    }, b9 = R, _0 = function(n) {
        return function(r) {
            return n(r);
        };
    }, sC = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    return function() {
                        var o = Cr({})(), u = Cr(yi)(), i = Cr(yi)(), c = Cr(e)(), l = Cr(new E(kn.value))(), d = Cr(new E(kn.value))(), m = Cr(F.value)(), v = Cr(1)(), _ = Cr(new E(Ft))(), D = Cr(Ft)(), T = {
                            component: n,
                            state: n.initialState(r),
                            refs: Ft,
                            children: yi,
                            childrenIn: u,
                            childrenOut: i,
                            selfRef: o,
                            handlerRef: c,
                            pendingQueries: l,
                            pendingOuts: d,
                            pendingHandlers: m,
                            rendering: F.value,
                            fresh: v,
                            subscriptions: _,
                            forks: D,
                            lifecycleHandlers: t
                        };
                        return mr(T)(o)(), b9(o);
                    };
                };
            };
        };
    };
    var y9 = ne(xr)(me), C9 = Pr(Pe), E9 = Oo(Jd), re = Z(fe), Ar = ir(ye), T9 = yt(Ct), na = T9(fe), hC = ne(tt), M9 = hC(et), DC = p0(s0), F9 = ci(Ca)(fo)(et), Ia = k(tt), w9 = C(Zm), pC = ro(Ca), x9 = C(ya), mC = du(Ca), A9 = C(wr), I9 = uo(Jd), L9 = d2(fo), S9 = Di(r0), R9 = N1(Ka), N9 = uo(r0), dC = hC(me), _C = Oo(r0), H9 = Oo(oe), P9 = L2(Mb), k9 = Mm(oe), O9 = function(n) {
        return function(r) {
            return function() {
                var t = hn(r)(), a = hn(t.subscriptions)();
                return y9(Zs)(C9(E9(n))(a))();
            };
        };
    }, v0 = function(n) {
        return function(r) {
            return re(Ar(hn(n)))(function(e) {
                if (e instanceof F) return r;
                if (e instanceof E) return Ar(mr(new E(new Wn(r, e.value0)))(n));
                throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 188, column 33 - line 190, column 57): " + [
                    e.constructor.name
                ]);
            });
        };
    }, h0 = function(n) {
        return function(r) {
            return na(Ar(mr({
                initializers: kn.value,
                finalizers: kn.value
            })(n)))(function() {
                return re(Ar(r))(function(e) {
                    return re(Ar(hn(n)))(function(t) {
                        return na(M9(DC)(t.finalizers))(function() {
                            return na(F9(t.initializers))(function() {
                                return Ia(e);
                            });
                        });
                    });
                });
            });
        };
    }, ku = dc(ke(xo)(Q(k(xr)(void 0)))), vC = function(n) {
        return function(r) {
            return re(Ar(hn(r)))(function(e) {
                return Ar(vp(function(t) {
                    return {
                        state: t + 1 | 0,
                        value: n(t)
                    };
                })(e.fresh));
            });
        };
    }, i_ = function(n) {
        return function(r) {
            return function(e) {
                return re(Ar(hn(r)))(function(t) {
                    return jo(n)(r)(t.component.eval(new Oi(w9(E.create)(ly(e)), Q(F.value))));
                });
            };
        };
    }, jo = function(n) {
        return function(r) {
            return function(e) {
                var t = function(o) {
                    return function(u) {
                        return re(Ar(hn(o)))(function(i) {
                            return R2(function(c) {
                                var l = function(d) {
                                    return pC(re(Ar(hn(d)))(function(m) {
                                        return Zt(function(v) {
                                            return i_(n)(v.selfRef)(c.value1);
                                        })(m);
                                    }));
                                };
                                return x9(c.value2)(mC(c.value0(fo)(l)(i.children)));
                            })(u);
                        });
                    };
                }, a = function(o) {
                    return function(u) {
                        if (u instanceof Su) return re(Ar(hn(o)))(function(i) {
                            var c = u.value0(i.state);
                            if (Ti(i.state)(c.value1)) return Ia(c.value0);
                            if (Wr) return na(Ar(mr({
                                component: i.component,
                                refs: i.refs,
                                children: i.children,
                                childrenIn: i.childrenIn,
                                childrenOut: i.childrenOut,
                                selfRef: i.selfRef,
                                handlerRef: i.handlerRef,
                                pendingQueries: i.pendingQueries,
                                pendingOuts: i.pendingOuts,
                                pendingHandlers: i.pendingHandlers,
                                rendering: i.rendering,
                                fresh: i.fresh,
                                subscriptions: i.subscriptions,
                                forks: i.forks,
                                lifecycleHandlers: i.lifecycleHandlers,
                                state: c.value1
                            })(o)))(function() {
                                return na(h0(i.lifecycleHandlers)(n(i.lifecycleHandlers)(o)))(function() {
                                    return Ia(c.value0);
                                });
                            });
                            throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 86, column 7 - line 92, column 21): " + [
                                c.constructor.name
                            ]);
                        });
                        if (u instanceof Mi) return re(vC(O2)(o))(function(i) {
                            return re(Ar(H2(u.value0(i))(function(c) {
                                return ku(f_(n)(o)(new co(c)));
                            })))(function(c) {
                                return re(Ar(hn(o)))(function(l) {
                                    return na(Ar(qe(A9(I9(i)(c)))(l.subscriptions)))(function() {
                                        return Ia(u.value1(i));
                                    });
                                });
                            });
                        });
                        if (u instanceof Fi) return na(Ar(O9(u.value0)(o)))(function() {
                            return Ia(u.value1);
                        });
                        if (u instanceof xa) return u.value0;
                        if (u instanceof wi) return t(o)(u.value0);
                        if (u instanceof xi) return re(Ar(hn(o)))(function(i) {
                            return re(Ar(hn(i.handlerRef)))(function(c) {
                                return na(v0(i.pendingOuts)(c(u.value0)))(function() {
                                    return Ia(u.value1);
                                });
                            });
                        });
                        if (u instanceof Ru) return mC(L9(Ks(function() {
                            var i = jo(n)(o);
                            return function(c) {
                                return pC(i(c));
                            };
                        }())(u.value0)));
                        if (u instanceof Ai) return re(vC(q2)(o))(function(i) {
                            return re(Ar(hn(o)))(function(c) {
                                return re(Ar(Cr(!1)))(function(l) {
                                    return re(DC(bb(Ar(function() {
                                        return qe(S9(i))(c.forks)(), mr(!0)(l)();
                                    }))(jo(n)(o)(u.value0))))(function(d) {
                                        return na(Ar(R9(hn(l))(qe(N9(i)(d))(c.forks))))(function() {
                                            return Ia(u.value1(i));
                                        });
                                    });
                                });
                            });
                        });
                        if (u instanceof Ii) return re(Ar(hn(o)))(function(i) {
                            return re(Ar(hn(i.forks)))(function(c) {
                                return na(dC(pc)(_C(u.value0)(c)))(function() {
                                    return Ia(u.value1);
                                });
                            });
                        });
                        if (u instanceof Li) return re(Ar(hn(o)))(function(i) {
                            return re(Ar(hn(i.forks)))(function(c) {
                                return na(dC(mc(pt("Cancelled")))(_C(u.value0)(c)))(function() {
                                    return Ia(u.value1);
                                });
                            });
                        });
                        if (u instanceof Si) return re(Ar(hn(o)))(function(i) {
                            return Ia(u.value1(H9(u.value0)(i.refs)));
                        });
                        throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 83, column 12 - line 139, column 33): " + [
                            u.constructor.name
                        ]);
                    };
                };
                return P9(a(r))(e);
            };
        };
    }, f_ = function(n) {
        return function(r) {
            return function(e) {
                if (e instanceof Cc) return Ar(On(qe)(r)(_0(function(t) {
                    return {
                        component: t.component,
                        state: t.state,
                        children: t.children,
                        childrenIn: t.childrenIn,
                        childrenOut: t.childrenOut,
                        selfRef: t.selfRef,
                        handlerRef: t.handlerRef,
                        pendingQueries: t.pendingQueries,
                        pendingOuts: t.pendingOuts,
                        pendingHandlers: t.pendingHandlers,
                        rendering: t.rendering,
                        fresh: t.fresh,
                        subscriptions: t.subscriptions,
                        forks: t.forks,
                        lifecycleHandlers: t.lifecycleHandlers,
                        refs: k9(Q(e.value1))(e.value0)(t.refs)
                    };
                })));
                if (e instanceof co) return re(Ar(hn(r)))(function(t) {
                    return jo(n)(r)(t.component.eval(new ki(e.value0, void 0)));
                });
                throw new Error("Failed pattern match at Halogen.Aff.Driver.Eval (line 52, column 20 - line 58, column 62): " + [
                    e.constructor.name
                ]);
            };
        };
    };
    var W9 = Z(he), $9 = yt(Ct), MC = $l(xr)(me), FC = ne(tt)(et), wC = p0(s0), Wc = Pr(he), xC = ne(xr), AC = xC(me), gC = xC(bu), bC = $9(fe), U9 = ci(Ca)(fo)(et), qc = ir(ye), yC = k(xr), c_ = C(Pn), l_ = k(tt), s_ = bt(xr), B9 = lC(Pn), z9 = Hr(ya), CC = py(xr), V9 = cC(xr), J9 = Pt(Dh), G9 = eu(Pn), p_ = Z(fe), j9 = ir(Ih), EC = function() {
        return Cr({
            initializers: kn.value,
            finalizers: kn.value
        });
    }(), TC = function(n) {
        return function() {
            var e = hn(n)();
            return mr(F.value)(n)(), MC(e)(function() {
                var t = FC(wC);
                return function(a) {
                    return ku(t(ko(a)));
                };
            }())();
        };
    }, Q9 = function(n) {
        return function() {
            return Wc(AC(gC(Zs)))(hn(n.subscriptions))(), mr(F.value)(n.subscriptions)(), Wc(gC(function() {
                var e = mc(pt("finalized"));
                return function(t) {
                    return ku(e(t));
                };
            }()))(hn(n.forks))(), mr(Ft)(n.forks)();
        };
    }, IC = function(n) {
        return function(r) {
            return function(e) {
                var t = function(d) {
                    return function(m) {
                        return Zt(function(v) {
                            var _ = jo(u)(v.selfRef)(v.component.eval(new Ni(void 0)));
                            return qe(function(D) {
                                return {
                                    initializers: new Wn(bC(U9(ko(D.initializers)))(function() {
                                        return bC(_)(function() {
                                            return qc(function() {
                                                return TC(v.pendingQueries)(), TC(v.pendingOuts)();
                                            });
                                        });
                                    }), m),
                                    finalizers: D.finalizers
                                };
                            })(d);
                        });
                    };
                }, a = function(d) {
                    return function(m) {
                        return function(v) {
                            return u0(function(_) {
                                return function() {
                                    var T = EC(), I = sC(_)(v)(m)(T)(), $ = hn(d)();
                                    return mr({
                                        initializers: kn.value,
                                        finalizers: $.finalizers
                                    })(d)(), Wc(Zt(function() {
                                        var q = u(d);
                                        return function(z) {
                                            return q(function(S) {
                                                return S.selfRef;
                                            }(z));
                                        };
                                    }()))(hn(I))(), Wc(t(d)($.initializers))(hn(I))(), I;
                                };
                            });
                        };
                    };
                }, o = function(d) {
                    return function(m) {
                        return function(v) {
                            return function(_) {
                                return o0(function(D) {
                                    return function() {
                                        var I = c_(D.pop)(hn(v))(), $ = function() {
                                            if (I instanceof E) {
                                                mr(I.value0.value1)(v)();
                                                var z = hn(I.value0.value0)();
                                                return Zt(function(S) {
                                                    return function() {
                                                        return On(mr)(S.handlerRef)(function() {
                                                            var Y = _r(l_(void 0))(m);
                                                            return function(Yn) {
                                                                return Y(D.output(Yn));
                                                            };
                                                        }())(), ku(jo(u)(S.selfRef)(S.component.eval(new Pi(D.input, void 0))))();
                                                    };
                                                })(z)(), I.value0.value0;
                                            }
                                            if (I instanceof F) return a(d)(function() {
                                                var S = _r(l_(void 0))(m);
                                                return function(x) {
                                                    return S(D.output(x));
                                                };
                                            }())(D.input)(D.component)();
                                            throw new Error("Failed pattern match at Halogen.Aff.Driver (line 213, column 14 - line 222, column 98): " + [
                                                I.constructor.name
                                            ]);
                                        }(), q = c_(function(z) {
                                            return El(D.get(z));
                                        })(hn(_))();
                                        return s_(q)(_c("Halogen: Duplicate slot address was detected during rendering, unexpected results may occur"))(), qe(D.set($))(_)(), W9(hn($))(B9(function(z) {
                                            if (z instanceof F) return ph("Halogen internal error: child was not initialized in renderChild");
                                            if (z instanceof E) return yC(n.renderChild(z.value0));
                                            throw new Error("Failed pattern match at Halogen.Aff.Driver (line 227, column 37 - line 229, column 50): " + [
                                                z.constructor.name
                                            ]);
                                        }))();
                                    };
                                });
                            };
                        };
                    };
                }, u = function(d) {
                    return function(m) {
                        return function() {
                            var _ = hn(m)(), D = c_(Mo)(hn(_.pendingHandlers))();
                            s_(D)(mr(new E(kn.value))(_.pendingHandlers))(), mr(yi)(_.childrenOut)(), mr(_.children)(_.childrenIn)();
                            var T = function() {
                                var S = v0(_.pendingHandlers), x = f_(u)(_.selfRef);
                                return function(Y) {
                                    return S(z9(x(Y)));
                                };
                            }(), I = function() {
                                var S = v0(_.pendingQueries);
                                return function(x) {
                                    return S(T(co.create(x)));
                                };
                            }(), $ = n.render(function(S) {
                                return ku(T(S));
                            })(o(d)(I)(_.childrenIn)(_.childrenOut))(_.component.render(_.state))(_.rendering)(), q = hn(_.childrenOut)(), z = hn(_.childrenIn)();
                            return CC(z)(function(S) {
                                return function() {
                                    var Y = hn(S)();
                                    return V9(n.removeChild)(Y)(), i(d)(Y)();
                                };
                            })(), On(qe)(_.selfRef)(_0(function(S) {
                                return {
                                    component: S.component,
                                    state: S.state,
                                    refs: S.refs,
                                    childrenIn: S.childrenIn,
                                    childrenOut: S.childrenOut,
                                    selfRef: S.selfRef,
                                    handlerRef: S.handlerRef,
                                    pendingQueries: S.pendingQueries,
                                    pendingOuts: S.pendingOuts,
                                    pendingHandlers: S.pendingHandlers,
                                    fresh: S.fresh,
                                    subscriptions: S.subscriptions,
                                    forks: S.forks,
                                    lifecycleHandlers: S.lifecycleHandlers,
                                    rendering: new E($),
                                    children: q
                                };
                            }))(), s_(D)(On(J9)(void 0)(function(S) {
                                return function() {
                                    var Y = hn(_.pendingHandlers)();
                                    mr(new E(kn.value))(_.pendingHandlers)(), AC(function() {
                                        var cr = FC(wC);
                                        return function(Xr) {
                                            return ku(cr(ko(Xr)));
                                        };
                                    }())(Y)();
                                    var Yn = hn(_.pendingHandlers)(), dr = _r(!1)(Mg)(Yn);
                                    return dr ? G9(mr(F.value)(_.pendingHandlers))(new we(void 0))() : new We(void 0);
                                };
                            }))();
                        };
                    };
                }, i = function(d) {
                    return Zt(function(m) {
                        return function() {
                            Q9(m)();
                            var _ = jo(u)(m.selfRef)(m.component.eval(new Hi(void 0)));
                            return qe(function(D) {
                                return {
                                    initializers: D.initializers,
                                    finalizers: new Wn(_, D.finalizers)
                                };
                            })(d)(), CC(m.children)(function(D) {
                                return function() {
                                    var I = hn(D)();
                                    return i(d)(I)();
                                };
                            })();
                        };
                    });
                }, c = function(d) {
                    return function(m) {
                        return function(v) {
                            return p_(qc(hn(d)))(function(_) {
                                return _ ? l_(F.value) : i_(u)(m)(v);
                            });
                        };
                    };
                }, l = function(d) {
                    return function(m) {
                        return function(v) {
                            return h0(m)(function() {
                                var D = hn(d)();
                                return D ? void 0 : (mr(!0)(d)(), i(m)(v)(), Zt(function(T) {
                                    return function() {
                                        var $ = j9(hn(T.selfRef))();
                                        return MC($.rendering)(n.dispose)();
                                    };
                                })(v)());
                            });
                        };
                    };
                };
                return p_(qc(EC))(function(d) {
                    return p_(qc(Cr(!1)))(function(m) {
                        return h0(d)(function() {
                            var _ = k2(), D = Wc(hn)(a(d)(function() {
                                var T = P2(_.listener);
                                return function(I) {
                                    return qc(T(I));
                                };
                            }())(e)(r))();
                            return Zt(function(T) {
                                return yC({
                                    query: c(m)(T.selfRef),
                                    messages: _.emitter,
                                    dispose: l(m)(d)(D)
                                });
                            })(D)();
                        });
                    });
                });
            };
        };
    };
    var ra = function(n) {
        return function(r) {
            return function() {
                return r[n];
            };
        };
    };
    var Y9 = ra("baseURI"), X9 = ra("ownerDocument"), LC = ra("parentNode"), Z9 = ra("parentElement");
    var nI = ra("childNodes"), rI = ra("firstChild"), eI = ra("lastChild"), tI = ra("previousSibling"), SC = ra("nextSibling"), aI = ra("nodeValue");
    function m_(n) {
        return function(r) {
            return function() {
                r.nodeValue = n;
            };
        };
    }
    var oI = ra("textContent");
    function d_(n) {
        return function(r) {
            return function(e) {
                return function() {
                    e.insertBefore(n, r);
                };
            };
        };
    }
    function D0(n) {
        return function(r) {
            return function() {
                r.appendChild(n);
            };
        };
    }
    function __(n) {
        return function(r) {
            return function() {
                r.removeChild(n);
            };
        };
    }
    var RC = C(Pn);
    var v_ = function() {
        var n = RC(Nr);
        return function(r) {
            return n(LC(r));
        };
    }();
    var NC = function() {
        var n = RC(Nr);
        return function(r) {
            return n(SC(r));
        };
    }();
    var h_ = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, D_ = Hr(Pn), cI = k(xr), lI = ne(xr)(me), sI = $e(), pI = bt(xr), mI = Lo(gp(gp(Io))), dI = vn(Dn), _I = Z(fe), vI = ir(ye), hI = C(Pn), DI = Pr(he);
    var gI = function(n) {
        return function(r) {
            return function(e) {
                return r instanceof E && e instanceof E ? D_(d_(n)(r.value0)(e.value0)) : r instanceof F && e instanceof E ? D_(D0(n)(e.value0)) : cI(void 0);
            };
        };
    }, PC = function(n) {
        return function() {
            var e = v_(n.node)();
            return lI(function(t) {
                return __(n.node)(t);
            })(e)();
        };
    }, bI = function(n) {
        return function(r) {
            return function(e) {
                var t = fC(function(i) {
                    return i.node;
                }), a = function(i) {
                    return i instanceof E ? _t(i.value0) : void 0;
                }, o = function(i) {
                    var c = Q2(sI)(i), l = h_("patch", "Halogen.VDom.Driver", function() {
                        return function(T, I) {
                            if (T instanceof E) {
                                if (I instanceof qi) return _t(T.value0), m(100)(I.value0);
                                if (I instanceof Wi) {
                                    var $ = dt(T.value0, I.value0);
                                    return Yr(new Kr(Je($), new E($), l(103), a));
                                }
                                throw new Error("Failed pattern match at Halogen.VDom.Driver (line 97, column 22 - line 103, column 79): " + [
                                    I.constructor.name
                                ]);
                            }
                            return d(104)(I);
                        };
                    }), d = h_("render", "Halogen.VDom.Driver", function() {
                        return function(T) {
                            if (T instanceof qi) return m(86)(T.value0);
                            if (T instanceof Wi) {
                                var I = c(T.value0);
                                return Yr(new Kr(Je(I), new E(I), l(89), a));
                            }
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 84, column 7 - line 89, column 75): " + [
                                T.constructor.name
                            ]);
                        };
                    }), m = h_("renderComponentSlot", "Halogen.VDom.Driver", function() {
                        return function(T) {
                            var I = hn(r)(), $ = I(T)(), q = t($);
                            return Yr(new Kr(q, F.value, l(117), a));
                        };
                    }), v = l(91), _ = d(82), D = m(109);
                    return _;
                }, u = Zy(n);
                return {
                    buildWidget: o,
                    buildAttributes: u,
                    document: e
                };
            };
        };
    }, yI = function(n) {
        return function(r) {
            var e = function(t) {
                return function(a) {
                    return function(o) {
                        return function(u) {
                            if (u instanceof F) return function() {
                                var c = Cr(a)(), l = bI(t)(c)(n), d = Ic(l)(o), m = Je(d);
                                return D_(D0(m)(Yb(r)))(), {
                                    machine: d,
                                    node: m,
                                    renderChildRef: c
                                };
                            };
                            if (u instanceof E) return function() {
                                mr(a)(u.value0.renderChildRef)();
                                var c = v_(u.value0.node)(), l = NC(u.value0.node)(), d = dt(u.value0.machine, o), m = Je(d);
                                return pI(mI(Ti)(u.value0.node)(m))(gI(m)(l)(c))(), {
                                    machine: d,
                                    node: m,
                                    renderChildRef: u.value0.renderChildRef
                                };
                            };
                            throw new Error("Failed pattern match at Halogen.VDom.Driver (line 157, column 5 - line 173, column 80): " + [
                                u.constructor.name
                            ]);
                        };
                    };
                };
            };
            return {
                render: e,
                renderChild: dI,
                removeChild: PC,
                dispose: PC
            };
        };
    }, kC = function(n) {
        return function(r) {
            return function(e) {
                return _I(vI(hI(ws)(DI(Ma)(Ve))))(function(t) {
                    return IC(yI(t)(e))(n)(r);
                });
            };
        };
    };
    var w_ = {};
    Dl(w_, {
        arrayReplaceAt: ()=>F_,
        asciiTrim: ()=>Uu,
        assign: ()=>Ji,
        escapeHtml: ()=>_o,
        escapeRE: ()=>aL,
        fromCodePoint: ()=>Gi,
        has: ()=>GI,
        isMdAsciiPunct: ()=>Wu,
        isPunctChar: ()=>aE,
        isPunctCharCode: ()=>qu,
        isSpace: ()=>fr,
        isString: ()=>I0,
        isValidEntityCode: ()=>L0,
        isWhiteSpace: ()=>Ou,
        lib: ()=>oL,
        normalizeReference: ()=>$u,
        unescapeAll: ()=>mo,
        unescapeMd: ()=>XI
    });
    var E0 = {};
    Dl(E0, {
        decode: ()=>$c,
        encode: ()=>y0,
        format: ()=>Bi,
        parse: ()=>Uc
    });
    var OC = {};
    function EI(n) {
        let r = OC[n];
        if (r) return r;
        r = OC[n] = [];
        for(let e = 0; e < 128; e++){
            let t = String.fromCharCode(e);
            r.push(t);
        }
        for(let e = 0; e < n.length; e++){
            let t = n.charCodeAt(e);
            r[t] = "%" + ("0" + t.toString(16).toUpperCase()).slice(-2);
        }
        return r;
    }
    function g0(n, r) {
        typeof r != "string" && (r = g0.defaultChars);
        let e = EI(r);
        return n.replace(/(%[a-f0-9]{2})+/gi, function(t) {
            let a = "";
            for(let o = 0, u = t.length; o < u; o += 3){
                let i = parseInt(t.slice(o + 1, o + 3), 16);
                if (i < 128) {
                    a += e[i];
                    continue;
                }
                if ((i & 224) === 192 && o + 3 < u) {
                    let c = parseInt(t.slice(o + 4, o + 6), 16);
                    if ((c & 192) === 128) {
                        let l = i << 6 & 1984 | c & 63;
                        l < 128 ? a += "\uFFFD\uFFFD" : a += String.fromCharCode(l), o += 3;
                        continue;
                    }
                }
                if ((i & 240) === 224 && o + 6 < u) {
                    let c = parseInt(t.slice(o + 4, o + 6), 16), l = parseInt(t.slice(o + 7, o + 9), 16);
                    if ((c & 192) === 128 && (l & 192) === 128) {
                        let d = i << 12 & 61440 | c << 6 & 4032 | l & 63;
                        d < 2048 || d >= 55296 && d <= 57343 ? a += "\uFFFD\uFFFD\uFFFD" : a += String.fromCharCode(d), o += 6;
                        continue;
                    }
                }
                if ((i & 248) === 240 && o + 9 < u) {
                    let c = parseInt(t.slice(o + 4, o + 6), 16), l = parseInt(t.slice(o + 7, o + 9), 16), d = parseInt(t.slice(o + 10, o + 12), 16);
                    if ((c & 192) === 128 && (l & 192) === 128 && (d & 192) === 128) {
                        let m = i << 18 & 1835008 | c << 12 & 258048 | l << 6 & 4032 | d & 63;
                        m < 65536 || m > 1114111 ? a += "\uFFFD\uFFFD\uFFFD\uFFFD" : (m -= 65536, a += String.fromCharCode(55296 + (m >> 10), 56320 + (m & 1023))), o += 9;
                        continue;
                    }
                }
                a += "\uFFFD";
            }
            return a;
        });
    }
    g0.defaultChars = ";/?:@&=+$,#";
    g0.componentChars = "";
    var $c = g0;
    var qC = {};
    function TI(n) {
        let r = qC[n];
        if (r) return r;
        r = qC[n] = [];
        for(let e = 0; e < 128; e++){
            let t = String.fromCharCode(e);
            /^[0-9a-z]$/i.test(t) ? r.push(t) : r.push("%" + ("0" + e.toString(16).toUpperCase()).slice(-2));
        }
        for(let e = 0; e < n.length; e++)r[n.charCodeAt(e)] = n[e];
        return r;
    }
    function b0(n, r, e) {
        typeof r != "string" && (e = r, r = b0.defaultChars), typeof e > "u" && (e = !0);
        let t = TI(r), a = "";
        for(let o = 0, u = n.length; o < u; o++){
            let i = n.charCodeAt(o);
            if (e && i === 37 && o + 2 < u && /^[0-9a-f]{2}$/i.test(n.slice(o + 1, o + 3))) {
                a += n.slice(o, o + 3), o += 2;
                continue;
            }
            if (i < 128) {
                a += t[i];
                continue;
            }
            if (i >= 55296 && i <= 57343) {
                if (i >= 55296 && i <= 56319 && o + 1 < u) {
                    let c = n.charCodeAt(o + 1);
                    if (c >= 56320 && c <= 57343) {
                        a += encodeURIComponent(n[o] + n[o + 1]), o++;
                        continue;
                    }
                }
                a += "%EF%BF%BD";
                continue;
            }
            a += encodeURIComponent(n[o]);
        }
        return a;
    }
    b0.defaultChars = ";/?:@&=+$,-_.!~*'()#";
    b0.componentChars = "-_.!~*'()";
    var y0 = b0;
    function Bi(n) {
        let r = "";
        return r += n.protocol || "", r += n.slashes ? "//" : "", r += n.auth ? n.auth + "@" : "", n.hostname && n.hostname.indexOf(":") !== -1 ? r += "[" + n.hostname + "]" : r += n.hostname || "", r += n.port ? ":" + n.port : "", r += n.pathname || "", r += n.search || "", r += n.hash || "", r;
    }
    function C0() {
        this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
    }
    var MI = /^([a-z0-9.+-]+:)/i, FI = /:[0-9]*$/, wI = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, xI = [
        "<",
        ">",
        '"',
        "`",
        " ",
        "\r",
        `
`,
        "	"
    ], AI = [
        "{",
        "}",
        "|",
        "\\",
        "^",
        "`"
    ].concat(xI), II = [
        "'"
    ].concat(AI), WC = [
        "%",
        "/",
        "?",
        ";",
        "#"
    ].concat(II), $C = [
        "/",
        "?",
        "#"
    ], LI = 255, UC = /^[+a-z0-9A-Z_-]{0,63}$/, SI = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, BC = {
        javascript: !0,
        "javascript:": !0
    }, zC = {
        http: !0,
        https: !0,
        ftp: !0,
        gopher: !0,
        file: !0,
        "http:": !0,
        "https:": !0,
        "ftp:": !0,
        "gopher:": !0,
        "file:": !0
    };
    function RI(n, r) {
        if (n && n instanceof C0) return n;
        let e = new C0;
        return e.parse(n, r), e;
    }
    C0.prototype.parse = function(n, r) {
        let e, t, a, o = n;
        if (o = o.trim(), !r && n.split("#").length === 1) {
            let l = wI.exec(o);
            if (l) return this.pathname = l[1], l[2] && (this.search = l[2]), this;
        }
        let u = MI.exec(o);
        if (u && (u = u[0], e = u.toLowerCase(), this.protocol = u, o = o.substr(u.length)), (r || u || o.match(/^\/\/[^@\/]+@[^@\/]+/)) && (a = o.substr(0, 2) === "//", a && !(u && BC[u]) && (o = o.substr(2), this.slashes = !0)), !BC[u] && (a || u && !zC[u])) {
            let l = -1;
            for(let D = 0; D < $C.length; D++)t = o.indexOf($C[D]), t !== -1 && (l === -1 || t < l) && (l = t);
            let d, m;
            l === -1 ? m = o.lastIndexOf("@") : m = o.lastIndexOf("@", l), m !== -1 && (d = o.slice(0, m), o = o.slice(m + 1), this.auth = d), l = -1;
            for(let D = 0; D < WC.length; D++)t = o.indexOf(WC[D]), t !== -1 && (l === -1 || t < l) && (l = t);
            l === -1 && (l = o.length), o[l - 1] === ":" && l--;
            let v = o.slice(0, l);
            o = o.slice(l), this.parseHost(v), this.hostname = this.hostname || "";
            let _ = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
            if (!_) {
                let D = this.hostname.split(/\./);
                for(let T = 0, I = D.length; T < I; T++){
                    let $ = D[T];
                    if ($ && !$.match(UC)) {
                        let q = "";
                        for(let z = 0, S = $.length; z < S; z++)$.charCodeAt(z) > 127 ? q += "x" : q += $[z];
                        if (!q.match(UC)) {
                            let z = D.slice(0, T), S = D.slice(T + 1), x = $.match(SI);
                            x && (z.push(x[1]), S.unshift(x[2])), S.length && (o = S.join(".") + o), this.hostname = z.join(".");
                            break;
                        }
                    }
                }
            }
            this.hostname.length > LI && (this.hostname = ""), _ && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
        }
        let i = o.indexOf("#");
        i !== -1 && (this.hash = o.substr(i), o = o.slice(0, i));
        let c = o.indexOf("?");
        return c !== -1 && (this.search = o.substr(c), o = o.slice(0, c)), o && (this.pathname = o), zC[e] && this.hostname && !this.pathname && (this.pathname = ""), this;
    };
    C0.prototype.parseHost = function(n) {
        let r = FI.exec(n);
        r && (r = r[0], r !== ":" && (this.port = r.substr(1)), n = n.substr(0, n.length - r.length)), n && (this.hostname = n);
    };
    var Uc = RI;
    var g_ = {};
    Dl(g_, {
        Any: ()=>T0,
        Cc: ()=>M0,
        Cf: ()=>VC,
        P: ()=>zi,
        S: ()=>F0,
        Z: ()=>w0
    });
    var T0 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var M0 = /[\0-\x1F\x7F-\x9F]/;
    var VC = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;
    var zi = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
    var F0 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;
    var w0 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
    var JC = new Uint16Array('\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\uD835\uDD04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\uD835\uDD38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\uD835\uDC9Cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\uD835\uDD05pf;\uC000\uD835\uDD39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\uD835\uDC9Ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\uD835\uDD07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\uD835\uDD3B\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\uD835\uDC9Frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\uD835\uDD08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\uD835\uDD3Csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\uD835\uDD09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\uD835\uDD3DAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\uD835\uDD0A;\u62D9pf;\uC000\uD835\uDD3Eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\uD835\uDCA2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\uD835\uDD40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\uD835\uDD0Dpf;\uC000\uD835\uDD41\u01E3\u07C7\0\u07CCr;\uC000\uD835\uDCA5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\uD835\uDD0Epf;\uC000\uD835\uDD42cr;\uC000\uD835\uDCA6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\uD835\uDD0F\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\uD835\uDD43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\uD835\uDD10nusPlus;\u6213pf;\uC000\uD835\uDD44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\uD835\uDD11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\uD835\uDCA9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\uD835\uDD12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\uD835\uDD46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\uD835\uDCAAash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\uD835\uDD13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\uD835\uDCAB;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\uD835\uDD14pf;\u611Acr;\uC000\uD835\uDCAC\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\uD835\uDD16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\uD835\uDD4A\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\uD835\uDCAEar;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\uD835\uDD17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\uD835\uDD4BipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\uD835\uDCAFrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\uD835\uDD18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\uD835\uDD4C\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\uD835\uDCB0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\uD835\uDD19pf;\uC000\uD835\uDD4Dcr;\uC000\uD835\uDCB1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\uD835\uDD1Apf;\uC000\uD835\uDD4Ecr;\uC000\uD835\uDCB2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\uD835\uDD1B;\u439Epf;\uC000\uD835\uDD4Fcr;\uC000\uD835\uDCB3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\uD835\uDD1Cpf;\uC000\uD835\uDD50cr;\uC000\uD835\uDCB4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\uD835\uDCB5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\uD835\uDD1Erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\uD835\uDD52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\uD835\uDCB6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\uD835\uDD1Fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\uD835\uDD53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\uD835\uDCB7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\uD835\uDD20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\uD835\uDD54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\uD835\uDCB8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\uD835\uDD21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\uD835\uDD55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\uD835\uDCB9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\uD835\uDD22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\uD835\uDD56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\uD835\uDD23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\uD835\uDD57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\uD835\uDCBB\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\uD835\uDD24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\uD835\uDD58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\uD835\uDD25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\uD835\uDD59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\uD835\uDCBDas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\uD835\uDD26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\uD835\uDD5Aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\uD835\uDCBEn\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\uD835\uDD27ath;\u4237pf;\uC000\uD835\uDD5B\u01E3\u23EC\0\u23F1r;\uC000\uD835\uDCBFrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\uD835\uDD28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\uD835\uDD5Ccr;\uC000\uD835\uDCC0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\uD835\uDD29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\uD835\uDD5Dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\uD835\uDCC1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\uD835\uDD2Ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\uD835\uDD5E\u0100ct\u28F8\u28FDr;\uC000\uD835\uDCC2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\uD835\uDD2B\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\uD835\uDD5F\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\uD835\uDCC3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\uD835\uDD2C\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\uD835\uDD60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\uD835\uDD2D\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\uD835\uDD61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\uD835\uDCC5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\uD835\uDD2Epf;\uC000\uD835\uDD62rime;\u6057cr;\uC000\uD835\uDCC6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\uD835\uDD2F\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\uD835\uDD63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\uD835\uDCC7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\uD835\uDD30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\uD835\uDD64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\uD835\uDCC8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\uD835\uDD31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\uD835\uDD65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\uD835\uDCC9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\uD835\uDD32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\uD835\uDD66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\uD835\uDCCA\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\uD835\uDD33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\uD835\uDD67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\uD835\uDCCB\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\uD835\uDD34pf;\uC000\uD835\uDD68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\uD835\uDCCC\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\uD835\uDD35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\uD835\uDD69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\uD835\uDCCD\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\uD835\uDD36cy;\u4457pf;\uC000\uD835\uDD6Acr;\uC000\uD835\uDCCE\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\uD835\uDD37cy;\u4436grarr;\u61DDpf;\uC000\uD835\uDD6Bcr;\uC000\uD835\uDCCF\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((n)=>n.charCodeAt(0)));
    var GC = new Uint16Array("\u0200aglq	\x1B\u026D\0\0p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((n)=>n.charCodeAt(0)));
    var b_, NI = new Map([
        [
            0,
            65533
        ],
        [
            128,
            8364
        ],
        [
            130,
            8218
        ],
        [
            131,
            402
        ],
        [
            132,
            8222
        ],
        [
            133,
            8230
        ],
        [
            134,
            8224
        ],
        [
            135,
            8225
        ],
        [
            136,
            710
        ],
        [
            137,
            8240
        ],
        [
            138,
            352
        ],
        [
            139,
            8249
        ],
        [
            140,
            338
        ],
        [
            142,
            381
        ],
        [
            145,
            8216
        ],
        [
            146,
            8217
        ],
        [
            147,
            8220
        ],
        [
            148,
            8221
        ],
        [
            149,
            8226
        ],
        [
            150,
            8211
        ],
        [
            151,
            8212
        ],
        [
            152,
            732
        ],
        [
            153,
            8482
        ],
        [
            154,
            353
        ],
        [
            155,
            8250
        ],
        [
            156,
            339
        ],
        [
            158,
            382
        ],
        [
            159,
            376
        ]
    ]), y_ = (b_ = String.fromCodePoint) !== null && b_ !== void 0 ? b_ : function(n) {
        let r = "";
        return n > 65535 && (n -= 65536, r += String.fromCharCode(n >>> 10 & 1023 | 55296), n = 56320 | n & 1023), r += String.fromCharCode(n), r;
    };
    function C_(n) {
        var r;
        return n >= 55296 && n <= 57343 || n > 1114111 ? 65533 : (r = NI.get(n)) !== null && r !== void 0 ? r : n;
    }
    var Se;
    (function(n) {
        n[n.NUM = 35] = "NUM", n[n.SEMI = 59] = "SEMI", n[n.EQUALS = 61] = "EQUALS", n[n.ZERO = 48] = "ZERO", n[n.NINE = 57] = "NINE", n[n.LOWER_A = 97] = "LOWER_A", n[n.LOWER_F = 102] = "LOWER_F", n[n.LOWER_X = 120] = "LOWER_X", n[n.LOWER_Z = 122] = "LOWER_Z", n[n.UPPER_A = 65] = "UPPER_A", n[n.UPPER_F = 70] = "UPPER_F", n[n.UPPER_Z = 90] = "UPPER_Z";
    })(Se || (Se = {}));
    var HI = 32, Qo;
    (function(n) {
        n[n.VALUE_LENGTH = 49152] = "VALUE_LENGTH", n[n.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", n[n.JUMP_TABLE = 127] = "JUMP_TABLE";
    })(Qo || (Qo = {}));
    function E_(n) {
        return n >= Se.ZERO && n <= Se.NINE;
    }
    function PI(n) {
        return n >= Se.UPPER_A && n <= Se.UPPER_F || n >= Se.LOWER_A && n <= Se.LOWER_F;
    }
    function kI(n) {
        return n >= Se.UPPER_A && n <= Se.UPPER_Z || n >= Se.LOWER_A && n <= Se.LOWER_Z || E_(n);
    }
    function OI(n) {
        return n === Se.EQUALS || kI(n);
    }
    var Le;
    (function(n) {
        n[n.EntityStart = 0] = "EntityStart", n[n.NumericStart = 1] = "NumericStart", n[n.NumericDecimal = 2] = "NumericDecimal", n[n.NumericHex = 3] = "NumericHex", n[n.NamedEntity = 4] = "NamedEntity";
    })(Le || (Le = {}));
    var ea;
    (function(n) {
        n[n.Legacy = 0] = "Legacy", n[n.Strict = 1] = "Strict", n[n.Attribute = 2] = "Attribute";
    })(ea || (ea = {}));
    var x0 = class {
        constructor(r, e, t){
            this.decodeTree = r, this.emitCodePoint = e, this.errors = t, this.state = Le.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = ea.Strict;
        }
        startEntity(r) {
            this.decodeMode = r, this.state = Le.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
        }
        write(r, e) {
            switch(this.state){
                case Le.EntityStart:
                    return r.charCodeAt(e) === Se.NUM ? (this.state = Le.NumericStart, this.consumed += 1, this.stateNumericStart(r, e + 1)) : (this.state = Le.NamedEntity, this.stateNamedEntity(r, e));
                case Le.NumericStart:
                    return this.stateNumericStart(r, e);
                case Le.NumericDecimal:
                    return this.stateNumericDecimal(r, e);
                case Le.NumericHex:
                    return this.stateNumericHex(r, e);
                case Le.NamedEntity:
                    return this.stateNamedEntity(r, e);
            }
        }
        stateNumericStart(r, e) {
            return e >= r.length ? -1 : (r.charCodeAt(e) | HI) === Se.LOWER_X ? (this.state = Le.NumericHex, this.consumed += 1, this.stateNumericHex(r, e + 1)) : (this.state = Le.NumericDecimal, this.stateNumericDecimal(r, e));
        }
        addToNumericResult(r, e, t, a) {
            if (e !== t) {
                let o = t - e;
                this.result = this.result * Math.pow(a, o) + parseInt(r.substr(e, o), a), this.consumed += o;
            }
        }
        stateNumericHex(r, e) {
            let t = e;
            for(; e < r.length;){
                let a = r.charCodeAt(e);
                if (E_(a) || PI(a)) e += 1;
                else return this.addToNumericResult(r, t, e, 16), this.emitNumericEntity(a, 3);
            }
            return this.addToNumericResult(r, t, e, 16), -1;
        }
        stateNumericDecimal(r, e) {
            let t = e;
            for(; e < r.length;){
                let a = r.charCodeAt(e);
                if (E_(a)) e += 1;
                else return this.addToNumericResult(r, t, e, 10), this.emitNumericEntity(a, 2);
            }
            return this.addToNumericResult(r, t, e, 10), -1;
        }
        emitNumericEntity(r, e) {
            var t;
            if (this.consumed <= e) return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            if (r === Se.SEMI) this.consumed += 1;
            else if (this.decodeMode === ea.Strict) return 0;
            return this.emitCodePoint(C_(this.result), this.consumed), this.errors && (r !== Se.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
        }
        stateNamedEntity(r, e) {
            let { decodeTree: t } = this, a = t[this.treeIndex], o = (a & Qo.VALUE_LENGTH) >> 14;
            for(; e < r.length; e++, this.excess++){
                let u = r.charCodeAt(e);
                if (this.treeIndex = qI(t, a, this.treeIndex + Math.max(1, o), u), this.treeIndex < 0) return this.result === 0 || this.decodeMode === ea.Attribute && (o === 0 || OI(u)) ? 0 : this.emitNotTerminatedNamedEntity();
                if (a = t[this.treeIndex], o = (a & Qo.VALUE_LENGTH) >> 14, o !== 0) {
                    if (u === Se.SEMI) return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
                    this.decodeMode !== ea.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
                }
            }
            return -1;
        }
        emitNotTerminatedNamedEntity() {
            var r;
            let { result: e, decodeTree: t } = this, a = (t[e] & Qo.VALUE_LENGTH) >> 14;
            return this.emitNamedEntityData(e, a, this.consumed), (r = this.errors) === null || r === void 0 || r.missingSemicolonAfterCharacterReference(), this.consumed;
        }
        emitNamedEntityData(r, e, t) {
            let { decodeTree: a } = this;
            return this.emitCodePoint(e === 1 ? a[r] & ~Qo.VALUE_LENGTH : a[r + 1], t), e === 3 && this.emitCodePoint(a[r + 2], t), t;
        }
        end() {
            var r;
            switch(this.state){
                case Le.NamedEntity:
                    return this.result !== 0 && (this.decodeMode !== ea.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
                case Le.NumericDecimal:
                    return this.emitNumericEntity(0, 2);
                case Le.NumericHex:
                    return this.emitNumericEntity(0, 3);
                case Le.NumericStart:
                    return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
                case Le.EntityStart:
                    return 0;
            }
        }
    };
    function jC(n) {
        let r = "", e = new x0(n, (t)=>r += y_(t));
        return function(a, o) {
            let u = 0, i = 0;
            for(; (i = a.indexOf("&", i)) >= 0;){
                r += a.slice(u, i), e.startEntity(o);
                let l = e.write(a, i + 1);
                if (l < 0) {
                    u = i + e.end();
                    break;
                }
                u = i + l, i = l === 0 ? u + 1 : u;
            }
            let c = r + a.slice(u);
            return r = "", c;
        };
    }
    function qI(n, r, e, t) {
        let a = (r & Qo.BRANCH_LENGTH) >> 7, o = r & Qo.JUMP_TABLE;
        if (a === 0) return o !== 0 && t === o ? e : -1;
        if (o) {
            let c = t - o;
            return c < 0 || c >= a ? -1 : n[e + c] - 1;
        }
        let u = e, i = u + a - 1;
        for(; u <= i;){
            let c = u + i >>> 1, l = n[c];
            if (l < t) u = c + 1;
            else if (l > t) i = c - 1;
            else return n[c + a];
        }
        return -1;
    }
    var QC = jC(JC), XDn = jC(GC);
    function Vi(n, r = ea.Legacy) {
        return QC(n, r);
    }
    function Bc(n) {
        return QC(n, ea.Strict);
    }
    function A0(n) {
        for(let r = 1; r < n.length; r++)n[r][0] += n[r - 1][0] + 1;
        return n;
    }
    var WI = new Map(A0([
        [
            9,
            "&Tab;"
        ],
        [
            0,
            "&NewLine;"
        ],
        [
            22,
            "&excl;"
        ],
        [
            0,
            "&quot;"
        ],
        [
            0,
            "&num;"
        ],
        [
            0,
            "&dollar;"
        ],
        [
            0,
            "&percnt;"
        ],
        [
            0,
            "&amp;"
        ],
        [
            0,
            "&apos;"
        ],
        [
            0,
            "&lpar;"
        ],
        [
            0,
            "&rpar;"
        ],
        [
            0,
            "&ast;"
        ],
        [
            0,
            "&plus;"
        ],
        [
            0,
            "&comma;"
        ],
        [
            1,
            "&period;"
        ],
        [
            0,
            "&sol;"
        ],
        [
            10,
            "&colon;"
        ],
        [
            0,
            "&semi;"
        ],
        [
            0,
            {
                v: "&lt;",
                n: 8402,
                o: "&nvlt;"
            }
        ],
        [
            0,
            {
                v: "&equals;",
                n: 8421,
                o: "&bne;"
            }
        ],
        [
            0,
            {
                v: "&gt;",
                n: 8402,
                o: "&nvgt;"
            }
        ],
        [
            0,
            "&quest;"
        ],
        [
            0,
            "&commat;"
        ],
        [
            26,
            "&lbrack;"
        ],
        [
            0,
            "&bsol;"
        ],
        [
            0,
            "&rbrack;"
        ],
        [
            0,
            "&Hat;"
        ],
        [
            0,
            "&lowbar;"
        ],
        [
            0,
            "&DiacriticalGrave;"
        ],
        [
            5,
            {
                n: 106,
                o: "&fjlig;"
            }
        ],
        [
            20,
            "&lbrace;"
        ],
        [
            0,
            "&verbar;"
        ],
        [
            0,
            "&rbrace;"
        ],
        [
            34,
            "&nbsp;"
        ],
        [
            0,
            "&iexcl;"
        ],
        [
            0,
            "&cent;"
        ],
        [
            0,
            "&pound;"
        ],
        [
            0,
            "&curren;"
        ],
        [
            0,
            "&yen;"
        ],
        [
            0,
            "&brvbar;"
        ],
        [
            0,
            "&sect;"
        ],
        [
            0,
            "&die;"
        ],
        [
            0,
            "&copy;"
        ],
        [
            0,
            "&ordf;"
        ],
        [
            0,
            "&laquo;"
        ],
        [
            0,
            "&not;"
        ],
        [
            0,
            "&shy;"
        ],
        [
            0,
            "&circledR;"
        ],
        [
            0,
            "&macr;"
        ],
        [
            0,
            "&deg;"
        ],
        [
            0,
            "&PlusMinus;"
        ],
        [
            0,
            "&sup2;"
        ],
        [
            0,
            "&sup3;"
        ],
        [
            0,
            "&acute;"
        ],
        [
            0,
            "&micro;"
        ],
        [
            0,
            "&para;"
        ],
        [
            0,
            "&centerdot;"
        ],
        [
            0,
            "&cedil;"
        ],
        [
            0,
            "&sup1;"
        ],
        [
            0,
            "&ordm;"
        ],
        [
            0,
            "&raquo;"
        ],
        [
            0,
            "&frac14;"
        ],
        [
            0,
            "&frac12;"
        ],
        [
            0,
            "&frac34;"
        ],
        [
            0,
            "&iquest;"
        ],
        [
            0,
            "&Agrave;"
        ],
        [
            0,
            "&Aacute;"
        ],
        [
            0,
            "&Acirc;"
        ],
        [
            0,
            "&Atilde;"
        ],
        [
            0,
            "&Auml;"
        ],
        [
            0,
            "&angst;"
        ],
        [
            0,
            "&AElig;"
        ],
        [
            0,
            "&Ccedil;"
        ],
        [
            0,
            "&Egrave;"
        ],
        [
            0,
            "&Eacute;"
        ],
        [
            0,
            "&Ecirc;"
        ],
        [
            0,
            "&Euml;"
        ],
        [
            0,
            "&Igrave;"
        ],
        [
            0,
            "&Iacute;"
        ],
        [
            0,
            "&Icirc;"
        ],
        [
            0,
            "&Iuml;"
        ],
        [
            0,
            "&ETH;"
        ],
        [
            0,
            "&Ntilde;"
        ],
        [
            0,
            "&Ograve;"
        ],
        [
            0,
            "&Oacute;"
        ],
        [
            0,
            "&Ocirc;"
        ],
        [
            0,
            "&Otilde;"
        ],
        [
            0,
            "&Ouml;"
        ],
        [
            0,
            "&times;"
        ],
        [
            0,
            "&Oslash;"
        ],
        [
            0,
            "&Ugrave;"
        ],
        [
            0,
            "&Uacute;"
        ],
        [
            0,
            "&Ucirc;"
        ],
        [
            0,
            "&Uuml;"
        ],
        [
            0,
            "&Yacute;"
        ],
        [
            0,
            "&THORN;"
        ],
        [
            0,
            "&szlig;"
        ],
        [
            0,
            "&agrave;"
        ],
        [
            0,
            "&aacute;"
        ],
        [
            0,
            "&acirc;"
        ],
        [
            0,
            "&atilde;"
        ],
        [
            0,
            "&auml;"
        ],
        [
            0,
            "&aring;"
        ],
        [
            0,
            "&aelig;"
        ],
        [
            0,
            "&ccedil;"
        ],
        [
            0,
            "&egrave;"
        ],
        [
            0,
            "&eacute;"
        ],
        [
            0,
            "&ecirc;"
        ],
        [
            0,
            "&euml;"
        ],
        [
            0,
            "&igrave;"
        ],
        [
            0,
            "&iacute;"
        ],
        [
            0,
            "&icirc;"
        ],
        [
            0,
            "&iuml;"
        ],
        [
            0,
            "&eth;"
        ],
        [
            0,
            "&ntilde;"
        ],
        [
            0,
            "&ograve;"
        ],
        [
            0,
            "&oacute;"
        ],
        [
            0,
            "&ocirc;"
        ],
        [
            0,
            "&otilde;"
        ],
        [
            0,
            "&ouml;"
        ],
        [
            0,
            "&div;"
        ],
        [
            0,
            "&oslash;"
        ],
        [
            0,
            "&ugrave;"
        ],
        [
            0,
            "&uacute;"
        ],
        [
            0,
            "&ucirc;"
        ],
        [
            0,
            "&uuml;"
        ],
        [
            0,
            "&yacute;"
        ],
        [
            0,
            "&thorn;"
        ],
        [
            0,
            "&yuml;"
        ],
        [
            0,
            "&Amacr;"
        ],
        [
            0,
            "&amacr;"
        ],
        [
            0,
            "&Abreve;"
        ],
        [
            0,
            "&abreve;"
        ],
        [
            0,
            "&Aogon;"
        ],
        [
            0,
            "&aogon;"
        ],
        [
            0,
            "&Cacute;"
        ],
        [
            0,
            "&cacute;"
        ],
        [
            0,
            "&Ccirc;"
        ],
        [
            0,
            "&ccirc;"
        ],
        [
            0,
            "&Cdot;"
        ],
        [
            0,
            "&cdot;"
        ],
        [
            0,
            "&Ccaron;"
        ],
        [
            0,
            "&ccaron;"
        ],
        [
            0,
            "&Dcaron;"
        ],
        [
            0,
            "&dcaron;"
        ],
        [
            0,
            "&Dstrok;"
        ],
        [
            0,
            "&dstrok;"
        ],
        [
            0,
            "&Emacr;"
        ],
        [
            0,
            "&emacr;"
        ],
        [
            2,
            "&Edot;"
        ],
        [
            0,
            "&edot;"
        ],
        [
            0,
            "&Eogon;"
        ],
        [
            0,
            "&eogon;"
        ],
        [
            0,
            "&Ecaron;"
        ],
        [
            0,
            "&ecaron;"
        ],
        [
            0,
            "&Gcirc;"
        ],
        [
            0,
            "&gcirc;"
        ],
        [
            0,
            "&Gbreve;"
        ],
        [
            0,
            "&gbreve;"
        ],
        [
            0,
            "&Gdot;"
        ],
        [
            0,
            "&gdot;"
        ],
        [
            0,
            "&Gcedil;"
        ],
        [
            1,
            "&Hcirc;"
        ],
        [
            0,
            "&hcirc;"
        ],
        [
            0,
            "&Hstrok;"
        ],
        [
            0,
            "&hstrok;"
        ],
        [
            0,
            "&Itilde;"
        ],
        [
            0,
            "&itilde;"
        ],
        [
            0,
            "&Imacr;"
        ],
        [
            0,
            "&imacr;"
        ],
        [
            2,
            "&Iogon;"
        ],
        [
            0,
            "&iogon;"
        ],
        [
            0,
            "&Idot;"
        ],
        [
            0,
            "&imath;"
        ],
        [
            0,
            "&IJlig;"
        ],
        [
            0,
            "&ijlig;"
        ],
        [
            0,
            "&Jcirc;"
        ],
        [
            0,
            "&jcirc;"
        ],
        [
            0,
            "&Kcedil;"
        ],
        [
            0,
            "&kcedil;"
        ],
        [
            0,
            "&kgreen;"
        ],
        [
            0,
            "&Lacute;"
        ],
        [
            0,
            "&lacute;"
        ],
        [
            0,
            "&Lcedil;"
        ],
        [
            0,
            "&lcedil;"
        ],
        [
            0,
            "&Lcaron;"
        ],
        [
            0,
            "&lcaron;"
        ],
        [
            0,
            "&Lmidot;"
        ],
        [
            0,
            "&lmidot;"
        ],
        [
            0,
            "&Lstrok;"
        ],
        [
            0,
            "&lstrok;"
        ],
        [
            0,
            "&Nacute;"
        ],
        [
            0,
            "&nacute;"
        ],
        [
            0,
            "&Ncedil;"
        ],
        [
            0,
            "&ncedil;"
        ],
        [
            0,
            "&Ncaron;"
        ],
        [
            0,
            "&ncaron;"
        ],
        [
            0,
            "&napos;"
        ],
        [
            0,
            "&ENG;"
        ],
        [
            0,
            "&eng;"
        ],
        [
            0,
            "&Omacr;"
        ],
        [
            0,
            "&omacr;"
        ],
        [
            2,
            "&Odblac;"
        ],
        [
            0,
            "&odblac;"
        ],
        [
            0,
            "&OElig;"
        ],
        [
            0,
            "&oelig;"
        ],
        [
            0,
            "&Racute;"
        ],
        [
            0,
            "&racute;"
        ],
        [
            0,
            "&Rcedil;"
        ],
        [
            0,
            "&rcedil;"
        ],
        [
            0,
            "&Rcaron;"
        ],
        [
            0,
            "&rcaron;"
        ],
        [
            0,
            "&Sacute;"
        ],
        [
            0,
            "&sacute;"
        ],
        [
            0,
            "&Scirc;"
        ],
        [
            0,
            "&scirc;"
        ],
        [
            0,
            "&Scedil;"
        ],
        [
            0,
            "&scedil;"
        ],
        [
            0,
            "&Scaron;"
        ],
        [
            0,
            "&scaron;"
        ],
        [
            0,
            "&Tcedil;"
        ],
        [
            0,
            "&tcedil;"
        ],
        [
            0,
            "&Tcaron;"
        ],
        [
            0,
            "&tcaron;"
        ],
        [
            0,
            "&Tstrok;"
        ],
        [
            0,
            "&tstrok;"
        ],
        [
            0,
            "&Utilde;"
        ],
        [
            0,
            "&utilde;"
        ],
        [
            0,
            "&Umacr;"
        ],
        [
            0,
            "&umacr;"
        ],
        [
            0,
            "&Ubreve;"
        ],
        [
            0,
            "&ubreve;"
        ],
        [
            0,
            "&Uring;"
        ],
        [
            0,
            "&uring;"
        ],
        [
            0,
            "&Udblac;"
        ],
        [
            0,
            "&udblac;"
        ],
        [
            0,
            "&Uogon;"
        ],
        [
            0,
            "&uogon;"
        ],
        [
            0,
            "&Wcirc;"
        ],
        [
            0,
            "&wcirc;"
        ],
        [
            0,
            "&Ycirc;"
        ],
        [
            0,
            "&ycirc;"
        ],
        [
            0,
            "&Yuml;"
        ],
        [
            0,
            "&Zacute;"
        ],
        [
            0,
            "&zacute;"
        ],
        [
            0,
            "&Zdot;"
        ],
        [
            0,
            "&zdot;"
        ],
        [
            0,
            "&Zcaron;"
        ],
        [
            0,
            "&zcaron;"
        ],
        [
            19,
            "&fnof;"
        ],
        [
            34,
            "&imped;"
        ],
        [
            63,
            "&gacute;"
        ],
        [
            65,
            "&jmath;"
        ],
        [
            142,
            "&circ;"
        ],
        [
            0,
            "&caron;"
        ],
        [
            16,
            "&breve;"
        ],
        [
            0,
            "&DiacriticalDot;"
        ],
        [
            0,
            "&ring;"
        ],
        [
            0,
            "&ogon;"
        ],
        [
            0,
            "&DiacriticalTilde;"
        ],
        [
            0,
            "&dblac;"
        ],
        [
            51,
            "&DownBreve;"
        ],
        [
            127,
            "&Alpha;"
        ],
        [
            0,
            "&Beta;"
        ],
        [
            0,
            "&Gamma;"
        ],
        [
            0,
            "&Delta;"
        ],
        [
            0,
            "&Epsilon;"
        ],
        [
            0,
            "&Zeta;"
        ],
        [
            0,
            "&Eta;"
        ],
        [
            0,
            "&Theta;"
        ],
        [
            0,
            "&Iota;"
        ],
        [
            0,
            "&Kappa;"
        ],
        [
            0,
            "&Lambda;"
        ],
        [
            0,
            "&Mu;"
        ],
        [
            0,
            "&Nu;"
        ],
        [
            0,
            "&Xi;"
        ],
        [
            0,
            "&Omicron;"
        ],
        [
            0,
            "&Pi;"
        ],
        [
            0,
            "&Rho;"
        ],
        [
            1,
            "&Sigma;"
        ],
        [
            0,
            "&Tau;"
        ],
        [
            0,
            "&Upsilon;"
        ],
        [
            0,
            "&Phi;"
        ],
        [
            0,
            "&Chi;"
        ],
        [
            0,
            "&Psi;"
        ],
        [
            0,
            "&ohm;"
        ],
        [
            7,
            "&alpha;"
        ],
        [
            0,
            "&beta;"
        ],
        [
            0,
            "&gamma;"
        ],
        [
            0,
            "&delta;"
        ],
        [
            0,
            "&epsi;"
        ],
        [
            0,
            "&zeta;"
        ],
        [
            0,
            "&eta;"
        ],
        [
            0,
            "&theta;"
        ],
        [
            0,
            "&iota;"
        ],
        [
            0,
            "&kappa;"
        ],
        [
            0,
            "&lambda;"
        ],
        [
            0,
            "&mu;"
        ],
        [
            0,
            "&nu;"
        ],
        [
            0,
            "&xi;"
        ],
        [
            0,
            "&omicron;"
        ],
        [
            0,
            "&pi;"
        ],
        [
            0,
            "&rho;"
        ],
        [
            0,
            "&sigmaf;"
        ],
        [
            0,
            "&sigma;"
        ],
        [
            0,
            "&tau;"
        ],
        [
            0,
            "&upsi;"
        ],
        [
            0,
            "&phi;"
        ],
        [
            0,
            "&chi;"
        ],
        [
            0,
            "&psi;"
        ],
        [
            0,
            "&omega;"
        ],
        [
            7,
            "&thetasym;"
        ],
        [
            0,
            "&Upsi;"
        ],
        [
            2,
            "&phiv;"
        ],
        [
            0,
            "&piv;"
        ],
        [
            5,
            "&Gammad;"
        ],
        [
            0,
            "&digamma;"
        ],
        [
            18,
            "&kappav;"
        ],
        [
            0,
            "&rhov;"
        ],
        [
            3,
            "&epsiv;"
        ],
        [
            0,
            "&backepsilon;"
        ],
        [
            10,
            "&IOcy;"
        ],
        [
            0,
            "&DJcy;"
        ],
        [
            0,
            "&GJcy;"
        ],
        [
            0,
            "&Jukcy;"
        ],
        [
            0,
            "&DScy;"
        ],
        [
            0,
            "&Iukcy;"
        ],
        [
            0,
            "&YIcy;"
        ],
        [
            0,
            "&Jsercy;"
        ],
        [
            0,
            "&LJcy;"
        ],
        [
            0,
            "&NJcy;"
        ],
        [
            0,
            "&TSHcy;"
        ],
        [
            0,
            "&KJcy;"
        ],
        [
            1,
            "&Ubrcy;"
        ],
        [
            0,
            "&DZcy;"
        ],
        [
            0,
            "&Acy;"
        ],
        [
            0,
            "&Bcy;"
        ],
        [
            0,
            "&Vcy;"
        ],
        [
            0,
            "&Gcy;"
        ],
        [
            0,
            "&Dcy;"
        ],
        [
            0,
            "&IEcy;"
        ],
        [
            0,
            "&ZHcy;"
        ],
        [
            0,
            "&Zcy;"
        ],
        [
            0,
            "&Icy;"
        ],
        [
            0,
            "&Jcy;"
        ],
        [
            0,
            "&Kcy;"
        ],
        [
            0,
            "&Lcy;"
        ],
        [
            0,
            "&Mcy;"
        ],
        [
            0,
            "&Ncy;"
        ],
        [
            0,
            "&Ocy;"
        ],
        [
            0,
            "&Pcy;"
        ],
        [
            0,
            "&Rcy;"
        ],
        [
            0,
            "&Scy;"
        ],
        [
            0,
            "&Tcy;"
        ],
        [
            0,
            "&Ucy;"
        ],
        [
            0,
            "&Fcy;"
        ],
        [
            0,
            "&KHcy;"
        ],
        [
            0,
            "&TScy;"
        ],
        [
            0,
            "&CHcy;"
        ],
        [
            0,
            "&SHcy;"
        ],
        [
            0,
            "&SHCHcy;"
        ],
        [
            0,
            "&HARDcy;"
        ],
        [
            0,
            "&Ycy;"
        ],
        [
            0,
            "&SOFTcy;"
        ],
        [
            0,
            "&Ecy;"
        ],
        [
            0,
            "&YUcy;"
        ],
        [
            0,
            "&YAcy;"
        ],
        [
            0,
            "&acy;"
        ],
        [
            0,
            "&bcy;"
        ],
        [
            0,
            "&vcy;"
        ],
        [
            0,
            "&gcy;"
        ],
        [
            0,
            "&dcy;"
        ],
        [
            0,
            "&iecy;"
        ],
        [
            0,
            "&zhcy;"
        ],
        [
            0,
            "&zcy;"
        ],
        [
            0,
            "&icy;"
        ],
        [
            0,
            "&jcy;"
        ],
        [
            0,
            "&kcy;"
        ],
        [
            0,
            "&lcy;"
        ],
        [
            0,
            "&mcy;"
        ],
        [
            0,
            "&ncy;"
        ],
        [
            0,
            "&ocy;"
        ],
        [
            0,
            "&pcy;"
        ],
        [
            0,
            "&rcy;"
        ],
        [
            0,
            "&scy;"
        ],
        [
            0,
            "&tcy;"
        ],
        [
            0,
            "&ucy;"
        ],
        [
            0,
            "&fcy;"
        ],
        [
            0,
            "&khcy;"
        ],
        [
            0,
            "&tscy;"
        ],
        [
            0,
            "&chcy;"
        ],
        [
            0,
            "&shcy;"
        ],
        [
            0,
            "&shchcy;"
        ],
        [
            0,
            "&hardcy;"
        ],
        [
            0,
            "&ycy;"
        ],
        [
            0,
            "&softcy;"
        ],
        [
            0,
            "&ecy;"
        ],
        [
            0,
            "&yucy;"
        ],
        [
            0,
            "&yacy;"
        ],
        [
            1,
            "&iocy;"
        ],
        [
            0,
            "&djcy;"
        ],
        [
            0,
            "&gjcy;"
        ],
        [
            0,
            "&jukcy;"
        ],
        [
            0,
            "&dscy;"
        ],
        [
            0,
            "&iukcy;"
        ],
        [
            0,
            "&yicy;"
        ],
        [
            0,
            "&jsercy;"
        ],
        [
            0,
            "&ljcy;"
        ],
        [
            0,
            "&njcy;"
        ],
        [
            0,
            "&tshcy;"
        ],
        [
            0,
            "&kjcy;"
        ],
        [
            1,
            "&ubrcy;"
        ],
        [
            0,
            "&dzcy;"
        ],
        [
            7074,
            "&ensp;"
        ],
        [
            0,
            "&emsp;"
        ],
        [
            0,
            "&emsp13;"
        ],
        [
            0,
            "&emsp14;"
        ],
        [
            1,
            "&numsp;"
        ],
        [
            0,
            "&puncsp;"
        ],
        [
            0,
            "&ThinSpace;"
        ],
        [
            0,
            "&hairsp;"
        ],
        [
            0,
            "&NegativeMediumSpace;"
        ],
        [
            0,
            "&zwnj;"
        ],
        [
            0,
            "&zwj;"
        ],
        [
            0,
            "&lrm;"
        ],
        [
            0,
            "&rlm;"
        ],
        [
            0,
            "&dash;"
        ],
        [
            2,
            "&ndash;"
        ],
        [
            0,
            "&mdash;"
        ],
        [
            0,
            "&horbar;"
        ],
        [
            0,
            "&Verbar;"
        ],
        [
            1,
            "&lsquo;"
        ],
        [
            0,
            "&CloseCurlyQuote;"
        ],
        [
            0,
            "&lsquor;"
        ],
        [
            1,
            "&ldquo;"
        ],
        [
            0,
            "&CloseCurlyDoubleQuote;"
        ],
        [
            0,
            "&bdquo;"
        ],
        [
            1,
            "&dagger;"
        ],
        [
            0,
            "&Dagger;"
        ],
        [
            0,
            "&bull;"
        ],
        [
            2,
            "&nldr;"
        ],
        [
            0,
            "&hellip;"
        ],
        [
            9,
            "&permil;"
        ],
        [
            0,
            "&pertenk;"
        ],
        [
            0,
            "&prime;"
        ],
        [
            0,
            "&Prime;"
        ],
        [
            0,
            "&tprime;"
        ],
        [
            0,
            "&backprime;"
        ],
        [
            3,
            "&lsaquo;"
        ],
        [
            0,
            "&rsaquo;"
        ],
        [
            3,
            "&oline;"
        ],
        [
            2,
            "&caret;"
        ],
        [
            1,
            "&hybull;"
        ],
        [
            0,
            "&frasl;"
        ],
        [
            10,
            "&bsemi;"
        ],
        [
            7,
            "&qprime;"
        ],
        [
            7,
            {
                v: "&MediumSpace;",
                n: 8202,
                o: "&ThickSpace;"
            }
        ],
        [
            0,
            "&NoBreak;"
        ],
        [
            0,
            "&af;"
        ],
        [
            0,
            "&InvisibleTimes;"
        ],
        [
            0,
            "&ic;"
        ],
        [
            72,
            "&euro;"
        ],
        [
            46,
            "&tdot;"
        ],
        [
            0,
            "&DotDot;"
        ],
        [
            37,
            "&complexes;"
        ],
        [
            2,
            "&incare;"
        ],
        [
            4,
            "&gscr;"
        ],
        [
            0,
            "&hamilt;"
        ],
        [
            0,
            "&Hfr;"
        ],
        [
            0,
            "&Hopf;"
        ],
        [
            0,
            "&planckh;"
        ],
        [
            0,
            "&hbar;"
        ],
        [
            0,
            "&imagline;"
        ],
        [
            0,
            "&Ifr;"
        ],
        [
            0,
            "&lagran;"
        ],
        [
            0,
            "&ell;"
        ],
        [
            1,
            "&naturals;"
        ],
        [
            0,
            "&numero;"
        ],
        [
            0,
            "&copysr;"
        ],
        [
            0,
            "&weierp;"
        ],
        [
            0,
            "&Popf;"
        ],
        [
            0,
            "&Qopf;"
        ],
        [
            0,
            "&realine;"
        ],
        [
            0,
            "&real;"
        ],
        [
            0,
            "&reals;"
        ],
        [
            0,
            "&rx;"
        ],
        [
            3,
            "&trade;"
        ],
        [
            1,
            "&integers;"
        ],
        [
            2,
            "&mho;"
        ],
        [
            0,
            "&zeetrf;"
        ],
        [
            0,
            "&iiota;"
        ],
        [
            2,
            "&bernou;"
        ],
        [
            0,
            "&Cayleys;"
        ],
        [
            1,
            "&escr;"
        ],
        [
            0,
            "&Escr;"
        ],
        [
            0,
            "&Fouriertrf;"
        ],
        [
            1,
            "&Mellintrf;"
        ],
        [
            0,
            "&order;"
        ],
        [
            0,
            "&alefsym;"
        ],
        [
            0,
            "&beth;"
        ],
        [
            0,
            "&gimel;"
        ],
        [
            0,
            "&daleth;"
        ],
        [
            12,
            "&CapitalDifferentialD;"
        ],
        [
            0,
            "&dd;"
        ],
        [
            0,
            "&ee;"
        ],
        [
            0,
            "&ii;"
        ],
        [
            10,
            "&frac13;"
        ],
        [
            0,
            "&frac23;"
        ],
        [
            0,
            "&frac15;"
        ],
        [
            0,
            "&frac25;"
        ],
        [
            0,
            "&frac35;"
        ],
        [
            0,
            "&frac45;"
        ],
        [
            0,
            "&frac16;"
        ],
        [
            0,
            "&frac56;"
        ],
        [
            0,
            "&frac18;"
        ],
        [
            0,
            "&frac38;"
        ],
        [
            0,
            "&frac58;"
        ],
        [
            0,
            "&frac78;"
        ],
        [
            49,
            "&larr;"
        ],
        [
            0,
            "&ShortUpArrow;"
        ],
        [
            0,
            "&rarr;"
        ],
        [
            0,
            "&darr;"
        ],
        [
            0,
            "&harr;"
        ],
        [
            0,
            "&updownarrow;"
        ],
        [
            0,
            "&nwarr;"
        ],
        [
            0,
            "&nearr;"
        ],
        [
            0,
            "&LowerRightArrow;"
        ],
        [
            0,
            "&LowerLeftArrow;"
        ],
        [
            0,
            "&nlarr;"
        ],
        [
            0,
            "&nrarr;"
        ],
        [
            1,
            {
                v: "&rarrw;",
                n: 824,
                o: "&nrarrw;"
            }
        ],
        [
            0,
            "&Larr;"
        ],
        [
            0,
            "&Uarr;"
        ],
        [
            0,
            "&Rarr;"
        ],
        [
            0,
            "&Darr;"
        ],
        [
            0,
            "&larrtl;"
        ],
        [
            0,
            "&rarrtl;"
        ],
        [
            0,
            "&LeftTeeArrow;"
        ],
        [
            0,
            "&mapstoup;"
        ],
        [
            0,
            "&map;"
        ],
        [
            0,
            "&DownTeeArrow;"
        ],
        [
            1,
            "&hookleftarrow;"
        ],
        [
            0,
            "&hookrightarrow;"
        ],
        [
            0,
            "&larrlp;"
        ],
        [
            0,
            "&looparrowright;"
        ],
        [
            0,
            "&harrw;"
        ],
        [
            0,
            "&nharr;"
        ],
        [
            1,
            "&lsh;"
        ],
        [
            0,
            "&rsh;"
        ],
        [
            0,
            "&ldsh;"
        ],
        [
            0,
            "&rdsh;"
        ],
        [
            1,
            "&crarr;"
        ],
        [
            0,
            "&cularr;"
        ],
        [
            0,
            "&curarr;"
        ],
        [
            2,
            "&circlearrowleft;"
        ],
        [
            0,
            "&circlearrowright;"
        ],
        [
            0,
            "&leftharpoonup;"
        ],
        [
            0,
            "&DownLeftVector;"
        ],
        [
            0,
            "&RightUpVector;"
        ],
        [
            0,
            "&LeftUpVector;"
        ],
        [
            0,
            "&rharu;"
        ],
        [
            0,
            "&DownRightVector;"
        ],
        [
            0,
            "&dharr;"
        ],
        [
            0,
            "&dharl;"
        ],
        [
            0,
            "&RightArrowLeftArrow;"
        ],
        [
            0,
            "&udarr;"
        ],
        [
            0,
            "&LeftArrowRightArrow;"
        ],
        [
            0,
            "&leftleftarrows;"
        ],
        [
            0,
            "&upuparrows;"
        ],
        [
            0,
            "&rightrightarrows;"
        ],
        [
            0,
            "&ddarr;"
        ],
        [
            0,
            "&leftrightharpoons;"
        ],
        [
            0,
            "&Equilibrium;"
        ],
        [
            0,
            "&nlArr;"
        ],
        [
            0,
            "&nhArr;"
        ],
        [
            0,
            "&nrArr;"
        ],
        [
            0,
            "&DoubleLeftArrow;"
        ],
        [
            0,
            "&DoubleUpArrow;"
        ],
        [
            0,
            "&DoubleRightArrow;"
        ],
        [
            0,
            "&dArr;"
        ],
        [
            0,
            "&DoubleLeftRightArrow;"
        ],
        [
            0,
            "&DoubleUpDownArrow;"
        ],
        [
            0,
            "&nwArr;"
        ],
        [
            0,
            "&neArr;"
        ],
        [
            0,
            "&seArr;"
        ],
        [
            0,
            "&swArr;"
        ],
        [
            0,
            "&lAarr;"
        ],
        [
            0,
            "&rAarr;"
        ],
        [
            1,
            "&zigrarr;"
        ],
        [
            6,
            "&larrb;"
        ],
        [
            0,
            "&rarrb;"
        ],
        [
            15,
            "&DownArrowUpArrow;"
        ],
        [
            7,
            "&loarr;"
        ],
        [
            0,
            "&roarr;"
        ],
        [
            0,
            "&hoarr;"
        ],
        [
            0,
            "&forall;"
        ],
        [
            0,
            "&comp;"
        ],
        [
            0,
            {
                v: "&part;",
                n: 824,
                o: "&npart;"
            }
        ],
        [
            0,
            "&exist;"
        ],
        [
            0,
            "&nexist;"
        ],
        [
            0,
            "&empty;"
        ],
        [
            1,
            "&Del;"
        ],
        [
            0,
            "&Element;"
        ],
        [
            0,
            "&NotElement;"
        ],
        [
            1,
            "&ni;"
        ],
        [
            0,
            "&notni;"
        ],
        [
            2,
            "&prod;"
        ],
        [
            0,
            "&coprod;"
        ],
        [
            0,
            "&sum;"
        ],
        [
            0,
            "&minus;"
        ],
        [
            0,
            "&MinusPlus;"
        ],
        [
            0,
            "&dotplus;"
        ],
        [
            1,
            "&Backslash;"
        ],
        [
            0,
            "&lowast;"
        ],
        [
            0,
            "&compfn;"
        ],
        [
            1,
            "&radic;"
        ],
        [
            2,
            "&prop;"
        ],
        [
            0,
            "&infin;"
        ],
        [
            0,
            "&angrt;"
        ],
        [
            0,
            {
                v: "&ang;",
                n: 8402,
                o: "&nang;"
            }
        ],
        [
            0,
            "&angmsd;"
        ],
        [
            0,
            "&angsph;"
        ],
        [
            0,
            "&mid;"
        ],
        [
            0,
            "&nmid;"
        ],
        [
            0,
            "&DoubleVerticalBar;"
        ],
        [
            0,
            "&NotDoubleVerticalBar;"
        ],
        [
            0,
            "&and;"
        ],
        [
            0,
            "&or;"
        ],
        [
            0,
            {
                v: "&cap;",
                n: 65024,
                o: "&caps;"
            }
        ],
        [
            0,
            {
                v: "&cup;",
                n: 65024,
                o: "&cups;"
            }
        ],
        [
            0,
            "&int;"
        ],
        [
            0,
            "&Int;"
        ],
        [
            0,
            "&iiint;"
        ],
        [
            0,
            "&conint;"
        ],
        [
            0,
            "&Conint;"
        ],
        [
            0,
            "&Cconint;"
        ],
        [
            0,
            "&cwint;"
        ],
        [
            0,
            "&ClockwiseContourIntegral;"
        ],
        [
            0,
            "&awconint;"
        ],
        [
            0,
            "&there4;"
        ],
        [
            0,
            "&becaus;"
        ],
        [
            0,
            "&ratio;"
        ],
        [
            0,
            "&Colon;"
        ],
        [
            0,
            "&dotminus;"
        ],
        [
            1,
            "&mDDot;"
        ],
        [
            0,
            "&homtht;"
        ],
        [
            0,
            {
                v: "&sim;",
                n: 8402,
                o: "&nvsim;"
            }
        ],
        [
            0,
            {
                v: "&backsim;",
                n: 817,
                o: "&race;"
            }
        ],
        [
            0,
            {
                v: "&ac;",
                n: 819,
                o: "&acE;"
            }
        ],
        [
            0,
            "&acd;"
        ],
        [
            0,
            "&VerticalTilde;"
        ],
        [
            0,
            "&NotTilde;"
        ],
        [
            0,
            {
                v: "&eqsim;",
                n: 824,
                o: "&nesim;"
            }
        ],
        [
            0,
            "&sime;"
        ],
        [
            0,
            "&NotTildeEqual;"
        ],
        [
            0,
            "&cong;"
        ],
        [
            0,
            "&simne;"
        ],
        [
            0,
            "&ncong;"
        ],
        [
            0,
            "&ap;"
        ],
        [
            0,
            "&nap;"
        ],
        [
            0,
            "&ape;"
        ],
        [
            0,
            {
                v: "&apid;",
                n: 824,
                o: "&napid;"
            }
        ],
        [
            0,
            "&backcong;"
        ],
        [
            0,
            {
                v: "&asympeq;",
                n: 8402,
                o: "&nvap;"
            }
        ],
        [
            0,
            {
                v: "&bump;",
                n: 824,
                o: "&nbump;"
            }
        ],
        [
            0,
            {
                v: "&bumpe;",
                n: 824,
                o: "&nbumpe;"
            }
        ],
        [
            0,
            {
                v: "&doteq;",
                n: 824,
                o: "&nedot;"
            }
        ],
        [
            0,
            "&doteqdot;"
        ],
        [
            0,
            "&efDot;"
        ],
        [
            0,
            "&erDot;"
        ],
        [
            0,
            "&Assign;"
        ],
        [
            0,
            "&ecolon;"
        ],
        [
            0,
            "&ecir;"
        ],
        [
            0,
            "&circeq;"
        ],
        [
            1,
            "&wedgeq;"
        ],
        [
            0,
            "&veeeq;"
        ],
        [
            1,
            "&triangleq;"
        ],
        [
            2,
            "&equest;"
        ],
        [
            0,
            "&ne;"
        ],
        [
            0,
            {
                v: "&Congruent;",
                n: 8421,
                o: "&bnequiv;"
            }
        ],
        [
            0,
            "&nequiv;"
        ],
        [
            1,
            {
                v: "&le;",
                n: 8402,
                o: "&nvle;"
            }
        ],
        [
            0,
            {
                v: "&ge;",
                n: 8402,
                o: "&nvge;"
            }
        ],
        [
            0,
            {
                v: "&lE;",
                n: 824,
                o: "&nlE;"
            }
        ],
        [
            0,
            {
                v: "&gE;",
                n: 824,
                o: "&ngE;"
            }
        ],
        [
            0,
            {
                v: "&lnE;",
                n: 65024,
                o: "&lvertneqq;"
            }
        ],
        [
            0,
            {
                v: "&gnE;",
                n: 65024,
                o: "&gvertneqq;"
            }
        ],
        [
            0,
            {
                v: "&ll;",
                n: new Map(A0([
                    [
                        824,
                        "&nLtv;"
                    ],
                    [
                        7577,
                        "&nLt;"
                    ]
                ]))
            }
        ],
        [
            0,
            {
                v: "&gg;",
                n: new Map(A0([
                    [
                        824,
                        "&nGtv;"
                    ],
                    [
                        7577,
                        "&nGt;"
                    ]
                ]))
            }
        ],
        [
            0,
            "&between;"
        ],
        [
            0,
            "&NotCupCap;"
        ],
        [
            0,
            "&nless;"
        ],
        [
            0,
            "&ngt;"
        ],
        [
            0,
            "&nle;"
        ],
        [
            0,
            "&nge;"
        ],
        [
            0,
            "&lesssim;"
        ],
        [
            0,
            "&GreaterTilde;"
        ],
        [
            0,
            "&nlsim;"
        ],
        [
            0,
            "&ngsim;"
        ],
        [
            0,
            "&LessGreater;"
        ],
        [
            0,
            "&gl;"
        ],
        [
            0,
            "&NotLessGreater;"
        ],
        [
            0,
            "&NotGreaterLess;"
        ],
        [
            0,
            "&pr;"
        ],
        [
            0,
            "&sc;"
        ],
        [
            0,
            "&prcue;"
        ],
        [
            0,
            "&sccue;"
        ],
        [
            0,
            "&PrecedesTilde;"
        ],
        [
            0,
            {
                v: "&scsim;",
                n: 824,
                o: "&NotSucceedsTilde;"
            }
        ],
        [
            0,
            "&NotPrecedes;"
        ],
        [
            0,
            "&NotSucceeds;"
        ],
        [
            0,
            {
                v: "&sub;",
                n: 8402,
                o: "&NotSubset;"
            }
        ],
        [
            0,
            {
                v: "&sup;",
                n: 8402,
                o: "&NotSuperset;"
            }
        ],
        [
            0,
            "&nsub;"
        ],
        [
            0,
            "&nsup;"
        ],
        [
            0,
            "&sube;"
        ],
        [
            0,
            "&supe;"
        ],
        [
            0,
            "&NotSubsetEqual;"
        ],
        [
            0,
            "&NotSupersetEqual;"
        ],
        [
            0,
            {
                v: "&subne;",
                n: 65024,
                o: "&varsubsetneq;"
            }
        ],
        [
            0,
            {
                v: "&supne;",
                n: 65024,
                o: "&varsupsetneq;"
            }
        ],
        [
            1,
            "&cupdot;"
        ],
        [
            0,
            "&UnionPlus;"
        ],
        [
            0,
            {
                v: "&sqsub;",
                n: 824,
                o: "&NotSquareSubset;"
            }
        ],
        [
            0,
            {
                v: "&sqsup;",
                n: 824,
                o: "&NotSquareSuperset;"
            }
        ],
        [
            0,
            "&sqsube;"
        ],
        [
            0,
            "&sqsupe;"
        ],
        [
            0,
            {
                v: "&sqcap;",
                n: 65024,
                o: "&sqcaps;"
            }
        ],
        [
            0,
            {
                v: "&sqcup;",
                n: 65024,
                o: "&sqcups;"
            }
        ],
        [
            0,
            "&CirclePlus;"
        ],
        [
            0,
            "&CircleMinus;"
        ],
        [
            0,
            "&CircleTimes;"
        ],
        [
            0,
            "&osol;"
        ],
        [
            0,
            "&CircleDot;"
        ],
        [
            0,
            "&circledcirc;"
        ],
        [
            0,
            "&circledast;"
        ],
        [
            1,
            "&circleddash;"
        ],
        [
            0,
            "&boxplus;"
        ],
        [
            0,
            "&boxminus;"
        ],
        [
            0,
            "&boxtimes;"
        ],
        [
            0,
            "&dotsquare;"
        ],
        [
            0,
            "&RightTee;"
        ],
        [
            0,
            "&dashv;"
        ],
        [
            0,
            "&DownTee;"
        ],
        [
            0,
            "&bot;"
        ],
        [
            1,
            "&models;"
        ],
        [
            0,
            "&DoubleRightTee;"
        ],
        [
            0,
            "&Vdash;"
        ],
        [
            0,
            "&Vvdash;"
        ],
        [
            0,
            "&VDash;"
        ],
        [
            0,
            "&nvdash;"
        ],
        [
            0,
            "&nvDash;"
        ],
        [
            0,
            "&nVdash;"
        ],
        [
            0,
            "&nVDash;"
        ],
        [
            0,
            "&prurel;"
        ],
        [
            1,
            "&LeftTriangle;"
        ],
        [
            0,
            "&RightTriangle;"
        ],
        [
            0,
            {
                v: "&LeftTriangleEqual;",
                n: 8402,
                o: "&nvltrie;"
            }
        ],
        [
            0,
            {
                v: "&RightTriangleEqual;",
                n: 8402,
                o: "&nvrtrie;"
            }
        ],
        [
            0,
            "&origof;"
        ],
        [
            0,
            "&imof;"
        ],
        [
            0,
            "&multimap;"
        ],
        [
            0,
            "&hercon;"
        ],
        [
            0,
            "&intcal;"
        ],
        [
            0,
            "&veebar;"
        ],
        [
            1,
            "&barvee;"
        ],
        [
            0,
            "&angrtvb;"
        ],
        [
            0,
            "&lrtri;"
        ],
        [
            0,
            "&bigwedge;"
        ],
        [
            0,
            "&bigvee;"
        ],
        [
            0,
            "&bigcap;"
        ],
        [
            0,
            "&bigcup;"
        ],
        [
            0,
            "&diam;"
        ],
        [
            0,
            "&sdot;"
        ],
        [
            0,
            "&sstarf;"
        ],
        [
            0,
            "&divideontimes;"
        ],
        [
            0,
            "&bowtie;"
        ],
        [
            0,
            "&ltimes;"
        ],
        [
            0,
            "&rtimes;"
        ],
        [
            0,
            "&leftthreetimes;"
        ],
        [
            0,
            "&rightthreetimes;"
        ],
        [
            0,
            "&backsimeq;"
        ],
        [
            0,
            "&curlyvee;"
        ],
        [
            0,
            "&curlywedge;"
        ],
        [
            0,
            "&Sub;"
        ],
        [
            0,
            "&Sup;"
        ],
        [
            0,
            "&Cap;"
        ],
        [
            0,
            "&Cup;"
        ],
        [
            0,
            "&fork;"
        ],
        [
            0,
            "&epar;"
        ],
        [
            0,
            "&lessdot;"
        ],
        [
            0,
            "&gtdot;"
        ],
        [
            0,
            {
                v: "&Ll;",
                n: 824,
                o: "&nLl;"
            }
        ],
        [
            0,
            {
                v: "&Gg;",
                n: 824,
                o: "&nGg;"
            }
        ],
        [
            0,
            {
                v: "&leg;",
                n: 65024,
                o: "&lesg;"
            }
        ],
        [
            0,
            {
                v: "&gel;",
                n: 65024,
                o: "&gesl;"
            }
        ],
        [
            2,
            "&cuepr;"
        ],
        [
            0,
            "&cuesc;"
        ],
        [
            0,
            "&NotPrecedesSlantEqual;"
        ],
        [
            0,
            "&NotSucceedsSlantEqual;"
        ],
        [
            0,
            "&NotSquareSubsetEqual;"
        ],
        [
            0,
            "&NotSquareSupersetEqual;"
        ],
        [
            2,
            "&lnsim;"
        ],
        [
            0,
            "&gnsim;"
        ],
        [
            0,
            "&precnsim;"
        ],
        [
            0,
            "&scnsim;"
        ],
        [
            0,
            "&nltri;"
        ],
        [
            0,
            "&NotRightTriangle;"
        ],
        [
            0,
            "&nltrie;"
        ],
        [
            0,
            "&NotRightTriangleEqual;"
        ],
        [
            0,
            "&vellip;"
        ],
        [
            0,
            "&ctdot;"
        ],
        [
            0,
            "&utdot;"
        ],
        [
            0,
            "&dtdot;"
        ],
        [
            0,
            "&disin;"
        ],
        [
            0,
            "&isinsv;"
        ],
        [
            0,
            "&isins;"
        ],
        [
            0,
            {
                v: "&isindot;",
                n: 824,
                o: "&notindot;"
            }
        ],
        [
            0,
            "&notinvc;"
        ],
        [
            0,
            "&notinvb;"
        ],
        [
            1,
            {
                v: "&isinE;",
                n: 824,
                o: "&notinE;"
            }
        ],
        [
            0,
            "&nisd;"
        ],
        [
            0,
            "&xnis;"
        ],
        [
            0,
            "&nis;"
        ],
        [
            0,
            "&notnivc;"
        ],
        [
            0,
            "&notnivb;"
        ],
        [
            6,
            "&barwed;"
        ],
        [
            0,
            "&Barwed;"
        ],
        [
            1,
            "&lceil;"
        ],
        [
            0,
            "&rceil;"
        ],
        [
            0,
            "&LeftFloor;"
        ],
        [
            0,
            "&rfloor;"
        ],
        [
            0,
            "&drcrop;"
        ],
        [
            0,
            "&dlcrop;"
        ],
        [
            0,
            "&urcrop;"
        ],
        [
            0,
            "&ulcrop;"
        ],
        [
            0,
            "&bnot;"
        ],
        [
            1,
            "&profline;"
        ],
        [
            0,
            "&profsurf;"
        ],
        [
            1,
            "&telrec;"
        ],
        [
            0,
            "&target;"
        ],
        [
            5,
            "&ulcorn;"
        ],
        [
            0,
            "&urcorn;"
        ],
        [
            0,
            "&dlcorn;"
        ],
        [
            0,
            "&drcorn;"
        ],
        [
            2,
            "&frown;"
        ],
        [
            0,
            "&smile;"
        ],
        [
            9,
            "&cylcty;"
        ],
        [
            0,
            "&profalar;"
        ],
        [
            7,
            "&topbot;"
        ],
        [
            6,
            "&ovbar;"
        ],
        [
            1,
            "&solbar;"
        ],
        [
            60,
            "&angzarr;"
        ],
        [
            51,
            "&lmoustache;"
        ],
        [
            0,
            "&rmoustache;"
        ],
        [
            2,
            "&OverBracket;"
        ],
        [
            0,
            "&bbrk;"
        ],
        [
            0,
            "&bbrktbrk;"
        ],
        [
            37,
            "&OverParenthesis;"
        ],
        [
            0,
            "&UnderParenthesis;"
        ],
        [
            0,
            "&OverBrace;"
        ],
        [
            0,
            "&UnderBrace;"
        ],
        [
            2,
            "&trpezium;"
        ],
        [
            4,
            "&elinters;"
        ],
        [
            59,
            "&blank;"
        ],
        [
            164,
            "&circledS;"
        ],
        [
            55,
            "&boxh;"
        ],
        [
            1,
            "&boxv;"
        ],
        [
            9,
            "&boxdr;"
        ],
        [
            3,
            "&boxdl;"
        ],
        [
            3,
            "&boxur;"
        ],
        [
            3,
            "&boxul;"
        ],
        [
            3,
            "&boxvr;"
        ],
        [
            7,
            "&boxvl;"
        ],
        [
            7,
            "&boxhd;"
        ],
        [
            7,
            "&boxhu;"
        ],
        [
            7,
            "&boxvh;"
        ],
        [
            19,
            "&boxH;"
        ],
        [
            0,
            "&boxV;"
        ],
        [
            0,
            "&boxdR;"
        ],
        [
            0,
            "&boxDr;"
        ],
        [
            0,
            "&boxDR;"
        ],
        [
            0,
            "&boxdL;"
        ],
        [
            0,
            "&boxDl;"
        ],
        [
            0,
            "&boxDL;"
        ],
        [
            0,
            "&boxuR;"
        ],
        [
            0,
            "&boxUr;"
        ],
        [
            0,
            "&boxUR;"
        ],
        [
            0,
            "&boxuL;"
        ],
        [
            0,
            "&boxUl;"
        ],
        [
            0,
            "&boxUL;"
        ],
        [
            0,
            "&boxvR;"
        ],
        [
            0,
            "&boxVr;"
        ],
        [
            0,
            "&boxVR;"
        ],
        [
            0,
            "&boxvL;"
        ],
        [
            0,
            "&boxVl;"
        ],
        [
            0,
            "&boxVL;"
        ],
        [
            0,
            "&boxHd;"
        ],
        [
            0,
            "&boxhD;"
        ],
        [
            0,
            "&boxHD;"
        ],
        [
            0,
            "&boxHu;"
        ],
        [
            0,
            "&boxhU;"
        ],
        [
            0,
            "&boxHU;"
        ],
        [
            0,
            "&boxvH;"
        ],
        [
            0,
            "&boxVh;"
        ],
        [
            0,
            "&boxVH;"
        ],
        [
            19,
            "&uhblk;"
        ],
        [
            3,
            "&lhblk;"
        ],
        [
            3,
            "&block;"
        ],
        [
            8,
            "&blk14;"
        ],
        [
            0,
            "&blk12;"
        ],
        [
            0,
            "&blk34;"
        ],
        [
            13,
            "&square;"
        ],
        [
            8,
            "&blacksquare;"
        ],
        [
            0,
            "&EmptyVerySmallSquare;"
        ],
        [
            1,
            "&rect;"
        ],
        [
            0,
            "&marker;"
        ],
        [
            2,
            "&fltns;"
        ],
        [
            1,
            "&bigtriangleup;"
        ],
        [
            0,
            "&blacktriangle;"
        ],
        [
            0,
            "&triangle;"
        ],
        [
            2,
            "&blacktriangleright;"
        ],
        [
            0,
            "&rtri;"
        ],
        [
            3,
            "&bigtriangledown;"
        ],
        [
            0,
            "&blacktriangledown;"
        ],
        [
            0,
            "&dtri;"
        ],
        [
            2,
            "&blacktriangleleft;"
        ],
        [
            0,
            "&ltri;"
        ],
        [
            6,
            "&loz;"
        ],
        [
            0,
            "&cir;"
        ],
        [
            32,
            "&tridot;"
        ],
        [
            2,
            "&bigcirc;"
        ],
        [
            8,
            "&ultri;"
        ],
        [
            0,
            "&urtri;"
        ],
        [
            0,
            "&lltri;"
        ],
        [
            0,
            "&EmptySmallSquare;"
        ],
        [
            0,
            "&FilledSmallSquare;"
        ],
        [
            8,
            "&bigstar;"
        ],
        [
            0,
            "&star;"
        ],
        [
            7,
            "&phone;"
        ],
        [
            49,
            "&female;"
        ],
        [
            1,
            "&male;"
        ],
        [
            29,
            "&spades;"
        ],
        [
            2,
            "&clubs;"
        ],
        [
            1,
            "&hearts;"
        ],
        [
            0,
            "&diamondsuit;"
        ],
        [
            3,
            "&sung;"
        ],
        [
            2,
            "&flat;"
        ],
        [
            0,
            "&natural;"
        ],
        [
            0,
            "&sharp;"
        ],
        [
            163,
            "&check;"
        ],
        [
            3,
            "&cross;"
        ],
        [
            8,
            "&malt;"
        ],
        [
            21,
            "&sext;"
        ],
        [
            33,
            "&VerticalSeparator;"
        ],
        [
            25,
            "&lbbrk;"
        ],
        [
            0,
            "&rbbrk;"
        ],
        [
            84,
            "&bsolhsub;"
        ],
        [
            0,
            "&suphsol;"
        ],
        [
            28,
            "&LeftDoubleBracket;"
        ],
        [
            0,
            "&RightDoubleBracket;"
        ],
        [
            0,
            "&lang;"
        ],
        [
            0,
            "&rang;"
        ],
        [
            0,
            "&Lang;"
        ],
        [
            0,
            "&Rang;"
        ],
        [
            0,
            "&loang;"
        ],
        [
            0,
            "&roang;"
        ],
        [
            7,
            "&longleftarrow;"
        ],
        [
            0,
            "&longrightarrow;"
        ],
        [
            0,
            "&longleftrightarrow;"
        ],
        [
            0,
            "&DoubleLongLeftArrow;"
        ],
        [
            0,
            "&DoubleLongRightArrow;"
        ],
        [
            0,
            "&DoubleLongLeftRightArrow;"
        ],
        [
            1,
            "&longmapsto;"
        ],
        [
            2,
            "&dzigrarr;"
        ],
        [
            258,
            "&nvlArr;"
        ],
        [
            0,
            "&nvrArr;"
        ],
        [
            0,
            "&nvHarr;"
        ],
        [
            0,
            "&Map;"
        ],
        [
            6,
            "&lbarr;"
        ],
        [
            0,
            "&bkarow;"
        ],
        [
            0,
            "&lBarr;"
        ],
        [
            0,
            "&dbkarow;"
        ],
        [
            0,
            "&drbkarow;"
        ],
        [
            0,
            "&DDotrahd;"
        ],
        [
            0,
            "&UpArrowBar;"
        ],
        [
            0,
            "&DownArrowBar;"
        ],
        [
            2,
            "&Rarrtl;"
        ],
        [
            2,
            "&latail;"
        ],
        [
            0,
            "&ratail;"
        ],
        [
            0,
            "&lAtail;"
        ],
        [
            0,
            "&rAtail;"
        ],
        [
            0,
            "&larrfs;"
        ],
        [
            0,
            "&rarrfs;"
        ],
        [
            0,
            "&larrbfs;"
        ],
        [
            0,
            "&rarrbfs;"
        ],
        [
            2,
            "&nwarhk;"
        ],
        [
            0,
            "&nearhk;"
        ],
        [
            0,
            "&hksearow;"
        ],
        [
            0,
            "&hkswarow;"
        ],
        [
            0,
            "&nwnear;"
        ],
        [
            0,
            "&nesear;"
        ],
        [
            0,
            "&seswar;"
        ],
        [
            0,
            "&swnwar;"
        ],
        [
            8,
            {
                v: "&rarrc;",
                n: 824,
                o: "&nrarrc;"
            }
        ],
        [
            1,
            "&cudarrr;"
        ],
        [
            0,
            "&ldca;"
        ],
        [
            0,
            "&rdca;"
        ],
        [
            0,
            "&cudarrl;"
        ],
        [
            0,
            "&larrpl;"
        ],
        [
            2,
            "&curarrm;"
        ],
        [
            0,
            "&cularrp;"
        ],
        [
            7,
            "&rarrpl;"
        ],
        [
            2,
            "&harrcir;"
        ],
        [
            0,
            "&Uarrocir;"
        ],
        [
            0,
            "&lurdshar;"
        ],
        [
            0,
            "&ldrushar;"
        ],
        [
            2,
            "&LeftRightVector;"
        ],
        [
            0,
            "&RightUpDownVector;"
        ],
        [
            0,
            "&DownLeftRightVector;"
        ],
        [
            0,
            "&LeftUpDownVector;"
        ],
        [
            0,
            "&LeftVectorBar;"
        ],
        [
            0,
            "&RightVectorBar;"
        ],
        [
            0,
            "&RightUpVectorBar;"
        ],
        [
            0,
            "&RightDownVectorBar;"
        ],
        [
            0,
            "&DownLeftVectorBar;"
        ],
        [
            0,
            "&DownRightVectorBar;"
        ],
        [
            0,
            "&LeftUpVectorBar;"
        ],
        [
            0,
            "&LeftDownVectorBar;"
        ],
        [
            0,
            "&LeftTeeVector;"
        ],
        [
            0,
            "&RightTeeVector;"
        ],
        [
            0,
            "&RightUpTeeVector;"
        ],
        [
            0,
            "&RightDownTeeVector;"
        ],
        [
            0,
            "&DownLeftTeeVector;"
        ],
        [
            0,
            "&DownRightTeeVector;"
        ],
        [
            0,
            "&LeftUpTeeVector;"
        ],
        [
            0,
            "&LeftDownTeeVector;"
        ],
        [
            0,
            "&lHar;"
        ],
        [
            0,
            "&uHar;"
        ],
        [
            0,
            "&rHar;"
        ],
        [
            0,
            "&dHar;"
        ],
        [
            0,
            "&luruhar;"
        ],
        [
            0,
            "&ldrdhar;"
        ],
        [
            0,
            "&ruluhar;"
        ],
        [
            0,
            "&rdldhar;"
        ],
        [
            0,
            "&lharul;"
        ],
        [
            0,
            "&llhard;"
        ],
        [
            0,
            "&rharul;"
        ],
        [
            0,
            "&lrhard;"
        ],
        [
            0,
            "&udhar;"
        ],
        [
            0,
            "&duhar;"
        ],
        [
            0,
            "&RoundImplies;"
        ],
        [
            0,
            "&erarr;"
        ],
        [
            0,
            "&simrarr;"
        ],
        [
            0,
            "&larrsim;"
        ],
        [
            0,
            "&rarrsim;"
        ],
        [
            0,
            "&rarrap;"
        ],
        [
            0,
            "&ltlarr;"
        ],
        [
            1,
            "&gtrarr;"
        ],
        [
            0,
            "&subrarr;"
        ],
        [
            1,
            "&suplarr;"
        ],
        [
            0,
            "&lfisht;"
        ],
        [
            0,
            "&rfisht;"
        ],
        [
            0,
            "&ufisht;"
        ],
        [
            0,
            "&dfisht;"
        ],
        [
            5,
            "&lopar;"
        ],
        [
            0,
            "&ropar;"
        ],
        [
            4,
            "&lbrke;"
        ],
        [
            0,
            "&rbrke;"
        ],
        [
            0,
            "&lbrkslu;"
        ],
        [
            0,
            "&rbrksld;"
        ],
        [
            0,
            "&lbrksld;"
        ],
        [
            0,
            "&rbrkslu;"
        ],
        [
            0,
            "&langd;"
        ],
        [
            0,
            "&rangd;"
        ],
        [
            0,
            "&lparlt;"
        ],
        [
            0,
            "&rpargt;"
        ],
        [
            0,
            "&gtlPar;"
        ],
        [
            0,
            "&ltrPar;"
        ],
        [
            3,
            "&vzigzag;"
        ],
        [
            1,
            "&vangrt;"
        ],
        [
            0,
            "&angrtvbd;"
        ],
        [
            6,
            "&ange;"
        ],
        [
            0,
            "&range;"
        ],
        [
            0,
            "&dwangle;"
        ],
        [
            0,
            "&uwangle;"
        ],
        [
            0,
            "&angmsdaa;"
        ],
        [
            0,
            "&angmsdab;"
        ],
        [
            0,
            "&angmsdac;"
        ],
        [
            0,
            "&angmsdad;"
        ],
        [
            0,
            "&angmsdae;"
        ],
        [
            0,
            "&angmsdaf;"
        ],
        [
            0,
            "&angmsdag;"
        ],
        [
            0,
            "&angmsdah;"
        ],
        [
            0,
            "&bemptyv;"
        ],
        [
            0,
            "&demptyv;"
        ],
        [
            0,
            "&cemptyv;"
        ],
        [
            0,
            "&raemptyv;"
        ],
        [
            0,
            "&laemptyv;"
        ],
        [
            0,
            "&ohbar;"
        ],
        [
            0,
            "&omid;"
        ],
        [
            0,
            "&opar;"
        ],
        [
            1,
            "&operp;"
        ],
        [
            1,
            "&olcross;"
        ],
        [
            0,
            "&odsold;"
        ],
        [
            1,
            "&olcir;"
        ],
        [
            0,
            "&ofcir;"
        ],
        [
            0,
            "&olt;"
        ],
        [
            0,
            "&ogt;"
        ],
        [
            0,
            "&cirscir;"
        ],
        [
            0,
            "&cirE;"
        ],
        [
            0,
            "&solb;"
        ],
        [
            0,
            "&bsolb;"
        ],
        [
            3,
            "&boxbox;"
        ],
        [
            3,
            "&trisb;"
        ],
        [
            0,
            "&rtriltri;"
        ],
        [
            0,
            {
                v: "&LeftTriangleBar;",
                n: 824,
                o: "&NotLeftTriangleBar;"
            }
        ],
        [
            0,
            {
                v: "&RightTriangleBar;",
                n: 824,
                o: "&NotRightTriangleBar;"
            }
        ],
        [
            11,
            "&iinfin;"
        ],
        [
            0,
            "&infintie;"
        ],
        [
            0,
            "&nvinfin;"
        ],
        [
            4,
            "&eparsl;"
        ],
        [
            0,
            "&smeparsl;"
        ],
        [
            0,
            "&eqvparsl;"
        ],
        [
            5,
            "&blacklozenge;"
        ],
        [
            8,
            "&RuleDelayed;"
        ],
        [
            1,
            "&dsol;"
        ],
        [
            9,
            "&bigodot;"
        ],
        [
            0,
            "&bigoplus;"
        ],
        [
            0,
            "&bigotimes;"
        ],
        [
            1,
            "&biguplus;"
        ],
        [
            1,
            "&bigsqcup;"
        ],
        [
            5,
            "&iiiint;"
        ],
        [
            0,
            "&fpartint;"
        ],
        [
            2,
            "&cirfnint;"
        ],
        [
            0,
            "&awint;"
        ],
        [
            0,
            "&rppolint;"
        ],
        [
            0,
            "&scpolint;"
        ],
        [
            0,
            "&npolint;"
        ],
        [
            0,
            "&pointint;"
        ],
        [
            0,
            "&quatint;"
        ],
        [
            0,
            "&intlarhk;"
        ],
        [
            10,
            "&pluscir;"
        ],
        [
            0,
            "&plusacir;"
        ],
        [
            0,
            "&simplus;"
        ],
        [
            0,
            "&plusdu;"
        ],
        [
            0,
            "&plussim;"
        ],
        [
            0,
            "&plustwo;"
        ],
        [
            1,
            "&mcomma;"
        ],
        [
            0,
            "&minusdu;"
        ],
        [
            2,
            "&loplus;"
        ],
        [
            0,
            "&roplus;"
        ],
        [
            0,
            "&Cross;"
        ],
        [
            0,
            "&timesd;"
        ],
        [
            0,
            "&timesbar;"
        ],
        [
            1,
            "&smashp;"
        ],
        [
            0,
            "&lotimes;"
        ],
        [
            0,
            "&rotimes;"
        ],
        [
            0,
            "&otimesas;"
        ],
        [
            0,
            "&Otimes;"
        ],
        [
            0,
            "&odiv;"
        ],
        [
            0,
            "&triplus;"
        ],
        [
            0,
            "&triminus;"
        ],
        [
            0,
            "&tritime;"
        ],
        [
            0,
            "&intprod;"
        ],
        [
            2,
            "&amalg;"
        ],
        [
            0,
            "&capdot;"
        ],
        [
            1,
            "&ncup;"
        ],
        [
            0,
            "&ncap;"
        ],
        [
            0,
            "&capand;"
        ],
        [
            0,
            "&cupor;"
        ],
        [
            0,
            "&cupcap;"
        ],
        [
            0,
            "&capcup;"
        ],
        [
            0,
            "&cupbrcap;"
        ],
        [
            0,
            "&capbrcup;"
        ],
        [
            0,
            "&cupcup;"
        ],
        [
            0,
            "&capcap;"
        ],
        [
            0,
            "&ccups;"
        ],
        [
            0,
            "&ccaps;"
        ],
        [
            2,
            "&ccupssm;"
        ],
        [
            2,
            "&And;"
        ],
        [
            0,
            "&Or;"
        ],
        [
            0,
            "&andand;"
        ],
        [
            0,
            "&oror;"
        ],
        [
            0,
            "&orslope;"
        ],
        [
            0,
            "&andslope;"
        ],
        [
            1,
            "&andv;"
        ],
        [
            0,
            "&orv;"
        ],
        [
            0,
            "&andd;"
        ],
        [
            0,
            "&ord;"
        ],
        [
            1,
            "&wedbar;"
        ],
        [
            6,
            "&sdote;"
        ],
        [
            3,
            "&simdot;"
        ],
        [
            2,
            {
                v: "&congdot;",
                n: 824,
                o: "&ncongdot;"
            }
        ],
        [
            0,
            "&easter;"
        ],
        [
            0,
            "&apacir;"
        ],
        [
            0,
            {
                v: "&apE;",
                n: 824,
                o: "&napE;"
            }
        ],
        [
            0,
            "&eplus;"
        ],
        [
            0,
            "&pluse;"
        ],
        [
            0,
            "&Esim;"
        ],
        [
            0,
            "&Colone;"
        ],
        [
            0,
            "&Equal;"
        ],
        [
            1,
            "&ddotseq;"
        ],
        [
            0,
            "&equivDD;"
        ],
        [
            0,
            "&ltcir;"
        ],
        [
            0,
            "&gtcir;"
        ],
        [
            0,
            "&ltquest;"
        ],
        [
            0,
            "&gtquest;"
        ],
        [
            0,
            {
                v: "&leqslant;",
                n: 824,
                o: "&nleqslant;"
            }
        ],
        [
            0,
            {
                v: "&geqslant;",
                n: 824,
                o: "&ngeqslant;"
            }
        ],
        [
            0,
            "&lesdot;"
        ],
        [
            0,
            "&gesdot;"
        ],
        [
            0,
            "&lesdoto;"
        ],
        [
            0,
            "&gesdoto;"
        ],
        [
            0,
            "&lesdotor;"
        ],
        [
            0,
            "&gesdotol;"
        ],
        [
            0,
            "&lap;"
        ],
        [
            0,
            "&gap;"
        ],
        [
            0,
            "&lne;"
        ],
        [
            0,
            "&gne;"
        ],
        [
            0,
            "&lnap;"
        ],
        [
            0,
            "&gnap;"
        ],
        [
            0,
            "&lEg;"
        ],
        [
            0,
            "&gEl;"
        ],
        [
            0,
            "&lsime;"
        ],
        [
            0,
            "&gsime;"
        ],
        [
            0,
            "&lsimg;"
        ],
        [
            0,
            "&gsiml;"
        ],
        [
            0,
            "&lgE;"
        ],
        [
            0,
            "&glE;"
        ],
        [
            0,
            "&lesges;"
        ],
        [
            0,
            "&gesles;"
        ],
        [
            0,
            "&els;"
        ],
        [
            0,
            "&egs;"
        ],
        [
            0,
            "&elsdot;"
        ],
        [
            0,
            "&egsdot;"
        ],
        [
            0,
            "&el;"
        ],
        [
            0,
            "&eg;"
        ],
        [
            2,
            "&siml;"
        ],
        [
            0,
            "&simg;"
        ],
        [
            0,
            "&simlE;"
        ],
        [
            0,
            "&simgE;"
        ],
        [
            0,
            {
                v: "&LessLess;",
                n: 824,
                o: "&NotNestedLessLess;"
            }
        ],
        [
            0,
            {
                v: "&GreaterGreater;",
                n: 824,
                o: "&NotNestedGreaterGreater;"
            }
        ],
        [
            1,
            "&glj;"
        ],
        [
            0,
            "&gla;"
        ],
        [
            0,
            "&ltcc;"
        ],
        [
            0,
            "&gtcc;"
        ],
        [
            0,
            "&lescc;"
        ],
        [
            0,
            "&gescc;"
        ],
        [
            0,
            "&smt;"
        ],
        [
            0,
            "&lat;"
        ],
        [
            0,
            {
                v: "&smte;",
                n: 65024,
                o: "&smtes;"
            }
        ],
        [
            0,
            {
                v: "&late;",
                n: 65024,
                o: "&lates;"
            }
        ],
        [
            0,
            "&bumpE;"
        ],
        [
            0,
            {
                v: "&PrecedesEqual;",
                n: 824,
                o: "&NotPrecedesEqual;"
            }
        ],
        [
            0,
            {
                v: "&sce;",
                n: 824,
                o: "&NotSucceedsEqual;"
            }
        ],
        [
            2,
            "&prE;"
        ],
        [
            0,
            "&scE;"
        ],
        [
            0,
            "&precneqq;"
        ],
        [
            0,
            "&scnE;"
        ],
        [
            0,
            "&prap;"
        ],
        [
            0,
            "&scap;"
        ],
        [
            0,
            "&precnapprox;"
        ],
        [
            0,
            "&scnap;"
        ],
        [
            0,
            "&Pr;"
        ],
        [
            0,
            "&Sc;"
        ],
        [
            0,
            "&subdot;"
        ],
        [
            0,
            "&supdot;"
        ],
        [
            0,
            "&subplus;"
        ],
        [
            0,
            "&supplus;"
        ],
        [
            0,
            "&submult;"
        ],
        [
            0,
            "&supmult;"
        ],
        [
            0,
            "&subedot;"
        ],
        [
            0,
            "&supedot;"
        ],
        [
            0,
            {
                v: "&subE;",
                n: 824,
                o: "&nsubE;"
            }
        ],
        [
            0,
            {
                v: "&supE;",
                n: 824,
                o: "&nsupE;"
            }
        ],
        [
            0,
            "&subsim;"
        ],
        [
            0,
            "&supsim;"
        ],
        [
            2,
            {
                v: "&subnE;",
                n: 65024,
                o: "&varsubsetneqq;"
            }
        ],
        [
            0,
            {
                v: "&supnE;",
                n: 65024,
                o: "&varsupsetneqq;"
            }
        ],
        [
            2,
            "&csub;"
        ],
        [
            0,
            "&csup;"
        ],
        [
            0,
            "&csube;"
        ],
        [
            0,
            "&csupe;"
        ],
        [
            0,
            "&subsup;"
        ],
        [
            0,
            "&supsub;"
        ],
        [
            0,
            "&subsub;"
        ],
        [
            0,
            "&supsup;"
        ],
        [
            0,
            "&suphsub;"
        ],
        [
            0,
            "&supdsub;"
        ],
        [
            0,
            "&forkv;"
        ],
        [
            0,
            "&topfork;"
        ],
        [
            0,
            "&mlcp;"
        ],
        [
            8,
            "&Dashv;"
        ],
        [
            1,
            "&Vdashl;"
        ],
        [
            0,
            "&Barv;"
        ],
        [
            0,
            "&vBar;"
        ],
        [
            0,
            "&vBarv;"
        ],
        [
            1,
            "&Vbar;"
        ],
        [
            0,
            "&Not;"
        ],
        [
            0,
            "&bNot;"
        ],
        [
            0,
            "&rnmid;"
        ],
        [
            0,
            "&cirmid;"
        ],
        [
            0,
            "&midcir;"
        ],
        [
            0,
            "&topcir;"
        ],
        [
            0,
            "&nhpar;"
        ],
        [
            0,
            "&parsim;"
        ],
        [
            9,
            {
                v: "&parsl;",
                n: 8421,
                o: "&nparsl;"
            }
        ],
        [
            44343,
            {
                n: new Map(A0([
                    [
                        56476,
                        "&Ascr;"
                    ],
                    [
                        1,
                        "&Cscr;"
                    ],
                    [
                        0,
                        "&Dscr;"
                    ],
                    [
                        2,
                        "&Gscr;"
                    ],
                    [
                        2,
                        "&Jscr;"
                    ],
                    [
                        0,
                        "&Kscr;"
                    ],
                    [
                        2,
                        "&Nscr;"
                    ],
                    [
                        0,
                        "&Oscr;"
                    ],
                    [
                        0,
                        "&Pscr;"
                    ],
                    [
                        0,
                        "&Qscr;"
                    ],
                    [
                        1,
                        "&Sscr;"
                    ],
                    [
                        0,
                        "&Tscr;"
                    ],
                    [
                        0,
                        "&Uscr;"
                    ],
                    [
                        0,
                        "&Vscr;"
                    ],
                    [
                        0,
                        "&Wscr;"
                    ],
                    [
                        0,
                        "&Xscr;"
                    ],
                    [
                        0,
                        "&Yscr;"
                    ],
                    [
                        0,
                        "&Zscr;"
                    ],
                    [
                        0,
                        "&ascr;"
                    ],
                    [
                        0,
                        "&bscr;"
                    ],
                    [
                        0,
                        "&cscr;"
                    ],
                    [
                        0,
                        "&dscr;"
                    ],
                    [
                        1,
                        "&fscr;"
                    ],
                    [
                        1,
                        "&hscr;"
                    ],
                    [
                        0,
                        "&iscr;"
                    ],
                    [
                        0,
                        "&jscr;"
                    ],
                    [
                        0,
                        "&kscr;"
                    ],
                    [
                        0,
                        "&lscr;"
                    ],
                    [
                        0,
                        "&mscr;"
                    ],
                    [
                        0,
                        "&nscr;"
                    ],
                    [
                        1,
                        "&pscr;"
                    ],
                    [
                        0,
                        "&qscr;"
                    ],
                    [
                        0,
                        "&rscr;"
                    ],
                    [
                        0,
                        "&sscr;"
                    ],
                    [
                        0,
                        "&tscr;"
                    ],
                    [
                        0,
                        "&uscr;"
                    ],
                    [
                        0,
                        "&vscr;"
                    ],
                    [
                        0,
                        "&wscr;"
                    ],
                    [
                        0,
                        "&xscr;"
                    ],
                    [
                        0,
                        "&yscr;"
                    ],
                    [
                        0,
                        "&zscr;"
                    ],
                    [
                        52,
                        "&Afr;"
                    ],
                    [
                        0,
                        "&Bfr;"
                    ],
                    [
                        1,
                        "&Dfr;"
                    ],
                    [
                        0,
                        "&Efr;"
                    ],
                    [
                        0,
                        "&Ffr;"
                    ],
                    [
                        0,
                        "&Gfr;"
                    ],
                    [
                        2,
                        "&Jfr;"
                    ],
                    [
                        0,
                        "&Kfr;"
                    ],
                    [
                        0,
                        "&Lfr;"
                    ],
                    [
                        0,
                        "&Mfr;"
                    ],
                    [
                        0,
                        "&Nfr;"
                    ],
                    [
                        0,
                        "&Ofr;"
                    ],
                    [
                        0,
                        "&Pfr;"
                    ],
                    [
                        0,
                        "&Qfr;"
                    ],
                    [
                        1,
                        "&Sfr;"
                    ],
                    [
                        0,
                        "&Tfr;"
                    ],
                    [
                        0,
                        "&Ufr;"
                    ],
                    [
                        0,
                        "&Vfr;"
                    ],
                    [
                        0,
                        "&Wfr;"
                    ],
                    [
                        0,
                        "&Xfr;"
                    ],
                    [
                        0,
                        "&Yfr;"
                    ],
                    [
                        1,
                        "&afr;"
                    ],
                    [
                        0,
                        "&bfr;"
                    ],
                    [
                        0,
                        "&cfr;"
                    ],
                    [
                        0,
                        "&dfr;"
                    ],
                    [
                        0,
                        "&efr;"
                    ],
                    [
                        0,
                        "&ffr;"
                    ],
                    [
                        0,
                        "&gfr;"
                    ],
                    [
                        0,
                        "&hfr;"
                    ],
                    [
                        0,
                        "&ifr;"
                    ],
                    [
                        0,
                        "&jfr;"
                    ],
                    [
                        0,
                        "&kfr;"
                    ],
                    [
                        0,
                        "&lfr;"
                    ],
                    [
                        0,
                        "&mfr;"
                    ],
                    [
                        0,
                        "&nfr;"
                    ],
                    [
                        0,
                        "&ofr;"
                    ],
                    [
                        0,
                        "&pfr;"
                    ],
                    [
                        0,
                        "&qfr;"
                    ],
                    [
                        0,
                        "&rfr;"
                    ],
                    [
                        0,
                        "&sfr;"
                    ],
                    [
                        0,
                        "&tfr;"
                    ],
                    [
                        0,
                        "&ufr;"
                    ],
                    [
                        0,
                        "&vfr;"
                    ],
                    [
                        0,
                        "&wfr;"
                    ],
                    [
                        0,
                        "&xfr;"
                    ],
                    [
                        0,
                        "&yfr;"
                    ],
                    [
                        0,
                        "&zfr;"
                    ],
                    [
                        0,
                        "&Aopf;"
                    ],
                    [
                        0,
                        "&Bopf;"
                    ],
                    [
                        1,
                        "&Dopf;"
                    ],
                    [
                        0,
                        "&Eopf;"
                    ],
                    [
                        0,
                        "&Fopf;"
                    ],
                    [
                        0,
                        "&Gopf;"
                    ],
                    [
                        1,
                        "&Iopf;"
                    ],
                    [
                        0,
                        "&Jopf;"
                    ],
                    [
                        0,
                        "&Kopf;"
                    ],
                    [
                        0,
                        "&Lopf;"
                    ],
                    [
                        0,
                        "&Mopf;"
                    ],
                    [
                        1,
                        "&Oopf;"
                    ],
                    [
                        3,
                        "&Sopf;"
                    ],
                    [
                        0,
                        "&Topf;"
                    ],
                    [
                        0,
                        "&Uopf;"
                    ],
                    [
                        0,
                        "&Vopf;"
                    ],
                    [
                        0,
                        "&Wopf;"
                    ],
                    [
                        0,
                        "&Xopf;"
                    ],
                    [
                        0,
                        "&Yopf;"
                    ],
                    [
                        1,
                        "&aopf;"
                    ],
                    [
                        0,
                        "&bopf;"
                    ],
                    [
                        0,
                        "&copf;"
                    ],
                    [
                        0,
                        "&dopf;"
                    ],
                    [
                        0,
                        "&eopf;"
                    ],
                    [
                        0,
                        "&fopf;"
                    ],
                    [
                        0,
                        "&gopf;"
                    ],
                    [
                        0,
                        "&hopf;"
                    ],
                    [
                        0,
                        "&iopf;"
                    ],
                    [
                        0,
                        "&jopf;"
                    ],
                    [
                        0,
                        "&kopf;"
                    ],
                    [
                        0,
                        "&lopf;"
                    ],
                    [
                        0,
                        "&mopf;"
                    ],
                    [
                        0,
                        "&nopf;"
                    ],
                    [
                        0,
                        "&oopf;"
                    ],
                    [
                        0,
                        "&popf;"
                    ],
                    [
                        0,
                        "&qopf;"
                    ],
                    [
                        0,
                        "&ropf;"
                    ],
                    [
                        0,
                        "&sopf;"
                    ],
                    [
                        0,
                        "&topf;"
                    ],
                    [
                        0,
                        "&uopf;"
                    ],
                    [
                        0,
                        "&vopf;"
                    ],
                    [
                        0,
                        "&wopf;"
                    ],
                    [
                        0,
                        "&xopf;"
                    ],
                    [
                        0,
                        "&yopf;"
                    ],
                    [
                        0,
                        "&zopf;"
                    ]
                ]))
            }
        ],
        [
            8906,
            "&fflig;"
        ],
        [
            0,
            "&filig;"
        ],
        [
            0,
            "&fllig;"
        ],
        [
            0,
            "&ffilig;"
        ],
        [
            0,
            "&ffllig;"
        ]
    ]));
    var $I = new Map([
        [
            34,
            "&quot;"
        ],
        [
            38,
            "&amp;"
        ],
        [
            39,
            "&apos;"
        ],
        [
            60,
            "&lt;"
        ],
        [
            62,
            "&gt;"
        ]
    ]), UI = String.prototype.codePointAt != null ? (n, r)=>n.codePointAt(r) : (n, r)=>(n.charCodeAt(r) & 64512) === 55296 ? (n.charCodeAt(r) - 55296) * 1024 + n.charCodeAt(r + 1) - 56320 + 65536 : n.charCodeAt(r);
    function T_(n, r) {
        return function(t) {
            let a, o = 0, u = "";
            for(; a = n.exec(t);)o !== a.index && (u += t.substring(o, a.index)), u += r.get(a[0].charCodeAt(0)), o = a.index + 1;
            return u + t.substring(o);
        };
    }
    var KC = T_(/[&<>'"]/g, $I), YC = T_(/["&\u00A0]/g, new Map([
        [
            34,
            "&quot;"
        ],
        [
            38,
            "&amp;"
        ],
        [
            160,
            "&nbsp;"
        ]
    ])), XC = T_(/[&<>\u00A0]/g, new Map([
        [
            38,
            "&amp;"
        ],
        [
            60,
            "&lt;"
        ],
        [
            62,
            "&gt;"
        ],
        [
            160,
            "&nbsp;"
        ]
    ]));
    var ZC;
    (function(n) {
        n[n.XML = 0] = "XML", n[n.HTML = 1] = "HTML";
    })(ZC || (ZC = {}));
    var nE;
    (function(n) {
        n[n.UTF8 = 0] = "UTF8", n[n.ASCII = 1] = "ASCII", n[n.Extensive = 2] = "Extensive", n[n.Attribute = 3] = "Attribute", n[n.Text = 4] = "Text";
    })(nE || (nE = {}));
    function VI(n) {
        return Object.prototype.toString.call(n);
    }
    function I0(n) {
        return VI(n) === "[object String]";
    }
    var JI = Object.prototype.hasOwnProperty;
    function GI(n, r) {
        return JI.call(n, r);
    }
    function Ji(n) {
        return Array.prototype.slice.call(arguments, 1).forEach(function(e) {
            if (e) {
                if (typeof e != "object") throw new TypeError(e + "must be object");
                Object.keys(e).forEach(function(t) {
                    n[t] = e[t];
                });
            }
        }), n;
    }
    function F_(n, r, e) {
        return [].concat(n.slice(0, r), e, n.slice(r + 1));
    }
    function L0(n) {
        return !(n >= 55296 && n <= 57343 || n >= 64976 && n <= 65007 || (n & 65535) === 65535 || (n & 65535) === 65534 || n >= 0 && n <= 8 || n === 11 || n >= 14 && n <= 31 || n >= 127 && n <= 159 || n > 1114111);
    }
    function Gi(n) {
        if (n > 65535) {
            n -= 65536;
            let r = 55296 + (n >> 10), e = 56320 + (n & 1023);
            return String.fromCharCode(r, e);
        }
        return String.fromCharCode(n);
    }
    var tE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, jI = /&([a-z#][a-z0-9]{1,31});/gi, QI = new RegExp(tE.source + "|" + jI.source, "gi"), KI = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
    function YI(n, r) {
        if (r.charCodeAt(0) === 35 && KI.test(r)) {
            let t = r[1].toLowerCase() === "x" ? parseInt(r.slice(2), 16) : parseInt(r.slice(1), 10);
            return L0(t) ? Gi(t) : n;
        }
        let e = Vi(n);
        return e !== n ? e : n;
    }
    function XI(n) {
        return n.indexOf("\\") < 0 ? n : n.replace(tE, "$1");
    }
    function mo(n) {
        return n.indexOf("\\") < 0 && n.indexOf("&") < 0 ? n : n.replace(QI, function(r, e, t) {
            return e || YI(r, t);
        });
    }
    var ZI = /[&<>"]/, nL = /[&<>"]/g, rL = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;"
    };
    function eL(n) {
        return rL[n];
    }
    function _o(n) {
        return ZI.test(n) ? n.replace(nL, eL) : n;
    }
    var tL = /[.?*+^$[\]\\(){}|-]/g;
    function aL(n) {
        return n.replace(tL, "\\$&");
    }
    function fr(n) {
        switch(n){
            case 9:
            case 32:
                return !0;
        }
        return !1;
    }
    function Ou(n) {
        if (n >= 8192 && n <= 8202) return !0;
        switch(n){
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 32:
            case 160:
            case 5760:
            case 8239:
            case 8287:
            case 12288:
                return !0;
        }
        return !1;
    }
    function aE(n) {
        return zi.test(n) || F0.test(n);
    }
    function qu(n) {
        return aE(Gi(n));
    }
    function Wu(n) {
        switch(n){
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 43:
            case 44:
            case 45:
            case 46:
            case 47:
            case 58:
            case 59:
            case 60:
            case 61:
            case 62:
            case 63:
            case 64:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 123:
            case 124:
            case 125:
            case 126:
                return !0;
            default:
                return !1;
        }
    }
    function $u(n) {
        return n = n.trim().replace(/\s+/g, " "), "\u1E9E".toLowerCase() === "\u1E7E" && (n = n.replace(/ẞ/g, "\xDF")), n.toLowerCase().toUpperCase();
    }
    function eE(n) {
        return n === 32 || n === 9 || n === 10 || n === 13;
    }
    function Uu(n) {
        let r = 0;
        for(; r < n.length && eE(n.charCodeAt(r)); r++);
        let e = n.length - 1;
        for(; e >= r && eE(n.charCodeAt(e)); e--);
        return n.slice(r, e + 1);
    }
    var oL = {
        mdurl: E0,
        ucmicro: g_
    };
    var L_ = {};
    Dl(L_, {
        parseLinkDestination: ()=>A_,
        parseLinkLabel: ()=>x_,
        parseLinkTitle: ()=>I_
    });
    function x_(n, r, e) {
        let t, a, o, u, i = n.posMax, c = n.pos;
        for(n.pos = r + 1, t = 1; n.pos < i;){
            if (o = n.src.charCodeAt(n.pos), o === 93 && (t--, t === 0)) {
                a = !0;
                break;
            }
            if (u = n.pos, n.md.inline.skipToken(n), o === 91) {
                if (u === n.pos - 1) t++;
                else if (e) return n.pos = c, -1;
            }
        }
        let l = -1;
        return a && (l = n.pos), n.pos = c, l;
    }
    function A_(n, r, e) {
        let t, a = r, o = {
            ok: !1,
            pos: 0,
            str: ""
        };
        if (n.charCodeAt(a) === 60) {
            for(a++; a < e;){
                if (t = n.charCodeAt(a), t === 10 || t === 60) return o;
                if (t === 62) return o.pos = a + 1, o.str = mo(n.slice(r + 1, a)), o.ok = !0, o;
                if (t === 92 && a + 1 < e) {
                    a += 2;
                    continue;
                }
                a++;
            }
            return o;
        }
        let u = 0;
        for(; a < e && (t = n.charCodeAt(a), !(t === 32 || t < 32 || t === 127));){
            if (t === 92 && a + 1 < e) {
                if (n.charCodeAt(a + 1) === 32) break;
                a += 2;
                continue;
            }
            if (t === 40 && (u++, u > 32)) return o;
            if (t === 41) {
                if (u === 0) break;
                u--;
            }
            a++;
        }
        return r === a || u !== 0 || (o.str = mo(n.slice(r, a)), o.pos = a, o.ok = !0), o;
    }
    function I_(n, r, e, t) {
        let a, o = r, u = {
            ok: !1,
            can_continue: !1,
            pos: 0,
            str: "",
            marker: 0
        };
        if (t) u.str = t.str, u.marker = t.marker;
        else {
            if (o >= e) return u;
            let i = n.charCodeAt(o);
            if (i !== 34 && i !== 39 && i !== 40) return u;
            r++, o++, i === 40 && (i = 41), u.marker = i;
        }
        for(; o < e;){
            if (a = n.charCodeAt(o), a === u.marker) return u.pos = o + 1, u.str += mo(n.slice(r, o)), u.ok = !0, u;
            if (a === 40 && u.marker === 41) return u;
            a === 92 && o + 1 < e && o++, o++;
        }
        return u.can_continue = !0, u.str += mo(n.slice(r, o)), u;
    }
    var La = {};
    La.code_inline = function(n, r, e, t, a) {
        let o = n[r];
        return "<code" + a.renderAttrs(o) + ">" + _o(o.content) + "</code>";
    };
    La.code_block = function(n, r, e, t, a) {
        let o = n[r];
        return "<pre" + a.renderAttrs(o) + "><code>" + _o(n[r].content) + `</code></pre>
`;
    };
    La.fence = function(n, r, e, t, a) {
        let o = n[r], u = o.info ? mo(o.info).trim() : "", i = "", c = "";
        if (u) {
            let d = u.split(/(\s+)/g);
            i = d[0], c = d.slice(2).join("");
        }
        let l;
        if (e.highlight ? l = e.highlight(o.content, i, c) || _o(o.content) : l = _o(o.content), l.indexOf("<pre") === 0) return l + `
`;
        if (u) {
            let d = o.attrIndex("class"), m = o.attrs ? o.attrs.slice() : [];
            d < 0 ? m.push([
                "class",
                e.langPrefix + i
            ]) : (m[d] = m[d].slice(), m[d][1] += " " + e.langPrefix + i);
            let v = {
                attrs: m
            };
            return `<pre><code${a.renderAttrs(v)}>${l}</code></pre>
`;
        }
        return `<pre><code${a.renderAttrs(o)}>${l}</code></pre>
`;
    };
    La.image = function(n, r, e, t, a) {
        let o = n[r];
        return o.attrs[o.attrIndex("alt")][1] = a.renderInlineAsText(o.children, e, t), a.renderToken(n, r, e);
    };
    La.hardbreak = function(n, r, e) {
        return e.xhtmlOut ? `<br />
` : `<br>
`;
    };
    La.softbreak = function(n, r, e) {
        return e.breaks ? e.xhtmlOut ? `<br />
` : `<br>
` : `
`;
    };
    La.text = function(n, r) {
        return _o(n[r].content);
    };
    La.html_block = function(n, r) {
        return n[r].content;
    };
    La.html_inline = function(n, r) {
        return n[r].content;
    };
    function ji() {
        this.rules = Ji({}, La);
    }
    ji.prototype.renderAttrs = function(r) {
        let e, t, a;
        if (!r.attrs) return "";
        for(a = "", e = 0, t = r.attrs.length; e < t; e++)a += " " + _o(r.attrs[e][0]) + '="' + _o(r.attrs[e][1]) + '"';
        return a;
    };
    ji.prototype.renderToken = function(r, e, t) {
        let a = r[e], o = "";
        if (a.hidden) return "";
        a.block && a.nesting !== -1 && e && r[e - 1].hidden && (o += `
`), o += (a.nesting === -1 ? "</" : "<") + a.tag, o += this.renderAttrs(a), a.nesting === 0 && t.xhtmlOut && (o += " /");
        let u = !1;
        if (a.block && (u = !0, a.nesting === 1 && e + 1 < r.length)) {
            let i = r[e + 1];
            (i.type === "inline" || i.hidden || i.nesting === -1 && i.tag === a.tag) && (u = !1);
        }
        return o += u ? `>
` : ">", o;
    };
    ji.prototype.renderInline = function(n, r, e) {
        let t = "", a = this.rules;
        for(let o = 0, u = n.length; o < u; o++){
            let i = n[o].type;
            typeof a[i] < "u" ? t += a[i](n, o, r, e, this) : t += this.renderToken(n, o, r);
        }
        return t;
    };
    ji.prototype.renderInlineAsText = function(n, r, e) {
        let t = "";
        for(let a = 0, o = n.length; a < o; a++)switch(n[a].type){
            case "text":
                t += n[a].content;
                break;
            case "image":
                t += this.renderInlineAsText(n[a].children, r, e);
                break;
            case "html_inline":
            case "html_block":
                t += n[a].content;
                break;
            case "softbreak":
            case "hardbreak":
                t += `
`;
                break;
            default:
        }
        return t;
    };
    ji.prototype.render = function(n, r, e) {
        let t = "", a = this.rules;
        for(let o = 0, u = n.length; o < u; o++){
            let i = n[o].type;
            i === "inline" ? t += this.renderInline(n[o].children, r, e) : typeof a[i] < "u" ? t += a[i](n, o, r, e, this) : t += this.renderToken(n, o, r, e);
        }
        return t;
    };
    var oE = ji;
    function ta() {
        this.__rules__ = [], this.__cache__ = null;
    }
    ta.prototype.__find__ = function(n) {
        for(let r = 0; r < this.__rules__.length; r++)if (this.__rules__[r].name === n) return r;
        return -1;
    };
    ta.prototype.__compile__ = function() {
        let n = this, r = [
            ""
        ];
        n.__rules__.forEach(function(e) {
            e.enabled && e.alt.forEach(function(t) {
                r.indexOf(t) < 0 && r.push(t);
            });
        }), n.__cache__ = {}, r.forEach(function(e) {
            n.__cache__[e] = [], n.__rules__.forEach(function(t) {
                t.enabled && (e && t.alt.indexOf(e) < 0 || n.__cache__[e].push(t.fn));
            });
        });
    };
    ta.prototype.at = function(n, r, e) {
        let t = this.__find__(n), a = e || {};
        if (t === -1) throw new Error("Parser rule not found: " + n);
        this.__rules__[t].fn = r, this.__rules__[t].alt = a.alt || [], this.__cache__ = null;
    };
    ta.prototype.before = function(n, r, e, t) {
        let a = this.__find__(n), o = t || {};
        if (a === -1) throw new Error("Parser rule not found: " + n);
        this.__rules__.splice(a, 0, {
            name: r,
            enabled: !0,
            fn: e,
            alt: o.alt || []
        }), this.__cache__ = null;
    };
    ta.prototype.after = function(n, r, e, t) {
        let a = this.__find__(n), o = t || {};
        if (a === -1) throw new Error("Parser rule not found: " + n);
        this.__rules__.splice(a + 1, 0, {
            name: r,
            enabled: !0,
            fn: e,
            alt: o.alt || []
        }), this.__cache__ = null;
    };
    ta.prototype.push = function(n, r, e) {
        let t = e || {};
        this.__rules__.push({
            name: n,
            enabled: !0,
            fn: r,
            alt: t.alt || []
        }), this.__cache__ = null;
    };
    ta.prototype.enable = function(n, r) {
        Array.isArray(n) || (n = [
            n
        ]);
        let e = [];
        return n.forEach(function(t) {
            let a = this.__find__(t);
            if (a < 0) {
                if (r) return;
                throw new Error("Rules manager: invalid rule name " + t);
            }
            this.__rules__[a].enabled = !0, e.push(t);
        }, this), this.__cache__ = null, e;
    };
    ta.prototype.enableOnly = function(n, r) {
        Array.isArray(n) || (n = [
            n
        ]), this.__rules__.forEach(function(e) {
            e.enabled = !1;
        }), this.enable(n, r);
    };
    ta.prototype.disable = function(n, r) {
        Array.isArray(n) || (n = [
            n
        ]);
        let e = [];
        return n.forEach(function(t) {
            let a = this.__find__(t);
            if (a < 0) {
                if (r) return;
                throw new Error("Rules manager: invalid rule name " + t);
            }
            this.__rules__[a].enabled = !1, e.push(t);
        }, this), this.__cache__ = null, e;
    };
    ta.prototype.getRules = function(n) {
        return this.__cache__ === null && this.__compile__(), this.__cache__[n] || [];
    };
    var Bu = ta;
    function Qi(n, r, e) {
        this.type = n, this.tag = r, this.attrs = null, this.map = null, this.nesting = e, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
    }
    Qi.prototype.attrIndex = function(r) {
        if (!this.attrs) return -1;
        let e = this.attrs;
        for(let t = 0, a = e.length; t < a; t++)if (e[t][0] === r) return t;
        return -1;
    };
    Qi.prototype.attrPush = function(r) {
        this.attrs ? this.attrs.push(r) : this.attrs = [
            r
        ];
    };
    Qi.prototype.attrSet = function(r, e) {
        let t = this.attrIndex(r), a = [
            r,
            e
        ];
        t < 0 ? this.attrPush(a) : this.attrs[t] = a;
    };
    Qi.prototype.attrGet = function(r) {
        let e = this.attrIndex(r), t = null;
        return e >= 0 && (t = this.attrs[e][1]), t;
    };
    Qi.prototype.attrJoin = function(r, e) {
        let t = this.attrIndex(r);
        t < 0 ? this.attrPush([
            r,
            e
        ]) : this.attrs[t][1] = this.attrs[t][1] + " " + e;
    };
    var vo = Qi;
    function uE(n, r, e) {
        this.src = n, this.env = e, this.tokens = [], this.inlineMode = !1, this.md = r;
    }
    uE.prototype.Token = vo;
    var iE = uE;
    var uL = /\r\n?|\n/g, iL = /\0/g;
    function S_(n) {
        let r;
        r = n.src.replace(uL, `
`), r = r.replace(iL, "\uFFFD"), n.src = r;
    }
    function R_(n) {
        let r;
        n.inlineMode ? (r = new n.Token("inline", "", 0), r.content = n.src, r.map = [
            0,
            1
        ], r.children = [], n.tokens.push(r)) : n.md.block.parse(n.src, n.md, n.env, n.tokens);
    }
    function N_(n) {
        let r = n.tokens;
        for(let e = 0, t = r.length; e < t; e++){
            let a = r[e];
            a.type === "inline" && n.md.inline.parse(a.content, n.md, n.env, a.children);
        }
    }
    function fL(n) {
        return /^<a[>\s]/i.test(n);
    }
    function cL(n) {
        return /^<\/a\s*>/i.test(n);
    }
    function H_(n) {
        let r = n.tokens;
        if (n.md.options.linkify) for(let e = 0, t = r.length; e < t; e++){
            if (r[e].type !== "inline" || !n.md.linkify.pretest(r[e].content)) continue;
            let a = r[e].children, o = 0;
            for(let u = a.length - 1; u >= 0; u--){
                let i = a[u];
                if (i.type === "link_close") {
                    for(u--; a[u].level !== i.level && a[u].type !== "link_open";)u--;
                    continue;
                }
                if (i.type === "html_inline" && (fL(i.content) && o > 0 && o--, cL(i.content) && o++), !(o > 0) && i.type === "text" && n.md.linkify.test(i.content)) {
                    let c = i.content, l = n.md.linkify.match(c), d = [], m = i.level, v = 0;
                    l.length > 0 && l[0].index === 0 && u > 0 && a[u - 1].type === "text_special" && (l = l.slice(1));
                    for(let _ = 0; _ < l.length; _++){
                        let D = l[_].url, T = n.md.normalizeLink(D);
                        if (!n.md.validateLink(T)) continue;
                        let I = l[_].text;
                        l[_].schema ? l[_].schema === "mailto:" && !/^mailto:/i.test(I) ? I = n.md.normalizeLinkText("mailto:" + I).replace(/^mailto:/, "") : I = n.md.normalizeLinkText(I) : I = n.md.normalizeLinkText("http://" + I).replace(/^http:\/\//, "");
                        let $ = l[_].index;
                        if ($ > v) {
                            let x = new n.Token("text", "", 0);
                            x.content = c.slice(v, $), x.level = m, d.push(x);
                        }
                        let q = new n.Token("link_open", "a", 1);
                        q.attrs = [
                            [
                                "href",
                                T
                            ]
                        ], q.level = m++, q.markup = "linkify", q.info = "auto", d.push(q);
                        let z = new n.Token("text", "", 0);
                        z.content = I, z.level = m, d.push(z);
                        let S = new n.Token("link_close", "a", -1);
                        S.level = --m, S.markup = "linkify", S.info = "auto", d.push(S), v = l[_].lastIndex;
                    }
                    if (v < c.length) {
                        let _ = new n.Token("text", "", 0);
                        _.content = c.slice(v), _.level = m, d.push(_);
                    }
                    r[e].children = a = F_(a, u, d);
                }
            }
        }
    }
    var fE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, lL = /\((c|tm|r)\)/i, sL = /\((c|tm|r)\)/ig, pL = {
        c: "\xA9",
        r: "\xAE",
        tm: "\u2122"
    };
    function mL(n, r) {
        return pL[r.toLowerCase()];
    }
    function dL(n) {
        let r = 0;
        for(let e = n.length - 1; e >= 0; e--){
            let t = n[e];
            t.type === "text" && !r && (t.content = t.content.replace(sL, mL)), t.type === "link_open" && t.info === "auto" && r--, t.type === "link_close" && t.info === "auto" && r++;
        }
    }
    function _L(n) {
        let r = 0;
        for(let e = n.length - 1; e >= 0; e--){
            let t = n[e];
            t.type === "text" && !r && fE.test(t.content) && (t.content = t.content.replace(/\+-/g, "\xB1").replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014").replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013")), t.type === "link_open" && t.info === "auto" && r--, t.type === "link_close" && t.info === "auto" && r++;
        }
    }
    function P_(n) {
        let r;
        if (n.md.options.typographer) for(r = n.tokens.length - 1; r >= 0; r--)n.tokens[r].type === "inline" && (lL.test(n.tokens[r].content) && dL(n.tokens[r].children), fE.test(n.tokens[r].content) && _L(n.tokens[r].children));
    }
    var vL = /['"]/, cE = /['"]/g, lE = "\u2019";
    function S0(n, r, e, t) {
        n[r] || (n[r] = []), n[r].push({
            pos: e,
            ch: t
        });
    }
    function hL(n, r) {
        let e = "", t = 0;
        r.sort((a, o)=>a.pos - o.pos);
        for(let a = 0; a < r.length; a++){
            let o = r[a];
            e += n.slice(t, o.pos) + o.ch, t = o.pos + 1;
        }
        return e + n.slice(t);
    }
    function DL(n, r) {
        let e, t = [], a = {};
        for(let o = 0; o < n.length; o++){
            let u = n[o], i = n[o].level;
            for(e = t.length - 1; e >= 0 && !(t[e].level <= i); e--);
            if (t.length = e + 1, u.type !== "text") continue;
            let c = u.content, l = 0, d = c.length;
            n: for(; l < d;){
                cE.lastIndex = l;
                let m = cE.exec(c);
                if (!m) break;
                let v = !0, _ = !0;
                l = m.index + 1;
                let D = m[0] === "'", T = 32;
                if (m.index - 1 >= 0) T = c.charCodeAt(m.index - 1);
                else for(e = o - 1; e >= 0 && !(n[e].type === "softbreak" || n[e].type === "hardbreak"); e--)if (n[e].content) {
                    T = n[e].content.charCodeAt(n[e].content.length - 1);
                    break;
                }
                let I = 32;
                if (l < d) I = c.charCodeAt(l);
                else for(e = o + 1; e < n.length && !(n[e].type === "softbreak" || n[e].type === "hardbreak"); e++)if (n[e].content) {
                    I = n[e].content.charCodeAt(0);
                    break;
                }
                let $ = Wu(T) || qu(T), q = Wu(I) || qu(I), z = Ou(T), S = Ou(I);
                if (S ? v = !1 : q && (z || $ || (v = !1)), z ? _ = !1 : $ && (S || q || (_ = !1)), I === 34 && m[0] === '"' && T >= 48 && T <= 57 && (_ = v = !1), v && _ && (v = $, _ = q), !v && !_) {
                    D && S0(a, o, m.index, lE);
                    continue;
                }
                if (_) for(e = t.length - 1; e >= 0; e--){
                    let x = t[e];
                    if (t[e].level < i) break;
                    if (x.single === D && t[e].level === i) {
                        x = t[e];
                        let Y, Yn;
                        D ? (Y = r.md.options.quotes[2], Yn = r.md.options.quotes[3]) : (Y = r.md.options.quotes[0], Yn = r.md.options.quotes[1]), S0(a, o, m.index, Yn), S0(a, x.token, x.pos, Y), t.length = e;
                        continue n;
                    }
                }
                v ? t.push({
                    token: o,
                    pos: m.index,
                    single: D,
                    level: i
                }) : _ && D && S0(a, o, m.index, lE);
            }
        }
        Object.keys(a).forEach(function(o) {
            n[o].content = hL(n[o].content, a[o]);
        });
    }
    function k_(n) {
        if (n.md.options.typographer) for(let r = n.tokens.length - 1; r >= 0; r--)n.tokens[r].type !== "inline" || !vL.test(n.tokens[r].content) || DL(n.tokens[r].children, n);
    }
    function O_(n) {
        let r, e, t = n.tokens, a = t.length;
        for(let o = 0; o < a; o++){
            if (t[o].type !== "inline") continue;
            let u = t[o].children, i = u.length;
            for(r = 0; r < i; r++)u[r].type === "text_special" && (u[r].type = "text");
            for(r = e = 0; r < i; r++)u[r].type === "text" && r + 1 < i && u[r + 1].type === "text" ? u[r + 1].content = u[r].content + u[r + 1].content : (r !== e && (u[e] = u[r]), e++);
            r !== e && (u.length = e);
        }
    }
    var q_ = [
        [
            "normalize",
            S_
        ],
        [
            "block",
            R_
        ],
        [
            "inline",
            N_
        ],
        [
            "linkify",
            H_
        ],
        [
            "replacements",
            P_
        ],
        [
            "smartquotes",
            k_
        ],
        [
            "text_join",
            O_
        ]
    ];
    function W_() {
        this.ruler = new Bu;
        for(let n = 0; n < q_.length; n++)this.ruler.push(q_[n][0], q_[n][1]);
    }
    W_.prototype.process = function(n) {
        let r = this.ruler.getRules("");
        for(let e = 0, t = r.length; e < t; e++)r[e](n);
    };
    W_.prototype.State = iE;
    var sE = W_;
    function Sa(n, r, e, t) {
        this.src = n, this.md = r, this.env = e, this.tokens = t, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
        let a = this.src;
        for(let o = 0, u = 0, i = 0, c = 0, l = a.length, d = !1; u < l; u++){
            let m = a.charCodeAt(u);
            if (!d) {
                if (fr(m)) {
                    i++, m === 9 ? c += 4 - c % 4 : c++;
                    continue;
                } else d = !0;
            }
            (m === 10 || u === l - 1) && (m !== 10 && u++, this.bMarks.push(o), this.eMarks.push(u), this.tShift.push(i), this.sCount.push(c), this.bsCount.push(0), d = !1, i = 0, c = 0, o = u + 1);
        }
        this.bMarks.push(a.length), this.eMarks.push(a.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
    }
    Sa.prototype.push = function(n, r, e) {
        let t = new vo(n, r, e);
        return t.block = !0, e < 0 && this.level--, t.level = this.level, e > 0 && this.level++, this.tokens.push(t), t;
    };
    Sa.prototype.isEmpty = function(r) {
        return this.bMarks[r] + this.tShift[r] >= this.eMarks[r];
    };
    Sa.prototype.skipEmptyLines = function(r) {
        for(let e = this.lineMax; r < e && !(this.bMarks[r] + this.tShift[r] < this.eMarks[r]); r++);
        return r;
    };
    Sa.prototype.skipSpaces = function(r) {
        for(let e = this.src.length; r < e; r++){
            let t = this.src.charCodeAt(r);
            if (!fr(t)) break;
        }
        return r;
    };
    Sa.prototype.skipSpacesBack = function(r, e) {
        if (r <= e) return r;
        for(; r > e;)if (!fr(this.src.charCodeAt(--r))) return r + 1;
        return r;
    };
    Sa.prototype.skipChars = function(r, e) {
        for(let t = this.src.length; r < t && this.src.charCodeAt(r) === e; r++);
        return r;
    };
    Sa.prototype.skipCharsBack = function(r, e, t) {
        if (r <= t) return r;
        for(; r > t;)if (e !== this.src.charCodeAt(--r)) return r + 1;
        return r;
    };
    Sa.prototype.getLines = function(r, e, t, a) {
        if (r >= e) return "";
        let o = new Array(e - r);
        for(let u = 0, i = r; i < e; i++, u++){
            let c = 0, l = this.bMarks[i], d = l, m;
            for(i + 1 < e || a ? m = this.eMarks[i] + 1 : m = this.eMarks[i]; d < m && c < t;){
                let v = this.src.charCodeAt(d);
                if (fr(v)) v === 9 ? c += 4 - (c + this.bsCount[i]) % 4 : c++;
                else if (d - l < this.tShift[i]) c++;
                else break;
                d++;
            }
            c > t ? o[u] = new Array(c - t + 1).join(" ") + this.src.slice(d, m) : o[u] = this.src.slice(d, m);
        }
        return o.join("");
    };
    Sa.prototype.Token = vo;
    var pE = Sa;
    var gL = 65536;
    function $_(n, r) {
        let e = n.bMarks[r] + n.tShift[r], t = n.eMarks[r];
        return n.src.slice(e, t);
    }
    function mE(n) {
        let r = [], e = n.length, t = 0, a = n.charCodeAt(t), o = !1, u = 0, i = "";
        for(; t < e;)a === 124 && (o ? (i += n.substring(u, t - 1), u = t) : (r.push(i + n.substring(u, t)), i = "", u = t + 1)), o = a === 92, t++, a = n.charCodeAt(t);
        return r.push(i + n.substring(u)), r;
    }
    function U_(n, r, e, t) {
        if (r + 2 > e) return !1;
        let a = r + 1;
        if (n.sCount[a] < n.blkIndent || n.sCount[a] - n.blkIndent >= 4) return !1;
        let o = n.bMarks[a] + n.tShift[a];
        if (o >= n.eMarks[a]) return !1;
        let u = n.src.charCodeAt(o++);
        if (u !== 124 && u !== 45 && u !== 58 || o >= n.eMarks[a]) return !1;
        let i = n.src.charCodeAt(o++);
        if (i !== 124 && i !== 45 && i !== 58 && !fr(i) || u === 45 && fr(i)) return !1;
        for(; o < n.eMarks[a];){
            let S = n.src.charCodeAt(o);
            if (S !== 124 && S !== 45 && S !== 58 && !fr(S)) return !1;
            o++;
        }
        let c = $_(n, r + 1), l = c.split("|"), d = [];
        for(let S = 0; S < l.length; S++){
            let x = l[S].trim();
            if (!x) {
                if (S === 0 || S === l.length - 1) continue;
                return !1;
            }
            if (!/^:?-+:?$/.test(x)) return !1;
            x.charCodeAt(x.length - 1) === 58 ? d.push(x.charCodeAt(0) === 58 ? "center" : "right") : x.charCodeAt(0) === 58 ? d.push("left") : d.push("");
        }
        if (c = $_(n, r).trim(), c.indexOf("|") === -1 || n.sCount[r] - n.blkIndent >= 4) return !1;
        l = mE(c), l.length && l[0] === "" && l.shift(), l.length && l[l.length - 1] === "" && l.pop();
        let m = l.length;
        if (m === 0 || m !== d.length) return !1;
        if (t) return !0;
        let v = n.parentType;
        n.parentType = "table";
        let _ = n.md.block.ruler.getRules("blockquote"), D = n.push("table_open", "table", 1), T = [
            r,
            0
        ];
        D.map = T;
        let I = n.push("thead_open", "thead", 1);
        I.map = [
            r,
            r + 1
        ];
        let $ = n.push("tr_open", "tr", 1);
        $.map = [
            r,
            r + 1
        ];
        for(let S = 0; S < l.length; S++){
            let x = n.push("th_open", "th", 1);
            d[S] && (x.attrs = [
                [
                    "style",
                    "text-align:" + d[S]
                ]
            ]);
            let Y = n.push("inline", "", 0);
            Y.content = l[S].trim(), Y.children = [], n.push("th_close", "th", -1);
        }
        n.push("tr_close", "tr", -1), n.push("thead_close", "thead", -1);
        let q, z = 0;
        for(a = r + 2; a < e && !(n.sCount[a] < n.blkIndent); a++){
            let S = !1;
            for(let Y = 0, Yn = _.length; Y < Yn; Y++)if (_[Y](n, a, e, !0)) {
                S = !0;
                break;
            }
            if (S || (c = $_(n, a).trim(), !c) || n.sCount[a] - n.blkIndent >= 4 || (l = mE(c), l.length && l[0] === "" && l.shift(), l.length && l[l.length - 1] === "" && l.pop(), z += m - l.length, z > gL)) break;
            if (a === r + 2) {
                let Y = n.push("tbody_open", "tbody", 1);
                Y.map = q = [
                    r + 2,
                    0
                ];
            }
            let x = n.push("tr_open", "tr", 1);
            x.map = [
                a,
                a + 1
            ];
            for(let Y = 0; Y < m; Y++){
                let Yn = n.push("td_open", "td", 1);
                d[Y] && (Yn.attrs = [
                    [
                        "style",
                        "text-align:" + d[Y]
                    ]
                ]);
                let dr = n.push("inline", "", 0);
                dr.content = l[Y] ? l[Y].trim() : "", dr.children = [], n.push("td_close", "td", -1);
            }
            n.push("tr_close", "tr", -1);
        }
        return q && (n.push("tbody_close", "tbody", -1), q[1] = a), n.push("table_close", "table", -1), T[1] = a, n.parentType = v, n.line = a, !0;
    }
    function B_(n, r, e) {
        if (n.sCount[r] - n.blkIndent < 4) return !1;
        let t = r + 1, a = t;
        for(; t < e;){
            if (n.isEmpty(t)) {
                t++;
                continue;
            }
            if (n.sCount[t] - n.blkIndent >= 4) {
                t++, a = t;
                continue;
            }
            break;
        }
        n.line = a;
        let o = n.push("code_block", "code", 0);
        return o.content = n.getLines(r, a, 4 + n.blkIndent, !1) + `
`, o.map = [
            r,
            n.line
        ], !0;
    }
    function z_(n, r, e, t) {
        let a = n.bMarks[r] + n.tShift[r], o = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4 || a + 3 > o) return !1;
        let u = n.src.charCodeAt(a);
        if (u !== 126 && u !== 96) return !1;
        let i = a;
        a = n.skipChars(a, u);
        let c = a - i;
        if (c < 3) return !1;
        let l = n.src.slice(i, a), d = n.src.slice(a, o);
        if (u === 96 && d.indexOf(String.fromCharCode(u)) >= 0) return !1;
        if (t) return !0;
        let m = r, v = !1;
        for(; m++, !(m >= e || (a = i = n.bMarks[m] + n.tShift[m], o = n.eMarks[m], a < o && n.sCount[m] < n.blkIndent));)if (n.src.charCodeAt(a) === u && !(n.sCount[m] - n.blkIndent >= 4) && (a = n.skipChars(a, u), !(a - i < c) && (a = n.skipSpaces(a), !(a < o)))) {
            v = !0;
            break;
        }
        c = n.sCount[r], n.line = m + (v ? 1 : 0);
        let _ = n.push("fence", "code", 0);
        return _.info = d, _.content = n.getLines(r + 1, m, c, !0), _.markup = l, _.map = [
            r,
            n.line
        ], !0;
    }
    function V_(n, r, e, t) {
        let a = n.bMarks[r] + n.tShift[r], o = n.eMarks[r], u = n.lineMax;
        if (n.sCount[r] - n.blkIndent >= 4 || n.src.charCodeAt(a) !== 62) return !1;
        if (t) return !0;
        let i = [], c = [], l = [], d = [], m = n.md.block.ruler.getRules("blockquote"), v = n.parentType;
        n.parentType = "blockquote";
        let _ = !1, D;
        for(D = r; D < e; D++){
            let z = n.sCount[D] < n.blkIndent;
            if (a = n.bMarks[D] + n.tShift[D], o = n.eMarks[D], a >= o) break;
            if (n.src.charCodeAt(a++) === 62 && !z) {
                let x = n.sCount[D] + 1, Y, Yn;
                n.src.charCodeAt(a) === 32 ? (a++, x++, Yn = !1, Y = !0) : n.src.charCodeAt(a) === 9 ? (Y = !0, (n.bsCount[D] + x) % 4 === 3 ? (a++, x++, Yn = !1) : Yn = !0) : Y = !1;
                let dr = x;
                for(i.push(n.bMarks[D]), n.bMarks[D] = a; a < o;){
                    let cr = n.src.charCodeAt(a);
                    if (fr(cr)) cr === 9 ? dr += 4 - (dr + n.bsCount[D] + (Yn ? 1 : 0)) % 4 : dr++;
                    else break;
                    a++;
                }
                _ = a >= o, c.push(n.bsCount[D]), n.bsCount[D] = n.sCount[D] + 1 + (Y ? 1 : 0), l.push(n.sCount[D]), n.sCount[D] = dr - x, d.push(n.tShift[D]), n.tShift[D] = a - n.bMarks[D];
                continue;
            }
            if (_) break;
            let S = !1;
            for(let x = 0, Y = m.length; x < Y; x++)if (m[x](n, D, e, !0)) {
                S = !0;
                break;
            }
            if (S) {
                n.lineMax = D, n.blkIndent !== 0 && (i.push(n.bMarks[D]), c.push(n.bsCount[D]), d.push(n.tShift[D]), l.push(n.sCount[D]), n.sCount[D] -= n.blkIndent);
                break;
            }
            i.push(n.bMarks[D]), c.push(n.bsCount[D]), d.push(n.tShift[D]), l.push(n.sCount[D]), n.sCount[D] = -1;
        }
        let T = n.blkIndent;
        n.blkIndent = 0;
        let I = n.push("blockquote_open", "blockquote", 1);
        I.markup = ">";
        let $ = [
            r,
            0
        ];
        I.map = $, n.md.block.tokenize(n, r, D);
        let q = n.push("blockquote_close", "blockquote", -1);
        q.markup = ">", n.lineMax = u, n.parentType = v, $[1] = n.line;
        for(let z = 0; z < d.length; z++)n.bMarks[z + r] = i[z], n.tShift[z + r] = d[z], n.sCount[z + r] = l[z], n.bsCount[z + r] = c[z];
        return n.blkIndent = T, !0;
    }
    function J_(n, r, e, t) {
        let a = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4) return !1;
        let o = n.bMarks[r] + n.tShift[r], u = n.src.charCodeAt(o++);
        if (u !== 42 && u !== 45 && u !== 95) return !1;
        let i = 1;
        for(; o < a;){
            let l = n.src.charCodeAt(o++);
            if (l !== u && !fr(l)) return !1;
            l === u && i++;
        }
        if (i < 3) return !1;
        if (t) return !0;
        n.line = r + 1;
        let c = n.push("hr", "hr", 0);
        return c.map = [
            r,
            n.line
        ], c.markup = Array(i + 1).join(String.fromCharCode(u)), !0;
    }
    function dE(n, r) {
        let e = n.eMarks[r], t = n.bMarks[r] + n.tShift[r], a = n.src.charCodeAt(t++);
        if (a !== 42 && a !== 45 && a !== 43) return -1;
        if (t < e) {
            let o = n.src.charCodeAt(t);
            if (!fr(o)) return -1;
        }
        return t;
    }
    function _E(n, r) {
        let e = n.bMarks[r] + n.tShift[r], t = n.eMarks[r], a = e;
        if (a + 1 >= t) return -1;
        let o = n.src.charCodeAt(a++);
        if (o < 48 || o > 57) return -1;
        for(;;){
            if (a >= t) return -1;
            if (o = n.src.charCodeAt(a++), o >= 48 && o <= 57) {
                if (a - e >= 10) return -1;
                continue;
            }
            if (o === 41 || o === 46) break;
            return -1;
        }
        return a < t && (o = n.src.charCodeAt(a), !fr(o)) ? -1 : a;
    }
    function bL(n, r) {
        let e = n.level + 2;
        for(let t = r + 2, a = n.tokens.length - 2; t < a; t++)n.tokens[t].level === e && n.tokens[t].type === "paragraph_open" && (n.tokens[t + 2].hidden = !0, n.tokens[t].hidden = !0, t += 2);
    }
    function G_(n, r, e, t) {
        let a, o, u, i, c = r, l = !0;
        if (n.sCount[c] - n.blkIndent >= 4 || n.listIndent >= 0 && n.sCount[c] - n.listIndent >= 4 && n.sCount[c] < n.blkIndent) return !1;
        let d = !1;
        t && n.parentType === "paragraph" && n.sCount[c] >= n.blkIndent && (d = !0);
        let m, v, _;
        if ((_ = _E(n, c)) >= 0) {
            if (m = !0, u = n.bMarks[c] + n.tShift[c], v = Number(n.src.slice(u, _ - 1)), d && v !== 1) return !1;
        } else if ((_ = dE(n, c)) >= 0) m = !1;
        else return !1;
        if (d && n.skipSpaces(_) >= n.eMarks[c]) return !1;
        if (t) return !0;
        let D = n.src.charCodeAt(_ - 1), T = n.tokens.length;
        m ? (i = n.push("ordered_list_open", "ol", 1), v !== 1 && (i.attrs = [
            [
                "start",
                v
            ]
        ])) : i = n.push("bullet_list_open", "ul", 1);
        let I = [
            c,
            0
        ];
        i.map = I, i.markup = String.fromCharCode(D);
        let $ = !1, q = n.md.block.ruler.getRules("list"), z = n.parentType;
        for(n.parentType = "list"; c < e;){
            o = _, a = n.eMarks[c];
            let S = n.sCount[c] + _ - (n.bMarks[c] + n.tShift[c]), x = S;
            for(; o < a;){
                let Vr = n.src.charCodeAt(o);
                if (Vr === 9) x += 4 - (x + n.bsCount[c]) % 4;
                else if (Vr === 32) x++;
                else break;
                o++;
            }
            let Y = o, Yn;
            Y >= a ? Yn = 1 : Yn = x - S, Yn > 4 && (Yn = 1);
            let dr = S + Yn;
            i = n.push("list_item_open", "li", 1), i.markup = String.fromCharCode(D);
            let cr = [
                c,
                0
            ];
            i.map = cr, m && (i.info = n.src.slice(u, _ - 1));
            let Xr = n.tight, te = n.tShift[c], fa = n.sCount[c], Te = n.listIndent;
            if (n.listIndent = n.blkIndent, n.blkIndent = dr, n.tight = !0, n.tShift[c] = Y - n.bMarks[c], n.sCount[c] = x, Y >= a && n.isEmpty(c + 1) ? n.line = Math.min(n.line + 2, e) : n.md.block.tokenize(n, c, e, !0), (!n.tight || $) && (l = !1), $ = n.line - c > 1 && n.isEmpty(n.line - 1), n.blkIndent = n.listIndent, n.listIndent = Te, n.tShift[c] = te, n.sCount[c] = fa, n.tight = Xr, i = n.push("list_item_close", "li", -1), i.markup = String.fromCharCode(D), c = n.line, cr[1] = c, c >= e || n.sCount[c] < n.blkIndent || n.sCount[c] - n.blkIndent >= 4) break;
            let Fr = !1;
            for(let Vr = 0, Er = q.length; Vr < Er; Vr++)if (q[Vr](n, c, e, !0)) {
                Fr = !0;
                break;
            }
            if (Fr) break;
            if (m) {
                if (_ = _E(n, c), _ < 0) break;
                u = n.bMarks[c] + n.tShift[c];
            } else if (_ = dE(n, c), _ < 0) break;
            if (D !== n.src.charCodeAt(_ - 1)) break;
        }
        return m ? i = n.push("ordered_list_close", "ol", -1) : i = n.push("bullet_list_close", "ul", -1), i.markup = String.fromCharCode(D), I[1] = c, n.line = c, n.parentType = z, l && bL(n, T), !0;
    }
    function j_(n, r, e, t) {
        let a = n.bMarks[r] + n.tShift[r], o = n.eMarks[r], u = r + 1;
        if (n.sCount[r] - n.blkIndent >= 4 || n.src.charCodeAt(a) !== 91) return !1;
        function i(q) {
            let z = n.lineMax;
            if (q >= z || n.isEmpty(q)) return null;
            let S = !1;
            if (n.sCount[q] - n.blkIndent > 3 && (S = !0), n.sCount[q] < 0 && (S = !0), !S) {
                let Yn = n.md.block.ruler.getRules("reference"), dr = n.parentType;
                n.parentType = "reference";
                let cr = !1;
                for(let Xr = 0, te = Yn.length; Xr < te; Xr++)if (Yn[Xr](n, q, z, !0)) {
                    cr = !0;
                    break;
                }
                if (n.parentType = dr, cr) return null;
            }
            let x = n.bMarks[q] + n.tShift[q], Y = n.eMarks[q];
            return n.src.slice(x, Y + 1);
        }
        let c = n.src.slice(a, o + 1);
        o = c.length;
        let l = -1;
        for(a = 1; a < o; a++){
            let q = c.charCodeAt(a);
            if (q === 91) return !1;
            if (q === 93) {
                l = a;
                break;
            } else if (q === 10) {
                let z = i(u);
                z !== null && (c += z, o = c.length, u++);
            } else if (q === 92 && (a++, a < o && c.charCodeAt(a) === 10)) {
                let z = i(u);
                z !== null && (c += z, o = c.length, u++);
            }
        }
        if (l < 0 || c.charCodeAt(l + 1) !== 58) return !1;
        for(a = l + 2; a < o; a++){
            let q = c.charCodeAt(a);
            if (q === 10) {
                let z = i(u);
                z !== null && (c += z, o = c.length, u++);
            } else if (!fr(q)) break;
        }
        let d = n.md.helpers.parseLinkDestination(c, a, o);
        if (!d.ok) return !1;
        let m = n.md.normalizeLink(d.str);
        if (!n.md.validateLink(m)) return !1;
        a = d.pos;
        let v = a, _ = u, D = a;
        for(; a < o; a++){
            let q = c.charCodeAt(a);
            if (q === 10) {
                let z = i(u);
                z !== null && (c += z, o = c.length, u++);
            } else if (!fr(q)) break;
        }
        let T = n.md.helpers.parseLinkTitle(c, a, o);
        for(; T.can_continue;){
            let q = i(u);
            if (q === null) break;
            c += q, a = o, o = c.length, u++, T = n.md.helpers.parseLinkTitle(c, a, o, T);
        }
        let I;
        for(a < o && D !== a && T.ok ? (I = T.str, a = T.pos) : (I = "", a = v, u = _); a < o;){
            let q = c.charCodeAt(a);
            if (!fr(q)) break;
            a++;
        }
        if (a < o && c.charCodeAt(a) !== 10 && I) for(I = "", a = v, u = _; a < o;){
            let q = c.charCodeAt(a);
            if (!fr(q)) break;
            a++;
        }
        if (a < o && c.charCodeAt(a) !== 10) return !1;
        let $ = $u(c.slice(1, l));
        return $ ? (t || (typeof n.env.references > "u" && (n.env.references = {}), typeof n.env.references[$] > "u" && (n.env.references[$] = {
            title: I,
            href: m
        }), n.line = u), !0) : !1;
    }
    var vE = [
        "address",
        "article",
        "aside",
        "base",
        "basefont",
        "blockquote",
        "body",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "html",
        "iframe",
        "legend",
        "li",
        "link",
        "main",
        "menu",
        "menuitem",
        "nav",
        "noframes",
        "ol",
        "optgroup",
        "option",
        "p",
        "param",
        "search",
        "section",
        "summary",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul"
    ];
    var yL = "[a-zA-Z_:][a-zA-Z0-9:._-]*", CL = "[^\"'=<>`\\x00-\\x20]+", EL = "'[^']*'", TL = '"[^"]*"', ML = "(?:" + CL + "|" + EL + "|" + TL + ")", FL = "(?:\\s+" + yL + "(?:\\s*=\\s*" + ML + ")?)", hE = "<[A-Za-z][A-Za-z0-9\\-]*" + FL + "*\\s*\\/?>", DE = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", wL = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", xL = "<[?][\\s\\S]*?[?]>", AL = "<![A-Za-z][^>]*>", IL = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", gE = new RegExp("^(?:" + hE + "|" + DE + "|" + wL + "|" + xL + "|" + AL + "|" + IL + ")"), bE = new RegExp("^(?:" + hE + "|" + DE + ")");
    var zu = [
        [
            /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
            /<\/(script|pre|style|textarea)>/i,
            !0
        ],
        [
            /^<!--/,
            /-->/,
            !0
        ],
        [
            /^<\?/,
            /\?>/,
            !0
        ],
        [
            /^<![A-Z]/,
            />/,
            !0
        ],
        [
            /^<!\[CDATA\[/,
            /\]\]>/,
            !0
        ],
        [
            new RegExp("^</?(" + vE.join("|") + ")(?=(\\s|/?>|$))", "i"),
            /^$/,
            !0
        ],
        [
            new RegExp(bE.source + "\\s*$"),
            /^$/,
            !1
        ]
    ];
    function Q_(n, r, e, t) {
        let a = n.bMarks[r] + n.tShift[r], o = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4 || !n.md.options.html || n.src.charCodeAt(a) !== 60) return !1;
        let u = n.src.slice(a, o), i = 0;
        for(; i < zu.length && !zu[i][0].test(u); i++);
        if (i === zu.length) return !1;
        if (t) return zu[i][2];
        let c = r + 1, l = zu[i][1].test("");
        if (!zu[i][1].test(u)) {
            for(; c < e && !(n.sCount[c] < n.blkIndent && (l || !n.isEmpty(c))); c++)if (a = n.bMarks[c] + n.tShift[c], o = n.eMarks[c], u = n.src.slice(a, o), zu[i][1].test(u)) {
                u.length !== 0 && c++;
                break;
            }
        }
        n.line = c;
        let d = n.push("html_block", "", 0);
        return d.map = [
            r,
            c
        ], d.content = n.getLines(r, c, n.blkIndent, !0), !0;
    }
    function K_(n, r, e, t) {
        let a = n.bMarks[r] + n.tShift[r], o = n.eMarks[r];
        if (n.sCount[r] - n.blkIndent >= 4) return !1;
        let u = n.src.charCodeAt(a);
        if (u !== 35 || a >= o) return !1;
        let i = 1;
        for(u = n.src.charCodeAt(++a); u === 35 && a < o && i <= 6;)i++, u = n.src.charCodeAt(++a);
        if (i > 6 || a < o && !fr(u)) return !1;
        if (t) return !0;
        o = n.skipSpacesBack(o, a);
        let c = n.skipCharsBack(o, 35, a);
        c > a && fr(n.src.charCodeAt(c - 1)) && (o = c), n.line = r + 1;
        let l = n.push("heading_open", "h" + String(i), 1);
        l.markup = "########".slice(0, i), l.map = [
            r,
            n.line
        ];
        let d = n.push("inline", "", 0);
        d.content = Uu(n.src.slice(a, o)), d.map = [
            r,
            n.line
        ], d.children = [];
        let m = n.push("heading_close", "h" + String(i), -1);
        return m.markup = "########".slice(0, i), !0;
    }
    function Y_(n, r, e) {
        let t = n.md.block.ruler.getRules("paragraph");
        if (n.sCount[r] - n.blkIndent >= 4) return !1;
        let a = n.parentType;
        n.parentType = "paragraph";
        let o = 0, u, i = r + 1;
        for(; i < e && !n.isEmpty(i); i++){
            if (n.sCount[i] - n.blkIndent > 3) continue;
            if (n.sCount[i] >= n.blkIndent) {
                let _ = n.bMarks[i] + n.tShift[i], D = n.eMarks[i];
                if (_ < D && (u = n.src.charCodeAt(_), (u === 45 || u === 61) && (_ = n.skipChars(_, u), _ = n.skipSpaces(_), _ >= D))) {
                    o = u === 61 ? 1 : 2;
                    break;
                }
            }
            if (n.sCount[i] < 0) continue;
            let v = !1;
            for(let _ = 0, D = t.length; _ < D; _++)if (t[_](n, i, e, !0)) {
                v = !0;
                break;
            }
            if (v) break;
        }
        if (!o) return n.parentType = a, !1;
        let c = Uu(n.getLines(r, i, n.blkIndent, !1));
        n.line = i + 1;
        let l = n.push("heading_open", "h" + String(o), 1);
        l.markup = String.fromCharCode(u), l.map = [
            r,
            n.line
        ];
        let d = n.push("inline", "", 0);
        d.content = c, d.map = [
            r,
            n.line - 1
        ], d.children = [];
        let m = n.push("heading_close", "h" + String(o), -1);
        return m.markup = String.fromCharCode(u), n.parentType = a, !0;
    }
    function X_(n, r, e) {
        let t = n.md.block.ruler.getRules("paragraph"), a = n.parentType, o = r + 1;
        for(n.parentType = "paragraph"; o < e && !n.isEmpty(o); o++){
            if (n.sCount[o] - n.blkIndent > 3 || n.sCount[o] < 0) continue;
            let l = !1;
            for(let d = 0, m = t.length; d < m; d++)if (t[d](n, o, e, !0)) {
                l = !0;
                break;
            }
            if (l) break;
        }
        let u = Uu(n.getLines(r, o, n.blkIndent, !1));
        n.line = o;
        let i = n.push("paragraph_open", "p", 1);
        i.map = [
            r,
            n.line
        ];
        let c = n.push("inline", "", 0);
        return c.content = u, c.map = [
            r,
            n.line
        ], c.children = [], n.push("paragraph_close", "p", -1), n.parentType = a, !0;
    }
    var R0 = [
        [
            "table",
            U_,
            [
                "paragraph",
                "reference"
            ]
        ],
        [
            "code",
            B_
        ],
        [
            "fence",
            z_,
            [
                "paragraph",
                "reference",
                "blockquote",
                "list"
            ]
        ],
        [
            "blockquote",
            V_,
            [
                "paragraph",
                "reference",
                "blockquote",
                "list"
            ]
        ],
        [
            "hr",
            J_,
            [
                "paragraph",
                "reference",
                "blockquote",
                "list"
            ]
        ],
        [
            "list",
            G_,
            [
                "paragraph",
                "reference",
                "blockquote"
            ]
        ],
        [
            "reference",
            j_
        ],
        [
            "html_block",
            Q_,
            [
                "paragraph",
                "reference",
                "blockquote"
            ]
        ],
        [
            "heading",
            K_,
            [
                "paragraph",
                "reference",
                "blockquote"
            ]
        ],
        [
            "lheading",
            Y_
        ],
        [
            "paragraph",
            X_
        ]
    ];
    function N0() {
        this.ruler = new Bu;
        for(let n = 0; n < R0.length; n++)this.ruler.push(R0[n][0], R0[n][1], {
            alt: (R0[n][2] || []).slice()
        });
    }
    N0.prototype.tokenize = function(n, r, e) {
        let t = this.ruler.getRules(""), a = t.length, o = n.md.options.maxNesting, u = r, i = !1;
        for(; u < e && (n.line = u = n.skipEmptyLines(u), !(u >= e || n.sCount[u] < n.blkIndent));){
            if (n.level >= o) {
                n.line = e;
                break;
            }
            let c = n.line, l = !1;
            for(let d = 0; d < a; d++)if (l = t[d](n, u, e, !1), l) {
                if (c >= n.line) throw new Error("block rule didn't increment state.line");
                break;
            }
            if (!l) throw new Error("none of the block rules matched");
            n.tight = !i, n.isEmpty(n.line - 1) && (i = !0), u = n.line, u < e && n.isEmpty(u) && (i = !0, u++, n.line = u);
        }
    };
    N0.prototype.parse = function(n, r, e, t) {
        if (!n) return;
        let a = new this.State(n, r, e, t);
        this.tokenize(a, a.line, a.lineMax);
    };
    N0.prototype.State = pE;
    var yE = N0;
    function zc(n, r, e, t) {
        this.src = n, this.env = e, this.md = r, this.tokens = t, this.tokens_meta = Array(t.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
    }
    zc.prototype.pushPending = function() {
        let n = new vo("text", "", 0);
        return n.content = this.pending, n.level = this.pendingLevel, this.tokens.push(n), this.pending = "", n;
    };
    zc.prototype.push = function(n, r, e) {
        this.pending && this.pushPending();
        let t = new vo(n, r, e), a = null;
        return e < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), t.level = this.level, e > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], a = {
            delimiters: this.delimiters
        }), this.pendingLevel = this.level, this.tokens.push(t), this.tokens_meta.push(a), t;
    };
    zc.prototype.scanDelims = function(n, r) {
        let e = this.posMax, t = this.src.charCodeAt(n), a;
        if (n === 0) a = 32;
        else if (n === 1) a = this.src.charCodeAt(0), (a & 63488) === 55296 && (a = 65533);
        else if (a = this.src.charCodeAt(n - 1), (a & 64512) === 56320) {
            let I = this.src.charCodeAt(n - 2);
            a = (I & 64512) === 55296 ? 65536 + (I - 55296 << 10) + (a - 56320) : 65533;
        } else (a & 64512) === 55296 && (a = 65533);
        let o = n;
        for(; o < e && this.src.charCodeAt(o) === t;)o++;
        let u = o - n, i = o < e ? this.src.charCodeAt(o) : 32;
        if ((i & 64512) === 55296) {
            let I = this.src.charCodeAt(o + 1);
            i = (I & 64512) === 56320 ? 65536 + (i - 55296 << 10) + (I - 56320) : 65533;
        } else (i & 64512) === 56320 && (i = 65533);
        let c = Wu(a) || qu(a), l = Wu(i) || qu(i), d = Ou(a), m = Ou(i), v = !m && (!l || d || c), _ = !d && (!c || m || l);
        return {
            can_open: v && (r || !_ || c),
            can_close: _ && (r || !v || l),
            length: u
        };
    };
    zc.prototype.Token = vo;
    var CE = zc;
    function LL(n) {
        switch(n){
            case 10:
            case 33:
            case 35:
            case 36:
            case 37:
            case 38:
            case 42:
            case 43:
            case 45:
            case 58:
            case 60:
            case 61:
            case 62:
            case 64:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 123:
            case 125:
            case 126:
                return !0;
            default:
                return !1;
        }
    }
    function Z_(n, r) {
        let e = n.pos;
        for(; e < n.posMax && !LL(n.src.charCodeAt(e));)e++;
        return e === n.pos ? !1 : (r || (n.pending += n.src.slice(n.pos, e)), n.pos = e, !0);
    }
    var SL = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
    function nv(n, r) {
        if (!n.md.options.linkify || n.linkLevel > 0) return !1;
        let e = n.pos, t = n.posMax;
        if (e + 3 > t || n.src.charCodeAt(e) !== 58 || n.src.charCodeAt(e + 1) !== 47 || n.src.charCodeAt(e + 2) !== 47) return !1;
        let a = n.pending.match(SL);
        if (!a) return !1;
        let o = a[1], u = n.md.linkify.matchAtStart(n.src.slice(e - o.length));
        if (!u) return !1;
        let i = u.url;
        if (i.length <= o.length) return !1;
        let c = i.length;
        for(; c > 0 && i.charCodeAt(c - 1) === 42;)c--;
        c !== i.length && (i = i.slice(0, c));
        let l = n.md.normalizeLink(i);
        if (!n.md.validateLink(l)) return !1;
        if (!r) {
            n.pending = n.pending.slice(0, -o.length);
            let d = n.push("link_open", "a", 1);
            d.attrs = [
                [
                    "href",
                    l
                ]
            ], d.markup = "linkify", d.info = "auto";
            let m = n.push("text", "", 0);
            m.content = n.md.normalizeLinkText(i);
            let v = n.push("link_close", "a", -1);
            v.markup = "linkify", v.info = "auto";
        }
        return n.pos += i.length - o.length, !0;
    }
    function rv(n, r) {
        let e = n.pos;
        if (n.src.charCodeAt(e) !== 10) return !1;
        let t = n.pending.length - 1, a = n.posMax;
        if (!r) {
            if (t >= 0 && n.pending.charCodeAt(t) === 32) {
                if (t >= 1 && n.pending.charCodeAt(t - 1) === 32) {
                    let o = t - 1;
                    for(; o >= 1 && n.pending.charCodeAt(o - 1) === 32;)o--;
                    n.pending = n.pending.slice(0, o), n.push("hardbreak", "br", 0);
                } else n.pending = n.pending.slice(0, -1), n.push("softbreak", "br", 0);
            } else n.push("softbreak", "br", 0);
        }
        for(e++; e < a && fr(n.src.charCodeAt(e));)e++;
        return n.pos = e, !0;
    }
    var ev = [];
    for(let n = 0; n < 256; n++)ev.push(0);
    "\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(n) {
        ev[n.charCodeAt(0)] = 1;
    });
    function tv(n, r) {
        let e = n.pos, t = n.posMax;
        if (n.src.charCodeAt(e) !== 92 || (e++, e >= t)) return !1;
        let a = n.src.charCodeAt(e);
        if (a === 10) {
            for(r || n.push("hardbreak", "br", 0), e++; e < t && (a = n.src.charCodeAt(e), !!fr(a));)e++;
            return n.pos = e, !0;
        }
        let o = n.src[e];
        if (a >= 55296 && a <= 56319 && e + 1 < t) {
            let i = n.src.charCodeAt(e + 1);
            i >= 56320 && i <= 57343 && (o += n.src[e + 1], e++);
        }
        let u = "\\" + o;
        if (!r) {
            let i = n.push("text_special", "", 0);
            a < 256 && ev[a] !== 0 ? i.content = o : i.content = u, i.markup = u, i.info = "escape";
        }
        return n.pos = e + 1, !0;
    }
    function av(n, r) {
        let e = n.pos;
        if (n.src.charCodeAt(e) !== 96) return !1;
        let a = e;
        e++;
        let o = n.posMax;
        for(; e < o && n.src.charCodeAt(e) === 96;)e++;
        let u = n.src.slice(a, e), i = u.length;
        if (n.backticksScanned && (n.backticks[i] || 0) <= a) return r || (n.pending += u), n.pos += i, !0;
        let c = e, l;
        for(; (l = n.src.indexOf("`", c)) !== -1;){
            for(c = l + 1; c < o && n.src.charCodeAt(c) === 96;)c++;
            let d = c - l;
            if (d === i) {
                if (!r) {
                    let m = n.push("code_inline", "code", 0);
                    m.markup = u, m.content = n.src.slice(e, l).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
                }
                return n.pos = c, !0;
            }
            n.backticks[d] = l;
        }
        return n.backticksScanned = !0, r || (n.pending += u), n.pos += i, !0;
    }
    function RL(n, r) {
        let e = n.pos, t = n.src.charCodeAt(e);
        if (r || t !== 126) return !1;
        let a = n.scanDelims(n.pos, !0), o = a.length, u = String.fromCharCode(t);
        if (o < 2) return !1;
        let i;
        o % 2 && (i = n.push("text", "", 0), i.content = u, o--);
        for(let c = 0; c < o; c += 2)i = n.push("text", "", 0), i.content = u + u, n.delimiters.push({
            marker: t,
            length: 0,
            token: n.tokens.length - 1,
            end: -1,
            open: a.can_open,
            close: a.can_close
        });
        return n.pos += a.length, !0;
    }
    function EE(n, r) {
        let e, t = [], a = r.length;
        for(let o = 0; o < a; o++){
            let u = r[o];
            if (u.marker !== 126 || u.end === -1) continue;
            let i = r[u.end];
            e = n.tokens[u.token], e.type = "s_open", e.tag = "s", e.nesting = 1, e.markup = "~~", e.content = "", e = n.tokens[i.token], e.type = "s_close", e.tag = "s", e.nesting = -1, e.markup = "~~", e.content = "", n.tokens[i.token - 1].type === "text" && n.tokens[i.token - 1].content === "~" && t.push(i.token - 1);
        }
        for(; t.length;){
            let o = t.pop(), u = o + 1;
            for(; u < n.tokens.length && n.tokens[u].type === "s_close";)u++;
            u--, o !== u && (e = n.tokens[u], n.tokens[u] = n.tokens[o], n.tokens[o] = e);
        }
    }
    function NL(n) {
        let r = n.tokens_meta, e = n.tokens_meta.length;
        EE(n, n.delimiters);
        for(let t = 0; t < e; t++)r[t] && r[t].delimiters && EE(n, r[t].delimiters);
    }
    var ov = {
        tokenize: RL,
        postProcess: NL
    };
    function HL(n, r) {
        let e = n.pos, t = n.src.charCodeAt(e);
        if (r || t !== 95 && t !== 42) return !1;
        let a = n.scanDelims(n.pos, t === 42);
        for(let o = 0; o < a.length; o++){
            let u = n.push("text", "", 0);
            u.content = String.fromCharCode(t), n.delimiters.push({
                marker: t,
                length: a.length,
                token: n.tokens.length - 1,
                end: -1,
                open: a.can_open,
                close: a.can_close
            });
        }
        return n.pos += a.length, !0;
    }
    function TE(n, r) {
        let e = r.length;
        for(let t = e - 1; t >= 0; t--){
            let a = r[t];
            if (a.marker !== 95 && a.marker !== 42 || a.end === -1) continue;
            let o = r[a.end], u = t > 0 && r[t - 1].end === a.end + 1 && r[t - 1].marker === a.marker && r[t - 1].token === a.token - 1 && r[a.end + 1].token === o.token + 1, i = String.fromCharCode(a.marker), c = n.tokens[a.token];
            c.type = u ? "strong_open" : "em_open", c.tag = u ? "strong" : "em", c.nesting = 1, c.markup = u ? i + i : i, c.content = "";
            let l = n.tokens[o.token];
            l.type = u ? "strong_close" : "em_close", l.tag = u ? "strong" : "em", l.nesting = -1, l.markup = u ? i + i : i, l.content = "", u && (n.tokens[r[t - 1].token].content = "", n.tokens[r[a.end + 1].token].content = "", t--);
        }
    }
    function PL(n) {
        let r = n.tokens_meta, e = n.tokens_meta.length;
        TE(n, n.delimiters);
        for(let t = 0; t < e; t++)r[t] && r[t].delimiters && TE(n, r[t].delimiters);
    }
    var uv = {
        tokenize: HL,
        postProcess: PL
    };
    function iv(n, r) {
        let e, t, a, o, u = "", i = "", c = n.pos, l = !0;
        if (n.src.charCodeAt(n.pos) !== 91) return !1;
        let d = n.pos, m = n.posMax, v = n.pos + 1, _ = n.md.helpers.parseLinkLabel(n, n.pos, !0);
        if (_ < 0) return !1;
        let D = _ + 1;
        if (D < m && n.src.charCodeAt(D) === 40) {
            for(l = !1, D++; D < m && (e = n.src.charCodeAt(D), !(!fr(e) && e !== 10)); D++);
            if (D >= m) return !1;
            if (c = D, a = n.md.helpers.parseLinkDestination(n.src, D, n.posMax), a.ok) {
                for(u = n.md.normalizeLink(a.str), n.md.validateLink(u) ? D = a.pos : u = "", c = D; D < m && (e = n.src.charCodeAt(D), !(!fr(e) && e !== 10)); D++);
                if (a = n.md.helpers.parseLinkTitle(n.src, D, n.posMax), D < m && c !== D && a.ok) for(i = a.str, D = a.pos; D < m && (e = n.src.charCodeAt(D), !(!fr(e) && e !== 10)); D++);
            }
            (D >= m || n.src.charCodeAt(D) !== 41) && (l = !0), D++;
        }
        if (l) {
            if (typeof n.env.references > "u") return !1;
            if (D < m && n.src.charCodeAt(D) === 91 ? (c = D + 1, D = n.md.helpers.parseLinkLabel(n, D), D >= 0 ? t = n.src.slice(c, D++) : D = _ + 1) : D = _ + 1, t || (t = n.src.slice(v, _)), o = n.env.references[$u(t)], !o) return n.pos = d, !1;
            u = o.href, i = o.title;
        }
        if (!r) {
            n.pos = v, n.posMax = _;
            let T = n.push("link_open", "a", 1), I = [
                [
                    "href",
                    u
                ]
            ];
            T.attrs = I, i && I.push([
                "title",
                i
            ]), n.linkLevel++, n.md.inline.tokenize(n), n.linkLevel--, n.push("link_close", "a", -1);
        }
        return n.pos = D, n.posMax = m, !0;
    }
    function fv(n, r) {
        let e, t, a, o, u, i, c, l, d = "", m = n.pos, v = n.posMax;
        if (n.src.charCodeAt(n.pos) !== 33 || n.src.charCodeAt(n.pos + 1) !== 91) return !1;
        let _ = n.pos + 2, D = n.md.helpers.parseLinkLabel(n, n.pos + 1, !1);
        if (D < 0) return !1;
        if (o = D + 1, o < v && n.src.charCodeAt(o) === 40) {
            for(o++; o < v && (e = n.src.charCodeAt(o), !(!fr(e) && e !== 10)); o++);
            if (o >= v) return !1;
            for(l = o, i = n.md.helpers.parseLinkDestination(n.src, o, n.posMax), i.ok && (d = n.md.normalizeLink(i.str), n.md.validateLink(d) ? o = i.pos : d = ""), l = o; o < v && (e = n.src.charCodeAt(o), !(!fr(e) && e !== 10)); o++);
            if (i = n.md.helpers.parseLinkTitle(n.src, o, n.posMax), o < v && l !== o && i.ok) for(c = i.str, o = i.pos; o < v && (e = n.src.charCodeAt(o), !(!fr(e) && e !== 10)); o++);
            else c = "";
            if (o >= v || n.src.charCodeAt(o) !== 41) return n.pos = m, !1;
            o++;
        } else {
            if (typeof n.env.references > "u") return !1;
            if (o < v && n.src.charCodeAt(o) === 91 ? (l = o + 1, o = n.md.helpers.parseLinkLabel(n, o), o >= 0 ? a = n.src.slice(l, o++) : o = D + 1) : o = D + 1, a || (a = n.src.slice(_, D)), u = n.env.references[$u(a)], !u) return n.pos = m, !1;
            d = u.href, c = u.title;
        }
        if (!r) {
            t = n.src.slice(_, D);
            let T = [];
            n.md.inline.parse(t, n.md, n.env, T);
            let I = n.push("image", "img", 0), $ = [
                [
                    "src",
                    d
                ],
                [
                    "alt",
                    ""
                ]
            ];
            I.attrs = $, I.children = T, I.content = t, c && $.push([
                "title",
                c
            ]);
        }
        return n.pos = o, n.posMax = v, !0;
    }
    var kL = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, OL = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
    function cv(n, r) {
        let e = n.pos;
        if (n.src.charCodeAt(e) !== 60) return !1;
        let t = n.pos, a = n.posMax;
        for(;;){
            if (++e >= a) return !1;
            let u = n.src.charCodeAt(e);
            if (u === 60) return !1;
            if (u === 62) break;
        }
        let o = n.src.slice(t + 1, e);
        if (OL.test(o)) {
            let u = n.md.normalizeLink(o);
            if (!n.md.validateLink(u)) return !1;
            if (!r) {
                let i = n.push("link_open", "a", 1);
                i.attrs = [
                    [
                        "href",
                        u
                    ]
                ], i.markup = "autolink", i.info = "auto";
                let c = n.push("text", "", 0);
                c.content = n.md.normalizeLinkText(o);
                let l = n.push("link_close", "a", -1);
                l.markup = "autolink", l.info = "auto";
            }
            return n.pos += o.length + 2, !0;
        }
        if (kL.test(o)) {
            let u = n.md.normalizeLink("mailto:" + o);
            if (!n.md.validateLink(u)) return !1;
            if (!r) {
                let i = n.push("link_open", "a", 1);
                i.attrs = [
                    [
                        "href",
                        u
                    ]
                ], i.markup = "autolink", i.info = "auto";
                let c = n.push("text", "", 0);
                c.content = n.md.normalizeLinkText(o);
                let l = n.push("link_close", "a", -1);
                l.markup = "autolink", l.info = "auto";
            }
            return n.pos += o.length + 2, !0;
        }
        return !1;
    }
    function qL(n) {
        return /^<a[>\s]/i.test(n);
    }
    function WL(n) {
        return /^<\/a\s*>/i.test(n);
    }
    function $L(n) {
        let r = n | 32;
        return r >= 97 && r <= 122;
    }
    function lv(n, r) {
        if (!n.md.options.html) return !1;
        let e = n.posMax, t = n.pos;
        if (n.src.charCodeAt(t) !== 60 || t + 2 >= e) return !1;
        let a = n.src.charCodeAt(t + 1);
        if (a !== 33 && a !== 63 && a !== 47 && !$L(a)) return !1;
        let o = n.src.slice(t).match(gE);
        if (!o) return !1;
        if (!r) {
            let u = n.push("html_inline", "", 0);
            u.content = o[0], qL(u.content) && n.linkLevel++, WL(u.content) && n.linkLevel--;
        }
        return n.pos += o[0].length, !0;
    }
    var UL = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, BL = /^&([a-z][a-z0-9]{1,31});/i;
    function sv(n, r) {
        let e = n.pos, t = n.posMax;
        if (n.src.charCodeAt(e) !== 38 || e + 1 >= t) return !1;
        if (n.src.charCodeAt(e + 1) === 35) {
            let o = n.src.slice(e).match(UL);
            if (o) {
                if (!r) {
                    let u = o[1][0].toLowerCase() === "x" ? parseInt(o[1].slice(1), 16) : parseInt(o[1], 10), i = n.push("text_special", "", 0);
                    i.content = L0(u) ? Gi(u) : Gi(65533), i.markup = o[0], i.info = "entity";
                }
                return n.pos += o[0].length, !0;
            }
        } else {
            let o = n.src.slice(e).match(BL);
            if (o) {
                let u = Bc(o[0]);
                if (u !== o[0]) {
                    if (!r) {
                        let i = n.push("text_special", "", 0);
                        i.content = u, i.markup = o[0], i.info = "entity";
                    }
                    return n.pos += o[0].length, !0;
                }
            }
        }
        return !1;
    }
    function ME(n) {
        let r = {}, e = n.length;
        if (!e) return;
        let t = 0, a = -2, o = [];
        for(let u = 0; u < e; u++){
            let i = n[u];
            if (o.push(0), (n[t].marker !== i.marker || a !== i.token - 1) && (t = u), a = i.token, i.length = i.length || 0, !i.close) continue;
            r.hasOwnProperty(i.marker) || (r[i.marker] = [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ]);
            let c = r[i.marker][(i.open ? 3 : 0) + i.length % 3], l = t - o[t] - 1, d = l;
            for(; l > c; l -= o[l] + 1){
                let m = n[l];
                if (m.marker === i.marker && m.open && m.end < 0) {
                    let v = !1;
                    if ((m.close || i.open) && (m.length + i.length) % 3 === 0 && (m.length % 3 !== 0 || i.length % 3 !== 0) && (v = !0), !v) {
                        let _ = l > 0 && !n[l - 1].open ? o[l - 1] + 1 : 0;
                        o[u] = u - l + _, o[l] = _, i.open = !1, m.end = u, m.close = !1, d = -1, a = -2;
                        break;
                    }
                }
            }
            d !== -1 && (r[i.marker][(i.open ? 3 : 0) + (i.length || 0) % 3] = d);
        }
    }
    function pv(n) {
        let r = n.tokens_meta, e = n.tokens_meta.length;
        ME(n.delimiters);
        for(let t = 0; t < e; t++)r[t] && r[t].delimiters && ME(r[t].delimiters);
    }
    function mv(n) {
        let r, e, t = 0, a = n.tokens, o = n.tokens.length;
        for(r = e = 0; r < o; r++)a[r].nesting < 0 && t--, a[r].level = t, a[r].nesting > 0 && t++, a[r].type === "text" && r + 1 < o && a[r + 1].type === "text" ? a[r + 1].content = a[r].content + a[r + 1].content : (r !== e && (a[e] = a[r]), e++);
        r !== e && (a.length = e);
    }
    var dv = [
        [
            "text",
            Z_
        ],
        [
            "linkify",
            nv
        ],
        [
            "newline",
            rv
        ],
        [
            "escape",
            tv
        ],
        [
            "backticks",
            av
        ],
        [
            "strikethrough",
            ov.tokenize
        ],
        [
            "emphasis",
            uv.tokenize
        ],
        [
            "link",
            iv
        ],
        [
            "image",
            fv
        ],
        [
            "autolink",
            cv
        ],
        [
            "html_inline",
            lv
        ],
        [
            "entity",
            sv
        ]
    ], _v = [
        [
            "balance_pairs",
            pv
        ],
        [
            "strikethrough",
            ov.postProcess
        ],
        [
            "emphasis",
            uv.postProcess
        ],
        [
            "fragments_join",
            mv
        ]
    ];
    function Vc() {
        this.ruler = new Bu;
        for(let n = 0; n < dv.length; n++)this.ruler.push(dv[n][0], dv[n][1]);
        this.ruler2 = new Bu;
        for(let n = 0; n < _v.length; n++)this.ruler2.push(_v[n][0], _v[n][1]);
    }
    Vc.prototype.skipToken = function(n) {
        let r = n.pos, e = this.ruler.getRules(""), t = e.length, a = n.md.options.maxNesting, o = n.cache;
        if (typeof o[r] < "u") {
            n.pos = o[r];
            return;
        }
        let u = !1;
        if (n.level < a) {
            for(let i = 0; i < t; i++)if (n.level++, u = e[i](n, !0), n.level--, u) {
                if (r >= n.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        } else n.pos = n.posMax;
        u || n.pos++, o[r] = n.pos;
    };
    Vc.prototype.tokenize = function(n) {
        let r = this.ruler.getRules(""), e = r.length, t = n.posMax, a = n.md.options.maxNesting;
        for(; n.pos < t;){
            let o = n.pos, u = !1;
            if (n.level < a) {
                for(let i = 0; i < e; i++)if (u = r[i](n, !1), u) {
                    if (o >= n.pos) throw new Error("inline rule didn't increment state.pos");
                    break;
                }
            }
            if (u) {
                if (n.pos >= t) break;
                continue;
            }
            n.pending += n.src[n.pos++];
        }
        n.pending && n.pushPending();
    };
    Vc.prototype.parse = function(n, r, e, t) {
        let a = new this.State(n, r, e, t);
        this.tokenize(a);
        let o = this.ruler2.getRules(""), u = o.length;
        for(let i = 0; i < u; i++)o[i](a);
    };
    Vc.prototype.State = CE;
    var FE = Vc;
    function wE(n) {
        let r = {};
        n = n || {}, r.src_Any = T0.source, r.src_Cc = M0.source, r.src_Z = w0.source, r.src_P = zi.source, r.src_ZPCc = [
            r.src_Z,
            r.src_P,
            r.src_Cc
        ].join("|"), r.src_ZCc = [
            r.src_Z,
            r.src_Cc
        ].join("|");
        let e = "[><\uFF5C]";
        return r.src_pseudo_letter = "(?:(?!" + e + "|" + r.src_ZPCc + ")" + r.src_Any + ")", r.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", r.src_auth = "(?:(?:(?!" + r.src_ZCc + "|[@/\\[\\]()]).)+@)?", r.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", r.src_host_terminator = "(?=$|" + e + "|" + r.src_ZPCc + ")(?!" + (n["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + r.src_ZPCc + "))", r.src_path = "(?:[/?#](?:(?!" + r.src_ZCc + "|" + e + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + r.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + r.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + r.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + r.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + r.src_ZCc + "|[']).)+\\'|\\'(?=" + r.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + r.src_ZCc + "|[.]|$)|" + (n["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + r.src_ZCc + "|$)|;(?!" + r.src_ZCc + "|$)|\\!+(?!" + r.src_ZCc + "|[!]|$)|\\?(?!" + r.src_ZCc + "|[?]|$))+|\\/)?", r.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', r.src_xn = "xn--[a-z0-9\\-]{1,59}", r.src_domain_root = "(?:" + r.src_xn + "|" + r.src_pseudo_letter + "{1,63})", r.src_domain = "(?:" + r.src_xn + "|(?:" + r.src_pseudo_letter + ")|(?:" + r.src_pseudo_letter + "(?:-|" + r.src_pseudo_letter + "){0,61}" + r.src_pseudo_letter + "))", r.src_host = "(?:(?:(?:(?:" + r.src_domain + ")\\.)*" + r.src_domain + "))", r.tpl_host_fuzzy = "(?:" + r.src_ip4 + "|(?:(?:(?:" + r.src_domain + ")\\.)+(?:%TLDS%)))", r.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + r.src_domain + ")\\.)+(?:%TLDS%))", r.src_host_strict = r.src_host + r.src_host_terminator, r.tpl_host_fuzzy_strict = r.tpl_host_fuzzy + r.src_host_terminator, r.src_host_port_strict = r.src_host + r.src_port + r.src_host_terminator, r.tpl_host_port_fuzzy_strict = r.tpl_host_fuzzy + r.src_port + r.src_host_terminator, r.tpl_host_port_no_ip_fuzzy_strict = r.tpl_host_no_ip_fuzzy + r.src_port + r.src_host_terminator, r.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + r.src_ZPCc + "|>|$))", r.tpl_email_fuzzy = "(^|" + e + '|"|\\(|' + r.src_ZCc + ")(" + r.src_email_name + "@" + r.tpl_host_fuzzy_strict + ")", r.tpl_link_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + r.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + r.tpl_host_port_fuzzy_strict + r.src_path + ")", r.tpl_link_no_ip_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + r.src_ZPCc + "))((?![$+<=>^`|\uFF5C])" + r.tpl_host_port_no_ip_fuzzy_strict + r.src_path + ")", r;
    }
    function vv(n) {
        return Array.prototype.slice.call(arguments, 1).forEach(function(e) {
            e && Object.keys(e).forEach(function(t) {
                n[t] = e[t];
            });
        }), n;
    }
    function P0(n) {
        return Object.prototype.toString.call(n);
    }
    function zL(n) {
        return P0(n) === "[object String]";
    }
    function VL(n) {
        return P0(n) === "[object Object]";
    }
    function JL(n) {
        return P0(n) === "[object RegExp]";
    }
    function xE(n) {
        return P0(n) === "[object Function]";
    }
    function GL(n) {
        return n.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
    }
    var IE = {
        fuzzyLink: !0,
        fuzzyEmail: !0,
        fuzzyIP: !1
    };
    function jL(n) {
        return Object.keys(n || {}).reduce(function(r, e) {
            return r || IE.hasOwnProperty(e);
        }, !1);
    }
    var QL = {
        "http:": {
            validate: function(n, r, e) {
                let t = n.slice(r);
                return e.re.http || (e.re.http = new RegExp("^\\/\\/" + e.re.src_auth + e.re.src_host_port_strict + e.re.src_path, "i")), e.re.http.test(t) ? t.match(e.re.http)[0].length : 0;
            }
        },
        "https:": "http:",
        "ftp:": "http:",
        "//": {
            validate: function(n, r, e) {
                let t = n.slice(r);
                return e.re.no_http || (e.re.no_http = new RegExp("^" + e.re.src_auth + "(?:localhost|(?:(?:" + e.re.src_domain + ")\\.)+" + e.re.src_domain_root + ")" + e.re.src_port + e.re.src_host_terminator + e.re.src_path, "i")), e.re.no_http.test(t) ? r >= 3 && n[r - 3] === ":" || r >= 3 && n[r - 3] === "/" ? 0 : t.match(e.re.no_http)[0].length : 0;
            }
        },
        "mailto:": {
            validate: function(n, r, e) {
                let t = n.slice(r);
                return e.re.mailto || (e.re.mailto = new RegExp("^" + e.re.src_email_name + "@" + e.re.src_host_strict, "i")), e.re.mailto.test(t) ? t.match(e.re.mailto)[0].length : 0;
            }
        }
    }, KL = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", YL = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
    function XL(n) {
        return function(r, e) {
            let t = r.slice(e);
            return n.test(t) ? t.match(n)[0].length : 0;
        };
    }
    function AE() {
        return function(n, r) {
            r.normalize(n);
        };
    }
    function H0(n) {
        let r = n.re = wE(n.__opts__), e = n.__tlds__.slice();
        n.onCompile(), n.__tlds_replaced__ || e.push(KL), e.push(r.src_xn), r.src_tlds = e.join("|");
        function t(i) {
            return i.replace("%TLDS%", r.src_tlds);
        }
        r.email_fuzzy = RegExp(t(r.tpl_email_fuzzy), "i"), r.email_fuzzy_global = RegExp(t(r.tpl_email_fuzzy), "ig"), r.link_fuzzy = RegExp(t(r.tpl_link_fuzzy), "i"), r.link_fuzzy_global = RegExp(t(r.tpl_link_fuzzy), "ig"), r.link_no_ip_fuzzy = RegExp(t(r.tpl_link_no_ip_fuzzy), "i"), r.link_no_ip_fuzzy_global = RegExp(t(r.tpl_link_no_ip_fuzzy), "ig"), r.host_fuzzy_test = RegExp(t(r.tpl_host_fuzzy_test), "i");
        let a = [];
        n.__compiled__ = {};
        function o(i, c) {
            throw new Error('(LinkifyIt) Invalid schema "' + i + '": ' + c);
        }
        Object.keys(n.__schemas__).forEach(function(i) {
            let c = n.__schemas__[i];
            if (c === null) return;
            let l = {
                validate: null,
                link: null
            };
            if (n.__compiled__[i] = l, VL(c)) {
                JL(c.validate) ? l.validate = XL(c.validate) : xE(c.validate) ? l.validate = c.validate : o(i, c), xE(c.normalize) ? l.normalize = c.normalize : c.normalize ? o(i, c) : l.normalize = AE();
                return;
            }
            if (zL(c)) {
                a.push(i);
                return;
            }
            o(i, c);
        }), a.forEach(function(i) {
            n.__compiled__[n.__schemas__[i]] && (n.__compiled__[i].validate = n.__compiled__[n.__schemas__[i]].validate, n.__compiled__[i].normalize = n.__compiled__[n.__schemas__[i]].normalize);
        }), n.__compiled__[""] = {
            validate: null,
            normalize: AE()
        };
        let u = Object.keys(n.__compiled__).filter(function(i) {
            return i.length > 0 && n.__compiled__[i];
        }).map(GL).join("|");
        n.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + r.src_ZPCc + "))(" + u + ")", "i"), n.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + r.src_ZPCc + "))(" + u + ")", "ig"), n.re.schema_at_start = RegExp("^" + n.re.schema_search.source, "i"), n.re.pretest = RegExp("(" + n.re.schema_test.source + ")|(" + n.re.host_fuzzy_test.source + ")|@", "i");
    }
    function LE(n, r, e, t) {
        let a = n.slice(e, t);
        this.schema = r.toLowerCase(), this.index = e, this.lastIndex = t, this.raw = a, this.text = a, this.url = a;
    }
    function xt(n, r) {
        if (!(this instanceof xt)) return new xt(n, r);
        r || jL(n) && (r = n, n = {}), this.__opts__ = vv({}, IE, r), this.__schemas__ = vv({}, QL, n), this.__compiled__ = {}, this.__tlds__ = YL, this.__tlds_replaced__ = !1, this.re = {}, H0(this);
    }
    xt.prototype.add = function(r, e) {
        return this.__schemas__[r] = e, H0(this), this;
    };
    xt.prototype.set = function(r) {
        return this.__opts__ = vv(this.__opts__, r), this;
    };
    xt.prototype.test = function(r) {
        if (!r.length) return !1;
        let e, t;
        if (this.re.schema_test.test(r)) {
            for(t = this.re.schema_search, t.lastIndex = 0; (e = t.exec(r)) !== null;)if (this.testSchemaAt(r, e[2], t.lastIndex)) return !0;
        }
        return !!(this.__opts__.fuzzyLink && this.__compiled__["http:"] && r.search(this.re.host_fuzzy_test) >= 0 && r.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy) !== null || this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && r.indexOf("@") >= 0 && r.match(this.re.email_fuzzy) !== null);
    };
    xt.prototype.pretest = function(r) {
        return this.re.pretest.test(r);
    };
    xt.prototype.testSchemaAt = function(r, e, t) {
        return this.__compiled__[e.toLowerCase()] ? this.__compiled__[e.toLowerCase()].validate(r, t, this) : 0;
    };
    xt.prototype.match = function(r) {
        let e = [], t = [], a = [], o = [], u, i, c;
        function l(v, _) {
            return v ? _ ? v.index !== _.index ? v.index < _.index ? v : _ : v.lastIndex >= _.lastIndex ? v : _ : v : _;
        }
        if (!r.length) return null;
        if (this.re.schema_test.test(r)) for(c = this.re.schema_search, c.lastIndex = 0; (u = c.exec(r)) !== null;)i = this.testSchemaAt(r, u[2], c.lastIndex), i && t.push({
            schema: u[2],
            index: u.index + u[1].length,
            lastIndex: u.index + u[0].length + i
        });
        if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) for(c = this.__opts__.fuzzyIP ? this.re.link_fuzzy_global : this.re.link_no_ip_fuzzy_global, c.lastIndex = 0; (u = c.exec(r)) !== null;)a.push({
            schema: "",
            index: u.index + u[1].length,
            lastIndex: u.index + u[0].length
        });
        if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) for(c = this.re.email_fuzzy_global, c.lastIndex = 0; (u = c.exec(r)) !== null;)o.push({
            schema: "mailto:",
            index: u.index + u[1].length,
            lastIndex: u.index + u[0].length
        });
        let d = [
            0,
            0,
            0
        ], m = 0;
        for(;;){
            let v = [
                t[d[0]],
                o[d[1]],
                a[d[2]]
            ], _ = l(l(v[0], v[1]), v[2]);
            if (!_) break;
            if (_ === v[0] ? d[0]++ : _ === v[1] ? d[1]++ : d[2]++, _.index < m) continue;
            let D = new LE(r, _.schema, _.index, _.lastIndex);
            this.__compiled__[D.schema].normalize(D, this), e.push(D), m = _.lastIndex;
        }
        return e.length ? e : null;
    };
    xt.prototype.matchAtStart = function(r) {
        if (!r.length) return null;
        let e = this.re.schema_at_start.exec(r);
        if (!e) return null;
        let t = this.testSchemaAt(r, e[2], e[0].length);
        if (!t) return null;
        let a = new LE(r, e[2], e.index + e[1].length, e.index + e[0].length + t);
        return this.__compiled__[a.schema].normalize(a, this), a;
    };
    xt.prototype.tlds = function(r, e) {
        return r = Array.isArray(r) ? r : [
            r
        ], e ? (this.__tlds__ = this.__tlds__.concat(r).sort().filter(function(t, a, o) {
            return t !== o[a - 1];
        }).reverse(), H0(this), this) : (this.__tlds__ = r.slice(), this.__tlds_replaced__ = !0, H0(this), this);
    };
    xt.prototype.normalize = function(r) {
        r.schema || (r.url = "http://" + r.url), r.schema === "mailto:" && !/^mailto:/i.test(r.url) && (r.url = "mailto:" + r.url);
    };
    xt.prototype.onCompile = function() {};
    var SE = xt;
    var ZL = /^xn--/, nS = /[^\0-\x7F]/, rS = /[\x2E\u3002\uFF0E\uFF61]/g, eS = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, hv = 35, Ra = Math.floor, Dv = String.fromCharCode;
    function Ko(n) {
        throw new RangeError(eS[n]);
    }
    function tS(n, r) {
        let e = [], t = n.length;
        for(; t--;)e[t] = r(n[t]);
        return e;
    }
    function NE(n, r) {
        let e = n.split("@"), t = "";
        e.length > 1 && (t = e[0] + "@", n = e[1]), n = n.replace(rS, ".");
        let a = n.split("."), o = tS(a, r).join(".");
        return t + o;
    }
    function HE(n) {
        let r = [], e = 0, t = n.length;
        for(; e < t;){
            let a = n.charCodeAt(e++);
            if (a >= 55296 && a <= 56319 && e < t) {
                let o = n.charCodeAt(e++);
                (o & 64512) == 56320 ? r.push(((a & 1023) << 10) + (o & 1023) + 65536) : (r.push(a), e--);
            } else r.push(a);
        }
        return r;
    }
    var aS = (n)=>String.fromCodePoint(...n), oS = function(n) {
        return n >= 48 && n < 58 ? 26 + (n - 48) : n >= 65 && n < 91 ? n - 65 : n >= 97 && n < 123 ? n - 97 : 36;
    }, RE = function(n, r) {
        return n + 22 + 75 * (n < 26) - ((r != 0) << 5);
    }, PE = function(n, r, e) {
        let t = 0;
        for(n = e ? Ra(n / 700) : n >> 1, n += Ra(n / r); n > hv * 26 >> 1; t += 36)n = Ra(n / hv);
        return Ra(t + (hv + 1) * n / (n + 38));
    }, kE = function(n) {
        let r = [], e = n.length, t = 0, a = 128, o = 72, u = n.lastIndexOf("-");
        u < 0 && (u = 0);
        for(let i = 0; i < u; ++i)n.charCodeAt(i) >= 128 && Ko("not-basic"), r.push(n.charCodeAt(i));
        for(let i = u > 0 ? u + 1 : 0; i < e;){
            let c = t;
            for(let d = 1, m = 36;; m += 36){
                i >= e && Ko("invalid-input");
                let v = oS(n.charCodeAt(i++));
                v >= 36 && Ko("invalid-input"), v > Ra((2147483647 - t) / d) && Ko("overflow"), t += v * d;
                let _ = m <= o ? 1 : m >= o + 26 ? 26 : m - o;
                if (v < _) break;
                let D = 36 - _;
                d > Ra(2147483647 / D) && Ko("overflow"), d *= D;
            }
            let l = r.length + 1;
            o = PE(t - c, l, c == 0), Ra(t / l) > 2147483647 - a && Ko("overflow"), a += Ra(t / l), t %= l, r.splice(t++, 0, a);
        }
        return String.fromCodePoint(...r);
    }, OE = function(n) {
        let r = [];
        n = HE(n);
        let e = n.length, t = 128, a = 0, o = 72;
        for (let c of n)c < 128 && r.push(Dv(c));
        let u = r.length, i = u;
        for(u && r.push("-"); i < e;){
            let c = 2147483647;
            for (let d of n)d >= t && d < c && (c = d);
            let l = i + 1;
            c - t > Ra((2147483647 - a) / l) && Ko("overflow"), a += (c - t) * l, t = c;
            for (let d of n)if (d < t && ++a > 2147483647 && Ko("overflow"), d === t) {
                let m = a;
                for(let v = 36;; v += 36){
                    let _ = v <= o ? 1 : v >= o + 26 ? 26 : v - o;
                    if (m < _) break;
                    let D = m - _, T = 36 - _;
                    r.push(Dv(RE(_ + D % T, 0))), m = Ra(D / T);
                }
                r.push(Dv(RE(m, 0))), o = PE(a, l, i === u), a = 0, ++i;
            }
            ++a, ++t;
        }
        return r.join("");
    }, uS = function(n) {
        return NE(n, function(r) {
            return ZL.test(r) ? kE(r.slice(4).toLowerCase()) : r;
        });
    }, iS = function(n) {
        return NE(n, function(r) {
            return nS.test(r) ? "xn--" + OE(r) : r;
        });
    }, fS = {
        version: "2.3.1",
        ucs2: {
            decode: HE,
            encode: aS
        },
        decode: kE,
        encode: OE,
        toASCII: iS,
        toUnicode: uS
    };
    var gv = fS;
    var qE = {
        options: {
            html: !1,
            xhtmlOut: !1,
            breaks: !1,
            langPrefix: "language-",
            linkify: !1,
            typographer: !1,
            quotes: "\u201C\u201D\u2018\u2019",
            highlight: null,
            maxNesting: 100
        },
        components: {
            core: {},
            block: {},
            inline: {}
        }
    };
    var WE = {
        options: {
            html: !1,
            xhtmlOut: !1,
            breaks: !1,
            langPrefix: "language-",
            linkify: !1,
            typographer: !1,
            quotes: "\u201C\u201D\u2018\u2019",
            highlight: null,
            maxNesting: 20
        },
        components: {
            core: {
                rules: [
                    "normalize",
                    "block",
                    "inline",
                    "text_join"
                ]
            },
            block: {
                rules: [
                    "paragraph"
                ]
            },
            inline: {
                rules: [
                    "text"
                ],
                rules2: [
                    "balance_pairs",
                    "fragments_join"
                ]
            }
        }
    };
    var $E = {
        options: {
            html: !0,
            xhtmlOut: !0,
            breaks: !1,
            langPrefix: "language-",
            linkify: !1,
            typographer: !1,
            quotes: "\u201C\u201D\u2018\u2019",
            highlight: null,
            maxNesting: 20
        },
        components: {
            core: {
                rules: [
                    "normalize",
                    "block",
                    "inline",
                    "text_join"
                ]
            },
            block: {
                rules: [
                    "blockquote",
                    "code",
                    "fence",
                    "heading",
                    "hr",
                    "html_block",
                    "lheading",
                    "list",
                    "reference",
                    "paragraph"
                ]
            },
            inline: {
                rules: [
                    "autolink",
                    "backticks",
                    "emphasis",
                    "entity",
                    "escape",
                    "html_inline",
                    "image",
                    "link",
                    "newline",
                    "text"
                ],
                rules2: [
                    "balance_pairs",
                    "emphasis",
                    "fragments_join"
                ]
            }
        }
    };
    var cS = {
        default: qE,
        zero: WE,
        commonmark: $E
    }, lS = /^(vbscript|javascript|file|data):/, sS = /^data:image\/(gif|png|jpeg|webp);/;
    function pS(n) {
        let r = n.trim().toLowerCase();
        return lS.test(r) ? sS.test(r) : !0;
    }
    var UE = [
        "http:",
        "https:",
        "mailto:"
    ];
    function mS(n) {
        let r = Uc(n, !0);
        if (r.hostname && (!r.protocol || UE.indexOf(r.protocol) >= 0)) try {
            r.hostname = gv.toASCII(r.hostname);
        } catch  {}
        return y0(Bi(r));
    }
    function dS(n) {
        let r = Uc(n, !0);
        if (r.hostname && (!r.protocol || UE.indexOf(r.protocol) >= 0)) try {
            r.hostname = gv.toUnicode(r.hostname);
        } catch  {}
        return $c(Bi(r), $c.defaultChars + "%");
    }
    function $t(n, r) {
        if (!(this instanceof $t)) return new $t(n, r);
        r || I0(n) || (r = n || {}, n = "default"), this.inline = new FE, this.block = new yE, this.core = new sE, this.renderer = new oE, this.linkify = new SE, this.validateLink = pS, this.normalizeLink = mS, this.normalizeLinkText = dS, this.utils = w_, this.helpers = Ji({}, L_), this.options = {}, this.configure(n), r && this.set(r);
    }
    $t.prototype.set = function(n) {
        return Ji(this.options, n), this;
    };
    $t.prototype.configure = function(n) {
        let r = this;
        if (I0(n)) {
            let e = n;
            if (n = cS[e], !n) throw new Error('Wrong `markdown-it` preset "' + e + '", check name');
        }
        if (!n) throw new Error("Wrong `markdown-it` preset, can't be empty");
        return n.options && r.set(n.options), n.components && Object.keys(n.components).forEach(function(e) {
            n.components[e].rules && r[e].ruler.enableOnly(n.components[e].rules), n.components[e].rules2 && r[e].ruler2.enableOnly(n.components[e].rules2);
        }), this;
    };
    $t.prototype.enable = function(n, r) {
        let e = [];
        Array.isArray(n) || (n = [
            n
        ]), [
            "core",
            "block",
            "inline"
        ].forEach(function(a) {
            e = e.concat(this[a].ruler.enable(n, !0));
        }, this), e = e.concat(this.inline.ruler2.enable(n, !0));
        let t = n.filter(function(a) {
            return e.indexOf(a) < 0;
        });
        if (t.length && !r) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + t);
        return this;
    };
    $t.prototype.disable = function(n, r) {
        let e = [];
        Array.isArray(n) || (n = [
            n
        ]), [
            "core",
            "block",
            "inline"
        ].forEach(function(a) {
            e = e.concat(this[a].ruler.disable(n, !0));
        }, this), e = e.concat(this.inline.ruler2.disable(n, !0));
        let t = n.filter(function(a) {
            return e.indexOf(a) < 0;
        });
        if (t.length && !r) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + t);
        return this;
    };
    $t.prototype.use = function(n) {
        let r = [
            this
        ].concat(Array.prototype.slice.call(arguments, 1));
        return n.apply(n, r), this;
    };
    $t.prototype.parse = function(n, r) {
        if (typeof n != "string") throw new Error("Input data should be a String");
        let e = new this.core.State(n, this, r);
        return this.core.process(e), e.tokens;
    };
    $t.prototype.render = function(n, r) {
        return r = r || {}, this.renderer.render(this.parse(n, r), this.options, r);
    };
    $t.prototype.parseInline = function(n, r) {
        let e = new this.core.State(n, this, r);
        return e.inlineMode = !0, this.core.process(e), e.tokens;
    };
    $t.prototype.renderInline = function(n, r) {
        return r = r || {}, this.renderer.render(this.parseInline(n, r), this.options, r);
    };
    var bv = $t;
    var m3 = gM(p3(), 1);
    function Uv(n) {
        return function() {
            let r = new bv({
                html: !0,
                highlight: function(e, t) {
                    return t && hljs.getLanguage(t) ? hljs.highlight(e, {
                        language: t
                    }).value : "";
                }
            });
            return r.use(m3.default), r.render(n);
        };
    }
    function Bv(n) {
        return function(r) {
            return function() {
                var e = document.getElementById(n);
                if (e) {
                    e.innerHTML = r;
                    var t = e.querySelectorAll("script");
                    t.forEach(function(a) {
                        for(var o = document.createElement("script"), u = 0; u < a.attributes.length; u++){
                            var i = a.attributes[u];
                            o.setAttribute(i.name, i.value);
                        }
                        o.text = a.textContent, a.parentNode.replaceChild(o, a);
                    });
                }
            };
        };
    }
    var iR = $e();
    var cf = function(n) {
        return iR(Mp(n));
    };
    function Vv(n) {
        return function() {
            return n.preventDefault();
        };
    }
    var v3 = "click";
    var bR = R;
    var yR = function(n) {
        return function(r) {
            return Rd(n)(function(e) {
                return new E(new co(r(e)));
            });
        };
    };
    var ul = function() {
        var n = yR(v3);
        return function(r) {
            return n(bR(r));
        };
    }();
    var Vt = function() {
        function n() {}
        return n.value = new n, n;
    }(), go = function() {
        function n() {}
        return n.value = new n, n;
    }(), ka = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Qu = function() {
        function n() {}
        return n.value = new n, n;
    }(), h3 = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), lf = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), Jv = function() {
        function n() {}
        return n.value = new n, n;
    }(), G0 = function() {
        function n() {}
        return n.value = new n, n;
    }(), D3 = {
        to: function(n) {
            if (n instanceof Xe) return Vt.value;
            if (n instanceof ce && n.value0 instanceof Xe) return go.value;
            if (n instanceof ce && n.value0 instanceof ce && n.value0.value0 instanceof Xe) return new ka(n.value0.value0.value0);
            if (n instanceof ce && n.value0 instanceof ce && n.value0.value0 instanceof ce) return Qu.value;
            throw new Error("Failed pattern match at Types (line 20, column 1 - line 20, column 46): " + [
                n.constructor.name
            ]);
        },
        from: function(n) {
            if (n instanceof Vt) return new Xe(Ja.value);
            if (n instanceof go) return new ce(new Xe(Ja.value));
            if (n instanceof ka) return new ce(new ce(new Xe(n.value0)));
            if (n instanceof Qu) return new ce(new ce(new ce(Ja.value)));
            throw new Error("Failed pattern match at Types (line 20, column 1 - line 20, column 46): " + [
                n.constructor.name
            ]);
        }
    }, j0 = {
        eq: function(n) {
            return function(r) {
                return n instanceof Vt && r instanceof Vt || n instanceof go && r instanceof go ? !0 : n instanceof ka && r instanceof ka ? n.value0 === r.value0 : n instanceof Qu && r instanceof Qu;
            };
        }
    };
    var Q0 = R;
    var g3 = tn(lt), b3 = C(Ur), MR = ei(Ur), FR = Cm(mi), Kn = function(n) {
        return eC(hc(n));
    }, wR = hr([
        Kn("max-w-3xl mx-auto px-6 py-6 text-sm")
    ])([
        Go([
            Pu("/"),
            ul(function() {
                var n = lf.create(Vt.value);
                return function(r) {
                    return n(Q0(r));
                };
            }()),
            Kn("text-gray-500 hover:text-gray-800 no-underline")
        ])([
            Mr("\u2190 Back to site")
        ])
    ]), y3 = function() {
        return hr([
            Kn("min-h-screen bg-white text-gray-800")
        ])([
            wR,
            hr([
                Kn("max-w-3xl mx-auto px-6 pb-16")
            ])([
                $i([
                    Kn("text-gray-900 text-2xl font-bold tracking-tight")
                ])([
                    Mr("Matthias Meschede \u2014 CV")
                ]),
                hr([
                    Kn("mt-8"),
                    Ui("cv-gate")
                ])([
                    m0([
                        Kn("text-gray-600 text-base")
                    ])([
                        Mr("This CV is encrypted. Enter the passphrase you were sent to read it.")
                    ]),
                    hr([
                        Kn("mt-4 flex flex-row flex-wrap items-center gap-3")
                    ])([
                        e_([
                            Ui("cv-password"),
                            nC(o2)(Rs.value),
                            rC("passphrase"),
                            Kn("border border-gray-300 px-3 py-1 text-base w-72 focus:outline-none focus:border-gray-500")
                        ]),
                        t_([
                            ul(function(n) {
                                return G0.value;
                            }),
                            Kn("border border-gray-300 text-gray-600 px-3 py-1 hover:text-gray-900 hover:border-gray-500")
                        ])([
                            Mr("Unlock")
                        ])
                    ]),
                    hr([
                        Kn("text-sm mt-3 text-gray-500"),
                        Ui("cv-status")
                    ])([])
                ]),
                hr([
                    Ui("cv-result")
                ])([])
            ])
        ]);
    }(), xR = function(n) {
        var r = Ir("")(n.id), e = Ir("/blog/" + r)(n.external);
        return Go(g3([
            Pu(e),
            Kn("block py-3 border-b border-gray-200 hover:bg-gray-50")
        ])(function() {
            if (n.external instanceof F) return [
                ul(function() {
                    var t = lf.create(new ka(r));
                    return function(a) {
                        return t(Q0(a));
                    };
                }())
            ];
            if (n.external instanceof E) return [
                Oc("_blank")
            ];
            throw new Error("Failed pattern match at Pages (line 155, column 14 - line 157, column 47): " + [
                n.external.constructor.name
            ]);
        }()))([
            hr([
                Kn("flex flex-row justify-between items-baseline")
            ])([
                hr([
                    Kn("text-gray-700")
                ])(g3([
                    Mr(Ir("no title")(n.title))
                ])(function() {
                    if (n.external instanceof F) return [];
                    if (n.external instanceof E) return [
                        d0([
                            Kn("text-gray-400 ml-2")
                        ])([
                            Mr("[external]")
                        ])
                    ];
                    throw new Error("Failed pattern match at Pages (line 162, column 18 - line 164, column 93): " + [
                        n.external.constructor.name
                    ]);
                }())),
                hr([
                    Kn("text-gray-500 text-base ml-6 shrink-0")
                ])([
                    Mr(Ir("")(n.date))
                ])
            ]),
            hr([
                Kn("text-gray-500 text-sm mt-1 max-w-2xl")
            ])([
                Mr(Ir("")(n.description))
            ])
        ]);
    }, AR = function() {
        var n = function(r) {
            return function(e) {
                return function(t) {
                    return Go([
                        Pu(r),
                        ul(function() {
                            var a = lf.create(t);
                            return function(o) {
                                return a(Q0(o));
                            };
                        }()),
                        Kn("text-gray-500 hover:text-gray-800 no-underline tracking-wide")
                    ])([
                        Mr(e)
                    ]);
                };
            };
        };
        return Hu([
            hr([
                Kn("px-6 py-4")
            ])([
                hr([
                    Kn("max-w-4xl mx-auto flex flex-row justify-between items-center text-base")
                ])([
                    hr([
                        Kn("flex flex-row gap-8")
                    ])([
                        n("/")("About")(Vt.value),
                        n("/blog")("Blog")(go.value)
                    ]),
                    hr([
                        Kn("flex flex-row gap-4 text-sm")
                    ])([
                        Go([
                            Pu("https://github.com/mmesch"),
                            Kn("text-gray-500 hover:text-gray-800"),
                            Oc("_blank")
                        ])([
                            Mr("GitHub")
                        ]),
                        Go([
                            Pu("https://www.linkedin.com/in/mmesch"),
                            Kn("text-gray-500 hover:text-gray-800"),
                            Oc("_blank")
                        ])([
                            Mr("LinkedIn")
                        ]),
                        Go([
                            Pu("https://fosstodon.org/@mattodon"),
                            Kn("text-gray-500 hover:text-gray-800"),
                            Oc("_blank")
                        ])([
                            Mr("Mastodon")
                        ])
                    ])
                ])
            ]),
            hr([
                Kn("nav-border")
            ])([])
        ]);
    }(), K0 = function(n) {
        return hr([
            Kn("min-h-screen bg-white text-gray-800")
        ])([
            AR,
            hr([
                Kn("max-w-4xl mx-auto px-4 py-8")
            ])(n)
        ]);
    }, C3 = K0([
        Mr("Loading...")
    ]), jv = function(n) {
        var r = function(a) {
            return n_([
                Kn("text-gray-700 text-base mt-8 mb-2 font-semibold")
            ])([
                d0([
                    Kn("text-gray-500 mr-4"),
                    aC("vertical-align: middle; position: relative; top: -3px")
                ])([
                    Mr("\u25B8 \u25B8 \u25B8")
                ]),
                Mr(a)
            ]);
        }, e = function(a) {
            return hr([
                Kn("border-l-2 border-gray-200 pl-3 my-3 text-sm")
            ])([
                hr([
                    Kn("text-gray-800")
                ])([
                    Mr(a.employer)
                ]),
                hr([
                    Kn("text-gray-500")
                ])([
                    Mr(a.role + (" (" + (a.years + ")")))
                ])
            ]);
        }, t = function(a) {
            return hr([
                Kn("border-l-2 border-gray-200 pl-3 my-3 text-sm")
            ])([
                hr([
                    Kn("text-gray-800")
                ])([
                    Mr(a.qualification)
                ]),
                hr([
                    Kn("text-gray-500")
                ])([
                    Mr(a.institution + (" \u2014 " + a.name))
                ])
            ]);
        };
        return K0(function() {
            if (n instanceof F) return [
                Mr("Loading...")
            ];
            if (n instanceof E) return [
                hr([
                    Kn("text-base")
                ])([
                    $i([
                        Kn("text-gray-800 text-2xl font-bold mb-6")
                    ])([
                        Mr(n.value0.summary)
                    ]),
                    r("What I do"),
                    Pc([
                        Mr(n.value0.what)
                    ]),
                    r("Fields I worked in"),
                    Pc([
                        Mr(n.value0.domains)
                    ]),
                    r("Tech stack"),
                    Pc([
                        Mr(n.value0.stack)
                    ]),
                    r("Experience"),
                    Hu(b3(e)(n.value0.experience)),
                    r("Education"),
                    Hu(b3(t)(n.value0.education))
                ])
            ];
            throw new Error("Failed pattern match at Pages (line 27, column 7 - line 43, column 12): " + [
                n.constructor.name
            ]);
        }());
    }, E3 = function(n) {
        var r = Ir("no title")(n.title), e = Ir("")(n.content), t = Ir("no date")(n.date);
        return K0([
            hr([
                Kn("markdown max-w-4xl")
            ])([
                hr([
                    Kn("text-gray-500 text-base mb-4")
                ])([
                    Mr(t)
                ]),
                $i([
                    Kn("text-gray-800 text-2xl font-bold mb-6")
                ])([
                    Mr(r)
                ]),
                function() {
                    if (n.description instanceof F) return hr([])([]);
                    if (n.description instanceof E) return Hu([
                        hr([
                            Kn("abstract")
                        ])([
                            Mr(n.description.value0)
                        ]),
                        r_([])
                    ]);
                    throw new Error("Failed pattern match at Pages (line 126, column 13 - line 131, column 18): " + [
                        n.description.constructor.name
                    ]);
                }(),
                hr([
                    Kn("post-content"),
                    Ui("post-content")
                ])([])
            ])
        ]);
    }, T3 = function(n) {
        return K0([
            hr([
                Kn("text-base")
            ])([
                $i([
                    Kn("text-gray-800 text-xl mb-8")
                ])([
                    Mr("Blog")
                ]),
                Hu(MR(Gl(FR(Hg(n.posts))))(xR))
            ])
        ]);
    };
    var M3 = {
        bifoldMap: function(n) {
            var r = tn(n.Semigroup0());
            return function(e) {
                return function(t) {
                    return function(a) {
                        return r(e(a.value0))(t(a.value1));
                    };
                };
            };
        },
        bifoldr: function(n) {
            return function(r) {
                return function(e) {
                    return function(t) {
                        return n(t.value0)(r(t.value1)(e));
                    };
                };
            };
        },
        bifoldl: function(n) {
            return function(r) {
                return function(e) {
                    return function(t) {
                        return r(n(e)(t.value0))(t.value1);
                    };
                };
            };
        }
    };
    var Kv = function(n) {
        return n.bitraverse;
    };
    var w3 = function(n) {
        var r = Kv(n);
        return function(e) {
            var t = r(e), a = k(e);
            return function(o) {
                return t(o)(a);
            };
        };
    };
    var Yv = {
        bitraverse: function(n) {
            var r = n.Apply0(), e = Gn(r), t = C(r.Functor0());
            return function(a) {
                return function(o) {
                    return function(u) {
                        return e(t(dn.create)(a(u.value0)))(o(u.value1));
                    };
                };
            };
        },
        bisequence: function(n) {
            var r = n.Apply0(), e = Gn(r), t = C(r.Functor0());
            return function(a) {
                return e(t(dn.create)(a.value0))(a.value1);
            };
        },
        Bifunctor0: function() {
            return _u;
        },
        Bifoldable1: function() {
            return M3;
        }
    };
    function $R(n) {
        return n.replace(/[!'()*]/g, function(r) {
            return "%" + r.charCodeAt(0).toString(16);
        });
    }
    function x3(n, r, e) {
        try {
            return r($R(encodeURIComponent(e)));
        } catch (t) {
            return n(t);
        }
    }
    function A3(n, r, e) {
        try {
            return r(decodeURIComponent(e));
        } catch (t) {
            return n(t);
        }
    }
    var il = function() {
        return eo(x3)(Q(F.value))(E.create);
    }();
    var Xv = function() {
        return eo(A3)(Q(F.value))(E.create);
    }();
    var I3 = {
        segments: [],
        params: [],
        hash: ""
    };
    var VR = function(n, r, e) {
        var t = 0, a;
        return function(o) {
            if (t === 2) return a;
            if (t === 1) throw new ReferenceError(n + " was needed before it finished initializing (module " + r + ", line " + o + ")", r, o);
            return t = 1, a = e(), t = 2, a;
        };
    }, L3 = Kv(Yv)(Qa), S3 = be(kt)(Qa);
    var JR = C(lm), GR = C(_e);
    var jR = kr(og), QR = ip(wo), KR = tn(ag), YR = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), XR = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }();
    var ZR = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), r1 = function() {
        function n() {}
        return n.value = new n, n;
    }(), Lt = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), bo = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), ua = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Ku = function() {
        function n(r) {
            this.value0 = r;
        }
        return n.create = function(r) {
            return new n(r);
        }, n;
    }(), Ke = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }(), R3 = function() {
        return new Ku(function(n) {
            var r = Kl(n.segments);
            return r instanceof E ? new bo({
                params: n.params,
                hash: n.hash,
                segments: r.value0.tail
            }, r.value0.head) : new Lt(r1.value);
        });
    }();
    var N3 = function() {
        return Ke.create;
    }(), nN = function() {
        var n = function(m) {
            return {
                segments: m.value0.value0,
                params: m.value0.value1,
                hash: m.value1
            };
        }, r = function(m) {
            return function(v) {
                return v === "" ? [] : qo(m)(v);
            };
        }, e = function(m) {
            return function(v) {
                return function(_) {
                    var D = xm(v)(_);
                    if (D instanceof E) return new dn(uc(D.value0)(_), ic(D.value0 + yu(v) | 0)(_));
                    if (D instanceof F) return m(_);
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 191, column 5 - line 193, column 23): " + [
                        D.constructor.name
                    ]);
                };
            };
        }, t = function(m) {
            var v = Xv(m);
            if (v instanceof F) return new rn(new ZR(m));
            if (v instanceof E) return new nn(v.value0);
            throw new Error("Failed pattern match at Routing.Duplex.Parser (line 195, column 29 - line 197, column 22): " + [
                v.constructor.name
            ]);
        }, a = function() {
            var m = L3(t)(t), v = e(On(dn.create)(""))("=");
            return function(_) {
                return m(v(_));
            };
        }(), o = function() {
            var m = S3(a), v = r("&");
            return function(_) {
                return m(v(_));
            };
        }(), u = function() {
            var m = r("/");
            return function(v) {
                return function(_) {
                    return _.length === 2 && _[0] === "" && _[1] === "" ? new nn([
                        ""
                    ]) : S3(t)(_);
                }(m(v));
            };
        }(), i = function() {
            var m = L3(u)(o), v = e(On(dn.create)(""))("?");
            return function(_) {
                return m(v(_));
            };
        }(), c = C(st)(n), l = w3(Yv)(Qa)(i), d = e(On(dn.create)(""))("#");
        return function(m) {
            return c(l(d(m)));
        };
    }();
    var rN = {
        map: function(n) {
            return function(r) {
                if (r instanceof Lt) return new Lt(r.value0);
                if (r instanceof bo) return new bo(r.value0, n(r.value1));
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 0, column 0 - line 0, column 0): " + [
                    r.constructor.name
                ]);
            };
        }
    }, H3 = C(rN), yo = {
        map: function(n) {
            return function(r) {
                if (r instanceof ua) return new ua(JR(C(yo)(n))(r.value0));
                if (r instanceof Ku) return new Ku(GR(H3(n))(r.value0));
                if (r instanceof Ke) return new Ke(r.value0, C(yo)(n)(r.value1));
                throw new Error("Failed pattern match at Routing.Duplex.Parser (line 0, column 0 - line 0, column 0): " + [
                    r.constructor.name
                ]);
            };
        }
    }, eN = C(yo);
    var P3 = function() {
        return new Ku(function(n) {
            var r = di(n.segments);
            if (r instanceof F) return new bo(n, void 0);
            if (r instanceof E) return new Lt(new XR(r.value0));
            throw new Error("Failed pattern match at Routing.Duplex.Parser (line 266, column 3 - line 268, column 45): " + [
                r.constructor.name
            ]);
        });
    }(), tN = function(n) {
        return function(r) {
            var e = di(r.segments);
            return e instanceof E && n === e.value0 ? new bo({
                params: r.params,
                hash: r.hash,
                segments: em(1)(r.segments)
            }, void 0) : e instanceof E ? new Lt(new YR(n, e.value0)) : new Lt(r1.value);
        };
    }, k3 = VR("runRouteParser", "Routing.Duplex.Parser", function() {
        var n = function(e) {
            return function(t) {
                return function(a) {
                    return t instanceof Lt ? k3(161)(e)(a) : t;
                };
            };
        }, r = function(e) {
            return function(t) {
                var a = e, o = !1, u;
                function i(c, l) {
                    if (l instanceof ua) return o = !0, jR(n(c))(new Lt(r1.value))(l.value0);
                    if (l instanceof Ku) return o = !0, l.value0(c);
                    if (l instanceof Ke) {
                        var d = tN(l.value0)(c);
                        if (d instanceof Lt) return o = !0, new Lt(d.value0);
                        if (d instanceof bo) {
                            a = d.value0, t = l.value1;
                            return;
                        }
                        throw new Error("Failed pattern match at Routing.Duplex.Parser (line 157, column 7 - line 159, column 40): " + [
                            d.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 153, column 14 - line 159, column 40): " + [
                        l.constructor.name
                    ]);
                }
                for(; !o;)u = i(a, t);
                return u;
            };
        };
        return r;
    }), n1 = k3(150);
    var O3 = function(n) {
        return QR(nN)(function() {
            var r = On(n1)(n);
            return function(e) {
                return function(t) {
                    if (t instanceof Lt) return new rn(t.value0);
                    if (t instanceof bo) return new nn(t.value1);
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 200, column 49 - line 202, column 29): " + [
                        t.constructor.name
                    ]);
                }(r(e));
            };
        }());
    };
    var fl = {
        apply: function(n) {
            return function(r) {
                return new Ku(function(e) {
                    var t = n1(e)(n);
                    if (t instanceof Lt) return new Lt(t.value0);
                    if (t instanceof bo) return H3(t.value1)(n1(t.value0)(r));
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 81, column 5 - line 83, column 56): " + [
                        t.constructor.name
                    ]);
                });
            };
        },
        Functor0: function() {
            return yo;
        }
    }, e1 = {
        pure: function() {
            var n = On(bo.create);
            return function(r) {
                return Ku.create(n(r));
            };
        }(),
        Apply0: function() {
            return fl;
        }
    }, aN = k(e1), oN = function(n) {
        return function(r) {
            var e = function(o) {
                return lg(n)(r);
            };
            if (r instanceof Ke) {
                var t = vm(n);
                if (t instanceof Ke) {
                    var a = r.value0 === t.value0;
                    return a ? cg(_m(n))(new Ke(r.value0, Rr(Yu)(t.value1)(r.value1))) : e(!0);
                }
                return e(!0);
            }
            return e(!0);
        };
    }, Yu = {
        alt: function(n) {
            return function(r) {
                return n instanceof ua && r instanceof ua ? new ua(iN(n.value0)(r.value0)) : n instanceof ua ? new ua(oN(n.value0)(r)) : r instanceof ua ? new ua(uN(n)(r.value0)) : n instanceof Ke && r instanceof Ke && n.value0 === r.value0 ? new Ke(n.value0, Rr(Yu)(n.value1)(r.value1)) : new ua(Dm(n)(sg(r)));
            };
        },
        Functor0: function() {
            return yo;
        }
    }, uN = function(n) {
        return function(r) {
            var e = function(o) {
                return Dm(n)(r);
            };
            if (n instanceof Ke) {
                var t = dm(r);
                if (t instanceof Ke) {
                    var a = n.value0 === t.value0;
                    return a ? as(new Ke(n.value0, Rr(Yu)(n.value1)(t.value1)))(hm(r)) : e(!0);
                }
                return e(!0);
            }
            return e(!0);
        };
    }, iN = function(n) {
        return function(r) {
            var e = n, t = !1, a;
            function o(u, i) {
                var c = function(D) {
                    if (Wr) return KR(u)(i);
                    throw new Error("Failed pattern match at Routing.Duplex.Parser (line 103, column 1 - line 107, column 35): " + [
                        u.constructor.name,
                        i.constructor.name
                    ]);
                }, l = vm(u);
                if (l instanceof Ke) {
                    var d = dm(i);
                    if (d instanceof Ke) {
                        var m = l.value0 === d.value0;
                        if (m) {
                            var v = as(new Ke(l.value0, Rr(Yu)(l.value1)(d.value1)))(hm(i)), _ = pg(_m(u));
                            if (_ instanceof E) {
                                e = _.value0, r = v;
                                return;
                            }
                            if (_ instanceof F) return t = !0, v;
                            throw new Error("Failed pattern match at Routing.Duplex.Parser (line 116, column 9 - line 118, column 25): " + [
                                _.constructor.name
                            ]);
                        }
                        return t = !0, c(!0);
                    }
                    return t = !0, c(!0);
                }
                return t = !0, c(!0);
            }
            for(; !t;)a = o(e, r);
            return a;
        };
    }, fN = Rr(Yu), q3 = function() {
        var n = On(fN);
        return function(r) {
            return n(aN(r));
        };
    }();
    var W3 = function() {
        var n = q3(F.value), r = eN(E.create);
        return function(e) {
            return n(r(e));
        };
    }();
    var U3 = tn(X1(Eo));
    var Y0 = {
        append: function(n) {
            return function(r) {
                return function(e) {
                    return r(n(e));
                };
            };
        }
    }, t1 = function(n) {
        return function(r) {
            return {
                params: r.params,
                hash: r.hash,
                segments: jf(r.segments)(n)
            };
        };
    }, cN = function(n) {
        var r = function(o) {
            return o.length === 1 && o[0] === "" ? "/" : Eu("/")(Kf(il)(o));
        }, e = function(o) {
            return function(u) {
                return u === "" ? il(o) : U3(il(o))(U3(new E("="))(il(u)));
            };
        }, t = function(o) {
            return o.length === 0 ? "" : "?" + Eu("&")(Kf(If(e))(o));
        }, a = function(o) {
            return o === "" ? "" : "#" + o;
        };
        return r(n.segments) + (t(n.params) + a(n.hash));
    };
    var B3 = function() {
        var n = up(I3), r = $e();
        return function(e) {
            return cN(n(r(e)));
        };
    }(), a1 = {
        mempty: vn(Dn),
        Semigroup0: function() {
            return Y0;
        }
    };
    var V3 = tn(Y0), lN = L1(fl), sN = k(e1), pN = vn(Dn), mN = Gn(fl), J3 = C(yo), dN = ge(me)(a1), _N = tr(a1);
    var vN = Gn(Df), hN = C(_e), Jt = function() {
        function n(r, e) {
            this.value0 = r, this.value1 = e;
        }
        return n.create = function(r) {
            return function(e) {
                return new n(r, e);
            };
        }, n;
    }();
    var G3 = pN, j3 = function() {
        return new Jt(t1, R3);
    }();
    var Q3 = {
        dimap: function(n) {
            return function(r) {
                return function(e) {
                    return new Jt(function(t) {
                        return e.value0(n(t));
                    }, J3(r)(e.value1));
                };
            };
        }
    }, K3 = function(n) {
        return function(r) {
            return B3(n.value0(r));
        };
    }, o1 = function(n) {
        return function(r) {
            return new Jt(function(e) {
                return V3(t1(n))(r.value0(e));
            }, N3(n)(r.value1));
        };
    }, u1 = function() {
        var n = On(Gr(ue)(o1)), r = qo("/");
        return function(e) {
            return n(r(e));
        };
    }(), Y3 = u1(""), i1 = function(n) {
        return O3(n.value1);
    };
    var X3 = function(n) {
        return new Jt(dN(n.value0), W3(n.value1));
    };
    var DN = {
        map: function(n) {
            return function(r) {
                return new Jt(r.value0, J3(n)(r.value1));
            };
        }
    };
    var Z3 = function(n) {
        return new Jt(n.value0, lN(n.value1)(P3));
    };
    var gN = {
        apply: function(n) {
            return function(r) {
                return new Jt(vN(hN(V3)(n.value0))(r.value0), mN(n.value1)(r.value1));
            };
        },
        Functor0: function() {
            return DN;
        }
    }, f1 = {
        pure: function() {
            var n = Jt.create(Q(_N));
            return function(r) {
                return n(sN(r));
            };
        }(),
        Apply0: function() {
            return gN;
        }
    };
    var bN = vn(Dn);
    var X0 = C(yo), yN = Rr(Yu), CN = Ip(Q3), cl = function() {
        return k(f1)(Ja.value);
    }();
    var ll = {
        gRouteDuplexCtr: bN
    }, s1 = function(n) {
        return n.gRouteDuplexCtr;
    };
    var l1 = function(n) {
        return n.gRouteDuplex;
    }, Z0 = function(n) {
        var r = l1(n);
        return function(e) {
            var t = l1(e);
            return {
                gRouteDuplex: function(a) {
                    return function(o) {
                        var u = r(a)(o), i = t(a)(o), c = function(d) {
                            if (d instanceof Xe) return u.value0(d.value0);
                            if (d instanceof ce) return i.value0(d.value0);
                            throw new Error("Failed pattern match at Routing.Duplex.Generic (line 51, column 11 - line 53, column 22): " + [
                                d.constructor.name
                            ]);
                        }, l = yN(X0(Xe.create)(u.value1))(X0(ce.create)(i.value1));
                        return new Jt(c, l);
                    };
                }
            };
        };
    }, n4 = function(n) {
        var r = sp(n), e = Y1(n);
        return function(t) {
            var a = CN(r)(e), o = l1(t)(Z3);
            return function(u) {
                return a(o(u));
            };
        };
    };
    var sl = function(n) {
        var r = Lm(n)();
        return function() {
            return function(e) {
                var t = s1(e);
                return {
                    gRouteDuplex: function(a) {
                        return function(o) {
                            var u = a(t(r($r.value)(o))), i = function(l) {
                                return u.value0(l);
                            }, c = X0(Q1)(u.value1);
                            return new Jt(i, c);
                        };
                    }
                };
            };
        };
    };
    var p1 = {
        gRouteDuplexCtr: function(n) {
            return new Jt(function(r) {
                return n.value0(r);
            }, X0(K1)(n.value1));
        }
    };
    var e4 = function(n) {
        var r = s1(n);
        return {
            gsep: function(e) {
                var t = o1(e);
                return function(a) {
                    return t(r(a));
                };
            }
        };
    };
    var t4 = function(n) {
        return n.gsep;
    };
    var Xu = function(n) {
        return function(r) {
            return function() {
                return r[n];
            };
        };
    }, NN = Xu("URL"), HN = Xu("documentURI"), PN = Xu("origin"), kN = Xu("compatMode"), ON = Xu("characterSet"), qN = Xu("contentType");
    var WN = Xu("documentElement");
    function m1(n) {
        return function(r) {
            return function() {
                return r.createTextNode(n);
            };
        };
    }
    function d1(n) {
        return function() {
            return new MutationObserver(function(r, e) {
                return n(r)(e)();
            });
        };
    }
    function i4(n) {
        return function(r) {
            return function(e) {
                return function() {
                    return e.observe(n, r);
                };
            };
        };
    }
    var f4 = function() {
        return i4;
    };
    var c4 = R;
    var l4 = "popstate";
    var nu = Z(he), s4 = C(Pn), GN = Et(Tf), jN = f4(), QN = k(xr), p4 = ne(xr), KN = p4(Po), YN = Tn(Va), Zu = Pr(he), XN = p4(bu), ZN = uo(He), nH = Di(He), rH = tu(Pn), eH = function(n) {
        return function() {
            var e = nu(Ve)(function() {
                var u = s4(ws);
                return function(i) {
                    return u(Ma(i));
                };
            }())(), t = Cr(new nn(0))(), a = s4(c4)(m1("")(e))(), o = d1(function(u) {
                return function(i) {
                    return function() {
                        return qe(ke(function() {
                            var l = GN(1);
                            return function(d) {
                                return nn.create(l(d));
                            };
                        }())(nn.create))(t)(), n();
                    };
                };
            })();
            return jN(a)({
                characterData: !0
            })(o)(), nu(hn(t))(KN(function(u) {
                return function() {
                    return mr(new rn(u + 1 | 0))(t)(), m_(YN(u))(a)();
                };
            }));
        };
    }, m4 = function() {
        var r = Cr(0)(), e = Cr(Ft)(), t = function(l) {
            return Zu(XN(function(d) {
                return d(l);
            }))(hn(e));
        }, a = function() {
            var d = nu(Ve)(Is)(), m = nu(nu(Ve)(Ls))(Vm)(), v = Jm(d)(), _ = Gm(d)(), D = As(d)(), T = v + (_ + D);
            return {
                state: m,
                pathname: v,
                search: _,
                hash: D,
                path: T
            };
        }, o = function(l) {
            return function() {
                var m = hn(r)();
                return mr(m + 1 | 0)(r)(), qe(ZN(m)(l))(e)(), qe(nH(m))(e);
            };
        }, u = eH(Zu(t)(a))(), i = function(l) {
            return function(d) {
                return function(m) {
                    return function() {
                        return nu(nu(Ve)(Ls))(l(d)("")(m))(), u();
                    };
                };
            };
        }, c = $o(function(l) {
            return Zu(t)(a);
        })();
        return nu(Ve)(function() {
            var l = bi(l4)(c)(!1);
            return function(d) {
                return l(gc(d));
            };
        }())(), {
            pushState: i(Bm),
            replaceState: i(zm),
            locationState: a,
            listen: o
        };
    }, tH = function(n) {
        return function(r) {
            return function(e) {
                return function() {
                    var a = Zu(Cr)(Zu(r)(e.locationState))();
                    return e.listen(function(o) {
                        return Zu(On(mr)(a))(Zu(On(n)(o))(hn(a)));
                    })();
                };
            };
        };
    }, aH = function(n) {
        return function(r) {
            return tH(function(e) {
                var t = n(e);
                return function(a) {
                    return t(function(o) {
                        return o.path;
                    }(a));
                };
            })(function(e) {
                return r(function(t) {
                    return t.path;
                }(e));
            });
        };
    }, d4 = function(n) {
        var r = Op(n);
        return function(e) {
            return function(t) {
                var a = function(o) {
                    var u = _r(QN(o))(function(c) {
                        return rH(new E(c))(t(o)(c));
                    }), i = r(0);
                    return function(c) {
                        return u(i(e(c)));
                    };
                };
                return aH(a)(a(F.value));
            };
        };
    };
    var _1 = t4(e4(ll));
    var oH = bt(xr), uH = uu(Fo(Fo(j0))), iH = Hr(ya), fH = d4(Po), cH = function(n) {
        return Ir(n)(ps("/")(n));
    };
    var lH = n4(D3)(Z0(sl({
        reflectSymbol: function() {
            return "Main";
        }
    })()(ll))(Z0(sl({
        reflectSymbol: function() {
            return "BlogList";
        }
    })()(ll))(Z0(sl({
        reflectSymbol: function() {
            return "Blog";
        }
    })()(p1))(sl({
        reflectSymbol: function() {
            return "Cv";
        }
    })()(ll)))))({
        Loading: _1("loading")(cl),
        Main: cl,
        BlogList: _1("blog")(cl),
        Blog: u1("blog")(G3(j3)),
        Cv: _1("cv")(cl)
    }), v1 = Y3(X3(lH)), h1 = function(n) {
        var r = ir(n);
        return function(e) {
            var t = e.pushState(Fd({})), a = K3(v1);
            return function(o) {
                return r(t(a(o)));
            };
        };
    }, v4 = function(n) {
        var r = Z(n.Monad0().Bind1()), e = ir(n), t = h1(n);
        return function(a) {
            return r(e(a.locationState))(function(o) {
                var u = ja(i1(v1)(cH(o.path)));
                return t(a)(Ir(new E(Vt.value))(u));
            });
        };
    };
    var h4 = function(n) {
        return function(r) {
            return fH(i1(v1))(function(e) {
                return function(t) {
                    return oH(uH(e)(new E(t)))(_b(iH(r.query(o_(h3.create(t))))));
                };
            })(n);
        };
    };
    var D4 = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    try {
                        return r(new RegExp(e, t));
                    } catch (a) {
                        return n(a.message);
                    }
                };
            };
        };
    };
    var g4 = function(n) {
        return function(r) {
            return function(e) {
                return function(t) {
                    var a = t.match(e);
                    if (a == null || a.length === 0) return r;
                    for(var o = 0; o < a.length; o++)a[o] = a[o] == null ? r : n(a[o]);
                    return n(a);
                };
            };
        };
    };
    var np = {
        global: !1,
        ignoreCase: !1,
        multiline: !1,
        dotAll: !1,
        sticky: !1,
        unicode: !1
    };
    var mH = function(n) {
        return function() {
            return n.global ? "g" : "";
        }() + (function() {
            return n.ignoreCase ? "i" : "";
        }() + (function() {
            return n.multiline ? "m" : "";
        }() + (function() {
            return n.dotAll ? "s" : "";
        }() + (function() {
            return n.sticky ? "y" : "";
        }() + function() {
            return n.unicode ? "u" : "";
        }()))));
    }, rp = function(n) {
        return function(r) {
            return D4(rn.create)(nn.create)(n)(mH(r));
        };
    };
    var ep = function() {
        return g4(E.create)(F.value);
    }();
    var _H = Object.create, y4 = Object.defineProperty, vH = Object.getOwnPropertyDescriptor, hH = Object.getOwnPropertyNames, DH = Object.getPrototypeOf, gH = Object.prototype.hasOwnProperty, zr = (n, r)=>()=>(r || (n((r = {
                exports: {}
            }).exports, r), n = null), r.exports), bH = (n, r, e, t)=>{
        if (r && typeof r == "object" || typeof r == "function") for(var a = hH(r), o = 0, u = a.length, i; o < u; o++)i = a[o], !gH.call(n, i) && i !== e && y4(n, i, {
            get: ((c)=>r[c]).bind(null, i),
            enumerable: !(t = vH(r, i)) || t.enumerable
        });
        return n;
    }, yH = (n, r, e)=>(e = n != null ? _H(DH(n)) : {}, bH(r || !n || !n.__esModule ? y4(e, "default", {
            value: n,
            enumerable: !0
        }) : e, n)), pl = zr((n, r)=>{
        function e(c) {
            return typeof c > "u" || c === null;
        }
        function t(c) {
            return typeof c == "object" && c !== null;
        }
        function a(c) {
            return Array.isArray(c) ? c : e(c) ? [] : [
                c
            ];
        }
        function o(c, l) {
            if (l) {
                let d = Object.keys(l);
                for(let m = 0, v = d.length; m < v; m += 1){
                    let _ = d[m];
                    c[_] = l[_];
                }
            }
            return c;
        }
        function u(c, l) {
            let d = "";
            for(let m = 0; m < l; m += 1)d += c;
            return d;
        }
        function i(c) {
            return c === 0 && Number.NEGATIVE_INFINITY === 1 / c;
        }
        r.exports.isNothing = e, r.exports.isObject = t, r.exports.toArray = a, r.exports.repeat = u, r.exports.isNegativeZero = i, r.exports.extend = o;
    }), ml = zr((n, r)=>{
        function e(a, o) {
            let u = "", i = a.reason || "(unknown reason)";
            return a.mark ? (a.mark.name && (u += 'in "' + a.mark.name + '" '), u += "(" + (a.mark.line + 1) + ":" + (a.mark.column + 1) + ")", !o && a.mark.snippet && (u += `

` + a.mark.snippet), i + " " + u) : i;
        }
        function t(a, o) {
            Error.call(this), this.name = "YAMLException", this.reason = a, this.mark = o, this.message = e(this, !1), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "";
        }
        t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t.prototype.toString = function(o) {
            return this.name + ": " + e(this, o);
        }, r.exports = t;
    }), CH = zr((n, r)=>{
        var e = pl();
        function t(u, i, c, l, d) {
            let m = "", v = "", _ = Math.floor(d / 2) - 1;
            return l - i > _ && (m = " ... ", i = l - _ + m.length), c - l > _ && (v = " ...", c = l + _ - v.length), {
                str: m + u.slice(i, c).replace(/\t/g, "\u2192") + v,
                pos: l - i + m.length
            };
        }
        function a(u, i) {
            return e.repeat(" ", i - u.length) + u;
        }
        function o(u, i) {
            if (i = Object.create(i || null), !u.buffer) return null;
            i.maxLength || (i.maxLength = 79), typeof i.indent != "number" && (i.indent = 1), typeof i.linesBefore != "number" && (i.linesBefore = 3), typeof i.linesAfter != "number" && (i.linesAfter = 2);
            let c = /\r?\n|\r|\0/g, l = [
                0
            ], d = [], m, v = -1;
            for(; m = c.exec(u.buffer);)d.push(m.index), l.push(m.index + m[0].length), u.position <= m.index && v < 0 && (v = l.length - 2);
            v < 0 && (v = l.length - 1);
            let _ = "", D = Math.min(u.line + i.linesAfter, d.length).toString().length, T = i.maxLength - (i.indent + D + 3);
            for(let $ = 1; $ <= i.linesBefore && !(v - $ < 0); $++){
                let q = t(u.buffer, l[v - $], d[v - $], u.position - (l[v] - l[v - $]), T);
                _ = e.repeat(" ", i.indent) + a((u.line - $ + 1).toString(), D) + " | " + q.str + `
` + _;
            }
            let I = t(u.buffer, l[v], d[v], u.position, T);
            _ += e.repeat(" ", i.indent) + a((u.line + 1).toString(), D) + " | " + I.str + `
`, _ += e.repeat("-", i.indent + D + 3 + I.pos) + `^
`;
            for(let $ = 1; $ <= i.linesAfter && !(v + $ >= d.length); $++){
                let q = t(u.buffer, l[v + $], d[v + $], u.position - (l[v] - l[v + $]), T);
                _ += e.repeat(" ", i.indent) + a((u.line + $ + 1).toString(), D) + " | " + q.str + `
`;
            }
            return _.replace(/\n$/, "");
        }
        r.exports = o;
    }), ut = zr((n, r)=>{
        var e = ml(), t = [
            "kind",
            "multi",
            "resolve",
            "construct",
            "instanceOf",
            "predicate",
            "represent",
            "representName",
            "defaultStyle",
            "styleAliases"
        ], a = [
            "scalar",
            "sequence",
            "mapping"
        ];
        function o(i) {
            let c = {};
            return i !== null && Object.keys(i).forEach(function(l) {
                i[l].forEach(function(d) {
                    c[String(d)] = l;
                });
            }), c;
        }
        function u(i, c) {
            if (c = c || {}, Object.keys(c).forEach(function(l) {
                if (t.indexOf(l) === -1) throw new e('Unknown option "' + l + '" is met in definition of "' + i + '" YAML type.');
            }), this.options = c, this.tag = i, this.kind = c.kind || null, this.resolve = c.resolve || function() {
                return !0;
            }, this.construct = c.construct || function(l) {
                return l;
            }, this.instanceOf = c.instanceOf || null, this.predicate = c.predicate || null, this.represent = c.represent || null, this.representName = c.representName || null, this.defaultStyle = c.defaultStyle || null, this.multi = c.multi || !1, this.styleAliases = o(c.styleAliases || null), a.indexOf(this.kind) === -1) throw new e('Unknown kind "' + this.kind + '" is specified for "' + i + '" YAML type.');
        }
        r.exports = u;
    }), C4 = zr((n, r)=>{
        var e = ml(), t = ut();
        function a(i, c) {
            let l = [];
            return i[c].forEach(function(d) {
                let m = l.length;
                l.forEach(function(v, _) {
                    v.tag === d.tag && v.kind === d.kind && v.multi === d.multi && (m = _);
                }), l[m] = d;
            }), l;
        }
        function o() {
            let i = {
                scalar: {},
                sequence: {},
                mapping: {},
                fallback: {},
                multi: {
                    scalar: [],
                    sequence: [],
                    mapping: [],
                    fallback: []
                }
            };
            function c(l) {
                l.multi ? (i.multi[l.kind].push(l), i.multi.fallback.push(l)) : i[l.kind][l.tag] = i.fallback[l.tag] = l;
            }
            for(let l = 0, d = arguments.length; l < d; l += 1)arguments[l].forEach(c);
            return i;
        }
        function u(i) {
            return this.extend(i);
        }
        u.prototype.extend = function(c) {
            let l = [], d = [];
            if (c instanceof t) d.push(c);
            else if (Array.isArray(c)) d = d.concat(c);
            else if (c && (Array.isArray(c.implicit) || Array.isArray(c.explicit))) c.implicit && (l = l.concat(c.implicit)), c.explicit && (d = d.concat(c.explicit));
            else throw new e("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
            l.forEach(function(v) {
                if (!(v instanceof t)) throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
                if (v.loadKind && v.loadKind !== "scalar") throw new e("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
                if (v.multi) throw new e("There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.");
            }), d.forEach(function(v) {
                if (!(v instanceof t)) throw new e("Specified list of YAML types (or a single Type object) contains a non-Type object.");
            });
            let m = Object.create(u.prototype);
            return m.implicit = (this.implicit || []).concat(l), m.explicit = (this.explicit || []).concat(d), m.compiledImplicit = a(m, "implicit"), m.compiledExplicit = a(m, "explicit"), m.compiledTypeMap = o(m.compiledImplicit, m.compiledExplicit), m;
        }, r.exports = u;
    }), E4 = zr((n, r)=>{
        r.exports = new (ut())("tag:yaml.org,2002:str", {
            kind: "scalar",
            construct: function(e) {
                return e !== null ? e : "";
            }
        });
    }), T4 = zr((n, r)=>{
        r.exports = new (ut())("tag:yaml.org,2002:seq", {
            kind: "sequence",
            construct: function(e) {
                return e !== null ? e : [];
            }
        });
    }), M4 = zr((n, r)=>{
        r.exports = new (ut())("tag:yaml.org,2002:map", {
            kind: "mapping",
            construct: function(e) {
                return e !== null ? e : {};
            }
        });
    }), F4 = zr((n, r)=>{
        r.exports = new (C4())({
            explicit: [
                E4(),
                T4(),
                M4()
            ]
        });
    }), w4 = zr((n, r)=>{
        var e = ut();
        function t(u) {
            if (u === null) return !0;
            let i = u.length;
            return i === 1 && u === "~" || i === 4 && (u === "null" || u === "Null" || u === "NULL");
        }
        function a() {
            return null;
        }
        function o(u) {
            return u === null;
        }
        r.exports = new e("tag:yaml.org,2002:null", {
            kind: "scalar",
            resolve: t,
            construct: a,
            predicate: o,
            represent: {
                canonical: function() {
                    return "~";
                },
                lowercase: function() {
                    return "null";
                },
                uppercase: function() {
                    return "NULL";
                },
                camelcase: function() {
                    return "Null";
                },
                empty: function() {
                    return "";
                }
            },
            defaultStyle: "lowercase"
        });
    }), x4 = zr((n, r)=>{
        var e = ut();
        function t(u) {
            if (u === null) return !1;
            let i = u.length;
            return i === 4 && (u === "true" || u === "True" || u === "TRUE") || i === 5 && (u === "false" || u === "False" || u === "FALSE");
        }
        function a(u) {
            return u === "true" || u === "True" || u === "TRUE";
        }
        function o(u) {
            return Object.prototype.toString.call(u) === "[object Boolean]";
        }
        r.exports = new e("tag:yaml.org,2002:bool", {
            kind: "scalar",
            resolve: t,
            construct: a,
            predicate: o,
            represent: {
                lowercase: function(u) {
                    return u ? "true" : "false";
                },
                uppercase: function(u) {
                    return u ? "TRUE" : "FALSE";
                },
                camelcase: function(u) {
                    return u ? "True" : "False";
                }
            },
            defaultStyle: "lowercase"
        });
    }), A4 = zr((n, r)=>{
        var e = pl(), t = ut();
        function a(m) {
            return m >= 48 && m <= 57 || m >= 65 && m <= 70 || m >= 97 && m <= 102;
        }
        function o(m) {
            return m >= 48 && m <= 55;
        }
        function u(m) {
            return m >= 48 && m <= 57;
        }
        function i(m) {
            if (m === null) return !1;
            let v = m.length, _ = 0, D = !1;
            if (!v) return !1;
            let T = m[_];
            if ((T === "-" || T === "+") && (T = m[++_]), T === "0") {
                if (_ + 1 === v) return !0;
                if (T = m[++_], T === "b") {
                    for(_++; _ < v; _++){
                        if (T = m[_], T !== "0" && T !== "1") return !1;
                        D = !0;
                    }
                    return D && Number.isFinite(c(m));
                }
                if (T === "x") {
                    for(_++; _ < v; _++){
                        if (!a(m.charCodeAt(_))) return !1;
                        D = !0;
                    }
                    return D && Number.isFinite(c(m));
                }
                if (T === "o") {
                    for(_++; _ < v; _++){
                        if (!o(m.charCodeAt(_))) return !1;
                        D = !0;
                    }
                    return D && Number.isFinite(c(m));
                }
            }
            for(; _ < v; _++){
                if (!u(m.charCodeAt(_))) return !1;
                D = !0;
            }
            return D ? Number.isFinite(c(m)) : !1;
        }
        function c(m) {
            let v = m, _ = 1, D = v[0];
            if ((D === "-" || D === "+") && (D === "-" && (_ = -1), v = v.slice(1), D = v[0]), v === "0") return 0;
            if (D === "0") {
                if (v[1] === "b") return _ * parseInt(v.slice(2), 2);
                if (v[1] === "x") return _ * parseInt(v.slice(2), 16);
                if (v[1] === "o") return _ * parseInt(v.slice(2), 8);
            }
            return _ * parseInt(v, 10);
        }
        function l(m) {
            return c(m);
        }
        function d(m) {
            return Object.prototype.toString.call(m) === "[object Number]" && m % 1 === 0 && !e.isNegativeZero(m);
        }
        r.exports = new t("tag:yaml.org,2002:int", {
            kind: "scalar",
            resolve: i,
            construct: l,
            predicate: d,
            represent: {
                binary: function(m) {
                    return m >= 0 ? "0b" + m.toString(2) : "-0b" + m.toString(2).slice(1);
                },
                octal: function(m) {
                    return m >= 0 ? "0o" + m.toString(8) : "-0o" + m.toString(8).slice(1);
                },
                decimal: function(m) {
                    return m.toString(10);
                },
                hexadecimal: function(m) {
                    return m >= 0 ? "0x" + m.toString(16).toUpperCase() : "-0x" + m.toString(16).toUpperCase().slice(1);
                }
            },
            defaultStyle: "decimal",
            styleAliases: {
                binary: [
                    2,
                    "bin"
                ],
                octal: [
                    8,
                    "oct"
                ],
                decimal: [
                    10,
                    "dec"
                ],
                hexadecimal: [
                    16,
                    "hex"
                ]
            }
        });
    }), I4 = zr((n, r)=>{
        var e = pl(), t = ut(), a = new RegExp("^(?:[-+]?(?:[0-9]+)(?:\\.[0-9]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$"), o = new RegExp("^(?:[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
        function u(m) {
            return m === null || !a.test(m) ? !1 : Number.isFinite(parseFloat(m, 10)) ? !0 : o.test(m);
        }
        function i(m) {
            let v = m.toLowerCase(), _ = v[0] === "-" ? -1 : 1;
            return "+-".indexOf(v[0]) >= 0 && (v = v.slice(1)), v === ".inf" ? _ === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY : v === ".nan" ? NaN : _ * parseFloat(v, 10);
        }
        var c = /^[-+]?[0-9]+e/;
        function l(m, v) {
            if (isNaN(m)) switch(v){
                case "lowercase":
                    return ".nan";
                case "uppercase":
                    return ".NAN";
                case "camelcase":
                    return ".NaN";
            }
            else if (Number.POSITIVE_INFINITY === m) switch(v){
                case "lowercase":
                    return ".inf";
                case "uppercase":
                    return ".INF";
                case "camelcase":
                    return ".Inf";
            }
            else if (Number.NEGATIVE_INFINITY === m) switch(v){
                case "lowercase":
                    return "-.inf";
                case "uppercase":
                    return "-.INF";
                case "camelcase":
                    return "-.Inf";
            }
            else if (e.isNegativeZero(m)) return "-0.0";
            let _ = m.toString(10);
            return c.test(_) ? _.replace("e", ".e") : _;
        }
        function d(m) {
            return Object.prototype.toString.call(m) === "[object Number]" && (m % 1 !== 0 || e.isNegativeZero(m));
        }
        r.exports = new t("tag:yaml.org,2002:float", {
            kind: "scalar",
            resolve: u,
            construct: i,
            predicate: d,
            represent: l,
            defaultStyle: "lowercase"
        });
    }), L4 = zr((n, r)=>{
        r.exports = F4().extend({
            implicit: [
                w4(),
                x4(),
                A4(),
                I4()
            ]
        });
    }), S4 = zr((n, r)=>{
        r.exports = L4();
    }), R4 = zr((n, r)=>{
        var e = ut(), t = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"), a = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$");
        function o(c) {
            return c === null ? !1 : t.exec(c) !== null || a.exec(c) !== null;
        }
        function u(c) {
            let l = 0, d = null, m = t.exec(c);
            if (m === null && (m = a.exec(c)), m === null) throw new Error("Date resolve error");
            let v = +m[1], _ = +m[2] - 1, D = +m[3];
            if (!m[4]) return new Date(Date.UTC(v, _, D));
            let T = +m[4], I = +m[5], $ = +m[6];
            if (m[7]) {
                for(l = m[7].slice(0, 3); l.length < 3;)l += "0";
                l = +l;
            }
            if (m[9]) {
                let z = +m[10], S = +(m[11] || 0);
                d = (z * 60 + S) * 6e4, m[9] === "-" && (d = -d);
            }
            let q = new Date(Date.UTC(v, _, D, T, I, $, l));
            return d && q.setTime(q.getTime() - d), q;
        }
        function i(c) {
            return c.toISOString();
        }
        r.exports = new e("tag:yaml.org,2002:timestamp", {
            kind: "scalar",
            resolve: o,
            construct: u,
            instanceOf: Date,
            represent: i
        });
    }), N4 = zr((n, r)=>{
        var e = ut();
        function t(a) {
            return a === "<<" || a === null;
        }
        r.exports = new e("tag:yaml.org,2002:merge", {
            kind: "scalar",
            resolve: t
        });
    }), H4 = zr((n, r)=>{
        var e = ut(), t = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
        function a(c) {
            if (c === null) return !1;
            let l = 0, d = c.length, m = t;
            for(let v = 0; v < d; v++){
                let _ = m.indexOf(c.charAt(v));
                if (!(_ > 64)) {
                    if (_ < 0) return !1;
                    l += 6;
                }
            }
            return l % 8 === 0;
        }
        function o(c) {
            let l = c.replace(/[\r\n=]/g, ""), d = l.length, m = t, v = 0, _ = [];
            for(let T = 0; T < d; T++)T % 4 === 0 && T && (_.push(v >> 16 & 255), _.push(v >> 8 & 255), _.push(v & 255)), v = v << 6 | m.indexOf(l.charAt(T));
            let D = d % 4 * 6;
            return D === 0 ? (_.push(v >> 16 & 255), _.push(v >> 8 & 255), _.push(v & 255)) : D === 18 ? (_.push(v >> 10 & 255), _.push(v >> 2 & 255)) : D === 12 && _.push(v >> 4 & 255), new Uint8Array(_);
        }
        function u(c) {
            let l = "", d = 0, m = c.length, v = t;
            for(let D = 0; D < m; D++)D % 3 === 0 && D && (l += v[d >> 18 & 63], l += v[d >> 12 & 63], l += v[d >> 6 & 63], l += v[d & 63]), d = (d << 8) + c[D];
            let _ = m % 3;
            return _ === 0 ? (l += v[d >> 18 & 63], l += v[d >> 12 & 63], l += v[d >> 6 & 63], l += v[d & 63]) : _ === 2 ? (l += v[d >> 10 & 63], l += v[d >> 4 & 63], l += v[d << 2 & 63], l += v[64]) : _ === 1 && (l += v[d >> 2 & 63], l += v[d << 4 & 63], l += v[64], l += v[64]), l;
        }
        function i(c) {
            return Object.prototype.toString.call(c) === "[object Uint8Array]";
        }
        r.exports = new e("tag:yaml.org,2002:binary", {
            kind: "scalar",
            resolve: a,
            construct: o,
            predicate: i,
            represent: u
        });
    }), P4 = zr((n, r)=>{
        var e = ut(), t = Object.prototype.hasOwnProperty, a = Object.prototype.toString;
        function o(i) {
            if (i === null) return !0;
            let c = [], l = i;
            for(let d = 0, m = l.length; d < m; d += 1){
                let v = l[d], _ = !1;
                if (a.call(v) !== "[object Object]") return !1;
                let D;
                for(D in v)if (t.call(v, D)) {
                    if (!_) _ = !0;
                    else return !1;
                }
                if (!_) return !1;
                if (c.indexOf(D) === -1) c.push(D);
                else return !1;
            }
            return !0;
        }
        function u(i) {
            return i !== null ? i : [];
        }
        r.exports = new e("tag:yaml.org,2002:omap", {
            kind: "sequence",
            resolve: o,
            construct: u
        });
    }), k4 = zr((n, r)=>{
        var e = ut(), t = Object.prototype.toString;
        function a(u) {
            if (u === null) return !0;
            let i = u, c = new Array(i.length);
            for(let l = 0, d = i.length; l < d; l += 1){
                let m = i[l];
                if (t.call(m) !== "[object Object]") return !1;
                let v = Object.keys(m);
                if (v.length !== 1) return !1;
                c[l] = [
                    v[0],
                    m[v[0]]
                ];
            }
            return !0;
        }
        function o(u) {
            if (u === null) return [];
            let i = u, c = new Array(i.length);
            for(let l = 0, d = i.length; l < d; l += 1){
                let m = i[l], v = Object.keys(m);
                c[l] = [
                    v[0],
                    m[v[0]]
                ];
            }
            return c;
        }
        r.exports = new e("tag:yaml.org,2002:pairs", {
            kind: "sequence",
            resolve: a,
            construct: o
        });
    }), O4 = zr((n, r)=>{
        var e = ut(), t = Object.prototype.hasOwnProperty;
        function a(u) {
            if (u === null) return !0;
            let i = u;
            for(let c in i)if (t.call(i, c) && i[c] !== null) return !1;
            return !0;
        }
        function o(u) {
            return u !== null ? u : {};
        }
        r.exports = new e("tag:yaml.org,2002:set", {
            kind: "mapping",
            resolve: a,
            construct: o
        });
    }), D1 = zr((n, r)=>{
        r.exports = S4().extend({
            implicit: [
                R4(),
                N4()
            ],
            explicit: [
                H4(),
                P4(),
                k4(),
                O4()
            ]
        });
    }), EH = zr((n, r)=>{
        var e = pl(), t = ml(), a = CH(), o = D1(), u = Object.prototype.hasOwnProperty, i = 1, c = 2, l = 3, d = 4, m = 1, v = 2, _ = 3, D = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, T = /[\x85\u2028\u2029]/, I = /[,\[\]{}]/, $ = /^(?:!|!!|![0-9A-Za-z-]+!)$/, q = /^(?:!|[^,\[\]{}])(?:%[0-9a-f]{2}|[0-9a-z\-#;/?:@&=+$,_.!~*'()\[\]])*$/i;
        function z(f) {
            return Object.prototype.toString.call(f);
        }
        function S(f) {
            return f === 10 || f === 13;
        }
        function x(f) {
            return f === 9 || f === 32;
        }
        function Y(f) {
            return f === 9 || f === 32 || f === 10 || f === 13;
        }
        function Yn(f) {
            return f === 44 || f === 91 || f === 93 || f === 123 || f === 125;
        }
        function dr(f) {
            if (f >= 48 && f <= 57) return f - 48;
            let M = f | 32;
            return M >= 97 && M <= 102 ? M - 97 + 10 : -1;
        }
        function cr(f) {
            return f === 120 ? 2 : f === 117 ? 4 : f === 85 ? 8 : 0;
        }
        function Xr(f) {
            return f >= 48 && f <= 57 ? f - 48 : -1;
        }
        function te(f) {
            switch(f){
                case 48:
                    return "\0";
                case 97:
                    return "\x07";
                case 98:
                    return "\b";
                case 116:
                    return "	";
                case 9:
                    return "	";
                case 110:
                    return `
`;
                case 118:
                    return "\v";
                case 102:
                    return "\f";
                case 114:
                    return "\r";
                case 101:
                    return "\x1B";
                case 32:
                    return " ";
                case 34:
                    return '"';
                case 47:
                    return "/";
                case 92:
                    return "\\";
                case 78:
                    return "\x85";
                case 95:
                    return "\xA0";
                case 76:
                    return "\u2028";
                case 80:
                    return "\u2029";
                default:
                    return "";
            }
        }
        function fa(f) {
            return f <= 65535 ? String.fromCharCode(f) : String.fromCharCode((f - 65536 >> 10) + 55296, (f - 65536 & 1023) + 56320);
        }
        function Te(f, M, L) {
            M === "__proto__" ? Object.defineProperty(f, M, {
                configurable: !0,
                enumerable: !0,
                writable: !0,
                value: L
            }) : f[M] = L;
        }
        var Fr = new Array(256), Vr = new Array(256);
        for(let f = 0; f < 256; f++)Fr[f] = te(f) ? 1 : 0, Vr[f] = te(f);
        function Er(f, M) {
            this.input = f, this.filename = M.filename || null, this.schema = M.schema || o, this.onWarning = M.onWarning || null, this.legacy = M.legacy || !1, this.json = M.json || !1, this.listener = M.listener || null, this.maxDepth = typeof M.maxDepth == "number" ? M.maxDepth : 100, this.maxMergeSeqLength = typeof M.maxMergeSeqLength == "number" ? M.maxMergeSeqLength : 20, this.implicitTypes = this.schema.compiledImplicit, this.typeMap = this.schema.compiledTypeMap, this.length = f.length, this.position = 0, this.line = 0, this.lineStart = 0, this.lineIndent = 0, this.depth = 0, this.firstTabInLine = -1, this.documents = [], this.anchorMapTransactions = [];
        }
        function it(f, M) {
            let L = {
                name: f.filename,
                buffer: f.input.slice(0, -1),
                position: f.position,
                line: f.line,
                column: f.position - f.lineStart
            };
            return L.snippet = a(L), new t(M, L);
        }
        function en(f, M) {
            throw it(f, M);
        }
        function St(f, M) {
            f.onWarning && f.onWarning.call(null, it(f, M));
        }
        function ht(f, M, L) {
            let O = f.anchorMapTransactions;
            if (O.length !== 0) {
                let A = O[O.length - 1];
                u.call(A, M) || (A[M] = {
                    existed: u.call(f.anchorMap, M),
                    value: f.anchorMap[M]
                });
            }
            f.anchorMap[M] = L;
        }
        function pf(f) {
            f.anchorMapTransactions.push(Object.create(null));
        }
        function qa(f) {
            let M = f.anchorMapTransactions.pop(), L = f.anchorMapTransactions;
            if (L.length === 0) return;
            let O = L[L.length - 1], A = Object.keys(M);
            for(let V = 0, h = A.length; V < h; V += 1){
                let w = A[V];
                u.call(O, w) || (O[w] = M[w]);
            }
        }
        function pn(f) {
            let M = f.anchorMapTransactions.pop(), L = Object.keys(M);
            for(let O = L.length - 1; O >= 0; O -= 1){
                let A = M[L[O]];
                A.existed ? f.anchorMap[L[O]] = A.value : delete f.anchorMap[L[O]];
            }
        }
        function er(f) {
            return {
                position: f.position,
                line: f.line,
                lineStart: f.lineStart,
                lineIndent: f.lineIndent,
                firstTabInLine: f.firstTabInLine,
                tag: f.tag,
                anchor: f.anchor,
                kind: f.kind,
                result: f.result
            };
        }
        function Tr(f, M) {
            f.position = M.position, f.line = M.line, f.lineStart = M.lineStart, f.lineIndent = M.lineIndent, f.firstTabInLine = M.firstTabInLine, f.tag = M.tag, f.anchor = M.anchor, f.kind = M.kind, f.result = M.result;
        }
        var lr = {
            YAML: function(M, L, O) {
                M.version !== null && en(M, "duplication of %YAML directive"), O.length !== 1 && en(M, "YAML directive accepts exactly one argument");
                let A = /^([0-9]+)\.([0-9]+)$/.exec(O[0]);
                A === null && en(M, "ill-formed argument of the YAML directive");
                let V = parseInt(A[1], 10), h = parseInt(A[2], 10);
                V !== 1 && en(M, "unacceptable YAML version of the document"), M.version = O[0], M.checkLineBreaks = h < 2, h !== 1 && h !== 2 && St(M, "unsupported YAML version of the document");
            },
            TAG: function(M, L, O) {
                let A;
                O.length !== 2 && en(M, "TAG directive accepts exactly two arguments");
                let V = O[0];
                A = O[1], $.test(V) || en(M, "ill-formed tag handle (first argument) of the TAG directive"), u.call(M.tagMap, V) && en(M, 'there is a previously declared suffix for "' + V + '" tag handle'), q.test(A) || en(M, "ill-formed tag prefix (second argument) of the TAG directive");
                try {
                    A = decodeURIComponent(A);
                } catch  {
                    en(M, "tag prefix is malformed: " + A);
                }
                M.tagMap[V] = A;
            }
        };
        function on(f, M, L, O) {
            if (M < L) {
                let A = f.input.slice(M, L);
                if (O) for(let V = 0, h = A.length; V < h; V += 1){
                    let w = A.charCodeAt(V);
                    w === 9 || w >= 32 && w <= 1114111 || en(f, "expected valid JSON character");
                }
                else D.test(A) && en(f, "the stream contains non-printable characters");
                f.result += A;
            }
        }
        function X(f, M, L, O) {
            e.isObject(L) || en(f, "cannot merge mappings; the provided source object is unacceptable");
            let A = Object.keys(L);
            for(let V = 0, h = A.length; V < h; V += 1){
                let w = A[V];
                u.call(M, w) || (Te(M, w, L[w]), O[w] = !0);
            }
        }
        function Zn(f, M, L, O, A, V, h, w, B) {
            if (Array.isArray(A)) {
                A = Array.prototype.slice.call(A);
                for(let H = 0, P = A.length; H < P; H += 1)Array.isArray(A[H]) && en(f, "nested arrays are not supported inside keys"), typeof A == "object" && z(A[H]) === "[object Object]" && (A[H] = "[object Object]");
            }
            if (typeof A == "object" && z(A) === "[object Object]" && (A = "[object Object]"), A = String(A), M === null && (M = {}), O === "tag:yaml.org,2002:merge") {
                if (Array.isArray(V)) {
                    V.length > f.maxMergeSeqLength && en(f, "merge sequence length exceeded maxMergeSeqLength (" + f.maxMergeSeqLength + ")");
                    let H = new Set;
                    for(let P = 0, U = V.length; P < U; P += 1){
                        let W = V[P];
                        H.has(W) || (H.add(W), X(f, M, W, L));
                    }
                } else X(f, M, V, L);
            } else !f.json && !u.call(L, A) && u.call(M, A) && (f.line = h || f.line, f.lineStart = w || f.lineStart, f.position = B || f.position, en(f, "duplicated mapping key")), Te(M, A, V), delete L[A];
            return M;
        }
        function Un(f) {
            let M = f.input.charCodeAt(f.position);
            M === 10 ? f.position++ : M === 13 ? (f.position++, f.input.charCodeAt(f.position) === 10 && f.position++) : en(f, "a line break is expected"), f.line += 1, f.lineStart = f.position, f.firstTabInLine = -1;
        }
        function Vn(f, M, L) {
            let O = 0, A = f.input.charCodeAt(f.position);
            for(; A !== 0;){
                for(; x(A);)A === 9 && f.firstTabInLine === -1 && (f.firstTabInLine = f.position), A = f.input.charCodeAt(++f.position);
                if (M && A === 35) do A = f.input.charCodeAt(++f.position);
                while (A !== 10 && A !== 13 && A !== 0);
                if (S(A)) for(Un(f), A = f.input.charCodeAt(f.position), O++, f.lineIndent = 0; A === 32;)f.lineIndent++, A = f.input.charCodeAt(++f.position);
                else break;
            }
            return L !== -1 && O !== 0 && f.lineIndent < L && St(f, "deficient indentation"), O;
        }
        function qr(f) {
            let M = f.position, L = f.input.charCodeAt(M);
            return !!((L === 45 || L === 46) && L === f.input.charCodeAt(M + 1) && L === f.input.charCodeAt(M + 2) && (M += 3, L = f.input.charCodeAt(M), L === 0 || Y(L)));
        }
        function ar(f, M) {
            M === 1 ? f.result += " " : M > 1 && (f.result += e.repeat(`
`, M - 1));
        }
        function Lr(f, M, L) {
            let O, A, V, h, w, B, H = f.kind, P = f.result, U = f.input.charCodeAt(f.position);
            if (Y(U) || Yn(U) || U === 35 || U === 38 || U === 42 || U === 33 || U === 124 || U === 62 || U === 39 || U === 34 || U === 37 || U === 64 || U === 96) return !1;
            if (U === 63 || U === 45) {
                let W = f.input.charCodeAt(f.position + 1);
                if (Y(W) || L && Yn(W)) return !1;
            }
            for(f.kind = "scalar", f.result = "", O = A = f.position, V = !1; U !== 0;){
                if (U === 58) {
                    let W = f.input.charCodeAt(f.position + 1);
                    if (Y(W) || L && Yn(W)) break;
                } else if (U === 35) {
                    if (Y(f.input.charCodeAt(f.position - 1))) break;
                } else {
                    if (f.position === f.lineStart && qr(f) || L && Yn(U)) break;
                    if (S(U)) {
                        if (h = f.line, w = f.lineStart, B = f.lineIndent, Vn(f, !1, -1), f.lineIndent >= M) {
                            V = !0, U = f.input.charCodeAt(f.position);
                            continue;
                        } else {
                            f.position = A, f.line = h, f.lineStart = w, f.lineIndent = B;
                            break;
                        }
                    }
                }
                V && (on(f, O, A, !1), ar(f, f.line - h), O = A = f.position, V = !1), x(U) || (A = f.position + 1), U = f.input.charCodeAt(++f.position);
            }
            return on(f, O, A, !1), f.result ? !0 : (f.kind = H, f.result = P, !1);
        }
        function Rt(f, M) {
            let L, O, A = f.input.charCodeAt(f.position);
            if (A !== 39) return !1;
            for(f.kind = "scalar", f.result = "", f.position++, L = O = f.position; (A = f.input.charCodeAt(f.position)) !== 0;)if (A === 39) {
                if (on(f, L, f.position, !0), A = f.input.charCodeAt(++f.position), A === 39) L = f.position, f.position++, O = f.position;
                else return !0;
            } else S(A) ? (on(f, L, O, !0), ar(f, Vn(f, !1, M)), L = O = f.position) : f.position === f.lineStart && qr(f) ? en(f, "unexpected end of the document within a single quoted scalar") : (f.position++, x(A) || (O = f.position));
            en(f, "unexpected end of the stream within a single quoted scalar");
        }
        function Me(f, M) {
            let L, O, A, V = f.input.charCodeAt(f.position);
            if (V !== 34) return !1;
            for(f.kind = "scalar", f.result = "", f.position++, L = O = f.position; (V = f.input.charCodeAt(f.position)) !== 0;){
                if (V === 34) return on(f, L, f.position, !0), f.position++, !0;
                if (V === 92) {
                    if (on(f, L, f.position, !0), V = f.input.charCodeAt(++f.position), S(V)) Vn(f, !1, M);
                    else if (V < 256 && Fr[V]) f.result += Vr[V], f.position++;
                    else if ((A = cr(V)) > 0) {
                        let h = A, w = 0;
                        for(; h > 0; h--)V = f.input.charCodeAt(++f.position), (A = dr(V)) >= 0 ? w = (w << 4) + A : en(f, "expected hexadecimal character");
                        f.result += fa(w), f.position++;
                    } else en(f, "unknown escape sequence");
                    L = O = f.position;
                } else S(V) ? (on(f, L, O, !0), ar(f, Vn(f, !1, M)), L = O = f.position) : f.position === f.lineStart && qr(f) ? en(f, "unexpected end of the document within a double quoted scalar") : (f.position++, x(V) || (O = f.position));
            }
            en(f, "unexpected end of the stream within a double quoted scalar");
        }
        function Dt(f, M) {
            let L = !0, O, A, V, h = f.tag, w, B = f.anchor, H, P, U, W, ln = Object.create(null), an, Mn, Rn, sr = f.input.charCodeAt(f.position);
            if (sr === 91) H = 93, W = !1, w = [];
            else if (sr === 123) H = 125, W = !0, w = {};
            else return !1;
            for(f.anchor !== null && ht(f, f.anchor, w), sr = f.input.charCodeAt(++f.position); sr !== 0;){
                if (Vn(f, !0, M), sr = f.input.charCodeAt(f.position), sr === H) return f.position++, f.tag = h, f.anchor = B, f.kind = W ? "mapping" : "sequence", f.result = w, !0;
                L ? sr === 44 && en(f, "expected the node content, but found ','") : en(f, "missed comma between flow collection entries"), Mn = an = Rn = null, P = U = !1, sr === 63 && Y(f.input.charCodeAt(f.position + 1)) && (P = U = !0, f.position++, Vn(f, !0, M)), O = f.line, A = f.lineStart, V = f.position, Qn(f, M, i, !1, !0), Mn = f.tag, an = f.result, Vn(f, !0, M), sr = f.input.charCodeAt(f.position), (U || f.line === O) && sr === 58 && (P = !0, sr = f.input.charCodeAt(++f.position), Vn(f, !0, M), Qn(f, M, i, !1, !0), Rn = f.result), W ? Zn(f, w, ln, Mn, an, Rn, O, A, V) : P ? w.push(Zn(f, null, ln, Mn, an, Rn, O, A, V)) : w.push(an), Vn(f, !0, M), sr = f.input.charCodeAt(f.position), sr === 44 ? (L = !0, sr = f.input.charCodeAt(++f.position)) : L = !1;
            }
            en(f, "unexpected end of the stream within a flow collection");
        }
        function gt(f, M) {
            let L, O = m, A = !1, V = !1, h = M, w = 0, B = !1, H, P = f.input.charCodeAt(f.position);
            if (P === 124) L = !1;
            else if (P === 62) L = !0;
            else return !1;
            for(f.kind = "scalar", f.result = ""; P !== 0;)if (P = f.input.charCodeAt(++f.position), P === 43 || P === 45) m === O ? O = P === 43 ? _ : v : en(f, "repeat of a chomping mode identifier");
            else if ((H = Xr(P)) >= 0) H === 0 ? en(f, "bad explicit indentation width of a block scalar; it cannot be less than one") : V ? en(f, "repeat of an indentation width identifier") : (h = M + H - 1, V = !0);
            else break;
            if (x(P)) {
                do P = f.input.charCodeAt(++f.position);
                while (x(P));
                if (P === 35) do P = f.input.charCodeAt(++f.position);
                while (!S(P) && P !== 0);
            }
            for(; P !== 0;){
                for(Un(f), f.lineIndent = 0, P = f.input.charCodeAt(f.position); (!V || f.lineIndent < h) && P === 32;)f.lineIndent++, P = f.input.charCodeAt(++f.position);
                if (!V && f.lineIndent > h && (h = f.lineIndent), S(P)) {
                    w++;
                    continue;
                }
                if (!V && h === 0 && en(f, "missing indentation for block scalar"), f.lineIndent < h) {
                    O === _ ? f.result += e.repeat(`
`, A ? 1 + w : w) : O === m && A && (f.result += `
`);
                    break;
                }
                L ? x(P) ? (B = !0, f.result += e.repeat(`
`, A ? 1 + w : w)) : B ? (B = !1, f.result += e.repeat(`
`, w + 1)) : w === 0 ? A && (f.result += " ") : f.result += e.repeat(`
`, w) : f.result += e.repeat(`
`, A ? 1 + w : w), A = !0, V = !0, w = 0;
                let U = f.position;
                for(; !S(P) && P !== 0;)P = f.input.charCodeAt(++f.position);
                on(f, U, f.position, !1);
            }
            return !0;
        }
        function Dr(f, M) {
            let L = f.tag, O = f.anchor, A = [], V = !1;
            if (f.firstTabInLine !== -1) return !1;
            f.anchor !== null && ht(f, f.anchor, A);
            let h = f.input.charCodeAt(f.position);
            for(; h !== 0 && (f.firstTabInLine !== -1 && (f.position = f.firstTabInLine, en(f, "tab characters must not be used in indentation")), !(h !== 45 || !Y(f.input.charCodeAt(f.position + 1))));){
                if (V = !0, f.position++, Vn(f, !0, -1) && f.lineIndent <= M) {
                    A.push(null), h = f.input.charCodeAt(f.position);
                    continue;
                }
                let w = f.line;
                if (Qn(f, M, l, !1, !0), A.push(f.result), Vn(f, !0, -1), h = f.input.charCodeAt(f.position), (f.line === w || f.lineIndent > M) && h !== 0) en(f, "bad indentation of a sequence entry");
                else if (f.lineIndent < M) break;
            }
            return V ? (f.tag = L, f.anchor = O, f.kind = "sequence", f.result = A, !0) : !1;
        }
        function wn(f, M, L) {
            let O, A, V, h, w = f.tag, B = f.anchor, H = {}, P = Object.create(null), U = null, W = null, ln = null, an = !1, Mn = !1;
            if (f.firstTabInLine !== -1) return !1;
            f.anchor !== null && ht(f, f.anchor, H);
            let Rn = f.input.charCodeAt(f.position);
            for(; Rn !== 0;){
                !an && f.firstTabInLine !== -1 && (f.position = f.firstTabInLine, en(f, "tab characters must not be used in indentation"));
                let sr = f.input.charCodeAt(f.position + 1), Zr = f.line;
                if ((Rn === 63 || Rn === 58) && Y(sr)) Rn === 63 ? (an && (Zn(f, H, P, U, W, null, A, V, h), U = W = ln = null), Mn = !0, an = !0, O = !0) : an ? (an = !1, O = !0) : en(f, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line"), f.position += 1, Rn = sr;
                else {
                    if (A = f.line, V = f.lineStart, h = f.position, !Qn(f, L, c, !1, !0)) break;
                    if (f.line === Zr) {
                        for(Rn = f.input.charCodeAt(f.position); x(Rn);)Rn = f.input.charCodeAt(++f.position);
                        if (Rn === 58) Rn = f.input.charCodeAt(++f.position), Y(Rn) || en(f, "a whitespace character is expected after the key-value separator within a block mapping"), an && (Zn(f, H, P, U, W, null, A, V, h), U = W = ln = null), Mn = !0, an = !1, O = !1, U = f.tag, W = f.result;
                        else if (Mn) en(f, "can not read an implicit mapping pair; a colon is missed");
                        else return f.tag = w, f.anchor = B, !0;
                    } else if (Mn) en(f, "can not read a block mapping entry; a multiline key may not be an implicit key");
                    else return f.tag = w, f.anchor = B, !0;
                }
                if ((f.line === Zr || f.lineIndent > M) && (an && (A = f.line, V = f.lineStart, h = f.position), Qn(f, M, d, !0, O) && (an ? W = f.result : ln = f.result), an || (Zn(f, H, P, U, W, ln, A, V, h), U = W = ln = null), Vn(f, !0, -1), Rn = f.input.charCodeAt(f.position)), (f.line === Zr || f.lineIndent > M) && Rn !== 0) en(f, "bad indentation of a mapping entry");
                else if (f.lineIndent < M) break;
            }
            return an && Zn(f, H, P, U, W, null, A, V, h), Mn && (f.tag = w, f.anchor = B, f.kind = "mapping", f.result = H), Mn;
        }
        function Xn(f) {
            let M = !1, L = !1, O, A, V = f.input.charCodeAt(f.position);
            if (V !== 33) return !1;
            f.tag !== null && en(f, "duplication of a tag property"), V = f.input.charCodeAt(++f.position), V === 60 ? (M = !0, V = f.input.charCodeAt(++f.position)) : V === 33 ? (L = !0, O = "!!", V = f.input.charCodeAt(++f.position)) : O = "!";
            let h = f.position;
            if (M) {
                do V = f.input.charCodeAt(++f.position);
                while (V !== 0 && V !== 62);
                f.position < f.length ? (A = f.input.slice(h, f.position), V = f.input.charCodeAt(++f.position)) : en(f, "unexpected end of the stream within a verbatim tag");
            } else {
                for(; V !== 0 && !Y(V);)V === 33 && (L ? en(f, "tag suffix cannot contain exclamation marks") : (O = f.input.slice(h - 1, f.position + 1), $.test(O) || en(f, "named tag handle cannot contain such characters"), L = !0, h = f.position + 1)), V = f.input.charCodeAt(++f.position);
                A = f.input.slice(h, f.position), I.test(A) && en(f, "tag suffix cannot contain flow indicator characters");
            }
            A && !q.test(A) && en(f, "tag name cannot contain such characters: " + A);
            try {
                A = decodeURIComponent(A);
            } catch  {
                en(f, "tag name is malformed: " + A);
            }
            return M ? f.tag = A : u.call(f.tagMap, O) ? f.tag = f.tagMap[O] + A : O === "!" ? f.tag = "!" + A : O === "!!" ? f.tag = "tag:yaml.org,2002:" + A : en(f, 'undeclared tag handle "' + O + '"'), !0;
        }
        function gn(f) {
            let M = f.input.charCodeAt(f.position);
            if (M !== 38) return !1;
            f.anchor !== null && en(f, "duplication of an anchor property"), M = f.input.charCodeAt(++f.position);
            let L = f.position;
            for(; M !== 0 && !Y(M) && !Yn(M);)M = f.input.charCodeAt(++f.position);
            return f.position === L && en(f, "name of an anchor node must contain at least one character"), f.anchor = f.input.slice(L, f.position), !0;
        }
        function Cn(f) {
            let M = f.input.charCodeAt(f.position);
            if (M !== 42) return !1;
            M = f.input.charCodeAt(++f.position);
            let L = f.position;
            for(; M !== 0 && !Y(M) && !Yn(M);)M = f.input.charCodeAt(++f.position);
            f.position === L && en(f, "name of an alias node must contain at least one character");
            let O = f.input.slice(L, f.position);
            return u.call(f.anchorMap, O) || en(f, 'unidentified alias "' + O + '"'), f.result = f.anchorMap[O], Vn(f, !0, -1), !0;
        }
        function nr(f, M, L, O) {
            let A = er(f);
            return pf(f), Tr(f, M), f.tag = null, f.anchor = null, f.kind = null, f.result = null, wn(f, L, O) && f.kind === "mapping" ? (qa(f), !0) : (pn(f), Tr(f, A), !1);
        }
        function Qn(f, M, L, O, A) {
            let V, h, w = 1, B = !1, H = !1, P = null, U, W, ln;
            f.depth >= f.maxDepth && en(f, "nesting exceeded maxDepth (" + f.maxDepth + ")"), f.depth += 1, f.listener !== null && f.listener("open", f), f.tag = null, f.anchor = null, f.kind = null, f.result = null;
            let an = V = h = d === L || l === L;
            if (O && Vn(f, !0, -1) && (B = !0, f.lineIndent > M ? w = 1 : f.lineIndent === M ? w = 0 : f.lineIndent < M && (w = -1)), w === 1) for(;;){
                let Mn = f.input.charCodeAt(f.position), Rn = er(f);
                if (B && (Mn === 33 && f.tag !== null || Mn === 38 && f.anchor !== null) || !Xn(f) && !gn(f)) break;
                P === null && (P = Rn), Vn(f, !0, -1) ? (B = !0, h = an, f.lineIndent > M ? w = 1 : f.lineIndent === M ? w = 0 : f.lineIndent < M && (w = -1)) : h = !1;
            }
            if (h && (h = B || A), w === 1 || d === L) {
                if (i === L || c === L ? W = M : W = M + 1, ln = f.position - f.lineStart, w === 1) {
                    if (h && (Dr(f, ln) || wn(f, ln, W)) || Dt(f, W)) H = !0;
                    else {
                        let Mn = f.input.charCodeAt(f.position);
                        P !== null && an && !h && Mn !== 124 && Mn !== 62 && nr(f, P, P.position - P.lineStart, W) || V && gt(f, W) || Rt(f, W) || Me(f, W) ? H = !0 : Cn(f) ? (H = !0, (f.tag !== null || f.anchor !== null) && en(f, "alias node should not have any properties")) : Lr(f, W, i === L) && (H = !0, f.tag === null && (f.tag = "?")), f.anchor !== null && ht(f, f.anchor, f.result);
                    }
                } else w === 0 && (H = h && Dr(f, ln));
            }
            if (f.tag === null) f.anchor !== null && ht(f, f.anchor, f.result);
            else if (f.tag === "?") {
                f.result !== null && f.kind !== "scalar" && en(f, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + f.kind + '"');
                for(let Mn = 0, Rn = f.implicitTypes.length; Mn < Rn; Mn += 1)if (U = f.implicitTypes[Mn], U.resolve(f.result)) {
                    f.result = U.construct(f.result), f.tag = U.tag, f.anchor !== null && ht(f, f.anchor, f.result);
                    break;
                }
            } else if (f.tag !== "!") {
                if (u.call(f.typeMap[f.kind || "fallback"], f.tag)) U = f.typeMap[f.kind || "fallback"][f.tag];
                else {
                    U = null;
                    let Mn = f.typeMap.multi[f.kind || "fallback"];
                    for(let Rn = 0, sr = Mn.length; Rn < sr; Rn += 1)if (f.tag.slice(0, Mn[Rn].tag.length) === Mn[Rn].tag) {
                        U = Mn[Rn];
                        break;
                    }
                }
                U || en(f, "unknown tag !<" + f.tag + ">"), f.result !== null && U.kind !== f.kind && en(f, "unacceptable node kind for !<" + f.tag + '> tag; it should be "' + U.kind + '", not "' + f.kind + '"'), U.resolve(f.result, f.tag) ? (f.result = U.construct(f.result, f.tag), f.anchor !== null && ht(f, f.anchor, f.result)) : en(f, "cannot resolve a node with !<" + f.tag + "> explicit tag");
            }
            return f.listener !== null && f.listener("close", f), f.depth -= 1, f.tag !== null || f.anchor !== null || H;
        }
        function Sr(f) {
            let M = f.position, L = !1, O;
            for(f.version = null, f.checkLineBreaks = f.legacy, f.tagMap = Object.create(null), f.anchorMap = Object.create(null); (O = f.input.charCodeAt(f.position)) !== 0 && (Vn(f, !0, -1), O = f.input.charCodeAt(f.position), !(f.lineIndent > 0 || O !== 37));){
                L = !0, O = f.input.charCodeAt(++f.position);
                let A = f.position;
                for(; O !== 0 && !Y(O);)O = f.input.charCodeAt(++f.position);
                let V = f.input.slice(A, f.position), h = [];
                for(V.length < 1 && en(f, "directive name must not be less than one character in length"); O !== 0;){
                    for(; x(O);)O = f.input.charCodeAt(++f.position);
                    if (O === 35) {
                        do O = f.input.charCodeAt(++f.position);
                        while (O !== 0 && !S(O));
                        break;
                    }
                    if (S(O)) break;
                    for(A = f.position; O !== 0 && !Y(O);)O = f.input.charCodeAt(++f.position);
                    h.push(f.input.slice(A, f.position));
                }
                O !== 0 && Un(f), u.call(lr, V) ? lr[V](f, V, h) : St(f, 'unknown document directive "' + V + '"');
            }
            if (Vn(f, !0, -1), f.lineIndent === 0 && f.input.charCodeAt(f.position) === 45 && f.input.charCodeAt(f.position + 1) === 45 && f.input.charCodeAt(f.position + 2) === 45 ? (f.position += 3, Vn(f, !0, -1)) : L && en(f, "directives end mark is expected"), Qn(f, f.lineIndent - 1, d, !1, !0), Vn(f, !0, -1), f.checkLineBreaks && T.test(f.input.slice(M, f.position)) && St(f, "non-ASCII line breaks are interpreted as content"), f.documents.push(f.result), f.position === f.lineStart && qr(f)) {
                f.input.charCodeAt(f.position) === 46 && (f.position += 3, Vn(f, !0, -1));
                return;
            }
            f.position < f.length - 1 && en(f, "end of the stream or a document separator is expected");
        }
        function ae(f, M) {
            f = String(f), M = M || {}, f.length !== 0 && (f.charCodeAt(f.length - 1) !== 10 && f.charCodeAt(f.length - 1) !== 13 && (f += `
`), f.charCodeAt(0) === 65279 && (f = f.slice(1)));
            let L = new Er(f, M), O = f.indexOf("\0");
            for(O !== -1 && (L.position = O, en(L, "null byte is not allowed in input")), L.input += "\0"; L.input.charCodeAt(L.position) === 32;)L.lineIndent += 1, L.position += 1;
            for(; L.position < L.length - 1;)Sr(L);
            return L.documents;
        }
        function ca(f, M, L) {
            M !== null && typeof M == "object" && typeof L > "u" && (L = M, M = null);
            let O = ae(f, L);
            if (typeof M != "function") return O;
            for(let A = 0, V = O.length; A < V; A += 1)M(O[A]);
        }
        function mf(f, M) {
            let L = ae(f, M);
            if (L.length !== 0) {
                if (L.length === 1) return L[0];
                throw new t("expected a single document in the stream, but found more");
            }
        }
        r.exports.loadAll = ca, r.exports.load = mf;
    }), TH = zr((n, r)=>{
        var e = pl(), t = ml(), a = D1(), o = Object.prototype.toString, u = Object.prototype.hasOwnProperty, i = 65279, c = 9, l = 10, d = 13, m = 32, v = 33, _ = 34, D = 35, T = 37, I = 38, $ = 39, q = 42, z = 44, S = 45, x = 58, Y = 61, Yn = 62, dr = 63, cr = 64, Xr = 91, te = 93, fa = 96, Te = 123, Fr = 124, Vr = 125, Er = {};
        Er[0] = "\\0", Er[7] = "\\a", Er[8] = "\\b", Er[9] = "\\t", Er[10] = "\\n", Er[11] = "\\v", Er[12] = "\\f", Er[13] = "\\r", Er[27] = "\\e", Er[34] = '\\"', Er[92] = "\\\\", Er[133] = "\\N", Er[160] = "\\_", Er[8232] = "\\L", Er[8233] = "\\P";
        var it = [
            "y",
            "Y",
            "yes",
            "Yes",
            "YES",
            "on",
            "On",
            "ON",
            "n",
            "N",
            "no",
            "No",
            "NO",
            "off",
            "Off",
            "OFF"
        ], en = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
        function St(h, w) {
            if (w === null) return {};
            let B = {}, H = Object.keys(w);
            for(let P = 0, U = H.length; P < U; P += 1){
                let W = H[P], ln = String(w[W]);
                W.slice(0, 2) === "!!" && (W = "tag:yaml.org,2002:" + W.slice(2));
                let an = h.compiledTypeMap.fallback[W];
                an && u.call(an.styleAliases, ln) && (ln = an.styleAliases[ln]), B[W] = ln;
            }
            return B;
        }
        function ht(h) {
            let w, B, H = h.toString(16).toUpperCase();
            if (h <= 255) w = "x", B = 2;
            else if (h <= 65535) w = "u", B = 4;
            else if (h <= 4294967295) w = "U", B = 8;
            else throw new t("code point within a string may not be greater than 0xFFFFFFFF");
            return "\\" + w + e.repeat("0", B - H.length) + H;
        }
        var pf = 1, qa = 2;
        function pn(h) {
            this.schema = h.schema || a, this.indent = Math.max(1, h.indent || 2), this.noArrayIndent = h.noArrayIndent || !1, this.skipInvalid = h.skipInvalid || !1, this.flowLevel = e.isNothing(h.flowLevel) ? -1 : h.flowLevel, this.styleMap = St(this.schema, h.styles || null), this.sortKeys = h.sortKeys || !1, this.lineWidth = h.lineWidth || 80, this.noRefs = h.noRefs || !1, this.noCompatMode = h.noCompatMode || !1, this.condenseFlow = h.condenseFlow || !1, this.quotingType = h.quotingType === '"' ? qa : pf, this.forceQuotes = h.forceQuotes || !1, this.replacer = typeof h.replacer == "function" ? h.replacer : null, this.implicitTypes = this.schema.compiledImplicit, this.explicitTypes = this.schema.compiledExplicit, this.tag = null, this.result = "", this.duplicates = [], this.usedDuplicates = null;
        }
        function er(h, w) {
            let B = e.repeat(" ", w), H = 0, P = "", U = h.length;
            for(; H < U;){
                let W, ln = h.indexOf(`
`, H);
                ln === -1 ? (W = h.slice(H), H = U) : (W = h.slice(H, ln + 1), H = ln + 1), W.length && W !== `
` && (P += B), P += W;
            }
            return P;
        }
        function Tr(h, w) {
            return `
` + e.repeat(" ", h.indent * w);
        }
        function lr(h, w) {
            for(let B = 0, H = h.implicitTypes.length; B < H; B += 1)if (h.implicitTypes[B].resolve(w)) return !0;
            return !1;
        }
        function on(h) {
            return h === m || h === c;
        }
        function X(h) {
            return h >= 32 && h <= 126 || h >= 161 && h <= 55295 && h !== 8232 && h !== 8233 || h >= 57344 && h <= 65533 && h !== i || h >= 65536 && h <= 1114111;
        }
        function Zn(h) {
            return X(h) && h !== i && h !== d && h !== l;
        }
        function Un(h, w, B) {
            let H = Zn(h), P = H && !on(h);
            return (B ? H : H && h !== z && h !== Xr && h !== te && h !== Te && h !== Vr) && h !== D && !(w === x && !P) || Zn(w) && !on(w) && h === D || w === x && P;
        }
        function Vn(h) {
            return X(h) && h !== i && !on(h) && h !== S && h !== dr && h !== x && h !== z && h !== Xr && h !== te && h !== Te && h !== Vr && h !== D && h !== I && h !== q && h !== v && h !== Fr && h !== Y && h !== Yn && h !== $ && h !== _ && h !== T && h !== cr && h !== fa;
        }
        function qr(h) {
            return !on(h) && h !== x;
        }
        function ar(h, w) {
            let B = h.charCodeAt(w), H;
            return B >= 55296 && B <= 56319 && w + 1 < h.length && (H = h.charCodeAt(w + 1), H >= 56320 && H <= 57343) ? (B - 55296) * 1024 + H - 56320 + 65536 : B;
        }
        function Lr(h) {
            return /^\n* /.test(h);
        }
        var Rt = 1, Me = 2, Dt = 3, gt = 4, Dr = 5;
        function wn(h, w, B, H, P, U, W, ln) {
            let an, Mn = 0, Rn = null, sr = !1, Zr = !1, x1 = H !== -1, df = -1, _f = Vn(ar(h, 0)) && qr(ar(h, h.length - 1));
            if (w || W) for(an = 0; an < h.length; Mn >= 65536 ? an += 2 : an++){
                if (Mn = ar(h, an), !X(Mn)) return Dr;
                _f = _f && Un(Mn, Rn, ln), Rn = Mn;
            }
            else {
                for(an = 0; an < h.length; Mn >= 65536 ? an += 2 : an++){
                    if (Mn = ar(h, an), Mn === l) sr = !0, x1 && (Zr = Zr || an - df - 1 > H && h[df + 1] !== " ", df = an);
                    else if (!X(Mn)) return Dr;
                    _f = _f && Un(Mn, Rn, ln), Rn = Mn;
                }
                Zr = Zr || x1 && an - df - 1 > H && h[df + 1] !== " ";
            }
            return !sr && !Zr ? _f && !W && !P(h) ? Rt : U === qa ? Dr : Me : B > 9 && Lr(h) ? Dr : W ? U === qa ? Dr : Me : Zr ? gt : Dt;
        }
        function Xn(h, w, B, H, P) {
            h.dump = function() {
                if (w.length === 0) return h.quotingType === qa ? '""' : "''";
                if (!h.noCompatMode && (it.indexOf(w) !== -1 || en.test(w))) return h.quotingType === qa ? '"' + w + '"' : "'" + w + "'";
                let U = h.indent * Math.max(1, B), W = h.lineWidth === -1 ? -1 : Math.max(Math.min(h.lineWidth, 40), h.lineWidth - U), ln = H || h.flowLevel > -1 && B >= h.flowLevel;
                function an(Mn) {
                    return lr(h, Mn);
                }
                switch(wn(w, ln, h.indent, W, an, h.quotingType, h.forceQuotes && !H, P)){
                    case Rt:
                        return w;
                    case Me:
                        return "'" + w.replace(/'/g, "''") + "'";
                    case Dt:
                        return "|" + gn(w, h.indent) + Cn(er(w, U));
                    case gt:
                        return ">" + gn(w, h.indent) + Cn(er(nr(w, W), U));
                    case Dr:
                        return '"' + Sr(w, W) + '"';
                    default:
                        throw new t("impossible error: invalid scalar style");
                }
            }();
        }
        function gn(h, w) {
            let B = Lr(h) ? String(w) : "", H = h[h.length - 1] === `
`;
            return B + (H && (h[h.length - 2] === `
` || h === `
`) ? "+" : H ? "" : "-") + `
`;
        }
        function Cn(h) {
            return h[h.length - 1] === `
` ? h.slice(0, -1) : h;
        }
        function nr(h, w) {
            let B = /(\n+)([^\n]*)/g, H = function() {
                let ln = h.indexOf(`
`);
                return ln = ln !== -1 ? ln : h.length, B.lastIndex = ln, Qn(h.slice(0, ln), w);
            }(), P = h[0] === `
` || h[0] === " ", U, W;
            for(; W = B.exec(h);){
                let ln = W[1], an = W[2];
                U = an[0] === " ", H += ln + (!P && !U && an !== "" ? `
` : "") + Qn(an, w), P = U;
            }
            return H;
        }
        function Qn(h, w) {
            if (h === "" || h[0] === " ") return h;
            let B = / [^ ]/g, H, P = 0, U, W = 0, ln = 0, an = "";
            for(; H = B.exec(h);)ln = H.index, ln - P > w && (U = W > P ? W : ln, an += `
` + h.slice(P, U), P = U + 1), W = ln;
            return an += `
`, h.length - P > w && W > P ? an += h.slice(P, W) + `
` + h.slice(W + 1) : an += h.slice(P), an.slice(1);
        }
        function Sr(h) {
            let w = "", B = 0;
            for(let H = 0; H < h.length; B >= 65536 ? H += 2 : H++){
                B = ar(h, H);
                let P = Er[B];
                !P && X(B) ? (w += h[H], B >= 65536 && (w += h[H + 1])) : w += P || ht(B);
            }
            return w;
        }
        function ae(h, w, B) {
            let H = "", P = h.tag;
            for(let U = 0, W = B.length; U < W; U += 1){
                let ln = B[U];
                h.replacer && (ln = h.replacer.call(B, String(U), ln)), (L(h, w, ln, !1, !1) || typeof ln > "u" && L(h, w, null, !1, !1)) && (H !== "" && (H += "," + (h.condenseFlow ? "" : " ")), H += h.dump);
            }
            h.tag = P, h.dump = "[" + H + "]";
        }
        function ca(h, w, B, H) {
            let P = "", U = h.tag;
            for(let W = 0, ln = B.length; W < ln; W += 1){
                let an = B[W];
                h.replacer && (an = h.replacer.call(B, String(W), an)), (L(h, w + 1, an, !0, !0, !1, !0) || typeof an > "u" && L(h, w + 1, null, !0, !0, !1, !0)) && ((!H || P !== "") && (P += Tr(h, w)), h.dump && l === h.dump.charCodeAt(0) ? P += "-" : P += "- ", P += h.dump);
            }
            h.tag = U, h.dump = P || "[]";
        }
        function mf(h, w, B) {
            let H = "", P = h.tag, U = Object.keys(B);
            for(let W = 0, ln = U.length; W < ln; W += 1){
                let an = "";
                H !== "" && (an += ", "), h.condenseFlow && (an += '"');
                let Mn = U[W], Rn = B[Mn];
                h.replacer && (Rn = h.replacer.call(B, Mn, Rn)), L(h, w, Mn, !1, !1) && (h.dump.length > 1024 && (an += "? "), an += h.dump + (h.condenseFlow ? '"' : "") + ":" + (h.condenseFlow ? "" : " "), L(h, w, Rn, !1, !1) && (an += h.dump, H += an));
            }
            h.tag = P, h.dump = "{" + H + "}";
        }
        function f(h, w, B, H) {
            let P = "", U = h.tag, W = Object.keys(B);
            if (h.sortKeys === !0) W.sort();
            else if (typeof h.sortKeys == "function") W.sort(h.sortKeys);
            else if (h.sortKeys) throw new t("sortKeys must be a boolean or a function");
            for(let ln = 0, an = W.length; ln < an; ln += 1){
                let Mn = "";
                (!H || P !== "") && (Mn += Tr(h, w));
                let Rn = W[ln], sr = B[Rn];
                if (h.replacer && (sr = h.replacer.call(B, Rn, sr)), !L(h, w + 1, Rn, !0, !0, !0)) continue;
                let Zr = h.tag !== null && h.tag !== "?" || h.dump && h.dump.length > 1024;
                Zr && (h.dump && l === h.dump.charCodeAt(0) ? Mn += "?" : Mn += "? "), Mn += h.dump, Zr && (Mn += Tr(h, w)), L(h, w + 1, sr, !0, Zr) && (h.dump && l === h.dump.charCodeAt(0) ? Mn += ":" : Mn += ": ", Mn += h.dump, P += Mn);
            }
            h.tag = U, h.dump = P || "{}";
        }
        function M(h, w, B) {
            let H = B ? h.explicitTypes : h.implicitTypes;
            for(let P = 0, U = H.length; P < U; P += 1){
                let W = H[P];
                if ((W.instanceOf || W.predicate) && (!W.instanceOf || typeof w == "object" && w instanceof W.instanceOf) && (!W.predicate || W.predicate(w))) {
                    if (B ? W.multi && W.representName ? h.tag = W.representName(w) : h.tag = W.tag : h.tag = "?", W.represent) {
                        let ln = h.styleMap[W.tag] || W.defaultStyle, an;
                        if (o.call(W.represent) === "[object Function]") an = W.represent(w, ln);
                        else if (u.call(W.represent, ln)) an = W.represent[ln](w, ln);
                        else throw new t("!<" + W.tag + '> tag resolver accepts not "' + ln + '" style');
                        h.dump = an;
                    }
                    return !0;
                }
            }
            return !1;
        }
        function L(h, w, B, H, P, U, W) {
            h.tag = null, h.dump = B, M(h, B, !1) || M(h, B, !0);
            let ln = o.call(h.dump), an = H;
            H && (H = h.flowLevel < 0 || h.flowLevel > w);
            let Mn = ln === "[object Object]" || ln === "[object Array]", Rn, sr;
            if (Mn && (Rn = h.duplicates.indexOf(B), sr = Rn !== -1), (h.tag !== null && h.tag !== "?" || sr || h.indent !== 2 && w > 0) && (P = !1), sr && h.usedDuplicates[Rn]) h.dump = "*ref_" + Rn;
            else {
                if (Mn && sr && !h.usedDuplicates[Rn] && (h.usedDuplicates[Rn] = !0), ln === "[object Object]") H && Object.keys(h.dump).length !== 0 ? (f(h, w, h.dump, P), sr && (h.dump = "&ref_" + Rn + h.dump)) : (mf(h, w, h.dump), sr && (h.dump = "&ref_" + Rn + " " + h.dump));
                else if (ln === "[object Array]") H && h.dump.length !== 0 ? (h.noArrayIndent && !W && w > 0 ? ca(h, w - 1, h.dump, P) : ca(h, w, h.dump, P), sr && (h.dump = "&ref_" + Rn + h.dump)) : (ae(h, w, h.dump), sr && (h.dump = "&ref_" + Rn + " " + h.dump));
                else if (ln === "[object String]") h.tag !== "?" && Xn(h, h.dump, w, U, an);
                else {
                    if (ln === "[object Undefined]") return !1;
                    if (h.skipInvalid) return !1;
                    throw new t("unacceptable kind of an object to dump " + ln);
                }
                if (h.tag !== null && h.tag !== "?") {
                    let Zr = encodeURI(h.tag[0] === "!" ? h.tag.slice(1) : h.tag).replace(/!/g, "%21");
                    h.tag[0] === "!" ? Zr = "!" + Zr : Zr.slice(0, 18) === "tag:yaml.org,2002:" ? Zr = "!!" + Zr.slice(18) : Zr = "!<" + Zr + ">", h.dump = Zr + " " + h.dump;
                }
            }
            return !0;
        }
        function O(h, w) {
            let B = [], H = [];
            A(h, B, H);
            let P = H.length;
            for(let U = 0; U < P; U += 1)w.duplicates.push(B[H[U]]);
            w.usedDuplicates = new Array(P);
        }
        function A(h, w, B) {
            if (h !== null && typeof h == "object") {
                let H = w.indexOf(h);
                if (H !== -1) B.indexOf(H) === -1 && B.push(H);
                else if (w.push(h), Array.isArray(h)) for(let P = 0, U = h.length; P < U; P += 1)A(h[P], w, B);
                else {
                    let P = Object.keys(h);
                    for(let U = 0, W = P.length; U < W; U += 1)A(h[P[U]], w, B);
                }
            }
        }
        function V(h, w) {
            w = w || {};
            let B = new pn(w);
            B.noRefs || O(h, B);
            let H = h;
            return B.replacer && (H = B.replacer.call({
                "": H
            }, "", H)), L(B, 0, H, !0, !0) ? B.dump + `
` : "";
        }
        r.exports.dump = V;
    }), q4 = yH(zr((n, r)=>{
        var e = EH(), t = TH();
        function a(o, u) {
            return function() {
                throw new Error("Function yaml." + o + " is removed in js-yaml 4. Use yaml." + u + " instead, which is now safe by default.");
            };
        }
        r.exports.Type = ut(), r.exports.Schema = C4(), r.exports.FAILSAFE_SCHEMA = F4(), r.exports.JSON_SCHEMA = L4(), r.exports.CORE_SCHEMA = S4(), r.exports.DEFAULT_SCHEMA = D1(), r.exports.load = e.load, r.exports.loadAll = e.loadAll, r.exports.dump = t.dump, r.exports.YAMLException = ml(), r.exports.types = {
            binary: H4(),
            float: I4(),
            map: M4(),
            null: w4(),
            pairs: k4(),
            set: O4(),
            timestamp: R4(),
            bool: x4(),
            int: A4(),
            merge: N4(),
            omap: P4(),
            seq: T4(),
            str: E4()
        }, r.exports.safeLoad = a("safeLoad", "load"), r.exports.safeLoadAll = a("safeLoadAll", "loadAll"), r.exports.safeDump = a("safeDump", "dump");
    })(), 1), { Type: i3n, Schema: f3n, FAILSAFE_SCHEMA: c3n, JSON_SCHEMA: l3n, CORE_SCHEMA: s3n, DEFAULT_SCHEMA: p3n, load: m3n, loadAll: d3n, dump: _3n, YAMLException: v3n, types: h3n, safeLoad: D3n, safeLoadAll: g3n, safeDump: b3n } = q4.default, W4 = q4.default;
    function $4(n, r, e) {
        try {
            return r(W4.load(e));
        } catch (t) {
            return n(t.toString());
        }
    }
    var FH = js(Nt), U4 = k(fi(Nt)), wH = Z(su(Nt)), xH = function(n) {
        return $4(function(r) {
            return FH(Td.create(r));
        }, U4, n);
    }, B4 = function(n) {
        return wH(xH(n))(function(r) {
            return U4(r);
        });
    };
    function z4(n) {
        return function(r) {
            return function(e) {
                return function() {
                    return n(r, e).catch(function(t) {
                        throw new Error(t);
                    });
                };
            };
        };
    }
    function V4(n) {
        return function() {
            return n.text();
        };
    }
    function J4(n) {
        return function(r) {
            return function(e) {
                return function() {
                    n.then(e, r);
                };
            };
        };
    }
    var SH = tu(Pn), RH = tr(Fb), NH = vn(Dn), HH = Rr($h(gg)(Nt)), PH = wd(Nt), kH = C(kl(Ya)), OH = xd(Nt), qH = Z(fe), WH = ir(ye), $H = function(n) {
        return function(r) {
            return Wo(function(e) {
                return SH(RH)(J4(r)(function(t) {
                    return e(rn.create(n(t)))();
                })(function(t) {
                    return e(nn.create(t))();
                }));
            });
        };
    };
    var UH = function(n) {
        return ke(function(r) {
            return pt("Promise failed, couldn't extract JS Error or String");
        })(NH)(cf(HH(PH("Error")(n))(kH(pt)(OH(n)))));
    }, BH = $H(UH), g1 = function(n) {
        return qH(WH(n))(BH);
    };
    var G4 = function(n) {
        return g1(V4(n));
    };
    var VH = "GET";
    var j4 = function(n) {
        return function() {
            return function(r) {
                return function(e) {
                    return g1(z4(n)(r)(e));
                };
            };
        };
    };
    var Q4 = {
        method: VH
    };
    var b1 = window.fetch;
    var jH = ge(hg)(Ml), QH = Z(su(Nt)), K4 = Hl(Ya), KH = Fp(_p), dl = Z(fe), YH = Kt(Up)(tt), XH = Ue(ha), ZH = Tn(mh), sf = k(tt), nP = C(st), rP = Z(wo), Oa = Z(Pe), eP = k(Ga), Co = Mu(Yg(_s)), tP = ir(ye), Y4 = yf(Pe), X4 = function(n) {
        var r = gi(n);
        return function(e) {
            var t = function(a) {
                return jH(function(o) {
                    return Gs(o);
                })(a);
            };
            return QH(K4(t)(B4(e)))(function(a) {
                return K4(eg)(KH(r(a)));
            });
        };
    }, aP = X4(Tu(Co(Co(Co(Co(Co(Co(Co(Co(Co(ds)({
        reflectSymbol: function() {
            return "title";
        }
    })()())({
        reflectSymbol: function() {
            return "thumbnail";
        }
    })()())({
        reflectSymbol: function() {
            return "thumb";
        }
    })()())({
        reflectSymbol: function() {
            return "path";
        }
    })()())({
        reflectSymbol: function() {
            return "id";
        }
    })()())({
        reflectSymbol: function() {
            return "external";
        }
    })()())({
        reflectSymbol: function() {
            return "description";
        }
    })()())({
        reflectSymbol: function() {
            return "date";
        }
    })()())({
        reflectSymbol: function() {
            return "content";
        }
    })()())()), y1 = function(n) {
        return dl(Tb(j4(b1)()(n)(Q4)))(function(r) {
            return YH(XH(ZH)(G4)(r));
        });
    }, Z4 = function(n) {
        return dl(y1(n))(function(r) {
            return sf(nP(qo(`
`))(r));
        });
    }, nM = function(n) {
        var r = X4(n);
        return function(e) {
            return dl(y1(e))(function(t) {
                return sf(rP(t)(function(a) {
                    return cf(r(a));
                }));
            });
        };
    }, oP = function(n) {
        return Oa(ja(rp("\\s*---([\\s\\S]*?)---\\s*([\\s\\S]*)")(np)))(function(r) {
            return Oa(ep(r)(n))(function(e) {
                return Oa(ec(e)(1))(function(t) {
                    return Oa(t)(function(a) {
                        return Oa(ec(e)(2))(function(o) {
                            return Oa(o)(function(u) {
                                return eP({
                                    header: a,
                                    body: u
                                });
                            });
                        });
                    });
                });
            });
        });
    }, rM = function(n) {
        return dl(y1(n))(function(r) {
            if (r instanceof rn) return sf(new rn(r.value0));
            if (r instanceof nn) {
                var e = oP(r.value0);
                if (e instanceof F) return sf(new rn("error in markdown extractions"));
                if (e instanceof E) {
                    var t = cf(aP(e.value0.header));
                    if (t instanceof rn) return sf(new rn(t.value0));
                    if (t instanceof nn) return dl(tP(Uv(e.value0.body)))(function(a) {
                        return sf(new nn({
                            description: t.value0.description,
                            external: t.value0.external,
                            thumb: t.value0.thumb,
                            thumbnail: t.value0.thumbnail,
                            title: t.value0.title,
                            content: new E(a),
                            path: new E(n),
                            date: Oa(ja(rp(".*/(\\d+-\\d+-\\d+)-.*")(np)))(function(o) {
                                return Oa(ep(o)(n))(function(u) {
                                    return Y4(ec(u)(1));
                                });
                            }),
                            id: Oa(ja(rp(".*/(.+)\\.md")(np)))(function(o) {
                                return Oa(ep(o)(n))(function(u) {
                                    return Y4(ec(u)(1));
                                });
                            })
                        }));
                    });
                    throw new Error("Failed pattern match at Util (line 49, column 32 - line 66, column 14): " + [
                        t.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Util (line 47, column 22 - line 66, column 14): " + [
                    e.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Util (line 45, column 3 - line 66, column 14): " + [
                r.constructor.name
            ]);
        });
    };
    var T1 = Z(he), F1 = Z(Pe), M1 = Oo(oe), uM = k(Ga), iP = Br($2), fP = Cf(kh(io)), eM = ss(oe)(ue), ni = Z(Qd), tM = Sf(Gd), iM = yt(Ct), ru = iM(Qd), cP = bt(Ri), lP = uu(Fo(j0)), C1 = Lf(Gd), E1 = k(Ri), ia = Mu(lc(_s)), tp = ia(ds), aM = {
        reflectSymbol: function() {
            return "name";
        }
    }, sP = nM(Tu(ia(Mu(lc(vs(Tu(ia(ia(tp({
        reflectSymbol: function() {
            return "qualification";
        }
    })()())(aM)()())({
        reflectSymbol: function() {
            return "institution";
        }
    })()())())))(Mu(lc(vs(Tu(ia(ia(tp({
        reflectSymbol: function() {
            return "years";
        }
    })()())({
        reflectSymbol: function() {
            return "role";
        }
    })()())({
        reflectSymbol: function() {
            return "employer";
        }
    })()())())))(ia(Mu(lc(vs(Tu(ia(tp({
        reflectSymbol: function() {
            return "url";
        }
    })()())({
        reflectSymbol: function() {
            return "label";
        }
    })()())())))(ia(ia(ia(tp({
        reflectSymbol: function() {
            return "what";
        }
    })()())({
        reflectSymbol: function() {
            return "summary";
        }
    })()())({
        reflectSymbol: function() {
            return "stack";
        }
    })()())(aM)()())({
        reflectSymbol: function() {
            return "links";
        }
    })()())({
        reflectSymbol: function() {
            return "headline";
        }
    })()())({
        reflectSymbol: function() {
            return "experience";
        }
    })()())({
        reflectSymbol: function() {
            return "education";
        }
    })()())({
        reflectSymbol: function() {
            return "domains";
        }
    })()())()), pP = qm(ye), _l = C(Ur), mP = tn(Eo), dP = Bp(Ca)(fo)(kt), _P = Tn(jt), vP = Bp(z2)(V2)(kt), ap = Z(fe), oM = ir(ye), hP = f0(ya), DP = iM(fe), gP = k(tt);
    var bP = T1(Ve)(jm(0)(0)), yP = function(n) {
        return function(r) {
            return Ep(r)(n);
        };
    }, CP = function(n) {
        return function(r) {
            if (r instanceof Vt) return "Welcome";
            if (r instanceof go) return "Blog List";
            if (r instanceof Qu) return "Matthias Meschede \u2014 CV";
            if (r instanceof ka) return Ir("")(F1(M1(r.value0)(n))(function(e) {
                return e.title;
            }));
            throw new Error("Failed pattern match at Main (line 104, column 24 - line 110, column 32): " + [
                r.constructor.name
            ]);
        };
    }, EP = function(n) {
        return function(r) {
            var e = Ir("not found")(F1(r)(function(t) {
                return uM(CP(n)(t));
            }));
            return T1(T1(Ve)(Ma))(jb(e));
        };
    }, fM = function(n) {
        return n.navigate;
    }, TP = function(n) {
        var r = iP(n.Monad0()), e = fM(n);
        return {
            navigate: function(t) {
                return r(e(t));
            },
            Monad0: function() {
                return Hc;
            }
        };
    }, cM = Sl(ye), MP = h1(cM), w1 = jd(cM), vl = ir(w1), FP = v4(w1), wP = qm(w1), lM = Of(io), xP = function(n) {
        return {
            ask: fP(Cp(n)),
            Monad0: function() {
                return lM;
            }
        };
    }, sM = xP(xh), AP = Cf(sM), IP = Cf(U2(sM)), LP = Sb(Lb), hl = Fu(B2(LP));
    var SP = Tp(fe), RP = Z(SP), NP = {
        navigate: function(n) {
            return RP(AP(function(r) {
                return r.nav;
            }))(function(r) {
                return MP(r)(n);
            });
        },
        Monad0: function() {
            return lM;
        }
    }, HP = fM(TP(NP)), PP = function() {
        var n = function(a) {
            if (a.page instanceof F) return C3;
            if (a.page instanceof E) {
                if (a.page.value0 instanceof Vt) return jv(a.cv);
                if (a.page.value0 instanceof Qu) return y3;
                if (a.page.value0 instanceof go) return T3(a);
                if (a.page.value0 instanceof ka) return Ir(jv(a.cv))(F1(M1(a.page.value0.value0)(a.posts))(function(o) {
                    return uM(E3(o));
                }));
                throw new Error("Failed pattern match at Main (line 202, column 18 - line 210, column 37): " + [
                    a.page.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Main (line 200, column 18 - line 210, column 37): " + [
                a.page.constructor.name
            ]);
        }, r = function(a) {
            return {
                page: F.value,
                posts: eM([]),
                cv: F.value
            };
        }, e = function(a) {
            return ni(tM)(function(o) {
                return ru(cP(lP(o.page)(a.value0))(C1(function(u) {
                    var i = {};
                    for(var c in u)({}).hasOwnProperty.call(u, c) && (i[c] = u[c]);
                    return i.page = a.value0, i;
                })))(function() {
                    return ru(vl(EP(o.posts)(a.value0)))(function() {
                        return ru(function() {
                            return a.value0 instanceof E && a.value0.value0 instanceof ka ? ru(hl(vb(10)))(function() {
                                var u = M1(a.value0.value0.value0)(o.posts);
                                if (u instanceof E) return vl(Bv("post-content")(Ir("")(u.value0.content)));
                                if (u instanceof F) return E1(void 0);
                                throw new Error("Failed pattern match at Main (line 162, column 11 - line 164, column 33): " + [
                                    u.constructor.name
                                ]);
                            }) : E1(void 0);
                        }())(function() {
                            return E1(new E(a.value1));
                        });
                    });
                });
            });
        }, t = function() {
            var a = function(o) {
                return new dn(Ir("default")(o.id), o);
            };
            return function(o) {
                if (o instanceof lf) return ru(vl(Vv(o.value1)))(function() {
                    return ni(tM)(function(u) {
                        return ru(HP(new E(o.value0)))(function() {
                            return vl(bP);
                        });
                    });
                });
                if (o instanceof G0) return vl(zp);
                if (o instanceof Jv) return ni(IP(function(u) {
                    return u.nav;
                }))(function(u) {
                    return ru(FP(u))(function() {
                        return ni(hl(sP("/assets/cv.yaml")))(function(i) {
                            return ru(C1(function(c) {
                                var l = {};
                                for(var d in c)({}).hasOwnProperty.call(c, d) && (l[d] = c[d]);
                                return l.cv = ja(i), l;
                            }))(function() {
                                return ni(hl(Z4("/posts/posts.dat")))(function(c) {
                                    if (c instanceof rn) return hl(pP(c.value0));
                                    if (c instanceof nn) {
                                        var l = _l(mP("/posts/"))(c.value0);
                                        return ni(hl(dP(_l(rM)(l))))(function(d) {
                                            var m = function(D) {
                                                return wP("failed path: " + (_P(De(D)) + (" - " + nh("unknown error")(xe(D)))));
                                            }, v = eM(_l(a)(am(_l(ja)(d)))), _ = rm(function(D) {
                                                return rh(D.value0);
                                            })(Xp(d)(l));
                                            return ni(vP(_l(m)(_)))(function() {
                                                return C1(function(D) {
                                                    var T = {};
                                                    for(var I in D)({}).hasOwnProperty.call(D, I) && (T[I] = D[I]);
                                                    return T.posts = v, T;
                                                });
                                            });
                                        });
                                    }
                                    throw new Error("Failed pattern match at Main (line 182, column 7 - line 195, column 60): " + [
                                        c.constructor.name
                                    ]);
                                });
                            });
                        });
                    });
                });
                throw new Error("Failed pattern match at Main (line 169, column 18 - line 195, column 60): " + [
                    o.constructor.name
                ]);
            };
        }();
        return i0({
            initialState: r,
            render: n,
            eval: Zd({
                receive: c0.receive,
                finalize: c0.finalize,
                handleQuery: e,
                handleAction: t,
                initialize: new E(Jv.value)
            })
        });
    }(), pM = oy(ap(oM(m4))(function(n) {
        var r = {
            nav: n
        }, e = hP(yP(r))(PP);
        return DP(Ym)(function() {
            return ap(uy)(function(t) {
                return ap(kC(e)(void 0)(t))(function(a) {
                    return ap(oM(h4(n)(a)))(function(o) {
                        return gP(void 0);
                    });
                });
            });
        });
    }));
    pM();
})(); /*! Bundled license information:

js-yaml/dist/js-yaml.mjs:
  (*! js-yaml 4.2.0 https://github.com/nodeca/js-yaml @license MIT *)
*/ 

//# sourceMappingURL=website.75355dbe.js.map
